import { TranslationInterface } from '../schema';

export const ro: TranslationInterface = {
  wss: {
    toggleOfferRequestValidators: 'Adauga cereri de oferta cu pana la 365 zile in trecut',
  },
  workflows: {
    workflowNames: {
      PAYMENTS: 'Plati demo',
      PAYMENT_DONE: 'Incasari plati',
      LOGO: 'Logo',
      CUSTOM_ETRANSPORT_UPLOAD: 'Upload ETransport personalizat',
      INVOICE_RECEIVED: 'Facturi primite',
    },
    workflowDescriptions: {
      PAYMENTS: 'Payments',
      PAYMENT_DONE: 'Configureaza daca sa se trimita automat emailuri cand se efectueaza o plata',
      LOGO: 'Configureaza daca logoul de platforma ar trebui afisat in meniu',
      CUSTOM_ETRANSPORT_UPLOAD: 'Configureaza daca upload-ul personalizat de excel pentru eTransport este activ',
      INVOICE_RECEIVED:
        'Configureaza daca facturile sunt acceptate automat sau trebuie sa astepte dupa actiune din partea utilizatorului',
    },
    selectableItems: {
      SHOW_CUSTOM_ETRANSPORT_UPLOAD: 'Activeaza upload-ul personalizat de excel pentru eTransport',
      PAYMENTS_TEST_WORKFLOW_STEP_001: 'Test workflow step 001 :) ',
      PAYMENTS_PAYMENTS_1: 'Test UI',
      PAYMENTS_EMAIL: 'Email ----',
      PAYMENT_DONE_FINAL_DUE_DATE: 'Ascunde posibilitatea configurarii datei scadenta a facturi',
      PAYMENT_DONE_EMAIL: 'Trimite emailuri',
      LOGO_LOGO_1: 'Afisaza logo',
      INVOICE_RECEIVED_INVOICE_WORKFLOW_NEVER_ACCEPT: 'Nu se accepta niciodata automat',
    },
    details: {
      workflowName: 'Nume workflow',
      workflowDefaultDescription: 'Descriere',
      title: 'Detalii workflow',
      systemName: 'Sistem',
      stepsUiTitle: 'Pași UI workflow',
      stepsTitle: 'Pași workflow',
      stepName: 'Denumire pas',
      notiTitle: 'Notificări',
      notificationType: 'Tip notificare',
      label: 'Etichetă',
      generalTitle: 'Informații generale',
      errors: {
        requiredLabel: "Campul 'Eticheta' este obligatoriu",
      },
    },
    configuration: {
      title: 'Configurare workflows',
      list: {
        validTo: 'Valid până la',
        validFrom: 'Valid din',
        systemName: 'Nume sistem',
        name: 'Nume workflow',
        configuredForOwner: 'Configurare',
        configurationType: {
          default: 'Predefinit',
          custom: 'Personalizat',
        },
      },
    },
  },
  'wip-message': {
    title: 'Zona in lucru',
    description: 'Unele functionalitati ar putea sa nu fie disponibile',
  },
  warehouses: {
    warehouseName: 'Nume depozit',
    warehouseDetails: 'Detalii depozit',
    terminals: {
      unloading: 'Descarcare',
      terminalTypeErrorMessage: 'Este necesar sa selectati minim un tip de terminal',
      terminalType: 'Tip terminal',
      reservations: {
        vendorVo: 'Transportator',
        vehicleType: 'Tip vehicul',
        UNLOADING: 'Descarcare',
        types: {
          UNLOADING: 'Descarcare',
          MAINTENANCE: 'Administrativ',
          LOADING: 'Incarcare',
          CLEANING: 'Curatenie',
        },
        to: 'Pana la',
        terminalReservationNumber: 'Numar referinta',
        driverPhoneNumber: 'Telefon sofer',
        tag: 'Eticheta',
        statuses: {
          upcoming: 'Planificat',
          partially_completed: 'Finalizata partial',
          expired: 'Expirata',
          completed: 'Finalizata',
          cancelled: 'Anulata',
          archived: 'Arhivata',
          arrived_at_gate: 'Ajuns la poartă',
          check_in: 'Check-in',
          loading_in_progress: 'Încărcare în curs',
          loading_completed: 'Încărcare finalizata',
          exited_gate: 'Ieșit la poartă',
          not_present_at_loading: 'Neprezentat',
          unloading_in_progress: 'Descărcare în curs',
          unloading_completed: 'Descărcare finalizată',
          not_present_at_unloading: 'Neprezentat',
        },
        hasUitCode: 'Cod UIT prezent',
        retrievedProtectionMaterials: 'Materiale de protecție ridicate',
        receivedProtectionMaterials: 'Materiale de protecție primite',
        nextStatus: 'Status urmator',
        notPresentAtLoading: 'Neprezentat la incarcare',
        notPresentAtUnloading: 'Neprezentat la descarcare',
        statusAlertMessage: 'Intervalul rezervarii a fost depasit, actualizeaza statusul!',
        status: 'Status',
        shipments: 'Transporturi',
        reservationType: 'Tip rezervare',
        reservationStatus: 'Status rezervare',
        orders: 'Comenzi',
        order: 'Comanda',
        MAINTENANCE: 'Administrativ',
        LOADING: 'Incarcare',
        licencePlate: 'Numar inmatriculare',
        from: 'De la',
        driver: 'Sofer',
        deleteMessage: 'Sunteti sigur ca doriti sa stergeti rezervarea?',
        contactPhoneNumber: 'Telefon responsabil',
        contactName: 'Nume responsabil',
        confirmHeader: 'Confirma stergerea',
        comments: 'Observatii',
        CLEANING: 'Curatenie',
        cancel: 'Anuleaza',
        list: {
          title: 'Programari depozit',
          columns: {
            terminalName: 'Nume terminal',
            terminalReservationNumber: 'Numar programare',
            orderNumbers: 'Numar comanda',
            serviceProviderName: 'Furnizor',
            timeRange: 'Interval orar',
            licencePlate: 'Inmatriculare vehicul',
            reservationType: 'Tip programare',
            reservationStatus: 'Status programare',
            terminalStatus: 'Status terminal',
          },
        },
      },
      name: 'Nume',
      loadingAndUnloading: 'Incarcare si Descarcare',
      loading: 'Incarcare',
      hour: 'Ora curenta',
      errors: {
        requiredTerminalReservationNumber: 'Campul este obligatoriu',
        requiredReservationType: 'Campul este obligatoriu',
        requiredName: 'Campul este obligatoriu',
        requiredDescription: 'Campul este obligatoriu',
        requiredContactPhoneNumber: 'Campul este obligatoriu',
        requiredContactName: 'Campul este obligatoriu',
        requiredDriverPhoneNumber: 'Campul este obligatoriu',
        requiredSpOrCourier: 'Campul este obligatoriu',
        requiredVehicleType: 'Campul este obligatoriu',
        requiredDriver: 'Campul este obligatoriu',
        requiredLicencePlate: 'Campul este obligatoriu',
      },
      emptyAttachments: 'Niciun document incarcat',
      vendor: 'Transportator',
      externalSP: 'Curier',
      editTerminal: 'Editeaza terminal',
      description: 'Descriere',
      'delete-confirmation-message': (param) =>
        `Esti sigur ca doresti sa stergi terminalul <strong>${param.terminalName}</strong> ? Aceasta actiune va anula toate programariile viitoare asociate terminalului.`,
      delete: 'Sterge terminal',
      deleted: 'Șters',
      active: 'Activ',
      contactPhoneNumber: 'Telefon responsabil',
      contactName: 'Nume responsabil',
      attachmentsTooltip: 'Vezi documente',
      attachments: 'Documente',
      addTerminal: 'Adauga terminal nou',
    },
    orderReservationButton: 'Programeaza comanda in depozit',
    moreDetails: 'Mai multe detalii',
    location: 'Locatie',
    lessDetails: 'Mai putine detalii',
    futureSchedule: 'Program incepand din',
    editWarehouse: 'Editeaza depozit',
    editFutureSchedule: 'Editeaza program viitor',
    deleteFutureScheduleMessage: 'Sunteti sigur ca doriti sa stergeti programul viitor?',
    deleteFutureScheduleHeader: 'Confirmare stergere',
    deleteFutureSchedule: 'Sterge program viitor',
    currentScheduled: 'Program curent',
    create: {
      warehouseName: 'Nume depozit',
      title: 'Creeaza depozit',
      timeSlot: 'Interval minim minute',
      openingTime: 'Ora incepere activitate',
      noExistingDeposit: 'Nu exista creat un depozit',
      error: {
        timeOrderError: 'Ora de finalizare trebuie sa fie dupa ora de incepere',
        requiredWarehouseName: 'Campul nume depozit este obligatoriu',
        requiredTimeSlot: 'Campul interval minim minute este obligatoriu',
        requiredOpeningTime: 'Campul ora incepere activitate este obligatoriu',
        requiredClosingTime: 'Campul ora finalizare activitate este obligatoriu',
        requiredAddress: 'Campurile de adresa sunt obligatorii',
        '0AddressDTO': 'Campurile de adresa sunt obligatorii',
      },
      createWarehouseForm: 'Completeaza campurile de mai jos pentru a crea un depozit',
      closingTime: 'Ora finalizare activitate',
    },
    addFutureSchedule: 'Adauga program viitor',
    tooltipFromOrderSchedulingMode: 'Dă click pe un slot pentru a programa comanda',
    clearOrderContext: 'Renunță la comanda activă',
  },
  'vendor-templates': {
    title: 'Sabloane',
    'empty-list': "Lista este goala.Adauga un sablon folosind butonul 'Adauga' de mai sus.",
    'add-template': 'Adauga sablon',
  },
  utils: {
    yes: 'Da',
    visibilityTypeDescription: {
      SERVICE_PROVIDER: 'Aceasta vizibilitate vizeaza contactele clientilor ce primesc cereri din partea furnizorilor',
      PUBLIC: 'Toate contactele marcate astfel pot fi vazute de toate firmele',
      NONE: 'Aceasta vizibilitate vizeaza gestiunea interna; Contactele marcate astfel nu pot fi vazute de firmele partenere',
      CUSTOMER: 'Aceasta vizibilitate vizeaza contactele furnizorilor ce primesc cereri din partea clientilor',
      BOTH: 'Aceasta vizibilitatea vizeaza contactele furnizorilor dar si a clientilor',
    },
    update: 'Actualizeaza',
    status: 'Status',
    partialSave: 'Salveaza partial',
    validateAndSave: 'Valideaza si salveaza',
    saveAndUpload: 'Salveaza si trimite',
    confirmation: 'Confirmare',
    timeLimit: 'zile termen plata',
    sync: 'Sincronizeaza',
    'show-more': 'Mai mult',
    'show-less': 'Mai putin',
    search: 'Cauta',
    save: 'Salveaza',
    deliverByDate: 'Data livrare',
    plannedDelivery: 'Livrare planificata',
    deliveryDate: 'Data de livrare',
    requiredLegend: 'Campurile marcate cu * sunt obligatorii!',
    successSave: 'Salvare cu success',
    verifyData: 'Verificati datele',
    defaultInfoSummary: 'Info',
    defaultInfoDetails: 'Detalii info',
    noDataFound: 'Nu s-au gasit date',
    no: 'Nu',
    languages: {
      ro: 'Română',
      en: 'Engleză',
    },
    emptyMessage: 'Nu a fost găsit niciun rezultat',
    edit: 'Editeaza',
    download: 'Descarca',
    deleteConfirmationMessage: 'Confirmare stergere',
    delete: 'Sterge',
    close: 'Inchide',
    closeDetails: 'Inchide detalii',
    back: 'Inapoi',
    all: 'Toate',
    add: 'Adauga',
    loadingSuccess: 'Incarcare cu succes!',
    downloadPdf: 'Descarca PDF',
    send: 'Trimite',
    seeDetails: 'Vezi detalii',
    saveForLater: 'Salveaza pentru mai tarziu',
    seeMore: 'Vezi mai mult',
    details: 'Detalii',
    resetData: 'Reseteaza datele',
    addContactInfoMessage: 'Adauga contact folosind urmatorul buton',
    existentCompany: 'Companie deja existenta!',
    existentCompanyDetails: 'Compania selectata a fost deja adaugata.',
    publicContact: 'Contact public',
    partnerContact: 'Contact privat',
    daysOfWeek: {
      MONDAY: 'Luni',
      TUESDAY: 'Marti',
      WEDNESDAY: 'Miercuri',
      THURSDAY: 'Joi',
      FRIDAY: 'Vineri',
      SATURDAY: 'Sambata',
      SUNDAY: 'Duminica',
    },
    shortDaysOfWeek: {
      MONDAY: 'Lun',
      TUESDAY: 'Mar',
      WEDNESDAY: 'Mie',
      THURSDAY: 'Joi',
      FRIDAY: 'Vin',
      SATURDAY: 'Sâm',
      SUNDAY: 'Dum',
    },
    inactive: 'Inactiv',
    packages: 'Pachete',
    itemsSelected: 'elemente selectate',
    upload: 'Încarcă',
  },
  user: {
    phoneNumberNotValidated: 'Numarul de telefon nu este validat',
  },
  'user-preferences': {
    filters: {
      saveSearch: 'Salveaza cautarea',
      savedFilters: 'Căutări salvate',
      resetSearch: 'Reseteaza filtre',
      filterName: 'Nume cautare',
      deleteSearchTooltip: 'Sterge cautarea',
      confirmDeletionMessage: 'Sunteti sigur ca doriti sa stergeti cautarea?',
      confirmDeletionHeader: 'Confirma stergerea',
      applyFilterTooltip: 'Click pentru a aplica filtrarea',
      addFilterName: 'Adauga nume pentru cautare',
      markAsDefaultTooltip: 'Marcheaza drept filtrare prestabilit',
    },
    defaultOption: 'Filtrare prestabilită',
    noDataMessage: 'Nicio căutare salvată',
    saveSuccessMessage: 'Căutarea a fost salvată cu succes',
    deleteSuccessMessage: 'Căutarea a fost stearsă cu succes',
  },
  'user-action-tracking': {
    userActionType: {
      scroll: 'Scroll',
      page_open: 'Pagina deschisa',
      page_exit: 'Pagina inchisa',
      button_press: 'Buton apasat',
    },
    userAction: {
      sp_invoices_open: 'Pagina Facturi Emise deschisa',
      sp_invoice_payments_open: 'Pagina Incasari deschisa',
      outbox_open: 'Pagina Outbox deschisa',
      order_page_open: 'Pagina comanda deschisa',
      offer_request_page_open: 'Pagina cerere de oferta deschisa',
      offer_page_open: 'Pagina oferta deschisa',
      invoice_page_open: 'Pagina factura deschisa',
      inbox_open: 'Pagina Inbox deschisa',
      homepage_open: 'Pagina de start deschisa',
      customer_invoices_open: 'Pagina Facturi Primite deschisa',
      customer_invoice_payments_open: 'Pagina Plati deschisa',
    },
    menu: {
      userActions: 'Actiuni utilizatori',
    },
    list: {
      userName: 'Nume utilizator',
      userActionType: 'Tip actiune utilizator',
      userAction: 'Actiune utilizator',
      trackedEntity: 'Entitate monitorizata',
      search: 'Cauta',
      all: 'Toate',
      actionUrl: 'Url actiune',
      actionedAt: 'Data actiunii',
    },
  },
  type: 'Tip cont global',
  'transport-project': {
    list: {
      validTo: 'Valid pana la',
      validFrom: 'Valid din',
      title: 'Proiecte de Transport',
      label: 'Eticheta',
      description: 'Descriere',
    },
    form: {
      validTo: 'Valid pana la',
      validFrom: 'Valid din',
      label: 'Eticheta',
      error: {
        requiredValidFrom: "Campul 'Valid din' este obligatoriu!",
        requiredLabel: "Campul 'Eticheta' este obligatoriu!",
      },
      description: 'Descriere',
    },
    edit: 'Editeaza Proiectul de Transport',
    add: 'Adauga un Proiect de Transport',
    shipment: {
      title: 'Transporturi',
    },
  },
  timeUnit: {
    WEEK: 'Saptamani',
    SECOND: 'Secunde',
    MINUTE: 'Minute',
    HOUR: 'Ore',
    DAY: 'Zile',
  },
  timeAvailability: {
    error: {
      requiredUnit: 'Unitatea de timp este obligatorie de completat!',
      requiredDuration: 'Durata este obligatorie de completat!',
      minValueExceededDuration: 'A fost depasita valoarea minima a valabilitatii!',
    },
  },
  'terms-and-conditions': {
    statuses: {
      rejected: 'Refuzate',
      accepted: 'Acceptate',
    },
    'preview-title': 'Vizualizare Termeni si Conditii',
    'not-found': 'Nu exista Termeni si Conditii!',
    currentStatus: 'Termenii si Conditiile au fost',
    comments: 'Motiv refuz',
  },
  task: {
    wizard: {
      secondStep: {
        title: 'Task-uri',
        task: 'Task',
        timeWarningMessage: 'Intervalele de timp sunt diferite de cele de pe comanda',
        dimensions: 'Lungime - Latime - Inaltime',
      },
      firstStep: {
        title: 'Ruta',
        selectRoute: 'Selecteaza o ruta',
        errors: {
          requiredVehicle: 'Masina este obligatorie',
          requiredMainDriver: 'Soferul principal este obligatoriu',
        },
        changeRoute: 'Schimba ruta',
      },
    },
    list: {
      updatedAt: 'Actualizat la',
      title: 'Dispecer Transporturi',
      deleteMessage: 'Sunteți sigur că doriți să ștergeți?',
      deleteTaskOnly: 'Sterge doar task',
      deleteSolution: 'Sterge solutia',
      solutionNotDeletable: 'Solutia contine alte segmente active',
      solutionDeletableWarning:
        'Ștergerea soluției implică ștergerea tuturor segmentelor și a transporturilor din hub provenite din această soluție',
      deletedSuccessfully: 'Task șters cu succes',
      deleteQuestionTask: 'Doriți să modificați detaliile acestui task?',
      deleteQuestionSegment: 'Doriți să realocați transporturile pe un alt segment de rută?',
      deleteSegment: 'Sterge segmentul / Dezaloca transporturi',
      deleteQuestionSolution: 'Doriți să renunțați la soluția actuală de rutare?',
      deleteEntireSolution: 'Sterge intreaga solutie',
      closeMessage: 'Sunteți sigur că doriți să închideți task-ul?',
      closeBody: 'Această acțiune nu va modifica statusurile de pe pachete, transporturi sau comenzi.',
      closeTask: 'Închide task',
      closedSuccessfully: 'Task închis cu succes',
      fullHandoverMessage: 'Finalizare completă',
      fullHandoverBody:
        'Această acțiune va finaliza toate checkpoint-urile și va actualiza statusurile pachetelor, transporturilor și comenzilor.',
      fullHandover: 'Finalizare completă',
      fullHandoverSuccessfully: 'Finalizare completă realizată cu succes',
      legend: {
        task: 'Task',
        shipment: 'Transport',
      },
      filter: 'Filtrează',
      filterInputs: {
        packageId: 'ID pachet',
        orderNumber: 'Număr comandă',
        series: 'Serie transport',
        serviceProviderName: 'Transportator',
        pickupDate: 'Dată preluare',
        deliveredBy: 'Dată livrare',
        mainDriverName: 'Nume șofer',
        licensePlate: 'Înmatriculare vehicul',
        pickupAddress: 'Adresă preluare',
        deliveryAddress: 'Adresă livrare',
        pickupLocation: 'Locație preluare',
        deliveryLocation: 'Locație livrare',
        taskStatus: 'Status task',
        shipmentStatus: 'Status transport',
        lastModifiedAt: 'Data ultimei modificari',
        unknownDestination: 'Destinație necunoscută',
      },
    },
    statusEnum: {
      created: 'Creat',
      accepted: 'Acceptat',
      rejected: 'Refuzat',
      in_transit: 'In tranzit',
      in_transit_returning: 'Retur in tranzit',
      completed: 'Finalizat',
      cancelled: 'Anulat',
      closed: 'Închis',
      partially_closed: 'Închis parțial',
    },
  },
  tariff: {
    tags: 'Etichete',
    pickupCity: 'Oras preluare',
    packageWeight: 'Greutate pachete',
    packageType: 'Tip pachete',
    emptyTariffsMessage: 'Nu s-a gasit niciun tarif pentru cautarea curenta.',
    deliveryCity: 'Oras predare',
    currencyCode: 'Moneda',
  },
  'system-administration': {
    utils: {
      save: 'Salveaza',
      cancel: 'Inchide',
    },
    menu: {
      reportTemplates: 'Sabloane Rapoarte',
      reports: 'Rapoarte',
      pdfTemplates: 'Sabloane PDF',
      jobSystem: 'Sistem joburi',
      jobLogs: 'Log joburi',
      jobExecution: 'Executie joburi',
      jobDefinition: 'Definire joburi',
      integrationExecutions: 'Executii',
      integrationDefinitions: 'Definitii',
      integration: 'Importuri de date',
      exceptions: 'Exceptii',
      dashboardDefinitions: 'Definitii',
      dashboard: 'Dashboard',
    },
    error: {
      defaultError:
        'A aparut o eroare pe server! Va rugam contactati echipa de suport in legatura cu problema intampinata la adresa well.suport@irian.ro',
    },
  },
  'suggestion-message': {
    title: 'Sugestie',
    'button-tooltip': 'Du-mă acolo',
  },
  'standard-package-dimension': {
    utils: {
      save: 'Salveaza',
      delete: 'Sterge',
      close: 'Inchide',
    },
    'update-package': 'Editeaza dimensiune standard',
    standardPackage: 'Pachet standard',
    'page-title': 'Pachete standard',
    package: 'Pachet',
    list: {
      width: 'Latime',
      type: 'Tip ambalaj',
      tags: 'Etichete',
      name: 'Denumire',
      length: 'Lungime',
      height: 'Inaltime',
      weight: 'Weight',
    },
    form: {
      width: 'Latime',
      type: 'Tip ambalaj',
      tags: 'Etichete',
      name: 'Denumire',
      length: 'Lungime',
      height: 'Inaltime',
      weight: 'Weight',
      errors: {
        requiredDescription: "Campul 'Denumire' este obligatoriu!",
        requiredlength: "Campul 'Lungime' este obligatoriu!",
        requiredwidth: "Campul 'Latime' este obligatoriu!",
        requiredheight: "Campul 'Inaltime' este obligatoriu!",
      },
    },
    emptyStandardPackagesMessage: 'Nu aveti niciun pachet standard adaugat',
    'delete-package': 'Sterge dimensiune standard',
    'delete-confirmation-message': (param) =>
      `Esti sigur ca vrei sa stergi dimensiunea standard <strong>${param.name}</strong> ?`,
  },
  sswl: {
    value: 'Valoare',
    type: 'Tip',
    system: 'Sistem',
    name_filter: 'Filtreazǎ dupǎ nume...',
    name: 'Nume',
    msg: {
      delete: 'Sigur vreți sǎ ștergeți inregistrarea?',
    },
    list_title: 'Setǎri sistem',
    delete_confirmation: 'Confirmǎ ștergerea',
    add_new_setting: 'Adaugǎ setare',
  },
  signup: {
    vatSplitStatus: 'Plata defalcata TVA',
    vatRegistration: 'Platitor TVA',
    vatInactiveStatus: 'Inactiv (TVA)',
    vatInactivationDate: 'Inactiv (TVA) de la',
    vat: 'Valoare TVA',
    editData: 'Editeaza date',
    utils: {
      select: 'Selecteaza',
      save: 'Salveaza',
      requiredLabel: 'Toate campurile marcate cu * sunt obligatorii',
      next: 'Pagina urmatoare',
      edit: 'Editeaza',
      close: 'Inchide',
      choose: 'Alege',
      cancel: 'Inchide',
      all: 'Toate',
    },
    uniqueIdNumber: 'Numar unic de identificare',
    title: 'Sign-up',
    'terms-and-conditions': 'Termenii și condițiile & Politica de prelucrare a datelor',
    successfulIfValid: 'Daca datele sunt valide, un e-mail de activare al contului a fost trimis catre tine!',
    subscriptionTypeTabTitle: 'Tip abonament',
    subscriptionTypeTabHeader: 'Alege tip abonament',
    'subscription-type': {
      subscription: {
        list: {
          title: 'Abonamente',
        },
        legalEntity: 'Companie',
        detail: 'Detalii',
      },
      private: 'Privat',
      'new-actions': 'Definire Actiuni',
      'list-title': 'Tipuri Abonamente',
      inputs: {
        typeName: 'Nume Abonament',
        subscriptionPrice: 'Pret',
        subscriptionCurrency: 'Moneda',
        private: 'Privat',
        legalEntity: 'Companie',
        creditStart: 'Creditul initial',
      },
      errors: {
        requiredtypeName: 'Campul Name este obligatoriu',
        requiredsubscriptionPrice: 'Campul pret este obligatoriu',
        requiredsubscriptionCurrency: 'Campul moneda este obligatoriu',
      },
      companies: 'Companii',
      'add-title': 'Definire Tipuri Abonamente',
      add: 'Adauga',
      actions: {
        SEND_ORDER: 'Trimitere comanda',
        RECEIVE_ORDER: 'Primire comanda',
        'offer-request': 'Cerere de oferta',
        monthlyIncludedAmount: 'Actiuni incluse',
        info: 'Acces la toate functionalitatiile aplicatiei',
        creditStart: 'Credit initial',
        CREATE_OFFER: 'Cereri de oferta',
        actionCost: 'O actiune suplimentara costa',
      },
    },
    'subscription-plan': {
      title: 'Selecteaza un abonament',
      'card-info': 'Informatii card',
    },
    subscription: 'Abonament',
    startingBalance: 'Balans initial',
    selectIndustryType: 'Selecteaza Tip Industrie',
    save: 'Salveaza',
    registrationCode: 'Nr. de ordine Registrul Comertului',
    preferredLanguage: 'Limba',
    payment: {
      termsAccept: 'Sunt de acord cu termenii si conditiile',
      terms: 'Termeni si conditii',
      paymentOrder: 'Ordin de plata',
      paymentMethod: 'Metoda de plata',
      go: 'Vezi',
      error: 'Acest camp este obligatoriu',
      card: 'Card',
    },
    'payment-info': 'Detalii plată',
    password: 'Parola',
    mainPhone: 'Telefon principal',
    mainEmailAddress: 'Email Principal',
    mainAddress: 'Adresa pricipala',
    legalEntityNotFound: 'Nu a fost selectata nici o companie',
    invoiceSeriesPrefix: 'Prefix Serie Factura',
    industryTypeValue: 'Tip industrie',
    indication: 'Selecteaza o companie sau creaza una noua',
    firstUser: 'Primul utilizator',
    firstEmployee: 'Primul angajat',
    firstContact: {
      visibilityTypes: {
        SERVICE_PROVIDER: 'Furnizor servicii',
        PUBLIC: 'Public',
        NONE: 'Privat',
        CUSTOMER: 'Client',
        BOTH: 'Ambele',
      },
      inputs: {
        visibilityType: 'Vizibilitate',
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        receivesRequestsRequiredTooltip: 'Pentru a selecta o metoda de contact trebuie sa primeasca cereri',
        receivesRequests: 'Accept sa fiu contactat prin metoda selectata',
        phoneNumber: 'Telefon',
        newDepartment: 'Departament nou',
        email: 'Email',
        departmentName: 'Nume departament',
        contactMethod: 'Metoda contact',
      },
      error: {
        uniqueIdNumberrequired: "Campul 'Numar unnic de intentificare' este obligatoriu",
        requiredVisibility: "Campul 'Vizibilitate' este obligatoriu",
        requiredValidFrom: "Campul 'Valid din' este obligatoriu",
        requiredPhoneNumber: "Campul 'Telefon' este obligatoriu",
        requiredPerson: "Campul 'Persoana' este obligatoriu",
        requiredInvoiceSeriesPrefix: "Campul 'Prefix Serie Factura' este necesar",
        requiredEmail: "Campul 'Email' este obligatoriu",
        requiredContactMethod: "Campul 'Metoda de contact' este obligatoriu",
        DuplicateUniqueID: 'Mai exista un client cu acest numar unic de inregistrare!',
        DuplicateCompanyName: 'Exista deja un client cu acest nume!',
        countryrequired: "Campul 'Tara' este obligatoriu",
        companyNamerequired: "Campul 'Nume Companie' este obligatoriu",
        cityrequired: "Campul 'Localitate' este obligatoriu",
      },
      contactMethods: {
        VISIT: 'Vizita',
        TEL: 'Telefon',
        EMAIL: 'E-Mail',
      },
    },
    existingCompanyError: 'Compania pe care doriti sa o adaugati este deja inregistrata in platforma',
    error: {
      requiredUniqueIdNumber: "Campul 'Numar unic de identificare' este obligatoriu",
      requiredPreferredLanguage: "Campul 'Limba' este obligatoriu",
      requiredInvoiceSeriesPrefix: "Campul 'Prefix Serie Factura' este obligatoriu",
      requiredCountry: "Campul 'Tara' este obligatoriu",
      requiredCompanyName: "Campul 'Nume Companie' este obligatoriu",
      companyTypeMismatch: 'Tipul inregistrat al companiei este diferit de cel selectat',
      patternUniqueIdNumber: 'Campul trebuie sa contina minim 2 cifre si sa nu contina spatii albe',
    },
    employee: {
      error: {
        requiredValidTo: 'Campul Valid pana la este obligatoriu',
        requiredValidFrom: 'Campul Valid din este obligatoriu',
        requireduserName: 'Campul Nume Utilizator este obligatoriu',
        requiredPerson: 'Campul Persoana este obligatoriu',
        requiredpassword: 'Campul Parola este obligatoriu',
        requiredname: 'Campul Nume este obligatoriu',
        requiredcounty: 'Campul Judet este obligatoriu',
      },
      common: {
        newDepartment: 'Departament nou',
        departmentName: 'Nume departament',
      },
    },
    emailImportSettings: 'Email Import Settings',
    discount: 'La data platii vei beneficia de urmatoarea reducere',
    description: 'Introduceti datele pentru utilizatorul administrator al companiei.',
    creditCard: {
      expirationDateFormat: 'MM/YY',
      expirationDate: 'Data expirarii',
      error: {
        requiredName: 'Campul Nume este obligatoriu',
        requiredExpirationDate: 'Campul Data expirarii este obligatoriu',
        requiredCardNumber: 'Campul Numar card este obligatoriu',
        invalidExpirationDate: 'Data expirarii este invalida',
        invalidCardNumber: 'Numarul cardului este invalid',
      },
      cardOwner: 'Nume',
      cardNumber: 'Numar card',
      card: 'CARD',
    },
    createServiceProvider: 'Service Provider',
    country: 'Tara',
    contact: 'Contact',
    confirm: 'Confirmati',
    companyTabTitle: 'Companie',
    companyTabHeader: 'Detalii companie',
    companyRegistration: 'Inregistrare Companie',
    companyName: 'Nume Companie',
    companyInfo: {
      title: 'Date Companie',
      confirmPassword: {
        error: {
          'Bad credentials': 'Parolă incorectă!',
        },
      },
      confirmLegalEntitySignup: 'Confirmati inregistrarea companiei',
    },
    companyFormSubTitle: 'Acestea sunt datele oficiale provenite de la ministerul finantelor',
    'company-info': 'Date companie',
    close: 'Inchide',
    city: 'Localitate',
    cardTabTitle: 'Card',
    cardTabHeader: 'Adauga card',
    bankAccountTabTitle: 'Conturi bancare',
    bankAccountTabHeader: 'Adauga conturi bancare',
    autocompletePlaceholder: 'Cauta companie inregistrata',
    address: {
      errors: {
        alreadyExistingAddressOfType: 'Exista deja o adresa de acest tip pentru aceasta companie',
      },
    },
    addCompany: 'Adauga companie noua',
    actions: {
      list: {
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        title: 'Lista actiuni',
        subscriptionTypeName: 'Nume subscriptie',
        subscriptionTypeModule: 'Modul subscriptie',
        search: 'Cauta',
        name: 'Nume',
        monthlyIncludedAmount: 'Inclus lunar',
        cost: 'Costul',
        adminTitle: 'Administrare actiuni',
      },
      inputs: {
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        monthlyIncludedAmount: 'Incluse in fiecare luna',
        actionName: 'Nume actiune',
        actionCost: 'Costul actiunii',
      },
      errors: {
        requiredcost: "Campul 'Costul actiunii' este necesar",
        requiredactionName: "Campul 'Nume Actiune' este necesar",
      },
      detailTitle: 'Detalii actiune',
      addTitle: 'Adauga actiune',
    },
    'account-type': {
      'vendor-description': 'Primeste comenzi de transport.',
      vendor: 'Transportator',
      title: 'Tip cont',
      'expedition-house-description': 'Intermediaza comenzi de transport.',
      'expedition-house': 'Forwarder',
      'client-with-fleet-description': 'Trimite comenzi de transport cu flota proprie',
      'client-with-fleet': 'Client cu flota',
      'client-description': 'Trimite comenzi de transport.',
      client: 'Client',
    },
  },
  'shipment-timeline': {
    utils: {
      workInProgressSolution: 'Vezi solutie in lucru',
      shipments: (param) =>
        param.shipments
          ? `${param.shipments} ` + (param.shipments === 1 ? 'transport' : 'transporturi')
          : '- transporturi',
      orderStatus: 'Status comanda: ',
      inactiveTooltip: 'Inca nu ai ajuns in stadiul acesta',
      date: 'La data de',
      consolidation: 'Consolidare',
      availableDocuments: 'Documente disponibile',
      attachments: (param) => (param.attachments !== null ? `${param.attachments} Atasamente` : '- Atasamente'),
      addSolution: 'Adauga o solutie',
    },
    solutionTab: {
      solution: 'Rezolvare',
      signup: 'Inregistreaza-te',
      routingOptions: (solutionTab) =>
        solutionTab.routingOptions !== null
          ? `${solutionTab.routingOptions} ` +
            (solutionTab.routingOptions === 1 ? 'varianta de rutare' : 'variante de rutare')
          : '- variante de rutare',
      requestOffer: 'Cere oferta',
      requestPreOffer: 'Cere pre-oferta',
      receivedOffers: (solutionTab) =>
        solutionTab.receivedOffers !== null
          ? `${solutionTab.receivedOffers} ` + (solutionTab.receivedOffers === 1 ? 'oferta primita' : 'oferte primite')
          : '0 oferte primite',
      preferredCompleteSolution: 'Solutie completa preferata',
      order: 'Comanda',
      orderDisabled: 'Comanda nu este disponibila in stadiul de cerere de oferta',
      preOrder: 'Pre-comanda',
      preOrderDisabled: 'Pre-comanda nu este disponibila in stadiul de cerere de oferta',
      task: 'Task',
      taskDisabled: 'Task-ul automat nu este disponibil pentru aceasta cerere de oferta sau comanda',
      taskTooltip: 'Creează un task care va fi rezolvat cu flota ta',
      requestOfferTooltip: 'Solicită o ofertă de la partenerii furnizori',
      orderTooltip: 'Trimite o comandă către un partener furnizor',
      notAllow: 'Aceasta actiune este rezervata pentru clientii inregistrati in platforma',
      completeSolutions: (solutionTab) =>
        solutionTab.completeSolutions !== null
          ? `${solutionTab.completeSolutions} ` +
            (solutionTab.completeSolutions === 1 ? 'solutie completa' : 'solutii complete')
          : '- solutii complete',
      completeSolution: 'Rezolvare completa',
    },
    'shipment-management': 'Shipment Management',
    orderTrackingTab: {
      transport: 'Transport',
      segmentsSolution: (orderTrackingTab) =>
        orderTrackingTab.segmentsNo !== null
          ? `Solutionata cu ${orderTrackingTab.segmentsNo} ` +
            (orderTrackingTab.segmentsNo === 1 ? 'segment' : 'segmente')
          : 'Solutionata cu - segmente',
      pickUpDate: (orderTrackingTab) =>
        orderTrackingTab.pickUpDate !== null
          ? `Ridicata la data de ${orderTrackingTab.pickUpDate}`
          : 'Ridicata la data de -',
      in_transit: 'In tranzit',
      complaints: (orderPhase) =>
        orderPhase.complaints !== null
          ? `${orderPhase.complaints} ` + (orderPhase.complaints === 1 ? 'Reclamatie' : 'Reclamatii')
          : '0 Reclamatii',
    },
    orderTab: {
      viewVehicle: 'Vezi masina',
      viewResume: 'Vezi rezumat transporturi',
      price: (param) => (param.value && param.currencyCode ? `Pret: ${param.value} ${param.currencyCode}` : 'Pret: -'),
      orderReceived: (param) =>
        param.orderNumber !== null ? `Comanda primita (${param.orderNumber})` : 'Comanda primita (-)',
      currency: 'RON',
    },
    offerRequestTab: {
      receivedOfferRequest: (param) =>
        param.offerRequestNumber !== null
          ? `Cerere de oferta primita (${param.offerRequestNumber})`
          : 'Cerere de oferta primita (-)',
      offersSent: (offerRequestTab) =>
        `${offerRequestTab.offersSent} ` + (offerRequestTab.offersSent === 1 ? 'oferta trimisa' : 'oferte trimise'),
      offerRefused: 'Oferta refuzata',
      offerAccepted: 'Oferta acceptata',
    },
    'notification-monitoring-tooltip': 'Momentan nu exista notificari ce pot fi monitorizate',
    'notification-monitoring': 'Monitorizare notificari',
    invoiceTab: {
      paymentTerm: (invoiceTab) =>
        invoiceTab.paymentTerm
          ? `Termen plata ${invoiceTab.paymentTerm} ` + (invoiceTab.paymentTerm === 1 ? 'zi' : 'zile')
          : 'Termen plata - zile',
      invoice: 'Facturare',
      account: (invoiceTab) => (invoiceTab.account ? `Cont: ${invoiceTab.account}` : 'Cont: -'),
    },
    'delivery-monitoring': 'Monitorizare actiuni utilizatori',
    change: {
      segment_solution_created: 'A fost creata o varinata de rutare noua',
      order_status_updated: 'Statusul a fost schimbat',
      order_created: 'A fost creata comanda',
      offer_received: 'S-a primit o oferta noua',
      offer_added: 'A fost creata o oferta noua',
      mrs_created: 'S-a creat solutie complata noua',
      marked_mrs_preferred: 'O solutie completa a fost marcata ca preferata',
      invoice_created: 'A fost creata factura',
    },
  },
  'shell-app': {
    termsAndConditions: {
      validFrom: 'Data realizarii actiunii',
      title: 'Termeni și condiții & Politică de prelucrare a datelor',
      needLogin: 'Pentru a face actiuni sau vizualiza statusul acordului tau, trebuie sa te autentifici',
      acceptedMessage: 'Termenii si conditiile au fost acceptate cu success!',
      retryLater: 'Pdf-ul nu a fost inca generat, va rugam incercati mai tarziu!',
      error: {
        user_agreement_exists:
          'Termenii si conditiile au fost acceptate pentru acest user. Reincarcati pagina pentru a trece mai departe.',
        email_agreement_exists:
          'Termenii si conditiile au fost acceptate pentru aceasta adresa de email. Reincarcati pagina pentru a trece mai departe.',
        defaultValidationMessage: 'A aparut o eroare!',
      },
      accepted: 'Ai acceptat termenii și condițiile.',
      accept: 'Accepta termenii si conditiile',
    },
    navigationMenu: {
      selectItems: 'Valori predefinite',
      myCompany: 'Profil compania mea',
      logout: 'Logout',
      delivery: 'Livrari',
      crm: 'CRM',
      allCompanies: 'Toate companiile',
      saftLabel: 'SAF-T',
    },
    dashboard: {
      delivery: 'Livrari',
      crm: 'CRM',
      companyAdministration: 'Administrare companii',
      saft: 'SAF-T',
    },
    companyValidation: {
      validateCompanyDetails: 'Validati datele companiei',
      title: 'Validare date companie',
      enableCompanyValidation: 'Confirm autenticitatea datelor companiei',
      validatedMessage: 'Datele companiei au fost validate cu succes!',
    },
  },
  sharedComponents: {
    timeInterval: {
      startTime: 'HH:mm ex: 08:00',
      endTime: 'HH:mm ex: 16:00',
    },
    search: 'Cauta',
    numberInterval: {
      startNumber: 'Start...',
      endNumber: 'Sfârșit...',
    },
    'language-dialog': {
      'select-language': 'Selecteaza limba',
      language: 'Limba',
    },
    errors: {
      minLengthWaypoints: 'Adaugati minim 2 locatii',
    },
    dateRange: {
      start: 'Data start',
      end: 'Data sfarsit',
    },
    dateTimeRange: {
      start: 'Ora start',
      end: 'Ora sfarsit',
    },
    attachments: {
      invalidTotalFileSizeMessageSummary: 'Limita totala atinsa!',
      invalidTotalFileSizeMessageDetail: 'Dimensiunea tuturor fisierelor nu poate depasi 10MB.',
      invalidFileSizeMessageSummary: 'Limita atinsa!',
      invalidFileSizeMessageDetail: 'Un fisier nu poate depasi dimensiunea de 2MB.',
      fileRemoved: 'Fisierul a fost sters cu succes!',
      confirmed: 'Confirmat',
      confirmDeletionMessage: 'Sunteti sigur ca doriti sa stergeti acest fisier?',
      confirmationHeader: 'Confirmati',
    },
  },
  'shared-providers': {
    'deactivate-message': 'Aveti date nesalvate! Daca parasiti pagina acestea vor fi pierdute.',
  },
  'select-items': {
    all: 'Toate',
  },
  'select-account': 'Selecteaza cont',
  'scheduled-utils': {
    stopRecurrenceMessage: 'Esti sigur ca vrei sa opresti recurenta?',
    stopRecurrenceConfirmation: 'Confirma oprirea recurentei',
    stopRecurrence: 'Opreste recurenta',
    recurrentShipmentTooltip: 'Transport recurent pana in',
    open: 'Deschide',
    newScheduledFromTemplate: 'Creează transport programat din șablon',
    edit: 'Editeaza',
    deleteTemplateMessage: 'Esti sigur ca vrei sa stergi sablonul selectat?',
    deleteTemplate: 'Sterge sablonul',
    deleteConfirmation: 'Confirma stergerea',
    delete: 'Sterge',
    close: 'Inchide',
    add: 'Adauga',
  },
  'scheduled-shipments': {
    'filter-fields': {
      transportProject: 'Proiecte de transport',
      shipmentFlowType: 'Tip Flux',
      pickupStart: 'Data ridicare',
      pickupCompanyName: 'Companie preluare',
      pickupCity: 'Oras preluare',
      filterTags: 'Etichete',
      externalReference: 'Referinta externa',
      shipmentSeries: 'Serie transport',
      deliveryCompanyName: 'Companie predare',
      deliveryCity: 'Oras predare',
      createdAt: 'Data adaugarii',
      vendor: 'Transportator',
      type: 'Tip',
      pickupLocation: 'Locatie preluare',
      deliveryLocation: 'Locatie predare',
    },
    'empty-list': "Lista este goala.Adauga un transport programat folosind butonul 'Adauga' de mai sus.",
    'edit-scheduled-shipment': 'Editeaza transport programat',
    deleteConfirmation: 'Sunteti sigur ca doriti sa stergeti transportul programat?',
    'delete-title': 'Confirmare stergere',
    assignToMe: 'Asigneaza mie',
    assignedToMe: 'Asignate mie',
    'add-scheduled-shipment-from-template': 'Adauga transport programat din sablon',
    'add-scheduled-shipment': 'Adauga transport programat',
  },
  'scheduled-shipments-shared': {
    'invalid-order-button-tooltip': 'Selecteaza transporturi cu acelasi furnizor si moneda pe tarif ',
    filter: 'Filtreaza',
    'create-order-info-message':
      'Pentru a putea trimite o comanda, fiecare transport cu tarif trebuie sa aiba acelasi furnizor si moneda.',
    'create-order-button-text': 'Creeaza comanda',
    'create-supplier-order-button-text': 'Creeaza comanda furnizor',
    'create-offer-request-info':
      'Selecteaza minim un transport programat si/sau un sablon, apoi apasa unul din butoanele de mai jos.',
    'create-offer-request-button-text': 'Creeaza cerere de oferta',
    'change-layout': 'Schimba dimensiunile paginii',
  },
  'route-share-location': {
    'view-route': 'Vezi ruta',
    'total-package-weight': 'Greutate totala',
    'total-package-volume': 'Volum total',
    'total-package-count': 'Numar pachete',
    title: 'Distribuie un checkpoint al rutei',
    'shared-with': 'Distribuit cu',
    'shared-by': 'Distribuit de',
    'share-checkpoint': 'Distribuie',
    'sent-route-share-location': 'Checkpoint-uri distribuite trimise',
    'saved-succes': 'Checkpointul a fost salvat cu succces!',
    'received-route-share-location': 'Checkpoint-uri distribuite primite',
    'no-data-share-checkpoint': 'Nu exista checkpointuri distribuite',
    list: 'Mergi la lista',
    'future-checkpoints': 'Checkpoint-uri urmatoare',
    form: {
      'task-checkpoint-required-error': 'Selectati un checkpoint',
      partners: 'Parteneri',
      checkpoint: 'Checkpoint',
    },
    'final-destination': 'Destinatie finala',
    'driver-phone': 'Telefon sofer',
    'driver-name': 'Nume sofer',
    details: 'Detalii',
    back: 'Inapoi',
  },
  resourceSavedNavigationDialog: {
    title: 'Salvare cu success!',
    closeButton: 'Rămân în pagină',
    backButton: 'Înapoi',
  },
  'resource-dropdown': {
    utils: {
      'empty-message': 'Niciun rezultat gasit.',
    },
  },
  'resource-availability': {
    selectRole: 'Selectează rol',
    selectResType: 'Selectează tipul de resursă',
    search: 'Caută',
    resType: 'Tip resursă',
    resRole: 'Rol resursă',
    partTimeDelegation: 'Delegatie partiala',
    name: 'Nume',
    fullTimeDelegation: 'Delegatie pe toata perioada',
    department: 'Departament',
    delegation: 'Delegatie',
    availability: 'Disponibilitate',
  },
  'reporting-client-lib': {
    template: {
      xml: 'Sablon XML',
      xls: 'Sablon Excel',
      uploadXML: 'Upload sablon XML',
      uploadXLS: 'Upload sablon Excel',
      title: 'Rapoarte - Sabloane',
      parentFolder: 'Folder parinte',
      new: 'Sablon nou',
      edit: 'Editare sablon',
      createdBy: 'Upload facut de',
      create: 'Creare sablon nou',
    },
    showGeneratedReports: 'Vizualizare rapoarte generate',
    search: 'Caută',
    save: 'Salvare',
    report: {
      title: 'Rapoarte',
      template: 'Sablon',
      filter: {
        values: 'Valori',
        title: 'Filtre',
        negated: 'Negat',
        filterTypes: {
          LT: 'mai mic',
          LIKE: 'like',
          LE: 'mai mic sau egal',
          IS_NULL: 'este null',
          IN: 'in',
          GT: 'mai mare',
          GE: 'mai mare sau egal',
          EQUALS: 'egal',
          BETWEEN: 'intre',
        },
        filterType: 'Operator',
        dataType: 'Tip',
        columnName: 'Nume Coloana',
      },
      edit: 'Editare raport',
      cron: {
        weekDays: 'Selecteaza zilele saptamanii',
        title: 'Orar',
        time: 'Selecteaza ora si minutul',
        schedule: 'Program',
        months: 'Selecteaza zilele lunii',
        monthDays: 'Selecteaza lunile',
        cronExpression: 'Expresie cronologica',
      },
      create: 'Creare raport nou',
    },
    refresh: 'Reincarcare',
    private: 'Privat',
    parametrized: 'Parametrizabil',
    parameters: 'Parametrii',
    noRecords: 'Nu exista intrari',
    newFolder: 'Director nou',
    new: 'Nou',
    name: 'Nume',
    hello: 'Salut!',
    generateReport: 'Generare raport',
    generatedReports: {
      title: 'Rapoarte generate',
      executionTime: 'Durata executie',
      dataLinesNumber: 'Nr randuri',
    },
    generate: 'Genereaza',
    folder: 'Director',
    error: {
      'xml-error': 'XML invalid!',
      'xls-error': 'EXCEL invalid!',
      'validation-error': 'Erroare validare!',
    },
    edit: 'Editare',
    download: 'Descarcare',
    details: 'Detalii',
    delete: 'Stergere',
    date: 'Data',
    createReport: 'Creare raport',
    createFolder: 'Creare director nou',
    createdBy: 'Creat de',
    columns: 'Coloane',
    cancel: 'Anulare',
    back: 'Inapoi',
    authorization: 'Autorizare',
  },
  pwl: {
    yes: 'Da',
    search: 'Caută',
    save: 'Salvează',
    reset: 'Resetează',
    remove: 'Șterge',
    person_edit: 'Editează persoană',
    person_delete: 'Ștergeți această persoană?',
    person_create: 'Creează persoană',
    no: 'Nu',
    name: 'Nume',
    list_title: 'Persoane',
    idSeries: 'Serie CI',
    idNumber: 'Număr CI',
    edit: 'Editează',
    detail_title: 'Detalii persoană',
    county: 'Județ',
    confirm_delete: 'Confirmare ștergere',
    cnp: 'CNP',
    back: 'Înapoi',
    address: 'Adresa',
  },
  priceManagement: {
    utils: {
      currency: 'Moneda',
    },
    error: {
      requiredValue: 'Pretul este obligatoriu de completat!',
      requiredCurrencyCode: 'Campul Moneda este obligatoriu',
      currencyCoderequired: 'Valuta este obligatoriu de ales!',
    },
  },
  price: {
    value: 'Pret',
    currencyCode: 'Valuta',
  },
  'platform-company-contact-form': {
    send: 'Trimite',
    leaveUsAMessage: 'Lasa-ne un mesaj!',
    inputs: {
      subject: 'Subiect',
      message: 'Mesaj',
      email: 'E-mail',
      company: 'Companie',
      category: 'Categorie',
      categoriesPlaceholder: 'Selecteaza o categorie',
      categories: {
        TECHNICAL_ISSUES: 'Probleme tehnice',
        SERVICE_INFORMATION: 'Informatii despre servicii',
        QUESTION: 'Intrebare',
        OFFER_REQUEST: 'Cerere de oferta',
        FEEDBACK: 'Pareri',
        COMPLAINTS: 'Reclamatii',
        ACCOUNT_ASSISTANCE: 'Asistenta cont',
      },
    },
    error: {
      requiredSubject: 'Subiectul e-mailului este obligatoriu!',
      requiredMessage: 'Mesajul este obligatoriu!',
      requiredEmail: 'E-mailul este obligatoriu!',
      emailEmail: 'Adresa de e-mail nu este valida!',
    },
  },
  'platform-administration': {
    utils: {
      search: 'Caută',
      save: 'Salveaza',
      platformCompany: 'Companie Platforma',
      emptyMessage: 'Nu a fost gasit nici un rezultat',
      details: 'Detalii companie',
      cancel: 'Anuleaza',
      billingDetails: 'Administrare date de facturare ale platformei',
      all: 'Toate',
    },
    subscriptionHistory: {
      validTo: 'Valid pana la',
      validFrom: 'Valid din',
      typeName: 'Nume abonament',
      subscriptionPrice: 'Pret',
      subscriptionCurrency: 'Moneda',
      'list-title': 'Istoric abonamente',
    },
    legalEntity: {
      validTo: 'Valid pana la',
      validFrom: 'Valid din',
      uniqueIdNumber: 'Număr unic identificare',
      subscriptionStatus: 'Status abonament',
      subscriptionPrice: 'Pret',
      subscriptionCurrency: 'Moneda',
      paymentPeriods: {
        OVERDUE: 'Depasit',
        IN_TIME: 'In termen',
      },
      activeStatuses: {
        true: 'Activ',
        false: 'Inactiv',
      },
      overduePaymentTerm: 'Termen plata',
      'list-title': 'Abonamente companii',
      invalidateSubscription: 'Stergere abonament si date companie',
      reactivateSubscription: 'Reactiveaza abonament si date companie',
      invalidateMessage:
        'Se vor sterge abonamentul si toate detaliile despre companie! Sunteti sigur ca vreti sa continuati?',
      reactivateMessage:
        'Se va restabili abonamentul si toate detaliile despre companie! Sunteti sigur ca vreti sa continuati?',
      invalidateDialogHeader: 'Confirmare stergere date companie',
      reactivateDialogHeader: 'Confirmare reactivare date companie',
      inactive: 'Inactiv',
      dialogButtonMessages: {
        yes: 'Da',
        no: 'Nu',
      },
      'detail-title': 'Detalii companie',
      createdAt: 'Creat la data',
      companyName: 'Nume Companie',
      active: 'Activ',
    },
    invoice: {
      totalPrice: 'Pret total',
      priceCurrencyCode: 'Moneda',
      paymentTimeLimit: 'Termen plata',
      paymentStatuses: {
        UNPAID: 'Neplatita',
        PAID: 'Platita',
      },
      paymentStatus: 'Status plata',
      paymentDueDate: 'Data scadenta',
      payment: {
        paymentDate: 'Data platii',
      },
      markAsPaid: 'Marcheaza ca platita',
      'list-title': 'Istoric facturi',
      issueDate: 'Data facturarii',
      invoiceSeries: 'Serie factura',
      download: 'Descarca factura',
    },
    company: {
      'legal-entity': {
        title: 'Companie Platforma',
        inputs: {
          uniqueIdentificationNumber: 'Numar Unic De Identificare',
          registrationCode: 'Cod De Inregistrare',
          preferredLanguage: 'Limba Preferata',
          mainPhoneNumber: 'Numar De Telefon Principal',
          mainEmailAddress: 'Adresa De Email Principala',
          invoicingTerms: {
            paymentTimeLimit: 'Termen de plata',
            invoiceSeriesPrefix: 'Prefix serie factura',
          },
          companyName: 'Nume Companie',
          bankAccount: {
            swiftCode: 'Cod Swift',
            iban: 'IBAN',
            currencyCode: 'Moneda',
            bankName: 'Banca',
          },
          address: {
            state: 'Judet',
            postalCode: 'Cod Postal',
            country: 'Tara',
            city: 'Oras',
            addressLine: 'Linie adresa',
          },
        },
        errors: {
          requiredUniqueIdentificationNumber: "Campul 'Numar Unic de Identificare' este obligatoriu",
          requiredRegistrationCode: "Campul 'Cod de Inregistrare' este obligatoriu",
          requiredPreferredLanguage: "Campul 'Limba Preferata' este obligatoriu",
          requiredCompanyName: "Campul 'Nume Companie' este obligatoriu",
        },
      },
    },
  },
  place: {
    searchOnGoogle: 'Cauta pe google maps',
  },
  personManagement: {
    input: {
      name: 'Nume',
      idSeries: 'Serie ID',
      idNumber: 'Numar ID',
      error: {
        requiredName: 'Campul Nume este obligatoriu',
        requiredCounty: 'Campul Judet este obligatoriu',
      },
      county: 'Judet',
      country: 'Tara',
      address: 'Adresa',
    },
  },
  person: {
    idSeries: 'Serie ID',
    idNumber: 'Numar ID',
  },
  pdf: {
    yes: 'Da',
    uploadFile: 'Adaugă fișier',
    template: 'Șablon',
    search: 'Caută',
    save: 'Salvează',
    remove: 'Șterge ordinul',
    pdf_delete: 'Sigur vreți să ștergeți acest șablon?',
    no: 'Nu',
    name: 'Nume',
    list_title: 'Listă șabloane PDF',
    key: 'Cheie',
    error: {
      startDateAfterEndDate: 'Data de sfarsit trebuie sa fie mai mare calendaristic decat data de inceput!',
      requiredresources: 'Trebuie aleasa minim o resursa!',
      requireddates: 'Trebuie sa fie aleasa atat o data de inceput cat si de sfarsit a alocarii!',
      required: 'Campul este obligatoriu de completat!',
      defaultValidationMessage: 'A apărut o eroare. Verifică datele introduse și încearcă din nou',
    },
    edit_title: 'Șablon PDF',
    edit: 'Editează șablonul',
    date: 'Data',
    create: 'Adaugă șablon nou',
    confirm_selection: 'Confirmă selecția',
    confirm_delete: 'Confirmă ștergerea',
    children: 'Șabloane secundare',
    cancel: 'Anulează',
    back: 'Înapoi',
    author: 'Autor',
  },
  paymentTermBannerMessage: 'Termenul de plata pentru ultima factura emisa de platforma a expirat',
  'payments-per-invoice': {
    utils: {
      search: 'Cauta',
      all: 'Toate',
    },
    list: {
      toBankAccount: 'Catre contul',
      title: 'Plati pe factura',
      paymentStatusType: 'Status plata',
      paymentStatuses: {
        deallocated: 'Dezalocata',
        canceled: 'Anulata',
        accepted: 'Acceptata',
      },
      paymentDate: 'Data platii',
      paidAmount: 'Suma platita',
      invoiceSeries: 'Serie factura',
      fromBankAccount: 'Din contul',
      currencyCode: 'Moneda',
    },
  },
  'payment-method': {
    retry: 'Reluati Plata',
    refresh: 'Reincarca',
    'pending-payment-method': 'Cardul dumneavoastra este in curs de verificare. Incercati mai tarziu',
    'payment-order': 'Ordin de plata',
    'payment-method': 'Metoda de plata',
    'long-processing-warning': 'Procesarea platii dureaza mai mult decat de obicei',
    'failed-payment-method': 'Autorizarea cardului a esuat. Va rugam reincercati',
    'change-payment-method': 'Schimbati metoda de plata',
  },
  order: {
    tariffs: 'Tarife',
    price: 'Pret',
    orderNumber: 'Numar comanda',
    'navigation-suggestions': {
      back: 'Inapoi',
    },
    invalidShipmentTariffs: 'Fiecare transport trebuie sa aiba un tarif selectat',
    invalidCurrencyShipments: 'Tarifele transporturilor trebuie sa aiba aceeasi moneda',
    errors: {
      requiredVendor: 'Campul este obligatoriu',
    },
    details: 'Detalii comanda',
    specialConditions: 'Conditii speciale',
    orderExternalPackages: 'Pachete scanate ad-hoc',
    customerName: 'Nume client',
    currencyCode: 'Moneda',
    contract: 'Contract',
    contactsMissing: 'Fiecare transport trebuie sa aiba campurile de contact completate',
    clientOrders: 'Comenzi client',
    'add-page-title': 'Adauga comanda noua',
    addOrderSubcontractingPageTitle: 'Subcontracteaza cu comanda noua',
    'add-internal-page-title': 'Adauga comanda interna noua',
    addPreOrderPageTitle: 'Adauga pre-comanda noua',
    addPreOrderSubcontractingPageTitle: 'Subcontracteaza cu pre-comanda noua',
  },
  'order-consolidation': {
    viewOrder: 'Vezi comanda primita',
    order: 'Comanda',
    customerOrders: 'Comenzi client',
  },
  'offer-request': {
    'sp-offer-request-reject': {
      title: 'Refuza Cerere de oferta',
      'reject-status': 'Motiv refuz',
    },
  },
  notification: {
    DELIVERY_ORDER_STATUS_CHANGED_FOR_CUSTOMER: 'Mail Status Comanda Schimbat',
    DELIVERY_ORDER_SENT: 'Mail Comanda Trimisa',
    DELIVERY_ORDER_RECEIVED: 'Mail Comanda Primita',
    DELIVERY_ORDER_HANDOVER_SP_ALERT_MAIL: 'Mail Alert Handover',
    DELIVERY_ORDER_HANDOVER_ALERT_MAIL: 'Mail Alerta Handover',
    DELIVERY_ORDER_CANCEL_REQUEST_REJECTED: 'Mail Respingere Cerere de Anulare',
    DELIVERY_ORDER_CANCEL_REQUEST: 'Mail Cerere de Anulare',
    DELIVERY_ORDER_CANCEL: 'Mail Comanda Anulata',
    DELIVERY_OFFER_REQUEST_CREATED_FOR_EXTERNAL_VENDOR: 'Mail Cerere de Oferta Noua',
    DELIVERY_OFFER_REFUSED_FOR_VENDOR_MAIL: 'Mail Oferta Refuzata',
    DELIVERY_OFFER_NEGOTIATION_MAIL: 'Mail Negociere Oferta ',
    DELIVERY_OFFER_CREATED_FOR_EXTERNAL_CUSTOMER: 'Mail Oferta Noua',
    COMPANY_TERMS_AND_CONDITIONS_AGREEMENT_EMAIL: 'Mail Acceptare Termeni si Conditii',
    COMPANY_DETAILS_EMAIL: 'Mail Invitare in Platforma',
    AUTH_USER_PASSWORD_RECOVERY: 'Mail Recuperare Parola',
    AUTH_USER_EMAIL_CONFIRMATION: 'Mail Confirmare Email',
    AUTH_SUPER_ADMIN_USER_EMAIL_CONFIRMATION: 'Mail Confirare Email Super Admin',
  },
  'notification-ui': {
    title: 'Notificari',
    delete: 'Sterge',
  },
  notif: {
    utils: {
      tableEmptyMessage: 'Nu a fost găsit nici un rezultat',
      search: 'Caută',
      all: 'Toate',
    },
    username: 'Nume utilizator',
    type_params: 'Param. tip',
    type: 'Tip',
    subject: 'Subiect',
    status: {
      SENT: 'Trimisă',
      SENDING: 'În trimitere',
      SEEN: 'Vazută',
      PENDING: 'În așteptare',
      FAILED_TO_SEND: 'Nu s-a putut trimite',
    },
    sentList: {
      title: 'Notificări trimise',
      subject: 'Subiect',
      status: 'Status notificare',
      senderType: 'Tip notificare',
      recipientAddress: 'Destinatar',
      processingStatus: 'Status procesare',
      eventType: 'Nume notificare',
      entityUuid: 'ID Entitate',
      createdAt: 'Creat la data',
    },
    senderType: {
      PUSH: 'Notificare de sistem',
      IN_APP: 'Notificare în aplicație',
      EMAIL_WITH_ATCH: 'Email cu atașament',
      EMAIL: 'Email',
      SES_EMAIL: 'SES Email',
      SES_EMAIL_WITH_ATTACH: 'SES Email cu atașament',
    },
    senders: 'Sendere',
    sender_type: 'Tip sender',
    recipients: 'Destinatari',
    protocol: 'Protocol',
    properties: 'Proprietǎți',
    processingStatus: {
      PROCESSING: 'Se procesează',
      PROCESSED: 'Procesată',
      PENDING: 'În așteptare',
      FAILED_TO_PROCESS: 'Nu s-a putut procesa',
    },
    processing_status: 'Status procesare',
    port: 'Port',
    password: 'Parolǎ',
    notifications_list: 'Notificǎri',
    notifiable_event: 'Eveniment',
    notif_sender_config_list: 'Configurații sendere',
    notif_config_list: 'Configurații notificǎri',
    msg: {
      delete: 'Sigur vreți sǎ ștergeți inregistrarea?',
    },
    mail_acc_list: 'Conturi mail',
    host: 'Host',
    group_content_template: 'Template continut grup',
    group_content: 'Continut grup',
    expected_type_params: 'Parametri tip',
    event_type: 'Tip eveniment',
    edit_config: 'Editeaza configuratia',
    description: 'Descriere',
    delete_confirmation: 'Confirmǎ ștergerea',
    default_recipients: 'Recipienti impliciti',
    date: 'Data',
    content_template: 'Template continut',
    content_params: 'Param. continut',
    config_params: 'Setǎri',
    body: 'Body',
    add_new_config: 'Adaugǎ configurație nouǎ',
    add_new_acc: 'Adaugǎ cont nou',
    _eventType: {
      MISSING_TIMEKEEPING_MANAGEMENT: 'Absențǎ pontaj - manageri',
      MISSING_TIMEKEEPING_ENTRIES: 'Absențǎ pontaj',
      DELEGATION_ORDER_AWAITING_APPROVAL: 'Ordine deplasare in asteptare',
      DELEGATION_ORDER_APPROVED_OR_REJECTED: 'Aprobare/Respingere ordin deplasare',
    },
  },
  'not-found': {
    title: 'Pagina nu a fost gasita!',
    message: 'Din pacate, pagina pe care o cauti nu exista.',
    errorMessage: '404',
    back: 'Intoarceti-va la Dashboard',
  },
  legalEntity: {
    selectCountry: 'Selecteaza o tara',
    noCompanyFound: 'Nu ati gasit compania? Adăugați o companie manual',
    inputs: {
      vatSplitStatus: 'Plată defalcată TVA',
      vatRegistration: 'Plătitor TVA',
      vatInactiveStatus: 'Inactiv (TVA)',
      vatInactivationDate: 'Inactiv (TVA) de la',
      uniqueIdNumber: 'Număr unic de identificare',
      registrationCode: 'Nr. de ordine Registrul Comertului',
      preferredLanguage: 'Limbă',
      officeAddress: 'Sediu social',
      mainPhone: 'Telefon principal',
      mainEmailAddress: 'Email Principal',
      mainAddress: 'Adresă principală',
      industryType: 'Tip industrie',
      financialAddress: 'Domiciliu fiscal',
      emailImportSettings: 'Email Import Settings',
      country: 'Țară',
      companyName: 'Nume Companie',
      city: 'Localitate',
    },
    existentAnafCompanyLabel:
      'Datele companiei ar putea exista în platformă, acestea fiind importate din platforma ANAF',
    error: {
      requiredUniqueIdNumber: 'Câmpul Număr unic de identificare este obligatoriu',
      requiredPreferredLanguage: 'Câmpul Limbă este obligatoriu',
      requiredOfficeAddressDTO: 'Câmpul Sediu social este obligatoriu',
      invalidOfficeAddressDTO: 'Completati toate campurile obligatorii',
      requiredFinancialAddressDTO: 'Câmpul Domiciliu fiscal este obligatoriu',
      invalidFinancialAddressDTO: 'Completati toate campurile obligatorii',
      requiredCountry: 'Câmpul Țară obligatoriu',
      requiredCompanyName: 'Câmpul Nume Companie este obligatoriu',
      noLegalEntityCreated:
        'Pentru a salva detaliile companiei, completați numele sau CUI-ul companiei și selectați una dintre opțiunile afișate. Dacă nu apare compania cautată, apăsați butonul de Adaugă companie nouă',
      patternUniqueIdNumber: 'Campul trebuie sa contina minim 2 cifre si sa nu contina spatii albe',
    },
    country: 'Țară',
    confirmationDialog: {
      dialogMessage: 'Informatia selectată este oficială și preluată de la ANAF',
      dialogHeader: 'Modificare date ANAF',
      cancelLabel: 'Renunță',
      acceptLabel: 'Doresc să modific',
    },
    closeInputs: 'Înapoi la căutare companie',
    autocompletePlaceholder: 'Caută companie existentă în platformă',
    autocomplete: 'Nume sau CUI',
    addManualCompany: 'Adăugați o companie manual',
  },
  job: {
    utilizationHint: {
      UTILIZATION_MINOR: 'Minor',
      UTILIZATION_MAJOR: 'Major',
      UTILIZATION_DEFAULT: 'Implicit',
      UTILIZATION_CONSIDERABLE: 'Considerabil',
    },
    utilization: 'Nivel utilizare',
    status: 'Status',
    search: 'Caută...',
    retry: 'Reexecuta',
    priority: 'Prioritate',
    prerequisistes: 'Executa dupa:',
    parameterType: {
      STRING: 'STRING',
      NUMERIC: 'NUMERIC',
      DATE: 'DATE',
      BOOLEAN: 'BOOLEAN',
    },
    options: 'Opțiuni',
    log_executions: {
      thread_name: 'Fir de execuție',
      processing_started_at: 'Data incepere',
      processing_ended_at: 'Data terminare',
      originator_system: 'Sistem de origine',
      logger_name: 'Nume logger',
      log_message: 'Mesaj Log',
      log_level: 'Nivel Log',
      log_executions: 'Log execuție',
      execution_duration: 'Durata executie',
    },
    lastTriggeredAt: 'Ultima executie',
    job_name: 'Nume job',
    job_executions: {
      processing_started_at: 'Procesare începută la',
      processing_ended_at: 'Procesare finalizată la',
      priority: {
        Medium: 'Medie',
        Lowest: 'Cea mai scăzută',
        Lower: 'Mai scăzută',
        Low: 'Scăzută',
        Highest: 'Cea mai crescută',
        Higher: 'Mai crescută',
        High: 'Crescută',
        Default: 'Implicită',
      },
      originator_system: 'Sistem originar',
      jobExecutionStatus: {
        WAITING: 'Așteaptă alte joburi',
        SUCCESSWITHWARNING: 'Succes cu avertizare',
        SUCCESS_WITH_WARNING: 'Succes cu avertizare',
        SUCCESS: 'Succes',
        STOPPING: 'Se oprește',
        PROCESSING: 'Procesare',
        PENDING: 'În așteptare',
        HALTED: 'Oprit',
        ERROR: 'Eroare',
      },
      job_executions: 'Execuție joburi',
      execution_duration: 'Durată execuție',
      cron_expression: 'Expresie cronologica',
    },
    job_descr: 'Descriere',
    job_definitions: {
      status: {
        TRIGGERED: 'Declanșat',
        SCHEDULED: 'Programat',
        NOT_TRIGGERED: 'Nedeclanșat',
        INTERRUPTED_TRIGGERED: 'Declansat',
        INTERRUPTED: 'Intrerupt',
        ARCHIVED: 'Arhivat',
      },
      job_parameters: 'Parametrii joburi',
      job_definitions: 'Joburi Programate',
    },
    job: 'Job',
    exception_details: 'Detalii exceptie',
    details: 'Detalii',
    date: {
      start: 'Start...',
      end: 'Sfârșit...',
    },
    createdAt: 'Creat',
    _priority: {
      Medium: 'Medie',
      Lowest: 'Cea mai scăzută',
      Lower: 'Mai scăzută',
      Low: 'Scăzută',
      Highest: 'Cea mai crescută',
      Higher: 'Mai crescută',
      High: 'Crescută',
      Default: 'Implicită',
    },
  },
  'issue-reporter': {
    user: 'Utilizator',
    type: 'Tip problema',
    'text-notes-description': '(optional) pozitionati-va pe elementul eronat, selectati-l si adaugati o descriere',
    'text-notes': 'Selecteaza elemente care contin probleme',
    summary: 'Rezumat',
    submit_feedback: 'Trimite feedback',
    submit_comment: 'Submit comment',
    'paint-description': '(optional) puteti sublinia, incercui, trasa sageti etc.',
    paint: 'Deseneaza',
    message: 'Message',
    'form-description': 'se introduce problema principala intampinata',
    form: 'Formular',
    description: 'Descriere',
    actions_description: 'Descriere meniu actiuni',
  },
  'invoice-payment': {
    utils: {
      yes: 'Da',
      search: 'Cauta',
      no: 'Nu',
      confirm: 'Confirmati actiunea',
      all: 'Toate',
    },
    'reject-payment-form': {
      reason: 'Motivul respingerii',
    },
    'payment-form': {
      toBankAccount: 'Catre contul',
      paymentReference: 'Referinta plata',
      paymentDate: 'Data platii',
      paidAmount: 'Suma',
      fromBankAccount: 'Din contul',
      currency: 'Moneda',
    },
    'new-per-invoice': {
      title: 'Adauga incasare pe factura',
      infoText: (params) => {
        const { invoiceSeries, remainingCost, currencyCode } = params;
        if (invoiceSeries && invoiceSeries.length > 1) {
          const formattedInvoiceSeries = invoiceSeries
            .map((series: any, index: any) => `${index + 1}.${series}`)
            .join(', ');
          return `Efectueaza incasare pentru facturile cu seriile ${formattedInvoiceSeries}. Suma ramasa de incasat ${remainingCost} ${currencyCode}`;
        }
        return `Efectueaza incasare pentru factura cu seria ${invoiceSeries[0]}. Suma ramasa de incasat ${remainingCost} ${currencyCode}`;
      },
    },
    'mark-as-paid': {
      title: 'Marcheaza ca incasat',
      customer: {
        title: 'Marcheaza ca platit',
      },
    },
    list: {
      toBankAccount: 'Catre contul',
      sold: 'Sold',
      serviceProviderName: 'Nume furnizor',
      sendPaymentDoneMail: 'Trimite plata pe mail',
      'receipts-title': 'Incasari',
      paymentStatuses: {
        deallocated: 'Dezalocata',
        canceled: 'Anulata',
        accepted: 'Acceptata',
      },
      paymentStatus: 'Status plata',
      'payments-title': 'Plati',
      paymentReference: 'Referinta plata',
      paymentDate: 'Data platii',
      paymentAgreementStatuses: {
        rejected: 'Respinsa',
        pending: 'In asteptare',
        finalized: 'Finalizata',
      },
      paymentAgreementStatus: 'Status intelegere',
      paidAmount: 'Suma platita',
      openPartialPayments: 'Deschide platile intermediare',
      invoiceSeries: 'Serie factura',
      invoicePaymentStatus: {
        UNPAID: 'Neplatita',
        PARTIAL_PAID: 'Platita partial',
        PAID: 'Platita',
      },
      invoiceDetailsTooltip: 'Click pentru detalii factura',
      fromBankAccount: 'Din contul',
      deallocatePayment: 'Dezaloca',
      customerName: 'Nume client',
      currencyCode: 'Moneda',
      createdBy: 'Efectuata de',
      cancelPayment: 'Anuleaza',
      canceledBy: 'Anulata de',
      acceptPaymentMessage: 'Sunteti sigur ca doriti sa acceptati plata? Aceasta actiune este ireversibila!',
    },
    filters: {
      paymentAgreementStatusPending: 'Incasari in asteptare',
    },
    errors: {
      requiredToBankAccountUuid: 'Campul Catre contul este obligatoriu',
      requiredPaymentDate: 'Campul Data platii este obligatoriu',
      requiredPaidAmount: 'Campul Suma este obligatoriu',
      requiredFromBankAccountUuid: 'Campul Din contul este obligatoriu',
      requiredCurrencyCode: 'Campul Moneda este obligatoriu',
      maxValueExceeded: 'Valoarea nu trebuie sa depaseasca totalul ramas',
    },
    'deallocate-payment-form': {
      errors: {
        requiredDeallocateReason: 'Campul Motivul dezalocarii este obligatoriu',
      },
      deallocateReason: 'Motivul dezalocarii',
    },
    customer: {
      title: 'Adauga plata pe factura',
      infoText: (params) => {
        const { invoiceSeries, remainingCost, currencyCode } = params;
        if (invoiceSeries && invoiceSeries.length > 1) {
          const formattedInvoiceSeries = invoiceSeries
            .map((series: any, index: any) => `${index + 1}.${series}`)
            .join(', ');
          return `Efectueaza plata pentru facturile cu seriile ${formattedInvoiceSeries}. Suma ramasa de plata ${remainingCost} ${currencyCode}`;
        }
        return `Efectueaza plata pentru factura cu seria ${invoiceSeries[0]}. Suma ramasa de plata ${remainingCost} ${currencyCode}`;
      },
    },
    'cancel-payment-form': {
      errors: {
        requiredCancelReason: 'Campul Motivul anularii este obligatoriu',
      },
      cancelReason: 'Motivul anularii',
    },
    actions: {
      reject: 'Refuza',
      accept: 'Accepta',
    },
  },
  'invoice-payment-reject': {
    title: 'Respinge plata',
  },
  'invoice-payment-deallocate': {
    title: 'Dezaloca plata',
  },
  'invoice-partial-payments': {
    list: {
      title: 'Plati partiale pe facturi',
    },
  },
  'invoice-cancel': {
    title: 'Anuleaza plata',
    description: 'Anuleaza plata',
  },
  integ: {
    upload: 'Incarca',
    msg: {
      q_delete_import_def:
        'Sigur stergeti aceasta definitie de import? Se vor sterge si toate intrarile corespunzatoare din jurnalul de executie.',
    },
    label: 'Label',
    import_parameters: 'Parametri',
    import_label: 'Label import',
    import_execution_list: 'Importuri executate',
    import_definition_list: 'Definitii importuri',
    execution_status: 'Status executie',
    execution_details: 'Detalii executie',
    edit_import_def: 'Editeaza definitie import',
    duration: 'Durata',
    description: 'Descriere',
    owner: 'Companie',
    delete: 'Sterge',
    date: 'Data',
    create_import_def: 'Defineste import nou',
    cancel: 'Anuleaza',
    all_values: 'Toate',
    _executionStatuses: {
      SUCCESS: 'Succes',
      FAILURE: 'Esec',
      FAILED: 'Esec',
    },
  },
  'http-error-interceptor': {
    ETransportNotificationInvalidStateException:
      'Starea eTransportului a fost schimbata intre timp. Reincarcati pagina.',
    SingleCompanyContactsSelectedException: 'Nu ati selectat contacte pentru ambele companii',
    sent: 'Trimisa',
    MissingAppropriateAddressException: 'Nu exista adresa principala sau de corespondenta pentru aceasta companie',
    InvalidOrderStatusTransitionException: (params) =>
      `Comanda nu poate trece din statusul ${params.param0} in statusul ${params.param1}`,
    in_transit: 'In preluare',
    in_progress: 'In desfasurare',
    GENERAL: 'GENERAL',
    documents_received: 'Documente transmise',
    CostCenterDuplicateLabelException: 'Exista un centru de cost cu acest nume',
    EmployeeUserPhoneNotFoundException: 'Utilizatorul asociat angajatului selectat nu are un numar de telefon validat',
    completed: 'Finalizata',
    cancelled: 'Anulata',
    archived: 'Arhivata',
    OperationalTerritoryPartnerNamedLocationDuplicateException:
      'Cateva asocieri partener-locatie exista deja pe alt teritoriu activ',
  },
  greeting: 'salut!',
  'gps-tracking': {
    tooltip: 'Monitorizare rute vehicul',
    title: (param) => `Monitorizare vehicul: ${param.licensePlate}`,
    monitoringInterval: 'Interval monitorizare vehicul: ',
    interval: {
      startDate: 'Inceput interval',
      endDate: 'Sfarsit interval',
    },
  },
  globalFilter: {
    minimizeFilters: '<<',
    expandFilters: '<<',
  },
  globalAccount: 'Cont global',
  generalErrors: {
    isNotServiceProvider:
      'Compania dumneavostra nu este Service Provider. Pentru a activa aceasta optiune intrati in profilul companiei',
  },
  fwl: {
    yes: 'Da',
    search: 'Caută',
    save: 'Salvează',
    reset: 'Resetează',
    remove: 'Șterge',
    phone: 'Telefon',
    nrComReg: 'Număr registru comerț',
    no: 'Nu',
    name: 'Nume',
    list_title: 'Firme',
    firm_edit: 'Editează firmă',
    firm_delete: 'Ștergeți această firmă?',
    firm_create: 'Creează firmă',
    fax: 'Fax',
    edit: 'Editează',
    detail_title: 'Detalii firma',
    createBankAccount: 'Creează cont bancar',
    county: 'Județ',
    confirm_delete: 'Confirmare ștergere',
    cif: 'Cif',
    capital: 'Capital',
    bankAccounts: 'Conturi Bancare',
    bank: 'Bancă',
    back: 'Înapoi',
    address: 'Adresa',
    account: 'Cont',
  },
  footer: {
    usefulLinks: {
      termsAndConditions: 'Termeni si conditii',
      privacyPolicy: 'Politica de confidentialitate',
      links: 'Link-uri utile',
      cookiePolicy: 'Politica cookie',
      ANPC: 'ANPC',
    },
    contactUs: 'Contacteaza-ne!',
    companyDetails: 'Detalii companie',
  },
  fileStorage: {
    dragAndDrop: 'Drag n Drop',
  },
  'exception-web-lib': {
    system_name: 'Sistem',
    stack_trace: 'Detalii excepție',
    search: 'Cauta...',
    message: 'Mesaj',
    list_of_exceptions: 'Lista excepțiior',
    exception_list: 'Exceptii',
    date: 'Data',
    author: 'Autor',
  },
  etransport: {
    declarant: {
      messages: 'Mesaje ANAF',
      list: {
        type: 'Tip',
        status: 'Stare',
        uit: 'UIT',
        declarationCode: 'Cod declarație',
        declarationReference: 'Referință declarație',
        postDamage: 'Status post avarie',
        source: 'Sursă',
        loadId: 'Id încărcare',
        creationDate: 'Data creare',
        modificationDate: 'Data modificare',
        operationType: 'Tip operațiune',
        transportDate: 'Data transport',
        pickupCountry: 'Țară ridicare',
        pickupCode: 'Cod ridicare',
        pickupName: 'Nume ridicare',
        deliveryCountry: 'Țară livrare',
        deliveryCode: 'Cod livrare',
        deliveryName: 'Nume livrare',
        vehicleModificationDate: 'Data modificare vehicul',
        vehicleNumber: 'Număr vehicul',
        trailer1Number: 'Număr remorcă 1',
        trailer2Number: 'Număr remorcă 2',
        vehicleModifications: 'Modificări vehicul',
        lineCount: 'Număr linii',
        totalNetWeight: 'Greutate totală netă',
        totalGrossWeight: 'Greutate totală brută',
        totalValue: 'Valoare totală',
        confirmation: 'Confirmare',
        messages: 'Mesaje',
        expiresIn: 'Expira in',
        expired: 'Expirat',
        actions: {
          seeVehicleModificationsAndAnafMessages: 'Vizualizare detalii mesaje',
        },
      },
      modifiedVehicleMessagesAndMessages: {
        title: 'Detalii',
      },
      vehicleModifMessages: {
        title: 'Mesaje modificari vehicule',
        dataModifVeh: 'Data',
        nrVeh: 'Număr vehicul',
        nrRem1: 'Număr remorcă 1',
        nrRem2: 'Număr remorcă 2',
        codDecl: 'Cod declarație',
        refDecl: 'Referință declarație',
        postAvarie: 'Status post avarie',
        sursa: 'Sursa',
        dataDecl: 'Data declarație',
        idIncarcare: 'ID încărcare',
        obs: 'Observații',
      },
      anafMessages: {
        title: 'Mesaje',
        tip: 'Tip',
        mesaj: 'Mesaj',
      },
    },
    uploadStatuses: {
      UPLOAD_SUCCESS: 'Succes',
      UNSENT: 'Netrimis',
      ERROR: 'Eroare',
      CONVERSION_ERROR: 'Eroare de conversie',
      COMMUNICATION_ERROR: 'Eroare de comunicare',
      AUTHORIZATION_ERROR: 'Eroare de autorizare',
      CANCEL_SUCCESS: 'Anulat',
    },
    integration: {
      uploadStatus: 'Status incarcare',
      uit: 'Codul UIT',
      title: 'eTransport',
      cancelConfirmationMessage: 'Sunteti siguri ca doriti sa anulati avizul?',
      resendButton: 'Retrimite eTransport',
      notificationButton: 'Adauga eTransport',
      uploadButton: 'Trimite eTransport',
      uploadButtonTooltip: 'Avizul nu este complet pentru a fi trimis',
      modifVehicleButton: 'Modifica vehicul',
      checkStatus: 'Status verificare',
      checkButton: 'Verifica starea',
      duplicateButton: 'Duplica eTransport',
      cancelButton: 'Anuleaza',
      deleteButton: 'Sterge',
      commercialDataInvitationEmail: 'Colaborare date comerciale',
      shipmentDataInvitationEmail: 'Colaborare date transport',
      moreDetailsMessage: 'Pentru mai multe detalii, folositi butonul de mai jos.',
      anafMessage: 'Mesaj',
      notificationDetails: 'Detalii eTransport',
      uits: 'UIT-uri',
      defaultStatusLabel: 'Netrimis/Neverificat',
      emailCommercialPartner: 'Trimite detalii la partener comercial',
      disabledEmailCommercialPartner:
        'UIT-ul trebuie sa fie valid, in perioada de valabilitate si sa fie selectate contacte pentru partenerul comercial',
      disabledEmailShipmentOrganizer:
        'UIT-ul trebuie sa fie valid, in perioada de valabilitate si sa fie selectate contacte pentru organizatorul de transport',
      emailShipmentOrganizer: 'Trimite detalii la organizator',
      downloadPdf: 'Descarca PDF',
      anafSearch: 'Cauta pe serverul ANAF',
    },
    nullUitMessage: 'Neobtinut',
    modifVehicle: {
      title: 'Modificare vehicul eTransport',
      modifyDateSuggestion: 'Data nu poate depasi perioada de valabilitate a UIT-ului si nu poate fi in trecut',
      notificationVehicle: 'Vehicul notificare eTransport',
      form: {
        licensePlate: 'Nr. auto',
        firstTrailerLicensePlate: 'Nr. auto prima remorca',
        secondTrailerLicensePlate: 'Nr. auto a 2-a remorca',
        modificationDate: 'Data modificare',
        observations: 'Observatii',
        errors: {
          requiredModificationDate: "Campul 'Data modificare' este obligatoriu",
          requiredLicensePlate: "Campul 'Nr. auto' este obligatoriu",
          patternLicensePlate:
            'Campul trebuie să aibă între 2 și 20 de caractere și să conțină doar litere mari și cifre.',
          patternFirstTrailerLicensePlate:
            'Campul trebuie să aibă între 2 și 20 de caractere și să conțină doar litere mari și cifre.',
          patternSecondTrailerLicensePlate:
            'Campul trebuie să aibă între 2 și 20 de caractere și să conțină doar litere mari și cifre.',
        },
      },
    },
    details: 'Detalii eTransport',
    form: {
      title: 'Adauga eTransport',
      editTitle: 'Editeaza eTransport',
      legendRequiredForSending: 'Campurile sunt obligatorii pentru a putea TRIMITE un eTransport.',
      legendRequiredForSaving: 'Campurile sunt obligatorii pentru a putea SALVA un eTransport (ex: Tip operatiune).',
      shipmentDocument: {
        title: 'Documente transport',
        observations: 'Observatii',
        documentTypes: {
          10: 'CMR (10)',
          20: 'Factura (20)',
          30: 'Aviz de însoțire a mărfii (30)',
          9999: 'Altele (9999)',
        },
        errors: {
          requiredObservations: "Campul 'Observatii' este obligatoriu",
          requiredDocumentType: "Campul 'Tip document' este obligatoriu",
          requiredDocumentDate: "Campul 'Data document' este obligatoriu",
          maxLength50: 'Campul nu poate depasi 50 de caractere',
          maxLength200: 'Campul nu poate depasi 200 de caractere',
        },
        documentType: 'Tip document',
        documentTitle: 'Document',
        documentNumber: 'Numar document',
        documentDate: 'Data document',
        add: 'Adauga document transport',
      },
      shipmentData: {
        transporterCountry: 'Tara transportator',
        title: 'Date transport',
        shipmentOrganizerName: 'Nume organizator transport',
        shipmentOrganizerCode: 'CUI',
        shipmentOrganizerAsIndividual: 'Persoana fizica',
        shipmentDateTooltip:
          'Data transportului trebuie sa fie data la care transportul incepe, daca acesta incepe de pe teritoriul romaniei, sau data la care acesta intra pe teritoriul romaniei',
        shipmentDate: 'Data transport',
        secondTrailerLicensePlate: 'Nr. auto a 2-a remorca',
        licensePlate: 'Nr. auto',
        firstTrailerLicensePlate: 'Nr. auto prima remorca',
        contacts: 'Contacte organizator transport',
        errors: {
          requiredTransporterCountry: "Campul 'Tara transportator' este obligatoriu",
          requiredShipmentOrganizerName: "Campul 'Nume organizator transport' este obligatoriu",
          requiredShipmentOrganizerCountryCode: "Campul 'Tara transportator' este obligatoriu",
          requiredShipmentDate: "Campul 'Data transport' este obligatoriu",
          requiredLicensePlate: "Campul 'Nr. auto' este obligatoriu",
          patternLicensePlate:
            'Campul trebuie să aibă între 2 și 20 de caractere și să conțină doar litere mari și cifre.',
          patternFirstTrailerLicensePlate:
            'Campul trebuie să aibă între 2 și 20 de caractere și să conțină doar litere mari și cifre.',
          patternSecondTrailerLicensePlate:
            'Campul trebuie să aibă între 2 și 20 de caractere și să conțină doar litere mari și cifre.',
          maxLength20: 'Campul nu poate depasi 20 de caractere',
          maxLength30: 'Campul nu poate depasi 30 de caractere',
          maxLength200: 'Campul nu poate depasi 200 de caractere',
          patternShipmentOrganizerCode: 'Campul trebuie sa contina minim 2 cifre si sa nu contina spatii albe',
        },
      },
      packages: {
        valueWithoutVAT: 'Valoare lei fara TVA',
        unitMeasurement: 'Unitate masura',
        title: 'Produse',
        addProduct: 'Adauga produs',
        changeLayout: 'Schimba formatul produselor',
        copyValueToAll: 'Aplica aceasta valoare la toate produsele',
        refDeclarant: 'Referinta declarant',
        operationPurpose: 'Scop operatiune',
        netWeight: 'Greutate neta (kg)',
        grossWeight: 'Greutate bruta (kg)',
        unitPrice: 'Pret unitar',
        productsResume: 'Rezumat produse',
        exchangeRate: 'Curs valutar',
        getBnrExchangeRate: 'Preia curs valutar BNR',
        successfulExchangeRateMessage: 'Curs valutar actualizat! Verificati datele.',
        convertToLeiMessage: 'Converteste din moneda alternativa in Lei',
        operationPurposes: {
          1001: 'Investiție în curs (1001)',
          101: 'Comercializare (101)',
          1101: 'Donații, ajutoare (1101)',
          201: 'Producție (201)',
          301: 'Gratuități (301)',
          401: 'Echipament comercial (401)',
          501: 'Mijloace fixe (501)',
          601: 'Consum propriu (601)',
          703: 'Operațiuni de livrare cu instalare (703)',
          704: 'Transfer între gestiuni (704)',
          705: 'Bunuri puse la dispoziția clientului (705)',
          801: 'Leasing financiar/operațional (801)',
          802: 'Bunuri în garanție (802)',
          901: 'Operațiuni scutite (901)',
          9901: 'Altele (9901)',
          9999: 'Același cu operațiunea (9999)',
        },
        measurementUnitTranslation: '',
        measurementUnit: {
          null: '-',
          '10': 'Grup (10)',
          '11': 'Ţinută (11)',
          '13': 'Ratia (13)',
          '14': 'Doză (14)',
          '15': 'Stick, militar (15)',
          '20': 'Container (20ft) (20)',
          '21': 'Container (40ft) (21)',
          '22': 'Decilitru pe gram (22)',
          '23': 'Gram pe centimetru cub (23)',
          '24': 'Livră teoretică (24)',
          '25': 'Gram pe centimetru pătrat (25)',
          '27': 'Tonă teoretică (27)',
          '28': 'Kilogram pe metru pătrat (28)',
          '33': 'Kilopascal pătrat metru pe gram (33)',
          '34': 'Kilopascal pe milimetru (34)',
          '35': 'Mililitru pe centimetru pătrat secundă (35)',
          '37': 'Uncie pe metru pătrat (37)',
          '38': 'Uncie pe metru pătrat la 0,01 inci (38)',
          '40': 'Mililitru pe secundă (40)',
          '41': 'Mililitru pe minut (41)',
          '56': 'Sitas (56)',
          '57': 'Plasă (57)',
          '58': 'Kilogram net (58)',
          '59': 'Parte la milion (59)',
          '60': 'Greutate procentuală (60)',
          '61': 'Parte pe miliard (SUA) (61)',
          '74': 'Milipascal (74)',
          '77': 'Milli (77)',
          '80': 'Kilogram pe centimetru pătrat absolut (80)',
          '81': 'Henry (81)',
          '85': 'Livră picior (lucru mecanic) (85)',
          '87': 'Livră pe picior cub (densitate) (87)',
          '89': 'Vâscozitate dinamică (pascal/sec) (89)',
          '91': 'Stokes (91)',
          '1I': 'Rată fixă (1I)',
          '2A': 'Radian pe secundă (2A)',
          '2B': 'Radian pe secundă la pătrat (2B)',
          '2C': 'Roentgen (2C)',
          '2G': 'Volt AC (2G)',
          '2H': 'Volt DC (2H)',
          '2I': 'BTU (tabel internațional) pe oră (2I)',
          '2J': 'Centimetru cub pe secundă (2J)',
          '2K': 'Picior cubic pe oră (2K)',
          '2L': 'Picior cubic pe minut (2L)',
          '2M': 'Centimetru pe secundă (2M)',
          '2N': 'Decibel (2N)',
          '2P': 'Kilobyte (2P)',
          '2Q': 'Kilobecquerel (2Q)',
          '2R': 'Kilocurie (2R)',
          '2U': 'Megagram (2U)',
          '2X': 'Metru pe minut (2X)',
          '2Y': 'Miliroentgen (2Y)',
          '2Z': 'Milivolt (2Z)',
          '3B': 'Megajoule (3B)',
          '3C': 'Lună om (3C)',
          '4C': 'Centistokes (4C)',
          '4G': 'Microlitru (4G)',
          '4H': 'Micrometru (micron) (4H)',
          '4K': 'Milliamper (4K)',
          '4L': 'Megabyte (4L)',
          '4M': 'Miligram pe oră (4M)',
          '4N': 'Megabecquerel (4N)',
          '4O': 'Microfarad (4O)',
          '4P': 'Newton pe metru (4P)',
          '4Q': 'Uncie pe inch (4Q)',
          '4R': 'Uncie pe picior (4R)',
          '4T': 'Picofarad (4T)',
          '4U': 'Livră pe oră (4U)',
          '4W': 'Tonă (SUA) pe oră (4W)',
          '4X': 'Kilolitru pe oră (4X)',
          '5A': 'Baril (SUA) pe minut (5A)',
          '5B': 'Lot (5B)',
          '5E': 'MMSCF/zi (5E)',
          '5J': 'Cal putere hidraulic (5J)',
          A10: 'Amper pe metru pătrat pe joule secundă (A10)',
          A11: 'Angstrom (A11)',
          A12: 'Unitate astronomică (A12)',
          A13: 'Joule atomic (A13)',
          A14: 'Barn (A14)',
          A15: 'Barn per electronvolt (A15)',
          A16: 'Barn per electronvolt steradian (A16)',
          A17: 'Barn pe steradian (A17)',
          A18: 'Becquerel pe kilogram (A18)',
          A19: 'Becquerel pe metru cub (A19)',
          A2: 'Amperi pe centimetru (A2)',
          A20: 'BTU pe secundă grad de metru pătrat Rankine (A20)',
          A21: 'BTU pe grad de lira Rankine (A21)',
          A22: 'BTU pe grad secund Rankine (A22)',
          A23: 'BTU pe oră grad de metru pătrat Rankine (A23)',
          A24: 'Candelă pe metru pătrat/Lux (A24)',
          A26: 'Coulomb metru (A26)',
          A27: 'Coulomb metru pătrat per volt (A27)',
          A28: 'Coulomb pe centimetru cub (A28)',
          A29: 'Coulomb pe metru cub (A29)',
          A3: 'Amper pe milimetru (A3)',
          A30: 'Coulomb pe milimetru cub (A30)',
          A31: 'Coulomb pe kilogram pe secundă (A31)',
          A32: 'Coulomb pe mol (A32)',
          A33: 'Coulomb pe centimetru pătrat (A33)',
          A34: 'Coulomb pe metru pătrat (A34)',
          A35: 'Coulomb pe milimetru pătrat (A35)',
          A36: 'Centimetru cub pe mol (A36)',
          A37: 'Decimetru cub pe mol (A37)',
          A38: 'Metru cub pe coulomb (A38)',
          A39: 'Metru cub pe kilogram (A39)',
          A4: 'Amper pe centimetru pătrat (A4)',
          A40: 'Metru cub pe mol (A40)',
          A41: 'Amperi pe metru pătrat (A41)',
          A42: 'Curie pe kilogram (A42)',
          A43: 'Tonă TWD (A43)',
          A44: 'Decalitru (A44)',
          A45: 'Decametru (A45)',
          A47: 'Decitex (A47)',
          A48: 'Grad Rankine (A48)',
          A49: 'Denier (A49)',
          A5: 'Amper metru pătrat (A5)',
          A53: 'Electronvolt (A53)',
          A54: 'Electronvolt pe metru (A54)',
          A55: 'Metru pătrat de electronvolt (A55)',
          A56: 'Electronvolt metru pătrat pe kilogram (A56)',
          A59: 'Okta (A59)',
          A6: 'Amper pe metru pătrat Kelvin pătrat (A6)',
          A68: 'Exajoule (A68)',
          A69: 'Farad pe metru (A69)',
          A7: 'Amper pe milimetru pătrat (A7)',
          A70: 'Femtojoule (A70)',
          A71: 'Femtometri (A71)',
          A73: 'Picior pe secundă la pătrat (A73)',
          A74: 'Livră picior forță pe secundă (A74)',
          A75: 'Tonă de marfă (A75)',
          A76: 'Gal (A76)',
          A8: 'Amper secundă (A8)',
          A84: 'Gigacoulomb pe metru cub (A84)',
          A85: 'Gigaelectronvolt (A85)',
          A86: 'Gigahertz (A86)',
          A87: 'Gigaohm (A87)',
          A88: 'Gigaohm metru (A88)',
          A89: 'Gigapascal (A89)',
          A9: 'Rata (A9)',
          A90: 'Gigawatt (A90)',
          A91: 'Gon (A91)',
          A93: 'Gram pe metru cub (A93)',
          A94: 'Moleculă (A94)',
          A95: 'Gray (A95)',
          A96: 'Gray pe secundă (A96)',
          A97: 'Hectopascal (A97)',
          A98: 'Henry pe metru (A98)',
          A99: 'Bit (A99)',
          AA: 'Spera solida (AA)',
          AB: 'Ambalaj în vrac (AB)',
          ACR: 'Ar (ACR)',
          ACT: 'Activitate (ACT)',
          AD: 'Byte (AD)',
          AE: 'Amper pe metru (AE)',
          AH: 'Minut suplimentar (AH)',
          AI: 'Minut mediu pe apel (AI)',
          AK: 'stânjen (AK)',
          AL: 'Linie de acces (AL)',
          AMH: 'Amper (AMH)',
          AMP: 'Amper (AMP)',
          ANN: 'An (ANN)',
          APZ: 'Uncie troy sau uncie farmaceutică (APZ)',
          AQ: 'Unitate de factor antihemofilic (AHF) (AQ)',
          AS: 'Sortiment (AS)',
          ASM: 'Grad alcool (masic) (ASM)',
          ASU: 'Grad alcool (volumic) (ASU)',
          ATM: 'Atmosferă standard (ATM)',
          AWG: 'Ecartament cale ferată (AWG)',
          AY: 'Mulțime (AY)',
          AZ: 'BTU (tabel internațional) per kilogram (AZ)',
          B1: 'Baril (SUA) pe zi (B1)',
          B10: 'Bit pe secundă (B10)',
          B11: 'Joule pe kilogram de Kelvin (B11)',
          B12: 'Joule pe metru (B12)',
          B13: 'Joule pe metru pătrat (B13)',
          B14: 'Joule pe metru la puterea a patra (B14)',
          B15: 'Joule pe mol (B15)',
          B16: 'Joule pe mol Kelvin (B16)',
          B17: 'Credit (B17)',
          B18: 'Joule pe secundă (B18)',
          B19: 'Cifră (B19)',
          B20: 'Joule metru pătrat pe kilogram (B20)',
          B21: 'Kelvin pe watt (B21)',
          B22: 'Kiloamper (B22)',
          B23: 'Kiloamper pe metru pătrat (B23)',
          B24: 'Kiloamper pe metru (B24)',
          B25: 'Kilobecquerel pe kilogram (B25)',
          B26: 'Kilocoulomb (B26)',
          B27: 'Kilocoulomb pe metru cub (B27)',
          B28: 'Kilocoulomb pe metru pătrat (B28)',
          B29: 'Kiloelectronvolt (B29)',
          B3: 'Livra putere (B3)',
          B30: 'Gibit (B30)',
          B31: 'Kilogram metru pe secundă (B31)',
          B32: 'Kilogram metru pătrat (B32)',
          B33: 'Kilogram metru pătrat pe secundă (B33)',
          B34: 'Kilogram pe decimetru cub (B34)',
          B35: 'Kilogram pe litru (B35)',
          B4: 'Baril, imperial (B4)',
          B41: 'Kilojoul pe Kelvin (B41)',
          B42: 'Kilojoul pe kilogram (B42)',
          B43: 'Kilojoul pe kilogram Kelvin (B43)',
          B44: 'Kilojoul pe mol (B44)',
          B45: 'Kilomol (B45)',
          B46: 'Kilomol pe metru cub (B46)',
          B47: 'Kilonewton (B47)',
          B48: 'Kilonewton pe metru (B48)',
          B49: 'Kiloohm (B49)',
          B50: 'Kiloohm pe metru (B50)',
          B52: 'Kilosecunde (B52)',
          B53: 'Kilosiemens (B53)',
          B54: 'Kilosiemens pe metru (B54)',
          B55: 'Kilovolt pe metru (B55)',
          B56: 'Kiloweber pe metru (B56)',
          B57: 'An (B57)',
          B58: 'Litru per mol (B58)',
          B59: 'Lumen pe oră (B59)',
          B60: 'Lumen pe metru pătrat (B60)',
          B61: 'Lumen pe watt (B61)',
          B62: 'Lumen pe secundă (B62)',
          B63: 'lux pe oră (B63)',
          B64: 'lux pe secundă (B64)',
          B66: 'Megaamper pe metru pătrat (B66)',
          B67: 'Megabecquerel pe kilogram (B67)',
          B68: 'Gigabit (B68)',
          B69: 'Megacoulomb pe metru cub (B69)',
          B7: 'Ciclu (B7)',
          B70: 'Megacoulomb pe metru pătrat (B70)',
          B71: 'Megaelectronvolt (B71)',
          B72: 'Megagram pe metru cub (B72)',
          B73: 'Meganewton (B73)',
          B74: 'meganewton pe metru (B74)',
          B75: 'Megaohm (B75)',
          B76: 'Megaohm pe metru (B76)',
          B77: 'Megasiemens pe metru (B77)',
          B78: 'Megavolt (B78)',
          B79: 'Megavolt pe metru (B79)',
          B8: 'Joule pe metru cub (B8)',
          B80: 'Gigabit pe secundă (B80)',
          B81: 'Metru pătrat reciproc (B81)',
          B82: 'inch pe metru liniar (B82)',
          B83: 'Metru la puterea a patra (B83)',
          B84: 'Microamper (B84)',
          B85: 'Microbar (B85)',
          B86: 'Microcoulomb (B86)',
          B87: 'Microcoulomb pe metru cub (B87)',
          B88: 'Microcoulomb pe metru pătrat (B88)',
          B89: 'Microfarad pe metru (B89)',
          B90: 'Microhenry (B90)',
          B91: 'Microhenry pe metru (B91)',
          B92: 'Micronewton (B92)',
          B93: 'micronewton pe metru (B93)',
          B94: 'Microohm (B94)',
          B95: 'microohm pe metru (B95)',
          B96: 'Micropascal (B96)',
          B97: 'Microradian (B97)',
          B98: 'Microsecundă (B98)',
          B99: 'Microsiemens (B99)',
          BAR: 'Bar [unitate de presiune] (BAR)',
          BB: 'Casetă (BB)',
          BFT: 'Picior cubic (cherestea) (BFT)',
          BHP: 'Cal putere la frânare (BHP)',
          BIL: 'Miliard (EUR) (BIL)',
          BLD: 'Baril uscat (SUA) (BLD)',
          BLL: 'Baril (SUA) (BLL)',
          BP: 'Kilo pasi (cherestea) (BP)',
          BPM: 'Bătăi pe minut (BPM)',
          BQL: 'Becquerel (BQL)',
          BTU: 'BTU (tabel internațional) (BTU)',
          BUA: 'Baniță (SUA) (BUA)',
          BUI: 'Baniță (UK) (BUI)',
          C0: 'Apel (C0)',
          C10: 'Millifarad (C10)',
          C11: 'Miligal (C11)',
          C12: 'Miligram pe metru (C12)',
          C13: 'Milligray (C13)',
          C14: 'Milihenry (C14)',
          C15: 'Milijoul (C15)',
          C16: 'Milimetru pe secundă (C16)',
          C17: 'Milimetru pătrat pe secundă (C17)',
          C18: 'Millimol (C18)',
          C19: 'Mol pe kilogram (C19)',
          C20: 'Millinewton (C20)',
          C21: 'Kibibit (C21)',
          C22: 'Milinewton pe metru (C22)',
          C23: 'Miliohm pe metru (C23)',
          C24: 'Milipascal pe secundă (C24)',
          C25: 'Milliradian (C25)',
          C26: 'Milisecundă (C26)',
          C27: 'Milisiemens (C27)',
          C28: 'Milisievert (C28)',
          C29: 'Millitesla (C29)',
          C3: 'Microvolt pe metru (C3)',
          C30: 'Milivolt pe metru (C30)',
          C31: 'Miliwatt (C31)',
          C32: 'Miliwatt pe metru pătrat (C32)',
          C33: 'Miliweber (C33)',
          C34: 'Mol (C34)',
          C35: 'Mol pe decimetru cub (C35)',
          C36: 'Mol pe metru cub (C36)',
          C37: 'Kilobit (C37)',
          C38: 'Mol pe litru (C38)',
          C39: 'Nanoamper (C39)',
          C40: 'Nanocoulomb (C40)',
          C41: 'Nanofarad (C41)',
          C42: 'Nanofarad pe metru (C42)',
          C43: 'Nanohenry (C43)',
          C44: 'Nanohenry pe metru (C44)',
          C45: 'Nanometri (C45)',
          C46: 'Nanoohm metru (C46)',
          C47: 'Nanosecundă (C47)',
          C48: 'Nanotesla (C48)',
          C49: 'Nanowatt (C49)',
          C50: 'Neper (C50)',
          C51: 'Neper pe secundă (C51)',
          C52: 'Picometru (C52)',
          C53: 'Newton metru pe secundă (C53)',
          C54: 'Newton metru pătrat pe kilogram la pătrat (C54)',
          C55: 'Newton pe metru pătrat (C55)',
          C56: 'Newton pe milimetru pătrat (C56)',
          C57: 'Newton secundă (C57)',
          C58: 'Newton secundă pe metru (C58)',
          C59: 'Octavă (C59)',
          C60: 'Ohm pe centimetru (C60)',
          C61: 'Ohm metru (C61)',
          C63: 'Parsec (C63)',
          C64: 'Pascal pe Kelvin (C64)',
          C65: 'Pascal secundă (C65)',
          C66: 'Pascal secundă pe metru cub (C66)',
          C67: 'Pascal secundă pe metru (C67)',
          C68: 'Petajoule (C68)',
          C69: 'Fon (C69)',
          C7: 'centipoise (C7)',
          C70: 'Picoamper (C70)',
          C71: 'Picocoulomb (C71)',
          C72: 'Picofarad pe metru (C72)',
          C73: 'Picohenry (C73)',
          C74: 'Kilobit pe secundă (C74)',
          C75: 'Picowatt (C75)',
          C76: 'Picowatt pe metru pătrat (C76)',
          C78: 'Livra (C78)',
          C79: 'Kilovolt amper oră (C79)',
          C8: 'Miliicoulomb pe kilogram (C8)',
          C80: 'Rad (C80)',
          C81: 'Radian (C81)',
          C82: 'Radian metru pătrat pe mol (C82)',
          C83: 'Radian metru pătrat pe kilogram (C83)',
          C84: 'Radian pe metru (C84)',
          C85: 'Angstrom reciproc (C85)',
          C86: 'Metru cub reciproc (C86)',
          C87: 'Metru cub reciproc pe secundă (C87)',
          C88: 'Electron volt reciproc per metru cub (C88)',
          C89: 'Henry reciproc (C89)',
          C9: 'Grup de bobine (C9)',
          C90: 'Joule reciproce pe metru cub (C90)',
          C91: 'Reciproc Kelvin sau Kelvin la puterea minus unu (C91)',
          C92: 'Metru reciproc (C92)',
          C93: 'Metru pătrat reciproc (C93)',
          C94: 'Minut reciproc (C94)',
          C95: 'Mol reciproc (C95)',
          C96: 'Pascal reciproc sau pascal la puterea minus unu (C96)',
          C97: 'Secundă la puterea minus unu (C97)',
          C99: 'Secundă la puterea minus unu pe metru pătrat (C99)',
          CCT: 'Capacitate de transport în tone metrice (CCT)',
          CDL: 'Candelă (CDL)',
          CEL: 'Grad Celsius (CEL)',
          CEN: 'Suta (CEN)',
          CG: 'Card (CG)',
          CGM: 'Centigram (CGM)',
          CKG: 'Coulomb pe kilogram (CKG)',
          CLF: 'Sac (ciment) (CLF)',
          CLT: 'Centilitru (CLT)',
          CMK: 'Centimetru pătrat (CMK)',
          CMQ: 'Centimetru cub (CMQ)',
          CNP: 'Pachet de o suta (CNP)',
          CNT: 'Cental (UK) (CNT)',
          COU: 'Coulomb (COU)',
          CTG: 'Conținut gram (CTG)',
          CTM: 'Carat metric (CTM)',
          CTN: 'Tonă de conţinut (metric) (CTN)',
          CUR: 'Curie (CUR)',
          CWA: 'Sute de livre (cwt)/sute de kilograme (SUA) (CWA)',
          CWI: 'Chintal (CWI)',
          D03: 'Kilowatt oră pe oră (D03)',
          D04: 'Lot [unitate de greutate] (D04)',
          D1: 'Secundă la puterea minus unu per steradian (D1)',
          D10: 'Siemens pe metru (D10)',
          D11: 'Mebibit (D11)',
          D12: 'Siemens metru pătrat per mol (D12)',
          D13: 'Sievert (D13)',
          D15: 'Son (D15)',
          D16: 'Centimetru pătrat pe erg (D16)',
          D17: 'Centimetru pătrat pe erg steradian (D17)',
          D18: 'Metru Kelvin (D18)',
          D19: 'Metru pătrat Kelvin pe watt (D19)',
          D2: 'Secundă la puterea minus unu pe metru steradian pătrat (D2)',
          D20: 'Metru pătrat pe joule (D20)',
          D21: 'Metru pătrat pe kilogram (D21)',
          D22: 'Metru pătrat pe mol (D22)',
          D23: '10 cmc per gram (D23)',
          D24: 'Metru pătrat pe steradian (D24)',
          D25: 'Metru pătrat pe joule steradian (D25)',
          D26: 'Metru pătrat pe secundă volt (D26)',
          D27: 'Steradian (D27)',
          D29: 'Terahertz (D29)',
          D30: 'Terajoule (D30)',
          D31: 'Terawatt (D31)',
          D32: 'Terawatt oră (D32)',
          D33: 'Tesla (D33)',
          D34: 'Tex (D34)',
          D36: 'Megabit (D36)',
          D41: 'Tonă pe metru cub (D41)',
          D42: 'An tropic (D42)',
          D43: 'Unitate de masă atomică unificată (D43)',
          D44: 'Var (D44)',
          D45: 'Volt pătrat pe Kelvin pătrat (D45)',
          D46: 'Volt (D46)',
          D47: 'Volt pe centimetru (D47)',
          D48: 'Volt per Kelvin (D48)',
          D49: 'Milivolt per Kelvin (D49)',
          D5: 'Kilogram pe centimetru pătrat (D5)',
          D50: 'Volt pe metru (D50)',
          D51: 'Volt pe milimetru (D51)',
          D52: 'Watt per Kelvin (D52)',
          D53: 'Watt pe metru Kelvin (D53)',
          D54: 'Watt pe metru pătrat (D54)',
          D55: 'Watt pe metru pătrat Kelvin (D55)',
          D56: 'Watt pe metru pătrat Kelvin la a patra putere (D56)',
          D57: 'Watt per steradian (D57)',
          D58: 'Watt per metru pătrat steradian (D58)',
          D59: 'Weber pe metru (D59)',
          D6: 'Roentgen pe secundă (D6)',
          D60: 'Weber pe milimetru (D60)',
          D61: 'Minut [unghi] (D61)',
          D62: 'Secunda [unitate de unghi] (D62)',
          D63: 'Carte (D63)',
          D65: 'Buștean (D65)',
          D68: 'Număr de cuvinte (D68)',
          D69: 'Inch la puterea a patra (D69)',
          D73: 'Joule metru pătrat (D73)',
          D74: 'Kilogram pe mol (D74)',
          D77: 'Megacoulomb (D77)',
          D78: 'Megajoule pe secundă (D78)',
          D80: 'Microwatt (D80)',
          D81: 'Microtesla (D81)',
          D82: 'Microvolt (D82)',
          D83: 'Milinewton metru (D83)',
          D85: 'Microwatt pe metru pătrat (D85)',
          D86: 'Miliicoulomb (D86)',
          D87: 'Millimol pe kilogram (D87)',
          D88: 'Miliicoulomb pe metru cub (D88)',
          D89: 'Miliicoulomb pe metru pătrat (D89)',
          D91: 'REM (D91)',
          D93: 'Secundă pe metru cub (D93)',
          D94: 'Secundă pe metru cub radian (D94)',
          D95: 'Joule pe gram (D95)',
          DAA: 'Decare (DAA)',
          DAD: 'Decadă (DAD)',
          DAY: 'Zi (DAY)',
          DB: 'Livra uscata (DB)',
          DD: 'Grad [unitate de unghi] (DD)',
          DEC: 'Deceniu (DEC)',
          DG: 'Decigramă (DG)',
          DJ: 'Decagramă (DJ)',
          DLT: 'Decilitru (DLT)',
          DMA: 'Decametru cub (DMA)',
          DMK: 'Decimetru pătrat (DMK)',
          DMO: 'Kilolitru standard (la 15 grd C) (DMO)',
          DMQ: 'Decimetru cub (DMQ)',
          DMT: 'Decimetru (DMT)',
          DN: 'Decinewton metru (DN)',
          DPC: 'Duzină (DPC)',
          DPR: 'Duzină de perechi (DPR)',
          DPT: 'Deplasament metric (tone) (DPT)',
          DRA: 'DRAM (SUA) (DRA)',
          DRI: 'DRAM (UK) (DRI)',
          DRL: 'Duzina de rolă (DRL)',
          DT: 'Tonă uscată (DT)',
          DTN: 'Decitonă (DTN)',
          DWT: 'Pennyweight (DWT)',
          DZP: 'Duzină de pachete (DZP)',
          E01: 'Newton pe centimetru pătrat (E01)',
          E07: 'Megawatt oră pe oră (E07)',
          E08: 'Megawatt per hertz (E08)',
          E09: 'Miliamper ora (E09)',
          E10: 'Grad pe zi (E10)',
          E12: 'Mille (E12)',
          E14: 'Kilocalorie (tabel internațional) (E14)',
          E15: 'Kilocalorie (termochimică) pe oră (E15)',
          E16: 'Milioane Btu(IT) pe oră (E16)',
          E17: 'Picior cubic pe secundă (E17)',
          E18: 'Tonă pe oră (E18)',
          E19: 'Ping (E19)',
          E20: 'Megabit pe secundă (E20)',
          E21: 'Acțiuni (E21)',
          E22: 'TEU (E22)',
          E23: 'Pneu (E23)',
          E25: 'Unitate activa (E25)',
          E27: 'Doză (E27)',
          E28: 'Tonă uscată de aer (E28)',
          E30: 'Componentă (E30)',
          E31: 'Metru pătrat pe litru (E31)',
          E32: 'Litru pe oră (E32)',
          E33: 'Picior la mie (E33)',
          E34: 'Gigabyte (E34)',
          E35: 'Terabyte (E35)',
          E36: 'Petabyte (E36)',
          E37: 'Pixel (E37)',
          E38: 'Megapixel (E38)',
          E39: 'Puncte pe inch (E39)',
          E4: 'Kilogram brut (E4)',
          E40: 'Partea la o suta de mii (E40)',
          E41: 'Kilogram (E41)',
          E42: 'Kilogram (E42)',
          E43: 'Joule pe centimetru pătrat (E43)',
          E44: 'Kilogram (E44)',
          E45: 'Miliohm (E45)',
          E46: 'Kilowatt oră pe metru cub (E46)',
          E47: 'Kilowatt oră per Kelvin (E47)',
          E48: 'Unitate de service (E48)',
          E49: 'Zi lucrătoare (E49)',
          E50: 'Unitate de contabilitate (E50)',
          E51: 'Loc de muncă (E51)',
          E52: 'Pasi deplasare (E52)',
          E53: 'Test (E53)',
          E54: 'Deplasare (E54)',
          E55: 'Utilizare (E55)',
          E56: 'Unitate de foraj (E56)',
          E57: 'Zonă (E57)',
          E58: 'Exabit pe secundă (E58)',
          E59: 'Exbibyte (E59)',
          E60: 'Pebibyte (E60)',
          E61: 'Tebibyte (E61)',
          E62: 'Gibibyte (E62)',
          E63: 'Mebibyte (E63)',
          E64: 'Kibibyte (E64)',
          E65: 'Exbibit pe metru (E65)',
          E66: 'Exbibit pe metru pătrat (E66)',
          E67: 'Exbibit pe metru cub (E67)',
          E68: 'Gigabyte pe secundă (E68)',
          E69: 'Gibibit pe metru (E69)',
          E70: 'Gibibit pe metru pătrat (E70)',
          E71: 'Gibibit pe metru cub (E71)',
          E72: 'Kibibit pe metru (E72)',
          E73: 'Kibibit pe metru pătrat (E73)',
          E74: 'Kibibit pe metru cub (E74)',
          E75: 'Mebibit pe metru (E75)',
          E76: 'Mebibit pe metru pătrat (E76)',
          E77: 'Mebibit pe metru cub (E77)',
          E78: 'Petabit (E78)',
          E79: 'Petabit pe secundă (E79)',
          E80: 'Pebibit pe metru (E80)',
          E81: 'Pebibit pe metru pătrat (E81)',
          E82: 'Pebibit pe metru cub (E82)',
          E83: 'Terabit (E83)',
          E84: 'Terabit pe secundă (E84)',
          E85: 'Tebibit pe metru (E85)',
          E86: 'Tebibit pe metru cub (E86)',
          E87: 'Tebibit pe metru pătrat (E87)',
          E88: 'Bit pe metru (E88)',
          E89: 'Bit pe metru pătrat (E89)',
          E90: 'Centimetru la puterea minus unu (E90)',
          E91: 'Zi la puterea minus unu (E91)',
          E92: 'Decimetru cub pe oră (E92)',
          E93: 'Kilogram pe oră (E93)',
          E94: 'Kilomol pe secundă (E94)',
          E95: 'Mol pe secundă (E95)',
          E96: 'Grad pe secundă (E96)',
          E97: 'Milimetri pe grad celcius metru (E97)',
          E98: 'Grad Celsius pe Kelvin (E98)',
          E99: 'Hectopascal per bar (E99)',
          EB: 'Căsută poștală electronică (EB)',
          EQ: 'Galon echivalent (EQ)',
          F01: 'Bit pe metru cub (F01)',
          F02: 'Kelvin per Kelvin (F02)',
          F03: 'Kilopascal pe bar (F03)',
          F04: 'Milibar pe bar (F04)',
          F05: 'Megapascal pe bar (F05)',
          F06: 'Poise pe bar (F06)',
          F07: 'Pascal pe bar (F07)',
          F08: 'Milliampere pe inch (F08)',
          F10: 'Kelvin pe oră (F10)',
          F11: 'Kelvin pe minut (F11)',
          F12: 'Kelvin pe secundă (F12)',
          F13: 'Slug (F13)',
          F14: 'Gram pe Kelvin (F14)',
          F15: 'Kilogram pe Kelvin (F15)',
          F16: 'Miligram per Kelvin (F16)',
          F17: 'Livră (F17)',
          F18: 'Kilogram de centimetru pătrat (F18)',
          F19: 'Kilogram milimetru pătrat (F19)',
          F20: 'Livra inch pătrat (F20)',
          F21: 'Livra (F21)',
          F22: 'Livra (F22)',
          F23: 'Gram pe decimetru cub (F23)',
          F24: 'Kilogram pe kilomol (F24)',
          F25: 'Gram per hertz (F25)',
          F26: 'Gram pe zi (F26)',
          F27: 'Gram pe oră (F27)',
          F28: 'Gram pe minut (F28)',
          F29: 'Gram pe secundă (F29)',
          F30: 'Kilogram pe zi (F30)',
          F31: 'Kilogram pe minut (F31)',
          F32: 'Miligram pe zi (F32)',
          F33: 'Miligram pe minut (F33)',
          F34: 'Miligram pe secundă (F34)',
          F35: 'Gram pe zi Kelvin (F35)',
          F36: 'Gram pe oră Kelvin (F36)',
          F37: 'Gram pe minut Kelvin (F37)',
          F38: 'Gram pe secundă Kelvin (F38)',
          F39: 'Kg pe zi Kelvin (F39)',
          F40: 'Kilogram pe oră Kelvin (F40)',
          F41: 'Kilogram pe minut Kelvin (F41)',
          F42: 'Kilogram pe secundă Kelvin (F42)',
          F43: 'Miligram pe zi Kelvin (F43)',
          F44: 'Miligram pe oră Kelvin (F44)',
          F45: 'Miligram pe minut Kelvin (F45)',
          F46: 'Miligram pe secundă Kelvin (F46)',
          F47: 'Newton pe milimetru (F47)',
          F48: 'Livră (F48)',
          F49: 'Tijă [unitate de distanță] (F49)',
          F50: 'Micrometru per Kelvin (F50)',
          F51: 'Centimetru pe Kelvin (F51)',
          F52: 'Metru pe Kelvin (F52)',
          F53: 'Milimetru pe Kelvin (F53)',
          F54: 'Miliohm pe metru (F54)',
          F55: 'Ohm pe milă (statute mile) (F55)',
          F56: 'Ohm pe kilometru (F56)',
          F57: 'Miliamper per kilogram (F57)',
          F58: 'Bar la puterea minus unu (F58)',
          F59: 'Milliamper pe bar (F59)',
          F60: 'Grad Celsius pe bar (F60)',
          F61: 'Kelvin pe bar (F61)',
          F62: 'Gram pe zi bar (F62)',
          F63: 'Gram pe oră bar (F63)',
          F64: 'Gram pe bar pe minut (F64)',
          F65: 'Gram pe secundă bar (F65)',
          F66: 'Kilogram pe bar pe zi (F66)',
          F67: 'Kilogram pe oră bar (F67)',
          F68: 'Kilogram pe minut bar (F68)',
          F69: 'Kilogram pe secundă bar (F69)',
          F70: 'Miligram pe zi bar (F70)',
          F71: 'Miligram pe oră bar (F71)',
          F72: 'Miligram pe bar de minut (F72)',
          F73: 'Miligram pe secundă bar (F73)',
          F74: 'Gram pe bar (F74)',
          F75: 'Miligram pe bar (F75)',
          F76: 'Miliamper pe milimetru (F76)',
          F77: 'Pascal pe secundă pe Kelvin (F77)',
          F78: 'Inch coloană de apă (F78)',
          F79: 'Centimetru coloană de mercur (F79)',
          F80: 'Cal putere hidraulic (F80)',
          F81: 'Bar pe Kelvin (F81)',
          F82: 'Hectopascal per Kelvin (F82)',
          F83: 'Kilopascal pe Kelvin (F83)',
          F84: 'Milibar pe Kelvin (F84)',
          F85: 'Megapascal pe Kelvin (F85)',
          F86: 'Poise per Kelvin (F86)',
          F87: 'Volt pe litru minut (F87)',
          F88: 'Centimetru Newton (F88)',
          F89: 'Newton metru pe grad (F89)',
          F90: 'Newton metru pe amper (F90)',
          F91: 'Bar litru pe secundă (F91)',
          F92: 'Bar cub metru pe secundă (F92)',
          F93: 'Hectopascal litru pe secundă (F93)',
          F94: 'Metru cub hectopascal pe secundă (F94)',
          F95: 'Milibar litru pe secundă (F95)',
          F96: 'Milibar metru cub pe secundă (F96)',
          F97: 'Megapascal litru pe secundă (F97)',
          F98: 'Metru cub megapascal pe secundă (F98)',
          F99: 'Litru Pascal pe secundă (F99)',
          FAH: 'Grad Fahrenheit (FAH)',
          FAR: 'Farad (FAR)',
          FBM: 'Metru de fibră (FBM)',
          FC: 'Kilo pași cub (FC)',
          FF: 'Sută metri cubi (FF)',
          FH: 'Micromol (FH)',
          FIT: 'Defect în timp (FIT)',
          FL: 'Tonă fulgi (FL)',
          FP: 'Livră pe metru pătrat (FP)',
          FR: 'Picior pe minut (FR)',
          FS: 'Picior pe secundă (FS)',
          FTK: 'Picior pătrat (FTK)',
          FTQ: 'Picior cubic (FTQ)',
          G01: 'Metru cub pascal pe secundă (G01)',
          G04: 'Centimetru pe bar (G04)',
          G05: 'Metru pe bar (G05)',
          G06: 'Milimetri per bar (G06)',
          G08: 'Pătrat inch pe secundă (G08)',
          G09: 'Metru pătrat pe secundă Kelvin (G09)',
          G10: 'Stokes per Kelvin (G10)',
          G11: 'Gram pe bar centimetru cub (G11)',
          G12: 'Gram pe bar de decimetru cub (G12)',
          G13: 'Gram pe litru bar (G13)',
          G14: 'Gram pe metru cub bar (G14)',
          G15: 'Gram pe bar mililitru (G15)',
          G16: 'Kilogram pe bar centimetru cub (G16)',
          G17: 'Kilogram pe litru bar (G17)',
          G18: 'Kilogram pe metru cub bar (G18)',
          G19: 'Newton metru pe kilogram (G19)',
          G2: 'Galon (SUA) pe minut (G2)',
          G20: 'Livră (G20)',
          G21: 'Cupă [unitate de volum] (G21)',
          G23: 'Peck (G23)',
          G24: 'Lingură (SUA) (G24)',
          G25: 'Linguriță (SUA) (G25)',
          G26: 'Ster (G26)',
          G27: 'Centimetru cub pe Kelvin (G27)',
          G28: 'Litru pe Kelvin (G28)',
          G29: 'Metru cub per Kelvin (G29)',
          G3: 'Galon imperial pe minut (G3)',
          G30: 'Mililitru pe Kelvin (G30)',
          G31: 'Kilogram pe centimetru cub (G31)',
          G32: 'Uncie (avoirdupois) per picior cubic (G32)',
          G33: 'Gram pe centimetru cub Kelvin (G33)',
          G34: 'Gram pe decimetru cub Kelvin (G34)',
          G35: 'Gram pe litru Kelvin (G35)',
          G36: 'Gram pe metru cub Kelvin (G36)',
          G37: 'Gram pe mililitru Kelvin (G37)',
          G38: 'Kilogram pe centimetru cub Kelvin (G38)',
          G39: 'Kilogram pe litru Kelvin (G39)',
          G40: 'Kilogram pe metru cub Kelvin (G40)',
          G41: 'Metru pătrat pe bar secundă (G41)',
          G42: 'Microsiemens pe centimetru (G42)',
          G43: 'Microsiemens pe metru (G43)',
          G44: 'Nanosiemens pe centimetru (G44)',
          G45: 'Nanosiemens pe metru (G45)',
          G46: 'Stokes pe bar (G46)',
          G47: 'Centimetru cub pe zi (G47)',
          G48: 'Centimetru cub pe oră (G48)',
          G49: 'Centimetru cub pe minut (G49)',
          G50: 'Galon (SUA) pe oră (G50)',
          G51: 'Litru pe secundă (G51)',
          G52: 'Metru cub pe zi (G52)',
          G53: 'Metru cub pe minut (G53)',
          G54: 'Mililitru pe zi (G54)',
          G55: 'Mililitru pe oră (G55)',
          G56: 'Centimetru cub pe oră (G56)',
          G57: 'Centimetru cub pe minut (G57)',
          G58: 'Centimetru cub pe secundă (G58)',
          G59: 'Miliamper pe litru minut (G59)',
          G60: 'Volt pe bar (G60)',
          G61: 'Centimetru cub pe zi Kelvin (G61)',
          G62: 'Centimetru cub pe oră Kelvin (G62)',
          G63: 'Centimetru cub pe minut Kelvin (G63)',
          G64: 'Centimetru cub pe secundă Kelvin (G64)',
          G65: 'Litru pe zi Kelvin (G65)',
          G66: 'Litru pe oră Kelvin (G66)',
          G67: 'Litru pe minut Kelvin (G67)',
          G68: 'Litru pe secundă Kelvin (G68)',
          G69: 'Metru cub pe zi Kelvin (G69)',
          G70: 'Metru cub pe oră Kelvin (G70)',
          G71: 'Metru cub pe minut Kelvin (G71)',
          G72: 'Metru cub pe secundă Kelvin (G72)',
          G73: 'Mililitru pe zi Kelvin (G73)',
          G74: 'Mililitru pe oră Kelvin (G74)',
          G75: 'Mililitru pe minut Kelvin (G75)',
          G76: 'Mililitru pe secundă Kelvin (G76)',
          G77: 'Milimetri la puterea a patra (G77)',
          G78: 'Centimetru cub pe bar zi (G78)',
          G79: 'Centimetru cub pe bar oră (G79)',
          G80: 'Centimetru cub pe bar minut (G80)',
          G81: 'Centimetru cub pe bar secundă (G81)',
          G82: 'Litru pe zi bar (G82)',
          G83: 'Litru pe oră bar (G83)',
          G84: 'Litru pe minut bar (G84)',
          G85: 'Litru pe secundă bar (G85)',
          G86: 'Metru cub pe zi bar (G86)',
          G87: 'Metru cub pe oră bar (G87)',
          G88: 'Metru cub pe minut bar (G88)',
          G89: 'Metru cub pe secundă bar (G89)',
          G90: 'Mililitru pe zi bar (G90)',
          G91: 'Mililitru pe oră bar (G91)',
          G92: 'Mililitru pe minut bar (G92)',
          G93: 'Mililitru pe secundă bar (G93)',
          G94: 'Centimetru cub pe bar (G94)',
          G95: 'Litru pe bar (G95)',
          G96: 'Metru cub pe bar (G96)',
          G97: 'Mililitru pe bar (G97)',
          G98: 'Microhenry pe kiloohm (G98)',
          G99: 'Microhenry pe ohm (G99)',
          GB: 'Galon (SUA) pe zi (GB)',
          GBQ: 'Gigabecquerel (GBQ)',
          GDW: 'Gram, greutate uscată (GDW)',
          GE: 'Livră pe galon (SUA) (GE)',
          GF: 'Gram pe metru (GF)',
          GFI: 'Gram de izotop fisionabil (GFI)',
          GGR: 'Unitate brută (GGR)',
          GIA: 'Gill (SUA) (GIA)',
          GIC: 'Gram, inclusiv recipientul (GIC)',
          GII: 'Gill (UK) (GII)',
          GIP: 'Gram, inclusiv ambalajul interior (GIP)',
          GJ: 'Gram pe mililitru (GJ)',
          GL: 'Gram pe litru (GL)',
          GLD: 'Galon uscat (SUA) (GLD)',
          GLI: 'Galon (UK) (GLI)',
          GLL: 'Galon (SUA) (GLL)',
          GM: 'Gram pe metru pătrat (GM)',
          GO: 'Miligram pe metru pătrat (GO)',
          GP: 'Miligram pe metru cub (GP)',
          GQ: 'Microgram pe metru cub (GQ)',
          GRN: 'Bob [unitate farmaceutică] (GRN)',
          GRO: 'Brut (GRO)',
          GV: 'Gigajoule (GV)',
          GWH: 'Gigawatt oră (GWH)',
          H03: 'Henry pe kiloohm (H03)',
          H04: 'Henry pe ohm (H04)',
          H05: 'Milihenry pe kiloohm (H05)',
          H06: 'Milihenry per ohm (H06)',
          H07: 'Pascal secundă pe bar (H07)',
          H08: 'Microbecquerel (H08)',
          H09: 'An la puterea minus unu (H09)',
          H10: 'Oră la puterea minus unu (H10)',
          H11: 'Lună la puterea minus unu (H11)',
          H12: 'Grad Celsius pe oră (H12)',
          H13: 'Grad Celsius pe minut (H13)',
          H14: 'Grad Celsius pe secundă (H14)',
          H15: 'Centimetru pătrat pe gram (H15)',
          H16: 'Decametru pătrat (H16)',
          H18: 'Hectometri pătrați (H18)',
          H19: 'Hectometri cubi (H19)',
          H20: 'Kilometru cub (H20)',
          H21: 'Blanchetă (H21)',
          H22: 'Volt pe inch pătrat pe kilogram (H22)',
          H23: 'Volt pe inch (H23)',
          H24: 'Volt pe microsecundă (H24)',
          H25: 'Procent per Kelvin (H25)',
          H26: 'Ohm pe metru (H26)',
          H27: 'Grad pe metru (H27)',
          H28: 'Microfarad pe kilometru (H28)',
          H29: 'Microgram per litru (H29)',
          H30: 'Micrometru pătrat (micron pătrat) (H30)',
          H31: 'Amper pe kilogram (H31)',
          H32: 'Amper pătrat pe secundă (H32)',
          H33: 'Farad pe kilometru (H33)',
          H34: 'Hertz metru (H34)',
          H35: 'Kelvin metru pe watt (H35)',
          H36: 'Megaohm pe kilometru (H36)',
          H37: 'Megaohm pe metru (H37)',
          H38: 'Megaamper (H38)',
          H39: 'Megahertz kilometru (H39)',
          H40: 'Newton pe amper (H40)',
          H41: 'Newton metru watt la puterea minus 0,5 (H41)',
          H42: 'Pascal pe metru (H42)',
          H43: 'Siemens pe centimetru (H43)',
          H44: 'Teraohm (H44)',
          H45: 'Volt secundă pe metru (H45)',
          H46: 'Volt pe secundă (H46)',
          H47: 'Watt pe metru cub (H47)',
          H48: 'Attofarad (H48)',
          H49: 'Centimetru pe oră (H49)',
          H50: 'Centimetru cub reciproc (H50)',
          H51: 'Decibel pe kilometru (H51)',
          H52: 'Decibel pe metru (H52)',
          H53: 'Kilogram per bar (H53)',
          H54: 'Kilogram pe decimetru cub Kelvin (H54)',
          H55: 'Kilogram pe bara de decimetru cub (H55)',
          H56: 'Kilogram pe metru pătrat secundă (H56)',
          H57: 'Inch per doi pi radiant (H57)',
          H58: 'Metru pe secundă volt (H58)',
          H59: 'Metru pătrat pe newton (H59)',
          H60: 'Metru cub pe metru cub (H60)',
          H61: 'Milisiemens pe centimetru (H61)',
          H62: 'Milivolt pe minut (H62)',
          H63: 'Miligram pe centimetru pătrat (H63)',
          H64: 'Miligram pe gram (H64)',
          H65: 'Mililitru pe metru cub (H65)',
          H66: 'Milimetri pe an (H66)',
          H67: 'Milimetri pe oră (H67)',
          H68: 'Millimol pe gram (H68)',
          H69: 'Picopascal pe kilometru (H69)',
          H70: 'Picosecundă (H70)',
          H71: 'Procente pe lună (H71)',
          H72: 'Procent pe hectobar (H72)',
          H73: 'Procente pe decaKelvin (H73)',
          H74: 'Watt pe metru (H74)',
          H75: 'Decapascal (H75)',
          H76: 'Gram pe milimetru (H76)',
          H77: 'Lățime modulară (H77)',
          H79: 'Ecartament francez (H79)',
          H80: 'Unitate de rack (H80)',
          H81: 'Milimetri pe minut (H81)',
          H82: 'Punct tipografic (H82)',
          H83: 'Litru pe kilogram (H83)',
          H84: 'Gram milimetru (H84)',
          H85: 'Săptămână la puterea minus unu (H85)',
          H88: 'Megaohm kilometru (H88)',
          H89: 'Procent pe ohm (H89)',
          H90: 'Procent pe grad (H90)',
          H91: 'Procent la zece mii (H91)',
          H92: 'Procent la suta de mii (H92)',
          H93: 'Procent la sută (H93)',
          H94: 'Procent la mie (H94)',
          H95: 'Procent per volt (H95)',
          H96: 'Procent per bar (H96)',
          H98: 'Procent pe inch (H98)',
          H99: 'Procent pe metru (H99)',
          HA: 'Hank (HA)',
          HBA: 'Hectobar (HBA)',
          HBX: 'Sute de cutii (HBX)',
          HC: 'Set de o suta (HC)',
          HDW: 'Chintal, greutate uscată (HDW)',
          HEA: 'Capete (HEA)',
          HGM: 'Hectogram (HGM)',
          HH: 'O sută de metri cubi (HH)',
          HIU: 'O sută de unități internaționale (HIU)',
          HKM: 'Chintal, masă netă (HKM)',
          HLT: 'Hectolitru (HLT)',
          HM: 'Milă pe oră (milometru statuat) (HM)',
          HMQ: 'Milioane de metri cubi (HMQ)',
          HMT: 'Hectometri (HMT)',
          HPA: 'Hectolitru de alcool pur (HPA)',
          HTZ: 'Hertz (HTZ)',
          HUR: 'Oră (HUR)',
          IA: 'Inch pe livră (IA)',
          IE: 'Persoană (IE)',
          INK: 'Centimetru pătrat (INK)',
          INQ: 'Inch cub (INQ)',
          ISD: 'Grad internațional de zahăr (ISD)',
          IU: 'Inch pe secundă (IU)',
          IUG: 'Unitate internațională pe gram (IUG)',
          IV: 'Centimetru pe secundă la pătrat (IV)',
          J10: 'Procent pe milimetru (J10)',
          J12: 'Per mille pe psi (J12)',
          J13: 'Grad API (J13)',
          J14: 'Grad Baume (scară de origine) (J14)',
          J15: 'Grad Baume (SUA, mai dens decât apa) (J15)',
          J16: 'Grad Baume (SUA, mai ușor decât apa) (J16)',
          J17: 'Grad Balling (J17)',
          J18: 'Grad Brix (J18)',
          J19: 'Grad Fahrenheit oră metru pătrat pe BTU (termochimic) (J19)',
          J2: 'Joule pe kilogram (J2)',
          J20: 'Grad Fahrenheit per Kelvin (J20)',
          J21: 'Grad Fahrenheit per bar (J21)',
          J22: 'Grad Fahrenheit oră pătrată pe BTU (masă internațională) (J22)',
          J23: 'Grad Fahrenheit pe orp (J23)',
          J24: 'Grad Fahrenheit pe minut (J24)',
          J25: 'Grad Fahrenheit pe secundă (J25)',
          J26: 'Grad reciproc Fahrenheit (J26)',
          J27: 'Grad Oechsle (J27)',
          J28: 'Grad Rankine pe oră (J28)',
          J29: 'Grad Rankine pe minut (J29)',
          J30: 'Grad Rankine pe secundă (J30)',
          J31: 'Grad Twaddell (J31)',
          J32: 'MicroPoise (J32)',
          J33: 'Microgram per kilogram (J33)',
          J34: 'Microgram pe metru cub Kelvin (J34)',
          J35: 'Microgram pe metru cub bar (J35)',
          J36: 'Microlitru pe litru (J36)',
          J38: 'Baud (J38)',
          J39: 'BTU (medie) (J39)',
          J40: 'BTU (măsură internațională) picior pe oră picior pătrat grad Fahrenheit (J40)',
          J41: 'BTU (măsură internațională) inch pe oră picior pătrat grad Fahrenheit (J41)',
          J42: 'BTU (măsură internațională) inch pe secundă picior pătrat grad Fahrenheit (J42)',
          J43: 'BTU (tabel internațional) pe grad pe livra Fahrenheit (J43)',
          J44: 'BTU (tabel internațional) pe minut (J44)',
          J45: 'BTU (tabel internațional) pe secundă (J45)',
          J46: 'BTU (termochimică) picior pe oră picior pătrat grad Fahrenheit (J46)',
          J47: 'BTU (termochimică) pe oră (J47)',
          J48: 'BTU (termochimică) inch pe oră picior pătrat grad Fahrenheit (J48)',
          J49: 'BTU (termochimică) inch pe secundă picior pătrat grad Fahrenheit (J49)',
          J50: 'BTU (termochimică) pe grad de lira Fahrenheit (J50)',
          J51: 'BTU (termochimică) pe minut (J51)',
          J52: 'BTU (termochimică) pe secundă (J52)',
          J53: 'Coulomb metru pătrat per kilogram (J53)',
          J54: 'Megabaud (J54)',
          J55: 'Watt pe secundă (J55)',
          J56: 'Bar pe bar (J56)',
          J58: 'Baril (UK Oil) pe minut (J58)',
          J59: 'Baril (UK Oil) pe zi (J59)',
          J60: 'Baril (UK petrol) pe oră (J60)',
          J61: 'Baril (UK Oil) pe secundă (J61)',
          J62: 'Baril (U.A. petrol) pe oră (J62)',
          J63: 'Baril (U.A. petrol) pe secundă (J63)',
          J64: 'Baniță (UK) pe zi (J64)',
          J65: 'Baniță (UK) pe oră (J65)',
          J66: 'Baniță (UK) pe minut (J66)',
          J67: 'Baniță (UK) pe secundă (J67)',
          J68: 'Baniță (SUA uscată) pe zi (J68)',
          J69: 'Baniță (SUA uscată) pe oră (J69)',
          J70: 'Bushel (US uscat) pe minut (J70)',
          J71: 'Bushel (US uscat) pe secundă (J71)',
          J72: 'Centinewton metru (J72)',
          J73: 'Centipoise pe Kelvin (J73)',
          J74: 'Centipoise pe bar (J74)',
          J75: 'Calorie (medie) (J75)',
          J76: 'Calorie (tabel internațional) pe gram grad Celsius (J76)',
          J78: 'Calorie (termochimic) pe centimetru secundă grad Celsius (J78)',
          J79: 'Calorie (termochimic) pe gram grad Celsius (J79)',
          J81: 'Calorii (termochimice) pe minut (J81)',
          J82: 'Calorii (termochimice) pe secundă (J82)',
          J83: 'Clo (J83)',
          J84: 'Centimetru pe secundă Kelvin (J84)',
          J85: 'Centimetru pe bar secundă (J85)',
          J87: 'Centimetru cub pe metru cub (J87)',
          J90: 'Decimetru cub pe zi (J90)',
          J91: 'Decimetru cub pe metru cub (J91)',
          J92: 'Decimetru cub pe minut (J92)',
          J93: 'Decimetru cub pe secundă (J93)',
          J95: 'Uncie (lichid Marea Britanie) pe zi (J95)',
          J96: 'Uncie (lichid Marea Britanie) pe oră (J96)',
          J97: 'Uncie (lichid Marea Britanie) pe minut (J97)',
          J98: 'Uncie (lichid Marea Britanie) pe secundă (J98)',
          J99: 'Uncie (lichid american) pe zi (J99)',
          JE: 'Joule per Kelvin (JE)',
          JK: 'Megajoul pe kilogram (JK)',
          JM: 'Megajoul pe metru cub (JM)',
          JNT: 'Bucăți îmbinare conductă (JNT)',
          JOU: 'Joule (JOU)',
          JPS: 'O suta de metri (JPS)',
          JWL: 'Carat (JWL)',
          K1: 'Kilowatt oră (K1)',
          K10: 'Uncie (lichid american) pe oră (K10)',
          K11: 'Uncie (lichid american) pe minut (K11)',
          K12: 'Uncie (lichid american) pe secundă (K12)',
          K13: 'Picior pe grad Fahrenheit (K13)',
          K14: 'Picior pe oră (K14)',
          K15: 'Livra pas (K15)',
          K16: 'Livra pas (K16)',
          K17: 'Picior pe psi (K17)',
          K18: 'Picior pe secundă grad Fahrenheit (K18)',
          K19: 'Picior pe secundă psi (K19)',
          K2: 'Amper kilovolt (K2)',
          K20: 'Picior cubic la puterea minus unu (K20)',
          K21: 'Picior cubic pe grad Fahrenheit (K21)',
          K22: 'Picior cubic pe zi (K22)',
          K23: 'Picior cubic pe psi (K23)',
          K26: 'Galon (UK) pe zi (K26)',
          K27: 'Galon (UK) pe oră (K27)',
          K28: 'Galon (UK) pe secundă (K28)',
          K3: 'Kilovolt ampere reactiv ora (K3)',
          K30: 'Galon (lichid SUA) pe secundă (K30)',
          K31: 'Gram (K31)',
          K32: 'Gill (UK) pe zi (K32)',
          K33: 'Gill (UK) pe oră (K33)',
          K34: 'Gill (UK) pe minut (K34)',
          K35: 'Gill (UK) pe secundă (K35)',
          K36: 'Gill (SUA) pe zi (K36)',
          K37: 'Gill (SUA) pe oră (K37)',
          K38: 'Gill (SUA) pe minut (K38)',
          K39: 'Gill (SUA) pe secundă (K39)',
          K40: 'Accelerația standard în cădere liberă (g) (K40)',
          K41: 'Cereale pe galon (SUA) (K41)',
          K42: 'Cal putere (boiler) (K42)',
          K43: 'Cal putere (electric) (K43)',
          K45: 'Inch pe grad Fahrenheit (K45)',
          K46: 'Inch pe psi (K46)',
          K47: 'Inch pe secundă grad Fahrenheit (K47)',
          K48: 'Inch pe secundă psi (K48)',
          K49: 'Centimetru cub reciproc (K49)',
          K50: 'Kilobaud (K50)',
          K51: 'Kilocalorie (medie) (K51)',
          K52: 'Kilocalorie (tabel internațional) pe oră grad Celsius (K52)',
          K53: 'Kilocalorie (termochimic) (K53)',
          K54: 'Kilocalorie (termochimică) pe minut (K54)',
          K55: 'Kilocalorie (termochimică) pe secundă (K55)',
          K58: 'Kilomol pe oră (K58)',
          K59: 'Kilomol pe metru cub Kelvin (K59)',
          K6: 'Kilolitrul (K6)',
          K60: 'Kilomol pe metru cub bar (K60)',
          K61: 'Kilomol pe minut (K61)',
          K62: 'Litru pe litru (K62)',
          K63: 'Litru reciproc (K63)',
          K64: 'Livra (avoirdupois) pe grad Fahrenheit (K64)',
          K65: 'Livra (avoirdupois) picior pătrat (K65)',
          K66: 'Livra (avoirdupois) pe zi (K66)',
          K67: 'Livra pe metru ora (K67)',
          K68: 'Livra pe secundă picior (K68)',
          K69: 'Livra (avoirdupois) per grad de picior cubic Fahrenheit (K69)',
          K70: 'Livra (avoirdupois) per psi picior cub (K70)',
          K71: 'Livra (avoirdupois) pe galon (UK) (K71)',
          K73: 'Livra (avoirdupois) pe oră grad Fahrenheit (K73)',
          K74: 'Livra (avoirdupois) pe oră psi (K74)',
          K75: 'Livra (avoirdupois) per grad cub inch Fahrenheit (K75)',
          K76: 'Livra (avoirdupois) per centimetru cub psi (K76)',
          K77: 'Livra (avoirdupois) per psi (K77)',
          K78: 'Livra (avoirdupois) pe minut (K78)',
          K79: 'Livra (avoirdupois) pe minut grad Fahrenheit (K79)',
          K80: 'Livra (avoirdupois) pe minut psi (K80)',
          K81: 'Livra (avoirdupois) pe secundă (K81)',
          K82: 'Livră (avoirdupois) pe gradul doi Fahrenheit (K82)',
          K83: 'Livra (avoirdupois) pe secundă psi (K83)',
          K84: 'Livra pe curte cubica (K84)',
          K85: 'Livra (K85)',
          K86: 'Livra (K86)',
          K87: 'PSI cubic inch pe secundă (K87)',
          K88: 'Litru PSI pe secundă (K88)',
          K89: 'PSI metru cub pe secundă (K89)',
          K90: 'Picior cubic psi pe secundă (K90)',
          K91: 'Livra (K91)',
          K92: 'Livra (K92)',
          K93: 'Psi la puterea minus unu (K93)',
          K94: 'Quart (lichid UK) pe zi (K94)',
          K95: 'Quart (lichid UK) pe oră (K95)',
          K96: 'Quart (lichid UK) pe minut (K96)',
          K97: 'Quart (lichid UK) pe secundă (K97)',
          K98: 'Quart (lichid US) pe zi (K98)',
          K99: 'Quart (lichid US) pe oră (K99)',
          KA: 'Disc (KA)',
          KAT: 'Katal (KAT)',
          KB: 'Kilocaracter (KB)',
          KBA: 'Kilobar (KBA)',
          KCC: 'Kilogram de clorură de colină (KCC)',
          KDW: 'Kg greutate netă scursă (KDW)',
          KEL: 'Kelvin (KEL)',
          KGS: 'Kilogram pe secundă (KGS)',
          KHY: 'Kilogram de peroxid de hidrogen (KHY)',
          KHZ: 'Kilohertz (KHZ)',
          KI: 'Kilogram pe milimetru lățime (KI)',
          KIC: 'Kilogram, inclusiv recipient (KIC)',
          KIP: 'Kilogram, inclusiv ambalajul interior (KIP)',
          KJ: 'Kilosegment (KJ)',
          KJO: 'Kilojoule (KJO)',
          KL: 'Kilogram pe metru (KL)',
          KLK: 'Procentul de substanta uscata lactica (KLK)',
          KLX: 'Kilolux (KLX)',
          KMA: 'Kilogram de metilamină (KMA)',
          KMH: 'Kilometru pe oră (KMH)',
          KMK: 'Kilometru pătrat (KMK)',
          KMQ: 'Kilogram pe metru cub (KMQ)',
          KNI: 'Kilogram de azot (KNI)',
          KNM: 'Kilonewton pe metru pătrat (KNM)',
          KNS: 'Kilogram de substanță numită (KNS)',
          KNT: 'Nod (KNT)',
          KO: 'Potasa caustica de miliechivalenta per gram de produs (KO)',
          KPA: 'Kilopascal (KPA)',
          KPH: 'Kilogram de hidroxid de potasiu (potasă caustică) (KPH)',
          KPO: 'Kilogram de oxid de potasiu (KPO)',
          KPP: 'Kilogram de pentoxid de fosfor (anhidridă fosforică) (KPP)',
          KR: 'Kiloroentgen (KR)',
          KSD: 'Kilogram de substanță 90 % uscată (KSD)',
          KSH: 'Kilogram de hidroxid de sodiu (sodă caustică) (KSH)',
          KT: 'Kit (KT)',
          KTN: 'Kilotonă (KTN)',
          KUR: 'Kilogram de uraniu (KUR)',
          KVA: 'Kilovolt (KVA)',
          KVR: 'Kilovar (KVR)',
          KVT: 'Kilovolt (KVT)',
          KW: 'Kilogram pe milimetru (KW)',
          KWH: 'Kilowatt oră (KWH)',
          KWN: 'Kilowatt oră per metru cub normalizat (KWN)',
          KWO: 'Kilogram de trioxid de tungsten (KWO)',
          KWS: 'Kilowatt oră pe metru cub standard (KWS)',
          KWT: 'Kilowatt (KWT)',
          KX: 'Mililitru pe kilogram (KX)',
          L10: 'Litru (lichid american) pe minut (L10)',
          L11: 'Litru (lichid american) pe secundă (L11)',
          L12: 'Metru pe secundă Kelvin (L12)',
          L13: 'Metru pe secundă bar (L13)',
          L14: 'Metru pătrat grad Celsius pe kilocalorie (tabel internațional) (L14)',
          L15: 'Milipascal secundă pe Kelvin (L15)',
          L16: 'Milipascal secundă pe bar (L16)',
          L17: 'Miligram pe metru cub Kelvin (L17)',
          L18: 'Miligram pe metru cub bar (L18)',
          L19: 'Mililitru pe litru (L19)',
          L2: 'Litru pe minut (L2)',
          L20: 'Milimetri cubi reciproci (L20)',
          L21: 'Milimetri cubi pe metru cub (L21)',
          L23: 'Mol pe oră (L23)',
          L24: 'Mol pe kilogram Kelvin (L24)',
          L25: 'Mol pe kilogram bar (L25)',
          L26: 'Mol pe litru Kelvin (L26)',
          L27: 'Mol pe litru bara (L27)',
          L28: 'Mol pe metru cub Kelvin (L28)',
          L29: 'Mol pe metru cub bara (L29)',
          L30: 'Mol pe minut (L30)',
          L31: 'Miliroentgen echivalent kilocorp (L31)',
          L32: 'Nanograme per kilogram (L32)',
          L33: 'Uncie (avoirdupois) pe zi (L33)',
          L34: 'Uncie (avoirdupois) pe oră (L34)',
          L35: 'Uncie (avoirdupois) pe minut (L35)',
          L36: 'Uncie (avoirdupois) pe secundă (L36)',
          L37: 'Uncie (avoirdupois) per galon (UK) (L37)',
          L38: 'Uncie (avoirdupois) pe galon (SUA) (L38)',
          L39: 'Uncie (avoirdupois) per centimetru cub (L39)',
          L40: 'Uncie (avoirdupois) (L40)',
          L41: 'Uncie (avoirdupois) (L41)',
          L42: 'Picosiemens pe metru (L42)',
          L43: 'Peck (UK) (L43)',
          L44: 'Peck (UK) pe zi (L44)',
          L45: 'Peck (UK) pe oră (L45)',
          L46: 'Peck (UK) pe minut (L46)',
          L47: 'Peck (UK) pe secundă (L47)',
          L48: 'Peck (SUA uscat) pe zi (L48)',
          L49: 'Peck (SUA uscat) pe oră (L49)',
          L50: 'Peck (US uscat) pe minut (L50)',
          L51: 'Peck (US uscat) pe secundă (L51)',
          L52: 'PSI pe psi (L52)',
          L53: 'Halba (UK) pe zi (L53)',
          L54: 'Halba (UK) pe oră (L54)',
          L55: 'Halba (UK) pe minut (L55)',
          L56: 'Halba (UK) pe secundă (L56)',
          L57: 'Halba lichidă (SUA) pe zi (L57)',
          L58: 'Halba lichidă (SUA) pe orĂ (L58)',
          L59: 'Halba lichidă (SUA) pe minut (L59)',
          L60: 'Halba lichidă (SUA) pe secundă (L60)',
          L63: 'Slug pe zi (L63)',
          L64: 'Slug pe secundă picior (L64)',
          L65: 'Slug pe picior cub (L65)',
          L66: 'Slug pe oră (L66)',
          L67: 'Slug pe minut (L67)',
          L68: 'Slug pe secundă (L68)',
          L69: 'Tonă per Kelvin (L69)',
          L70: 'Tonă per bar (L70)',
          L71: 'Tonă pe zi (L71)',
          L72: 'Tonă pe zi Kelvin (L72)',
          L73: 'Tonă pe zi bar (L73)',
          L74: 'Tonă pe oră Kelvin (L74)',
          L75: 'Tonă pe oră bar (L75)',
          L76: 'Tonă pe metru cub Kelvin (L76)',
          L77: 'Tonă pe metru cub bar (L77)',
          L78: 'Tonă pe minut (L78)',
          L79: 'Tonă pe minut Kelvin (L79)',
          L80: 'Tonă pe minut bar (L80)',
          L81: 'Tonă pe secundă (L81)',
          L82: 'Tonă pe secundă Kelvin (L82)',
          L83: 'Tonă pe secundă bar (L83)',
          L84: 'Ton (transport maritim în Marea Britanie) (L84)',
          L85: 'O tona lunga pe zi (L85)',
          L86: 'Ton (transport maritim american) (L86)',
          L87: 'Ton scurt pe grad Fahrenheit (L87)',
          L88: 'O tona scurta pe zi (L88)',
          L89: 'Ton scurt pe oră grad Fahrenheit (L89)',
          L90: 'O tona scurta pe oră psi (L90)',
          L91: 'O tona scurta per psi (L91)',
          L92: 'Tonă (Marea Britanie lunga) per yard cubic (L92)',
          L93: 'Tonă (SUA) pe yard cubic (L93)',
          L94: 'Forta tona (Scurta în SUA) (L94)',
          L95: 'An comun (L95)',
          L96: 'An sideral (L96)',
          L98: 'Yard pe grad Fahrenheit (L98)',
          L99: 'Yard per psi (L99)',
          LA: 'Livră pe centimetru cub (LA)',
          LAC: 'Procentajul excesului de lactoză (LAC)',
          LBR: 'Livră (LBR)',
          LBT: 'Troy pound (SUA) (LBT)',
          LD: 'Litru pe zi (LD)',
          LEF: 'Frunză (LEF)',
          LF: 'Picior liniar (LF)',
          LH: 'Ora travaliului (LH)',
          LK: 'Link (LK)',
          LN: 'Lungime (LN)',
          LO: 'Lot [unitatea de achiziții] (LO)',
          LP: 'Livră lichidă (LP)',
          LPA: 'Litru de alcool pur (LPA)',
          LR: 'Strat (LR)',
          LS: 'Sumă forfetară (LS)',
          LTN: 'Tonă (Marea Britanie) sau tonă lungă (SUA) (LTN)',
          LUB: 'Tonă metrică, ulei lubrifiant (LUB)',
          LUM: 'Lumen (LUM)',
          LUX: 'Lux (LUX)',
          LY: 'Yard liniar (LY)',
          M1: 'Miligram pe litru (M1)',
          M10: 'Yard cubic reciproc (M10)',
          M11: 'Yard cubic pe grad Fahrenheit (M11)',
          M12: 'Yard cubic pe zi (M12)',
          M13: 'Yard cubic pe oră (M13)',
          M14: 'Yard cubic per psi (M14)',
          M15: 'Yard cubic pe minut (M15)',
          M16: 'Yard cubic pe secundă (M16)',
          M17: 'Kilohertz metru (M17)',
          M18: 'Gigahertz metru (M18)',
          M19: 'Beaufort (M19)',
          M20: 'Reciproc megaKelvin sau megaKelvin la puterea minus unu (M20)',
          M21: 'Kilovolt reciproc (M21)',
          M22: 'Mililitru pe minut de centimetru pătrat (M22)',
          M23: 'Newton pe centimetru (M23)',
          M24: 'Ohm kilometru (M24)',
          M25: 'Procent pe grad Celsius (M25)',
          M26: 'Gigaohm pe metru (M26)',
          M27: 'Metru megahertz (M27)',
          M29: 'Kilogram pe kilogram (M29)',
          M30: 'Volt reciproc secundă amper reciproc (M30)',
          M31: 'Kilogram pe kilometru (M31)',
          M32: 'Pascal secundă pe litru (M32)',
          M33: 'Millimol per litru (M33)',
          M34: 'Newton metru pe metru pătrat (M34)',
          M35: 'Milivolt (M35)',
          M36: 'Lună de 30 zile (M36)',
          M37: 'Actual/360 (M37)',
          M38: 'Kilometru pe secundă la pătrat (M38)',
          M39: 'Centimetru pe secundă la pătrat (M39)',
          M4: 'Valoare monetară (M4)',
          M40: 'Yard pe secundă la pătrat (M40)',
          M41: 'Milimetri pe secundă la pătrat (M41)',
          M42: 'Milă (milometru statuat) pe secundă la pătrat (M42)',
          M43: 'Mil (M43)',
          M44: 'Rotație (M44)',
          M45: 'Grad [unitate de unghi] pe secundă la pătrat (M45)',
          M46: 'Rotație pe minut (M46)',
          M47: 'Mil circulară (M47)',
          M48: 'Milă pătrată (bazată pe piciorul studiului american) (M48)',
          M49: 'Lanț (bazat pe picior releveu SUA) (M49)',
          M5: 'Microcurie (M5)',
          M50: 'Furlong (M50)',
          M51: 'Picior (releveu SUA) (M51)',
          M52: 'Mile (bazat pe piciorul de sondaj american) (M52)',
          M53: 'Metru pe pascal (M53)',
          M55: 'Metru pe radiant (M55)',
          M56: 'Se agita (M56)',
          M57: 'Milă pe minut (M57)',
          M58: 'Milă pe secundă (M58)',
          M59: 'Metru pe secundă pascal (M59)',
          M60: 'Metru pe oră (M60)',
          M61: 'Inch pe an (M61)',
          M62: 'Kilometru pe secundă (M62)',
          M63: 'Inch pe minut (M63)',
          M64: 'Yard pe secundă (M64)',
          M65: 'Yard pe minut (M65)',
          M66: 'Yard pe oră (M66)',
          M67: 'Acre (M67)',
          M68: 'Cordonul (128 ft3) (M68)',
          M69: 'Mile cub (statutul Marii Britanii) (M69)',
          M7: 'Micro (M7)',
          M70: 'Ton, înregistrare (M70)',
          M71: 'Metru cub per pascal (M71)',
          M72: 'Bel (M72)',
          M73: 'Kilogram pe metru cub pascal (M73)',
          M74: 'Kilogram per pascal (M74)',
          M75: 'Kilometru (M75)',
          M76: 'Poundal (M76)',
          M77: 'Kilogram metru pe secundă la pătrat (M77)',
          M78: 'Iaz (M78)',
          M79: 'Picior pătrat pe oră (M79)',
          M80: 'Stokes per pascal (M80)',
          M81: 'Centimetru pătrat pe secundă (M81)',
          M82: 'Metru pătrat pe secundă pascal (M82)',
          M83: 'Denier (M83)',
          M84: 'Livră pe metru (M84)',
          M85: 'Ton, test de (M85)',
          M86: 'Pfund (M86)',
          M87: 'Kilogram pe secundă pascal (M87)',
          M88: 'Tonă pe lună (M88)',
          M89: 'Tonă pe an (M89)',
          M9: 'Milioane Btu per 1000 picior cub (M9)',
          M90: 'Kilometru pe oră (M90)',
          M91: 'Livră pe kilogram (M91)',
          M92: 'Livră (M92)',
          M93: 'Newton metru pe radian (M93)',
          M94: 'Kilogram de metru (M94)',
          M95: 'Piciorul poundal (M95)',
          M96: 'Livră inch (M96)',
          M97: 'Dyne metru (M97)',
          M98: 'Kilogram centimetru pe secundă (M98)',
          M99: 'Gram centimetru pe secundă (M99)',
          MAH: 'Megavolt amper reactiv oră (MAH)',
          MAL: 'Megalitre (MAL)',
          MAM: 'Megametre (MAM)',
          MAR: 'Megavar (MAR)',
          MAW: 'Megawatt (MAW)',
          MBE: 'O mie echivalent caramida standard (MBE)',
          MBF: 'O mie de picioare la bord (MBF)',
          MBR: 'Milibar (MBR)',
          MC: 'Microgram (MC)',
          MCU: 'Milicurie (MCU)',
          MD: 'Tonă metrică uscată de aer (MD)',
          MGM: 'Miligram (MGM)',
          MHZ: 'Megahertz (MHZ)',
          MIK: 'Milă pătrată (milometru statuat) (MIK)',
          MIL: 'Mii de persoane (MIL)',
          MIN: 'Minut [timp] (MIN)',
          MIO: 'Un milion (MIO)',
          MIU: 'Milioane de unitati internaționale (MIU)',
          MLD: 'Biliard (MLD)',
          MLT: 'Mililitru (MLT)',
          MMK: 'Milimetru pătrat (MMK)',
          MMQ: 'Milimetri cubi (MMQ)',
          MMT: 'Milimetri (MMT)',
          MND: 'Kilogram, greutate uscată (MND)',
          MON: 'Lună (MON)',
          MPA: 'Megapascal (MPA)',
          MQH: 'Metru cub pe oră (MQH)',
          MQS: 'Metru cub pe secundă (MQS)',
          MSK: 'Metru pe secundă la pătrat (MSK)',
          MTS: 'Metru pe secundă (MTS)',
          MVA: 'Megavolt amper (MVA)',
          MWH: 'Megawatt oră (1000 kW.h) (MWH)',
          N1: 'Caloria stiloului injector (pen) (N1)',
          N10: 'Livră picior pe secundă (N10)',
          N11: 'Livră inch pe secundă (N11)',
          N12: 'Pferdestaerke (N12)',
          N13: 'Centimetru de mercur (0 grd C) (N13)',
          N14: 'Centimetru de apa (4 grd C) (N14)',
          N15: 'Picior de apa (39,2 ›F) (N15)',
          N16: 'Centimetru de mercur (32 grd F) (N16)',
          N17: 'Centimetru de mercur (60 grd F) (N17)',
          N18: 'Inci de apă (39,2 ›F) (N18)',
          N19: 'Inci de apă (60 ›F) (N19)',
          N20: 'Kip pe inch pătrat (N20)',
          N21: 'Poundal pe metru pătrat (N21)',
          N22: 'Uncie (avoirdupois) pe centimetru pătrat (N22)',
          N23: 'Metru convențional de apă (N23)',
          N24: 'Gram pe milimetru pătrat (N24)',
          N25: 'Livră pe metru pătrat (N25)',
          N26: 'Poundal pe centimetru pătrat (N26)',
          N27: 'Picior la a patra putere (N27)',
          N28: 'Decimetru cub per kilogram (N28)',
          N29: 'Picior cub pe kilogram (N29)',
          N3: 'Punct de imprimare (N3)',
          N30: 'Centimetru cub per kilogram (N30)',
          N31: 'Kilonewton pe metru (N31)',
          N32: 'Poundal pe inch (N32)',
          N33: 'Livră (N33)',
          N34: 'Poundal (N34)',
          N35: 'Poise per pascal (N35)',
          N36: 'Newton secundă pe metru pătrat (N36)',
          N37: 'Kilogram pe metru de secundă (N37)',
          N38: 'Kilogram pe metru minut (N38)',
          N39: 'Kilogram pe metru de zi (N39)',
          N40: 'Kilogram pe metru oră (N40)',
          N41: 'Gram pe centimetru secundă (N41)',
          N42: 'Poundal (N42)',
          N43: 'Livră pe minut picior (N43)',
          N44: 'Livră pe zi picior (N44)',
          N45: 'Metru cub pe secundă pascal (N45)',
          N46: 'Livră picior (N46)',
          N47: 'Inch poundal (N47)',
          N48: 'Watt pe centimetru pătrat (N48)',
          N49: 'Watt pe inch pătrat (N49)',
          N50: 'BTU (masură internațională) pe metru pătrat ora (N50)',
          N51: 'BTU (termochimică) pe metru pătrat ora (N51)',
          N52: 'BTU (termochimică) pe minut de metru pătrat (N52)',
          N53: 'BTU (masură internațională) pe secundă metru pătrat (N53)',
          N54: 'BTU (termochimică) pe secundă metru pătrat (N54)',
          N55: 'BTU (masa internaționala) pe secundă pătrată (N55)',
          N56: 'Calorie (termochimic) pe centimetru pătrat minut (N56)',
          N57: 'Calorie (termochimic) pe centimetru pătrat secundă (N57)',
          N58: 'BTU (masură internațională) pe picior cub (N58)',
          N59: 'BTU (termochimică) pe picior cub (N59)',
          N60: 'BTU (tabel internațional) pe grad Fahrenheit (N60)',
          N61: 'BTU (termochimică) pe grad Fahrenheit (N61)',
          N62: 'BTU (tabel internațional) pe grad Rankine (N62)',
          N63: 'BTU (termochimică) pe grad Rankine (N63)',
          N64: 'BTU (termochimică) pe lira Rankine grad (N64)',
          N65: 'Kilocalorie (tabel internațional) pe gram Kelvin (N65)',
          N66: 'BTU (39 grd F) (N66)',
          N67: 'BTU (59 grd F) (N67)',
          N68: 'BTU (60 grd F) (N68)',
          N69: 'Calorii (20 grdC) (N69)',
          N70: 'Quad (1015 BtuIT) (N70)',
          N71: 'Term (CE) (N71)',
          N72: 'Therm (SUA) (N72)',
          N73: 'BTU (termochimică) per kilogram (N73)',
          N74: 'BTU (masură internațională) pe oră grad de metru pătrat Fahrenheit (N74)',
          N75: 'BTU (termochimică) pe oră grad de picior pătrat Fahrenheit (N75)',
          N76: 'BTU (masură internațională) pe secundă grad de picior pătrat Fahrenheit (N76)',
          N77: 'BTU (termochimică) pe secundă grad de picior pătrat Fahrenheit (N77)',
          N78: 'Kilowatt pe metru pătrat Kelvin (N78)',
          N79: 'Kelvin per pascal (N79)',
          N80: 'Watt pe metru grad Celsius (N80)',
          N81: 'Kilowatt pe metru Kelvin (N81)',
          N82: 'Kilowatt pe metru grad Celsius (N82)',
          N83: 'Metru pe grad celcius metru (N83)',
          N84: 'Grad Fahrenheit oră per unitate termică britanică (tabel internațional) (N84)',
          N85: 'Grad Fahrenheit oră per unitate termică britanică (termochimic) (N85)',
          N86: 'Grad Fahrenheit secundă pe unitate termică britanică (tabel internațional) (N86)',
          N87: 'Grad Fahrenheit secundă pe unitate termică britanică (termochimic) (N87)',
          N88: 'Grad Fahrenheit oră metru pătrat per unitate termică britanică (masa internaționala) inch (N88)',
          N89: 'Grad Fahrenheit oră metru pătrat per unitate termică britanică (termochimic) inch (N89)',
          N90: 'Kilofarad (N90)',
          N91: 'Joule reciproce (N91)',
          N92: 'Picosiemens (N92)',
          N93: 'Amperi per pascal (N93)',
          N94: 'Franklin (N94)',
          N95: 'Amper minut (N95)',
          N96: 'Biot (N96)',
          N97: 'Gilbert (N97)',
          N98: 'Volt per pascal (N98)',
          N99: 'Picovolt (N99)',
          NA: 'Miligram pe kilogram (NA)',
          NCL: 'Număr de celule (NCL)',
          NEW: 'Newton (NEW)',
          NF: 'Mesaj (NF)',
          NIL: 'Nul (NIL)',
          NIU: 'Număr de unități internaționale (NIU)',
          NL: 'Sarcina (NL)',
          NM3: 'Metru cub normalizat (NM3)',
          NMI: 'Milă marină (NMI)',
          NMP: 'Număr de ambalaje (NMP)',
          NPT: 'Număr de părți (NPT)',
          NT: 'Tonă netă (NT)',
          NU: 'Newton metru (NU)',
          NX: 'Parte la o mie (NX)',
          OA: 'Panou (OA)',
          ODE: 'Echivalent ODS (ODE)',
          ODG: 'Gram ODS (ODG)',
          ODK: 'Kilogram ODS (ODK)',
          ODM: 'Miligram ODS (ODM)',
          OHM: 'Ohm (OHM)',
          ON: 'Uncie pe metru pătrat (ON)',
          ONZ: 'Uncie (avoirdupois) (ONZ)',
          OPM: 'Oscilatii pe minut (OPM)',
          OT: 'Ore suplimentare ora (OT)',
          OZA: 'Uncie de lichid (SUA) (OZA)',
          OZI: 'Uncie de lichid (UK) (OZI)',
          P1: 'Procent (P1)',
          P10: 'Coulomb pe metru (P10)',
          P11: 'Kiloweber (P11)',
          P12: 'Gama (P12)',
          P13: 'Kilotesla (P13)',
          P14: 'Joule pe secundă (P14)',
          P15: 'Joule pe minut (P15)',
          P16: 'Joule pe oră (P16)',
          P17: 'Joule pe zi (P17)',
          P18: 'Kilojoul pe secundă (P18)',
          P19: 'Kilojoul pe minut (P19)',
          P2: 'Livră pe picior (P2)',
          P20: 'Kilojoul pe oră (P20)',
          P21: 'Kilojoul pe zi (P21)',
          P22: 'Nanoohm (P22)',
          P23: 'Ohm circular (P23)',
          P24: 'Kilohenry (P24)',
          P25: 'Lumen pe metru pătrat (P25)',
          P26: '?Phot? ? ?Phot? (P26)',
          P27: 'Licoare pentru picioare (P27)',
          P28: 'Candelă pe centimetru pătrat (P28)',
          P29: 'Footlambert (P29)',
          P30: 'Lambert (P30)',
          P31: 'Stilb (P31)',
          P32: 'Candelă pe metru pătrat (P32)',
          P33: 'Kilocandela (P33)',
          P34: 'Millicandela (P34)',
          P35: 'Hefner (P35)',
          P36: 'Candelă internațională (P36)',
          P37: 'BTU (masură internațională) pe metru pătrat (P37)',
          P38: 'BTU (termochimică) pe metru pătrat (P38)',
          P39: 'Calorii (termochimice) pe centimetru pătrat (P39)',
          P40: 'Langley (P40)',
          P41: 'Decadă (logaritmică) (P41)',
          P42: 'Pascal la pătrat secundă (P42)',
          P43: 'Bel pe metru (P43)',
          P44: 'Livră mol (P44)',
          P45: 'Livră mol pe secundă (P45)',
          P46: 'Livră mol pe minut (P46)',
          P47: 'Kilomol pe kilogram (P47)',
          P48: 'Livră mol pe kilogram (P48)',
          P49: 'Newton metru pătrat pe amperi (P49)',
          P5: 'Cinci pachete (P5)',
          P50: 'Weber metru (P50)',
          P51: 'Mol pe kilogram pascal (P51)',
          P52: 'Mol pe metru cub pascal (P52)',
          P53: 'Pol unitate de unitate (P53)',
          P54: 'Milligray pe secundă (P54)',
          P55: 'Micrograie pe secundă (P55)',
          P56: 'Nanogray pe secundă (P56)',
          P57: 'Gri pe minut (P57)',
          P58: 'Milligray pe minut (P58)',
          P59: 'Micrograie pe minut (P59)',
          P60: 'Nanogray pe minut (P60)',
          P61: 'Gri pe oră (P61)',
          P62: 'Milligray pe oră (P62)',
          P63: 'Micrograie pe oră (P63)',
          P64: 'Nanogray pe oră (P64)',
          P65: 'Sievert pe secundă (P65)',
          P66: 'Milisievert pe secundă (P66)',
          P67: 'Microsievert pe secundă (P67)',
          P68: 'Nanosievert pe secundă (P68)',
          P69: 'REM pe secundă (P69)',
          P70: 'Sievert pe oră (P70)',
          P71: 'Milisievert pe oră (P71)',
          P72: 'Microsievert pe oră (P72)',
          P73: 'Nanosievert pe oră (P73)',
          P74: 'Sievert pe minut (P74)',
          P75: 'Milisievert pe minut (P75)',
          P76: 'Microsievert pe minut (P76)',
          P77: 'Nanosievert pe minut (P77)',
          P78: 'Centimetru pătrat reciproc (P78)',
          P79: 'Patrat Pascal metru per kilogram (P79)',
          P80: 'Milipascal pe metru (P80)',
          P81: 'Kilopascal pe metru (P81)',
          P82: 'Hectopascal per metru (P82)',
          P83: 'Atmosferă standard pe metru (P83)',
          P84: 'Atmosferă tehnică pe metru (P84)',
          P85: 'Torr pe metru (P85)',
          P86: 'PSI pe inch (P86)',
          P87: 'Metru cub pe secundă metru pătrat (P87)',
          P88: 'Rhe (P88)',
          P89: 'Livră (P89)',
          P90: 'Livră (P90)',
          P91: 'Perm (0 ›C) (P91)',
          P92: 'Perm (23 ›C) (P92)',
          P93: 'Byte pe secundă (P93)',
          P94: 'Kilobyte pe secundă (P94)',
          P95: 'Megabyte pe secundă (P95)',
          P96: 'Volt reciproc (P96)',
          P97: 'Radian reciproc (P97)',
          P98: 'Pascal la suma de putere a numerelor stoichiometrice (P98)',
          P99: 'Mol pe metru de cubiv la suma de putere a numerelor stoechiometrice (P99)',
          PAL: 'Pascal (PAL)',
          PD: 'Pad (PD)',
          PFL: 'Litru de proba (PFL)',
          PGL: 'Galon de probă (PGL)',
          PI: 'Pas (PI)',
          PLA: 'Grad Plato (PLA)',
          PO: 'Livră pe centimetru de lungime (PO)',
          PQ: 'Pagina pe inch (PQ)',
          PR: 'Pereche (PR)',
          PS: 'Livră (PS)',
          PTD: 'Halba uscată (SUA) (PTD)',
          PTI: 'Halba (UK) (PTI)',
          PTL: 'Halba lichidă (SUA) (PTL)',
          PTN: 'Porțiune (PTN)',
          Q10: 'Joule per tesla (Q10)',
          Q11: 'Erlang (Q11)',
          Q12: 'Octet (Q12)',
          Q13: 'Octet pe secundă (Q13)',
          Q14: 'Shannon (Q14)',
          Q15: 'Hartley (Q15)',
          Q16: 'Unitate naturală de informații (Q16)',
          Q17: 'Shannon pe secundă (Q17)',
          Q18: 'Hartley pe secundă (Q18)',
          Q19: 'Unitate naturala de informatii pe secundă (Q19)',
          Q20: 'Secundă pe kilogram (Q20)',
          Q21: 'Metru pătrat Watt (Q21)',
          Q22: 'Secundă pe radian metru cub (Q22)',
          Q23: 'Weber la puterea minus unu (Q23)',
          Q24: 'Centimetru reciproc (Q24)',
          Q25: 'Dioptru (Q25)',
          Q26: 'Una pe una (Q26)',
          Q27: 'Newton metru pe metru (Q27)',
          Q28: 'Kilogram pe metru pătrat pascal secundă (Q28)',
          Q29: 'Microgram per hectograma (Q29)',
          Q30: 'PH (potential de hidrogen) (Q30)',
          Q31: 'Kilojoul pe gram (Q31)',
          Q32: 'Femtolitre (Q32)',
          Q33: 'Picolitre (Q33)',
          Q34: 'Nanolitrul (Q34)',
          Q35: 'Megawati pe minut (Q35)',
          Q36: 'Metru pătrat pe metru cub (Q36)',
          Q37: 'Metru cub standard pe zi (Q37)',
          Q38: 'Metru cub standard pe oră (Q38)',
          Q39: 'Metru cub normalizat pe zi (Q39)',
          Q40: 'Metru cub normalizat pe oră (Q40)',
          Q41: 'Joule per metru cub normalizat (Q41)',
          Q42: 'Joule pe metru cub standard (Q42)',
          Q3: 'Masă (Q3)',
          QA: 'Pagina (QA)',
          QAN: 'Trimestru (de un an) (QAN)',
          QB: 'Pagina (QB)',
          QR: 'Quire (QR)',
          QTD: 'Litru uscat (SUA) (QTD)',
          QTI: 'Quart (UK) (QTI)',
          QTL: 'Litru lichid (SUA) (QTL)',
          QTR: 'Trimestru (Regatul Unit) (QTR)',
          R1: 'Pica (R1)',
          R9: 'Mii de metri cubi (R9)',
          RH: 'Ora de functionare sau de functionare (RH)',
          RM: 'Ream (RM)',
          ROM: 'Cameră (ROM)',
          RP: 'Livră pe ream (RP)',
          RPM: 'Rotații pe minut (RPM)',
          RPS: 'Rotații pe secundă (RPS)',
          RT: 'Venituri de o mila (RT)',
          S3: 'Picior pătrat pe secundă (S3)',
          S4: 'Metru pătrat pe secundă (S4)',
          SAN: 'Jumatate de an (6 luni) (SAN)',
          SCO: 'Punctaj (SCO)',
          SCR: 'Scrupula (SCR)',
          SEC: 'Secundă [unitate de timp] (SEC)',
          SG: 'Segment (SG)',
          SIE: 'Siemens (SIE)',
          SM3: 'Metru cub standard (SM3)',
          SMI: 'Mile (milometru statuat) (SMI)',
          SQ: 'Patrat (SQ)',
          SQR: 'Patrat, acoperisuri (SQR)',
          SR: 'Benzi (SR)',
          STC: 'Stick (STC)',
          STI: 'Stone (UK) (STI)',
          STK: 'Stick, tigara (STK)',
          STL: 'Litru standard (la 15 grd C) (STL)',
          STN: 'Tonă (SUA) sau tona scurtă (UK/SUA) (STN)',
          STW: 'Paie (STW)',
          SW: 'Skein (SW)',
          SX: 'Transport (SX)',
          SYR: 'Seringa (SYR)',
          T0: 'Linie de telecomunicații în exploatare (T0)',
          T3: 'O mie de bucăți (T3)',
          TAH: 'Kiloampere oră (mii de amper ora) (TAH)',
          TAN: 'Număr total de acid (TAN)',
          TI: 'O mie de centimetri pătrați (TI)',
          TIC: 'Tonă metrică, inclusiv recipient (TIC)',
          TIP: 'Tonă metrică, inclusiv ambalajul interior (TIP)',
          TKM: 'Tonă kilometru (TKM)',
          TMS: 'Kilogram de carne importată, mai puțin organe comestibile (TMS)',
          TP: 'Zece pachete (TP)',
          TPI: 'Dinți pe centimetru (TPI)',
          TPR: 'Zece perechi (TPR)',
          TQD: 'Mii de metri cubi pe zi (TQD)',
          TRL: 'Trilion (EUR) (TRL)',
          TST: 'Zece set (TST)',
          TTS: 'Zece mii de bete (TTS)',
          U1: 'Tratament (U1)',
          U2: 'Comprimat (U2)',
          UB: 'Media liniei de telecomunicații în exploatare (UB)',
          UC: 'Port de telecomunicații (UC)',
          VA: 'Volt ? amper pe kilogram (VA)',
          VLT: 'Volt (VLT)',
          VP: 'Volumul procentual (VP)',
          W2: 'Kg umed (W2)',
          WA: 'Watt pe kilogram (WA)',
          WB: 'Livră umedă (WB)',
          WCD: 'Cordonul (WCD)',
          WE: 'Tonă umedă (WE)',
          WEB: 'Weber (WEB)',
          WEE: 'Săptămână (WEE)',
          WG: 'Galon de vin (WG)',
          WHR: 'Ora Watt (WHR)',
          WM: 'Lună de lucru (WM)',
          WSD: 'Standard (WSD)',
          WTT: 'Watt (WTT)',
          X1: 'Lantul lui Gunter (X1)',
          YDK: 'Yard pătrat (YDK)',
          YDQ: 'Yard cubic (YDQ)',
          YRD: 'Yard (YRD)',
          Z11: 'Container suspendat (Z11)',
          ZP: 'Pagina (ZP)',
          ZZ: 'Unitate definită de comun acord (ZZ)',
          X1A: 'Tambur, oțel (X1A)',
          X1B: 'Tambur, aluminiu (X1B)',
          X1D: 'Tambur, placaj (X1D)',
          X1F: 'Container, flexibil (X1F)',
          X1G: 'Tambur, fibre (X1G)',
          X1W: 'Tambur, din lemn (X1W)',
          X2C: 'Butoi, din lemn (X2C)',
          X3A: 'Jerrican, oțel (X3A)',
          X3H: 'Jerrican, plastic (X3H)',
          X43: 'Sac, super vrac (X43)',
          X44: 'Pungă, pungă de poligam (X44)',
          X4A: 'Cutie, oțel (X4A)',
          X4B: 'Cutie, aluminiu (X4B)',
          X4C: 'Cutie, lemn natural (X4C)',
          X4D: 'Cutie, placaj (X4D)',
          X4F: 'Cutie, lemn reconstituit (X4F)',
          X4G: 'Cutie, panouri fibrolemnoase (X4G)',
          X4H: 'Cutie, plastic (X4H)',
          X5H: 'Pungă, țesută din plastic (X5H)',
          X5L: 'Sac, textil (X5L)',
          X5M: 'Sac, hârtie (X5M)',
          X6H: 'Ambalaj compozit, recipient din plastic (X6H)',
          X6P: 'Ambalaj compozit, recipient din sticlă (X6P)',
          X7A: 'Case, masina (X7A)',
          X7B: 'Carcasă, din lemn (X7B)',
          X8A: 'Palet, din lemn (X8A)',
          X8B: 'Ladă, din lemn (X8B)',
          X8C: 'Pachet, din lemn (X8C)',
          XAA: 'Recipient mare pentru vrac, din plastic rigid (XAA)',
          XAB: 'Recipient, fibră (XAB)',
          XAC: 'Recipient, hârtie (XAC)',
          XAD: 'Recipient din lemn (XAD)',
          XAE: 'Aerosoli (XAE)',
          XAF: 'Palet, modular, manșon 80x60 cm (XAF)',
          XAG: 'Palet, înfășurat în vrac (XAG)',
          XAH: 'Palet, 100cm x 110cm (XAH)',
          XAI: 'Scoica de scoica (XAI)',
          XAJ: 'Con de con (XAJ)',
          XAL: 'Bilă (XAL)',
          XAM: 'Fiola, neprotejată (XAM)',
          XAP: 'Fiola, protejată (XAP)',
          XAT: 'Atomizor (XAT)',
          XAV: 'Capsulă (XAV)',
          XB4: 'Centură (XB4)',
          XBA: 'Baril (XBA)',
          XBB: 'Bobină (XBB)',
          XBC: 'Bottlecrate/bottlerack (XBC)',
          XBD: 'Board (XBD)',
          XBE: 'Pachet (XBE)',
          XBF: 'Balon, neprotejat (XBF)',
          XBG: 'Sac (XBG)',
          XBH: 'Buchet (XBH)',
          XBI: 'Coș de gunoi (XBI)',
          XBJ: 'Găleată (XBJ)',
          XBK: 'Coș (XBK)',
          XBL: 'Balot, comprimat (XBL)',
          XBM: 'Bazin (XBM)',
          XBN: 'Balot, necomprimat (XBN)',
          XBO: 'Sticlă, neprotejată, cilindrică (XBO)',
          XBP: 'Balon, protejat (XBP)',
          XBQ: 'Flacon, protejat cilindric (XBQ)',
          XBR: 'Bar (XBR)',
          XBS: 'Sticlă, neprotejată, cu bulbi (XBS)',
          XBT: 'Șurub (XBT)',
          XBU: 'Cap la cap (XBU)',
          XBV: 'Sticlă, protejată, cu bulbi (XBV)',
          XBW: 'Cutie, pentru lichide (XBW)',
          XBX: 'Cutie (XBX)',
          XBY: 'Masă, în pachet/bucata/truss (XBY)',
          XBZ: 'Bare, în pachet/bucată/truss (XBZ)',
          XCA: 'Cutie, dreptunghiulară (XCA)',
          XCB: 'Ladă, bere (XCB)',
          XCC: 'Churn (XCC)',
          XCD: 'Poate, cu mâner și gura de scurgere (XCD)',
          XCE: 'Creel (XCE)',
          XCF: 'Cufăr (XCF)',
          XCG: 'Cușcă (XCG)',
          XCH: 'Piept (XCH)',
          XCI: 'Canistră (XCI)',
          XCJ: 'Coșciug (XCJ)',
          XCK: 'Butoiaș (XCK)',
          XCL: 'Bobină (XCL)',
          XCM: 'Card (XCM)',
          XCN: 'Container, nespecificat altfel ca echipament de transport (XCN)',
          XCO: 'Carboy, neprotejat (XCO)',
          XCP: 'Carboy, protejat (XCP)',
          XCQ: 'Cartuș (XCQ)',
          XCR: 'Ladă (XCR)',
          XCS: 'Cutie (case) (XCS)',
          XCT: 'Cutie de carton (XCT)',
          XCU: 'Cupă (XCU)',
          XCV: 'Copertă (XCV)',
          XCW: 'Cușcă, rolă (XCW)',
          XCX: 'Can, cilindric (XCX)',
          XCZ: 'Canvas (XCZ)',
          XDA: 'Cutie, strat multiplu, plastic (XDA)',
          XDB: 'Ladă, strat multiplu, din lemn (XDB)',
          XDC: 'Cutie, strat multiplu, carton (XDC)',
          XDG: 'Cușcă (CHEP) (XDG)',
          XDH: 'Box, CHEP, Eurobox (XDH)',
          XDI: 'Tambur, fier (XDI)',
          XDJ: 'Demijohn, neprotejat (XDJ)',
          XDK: 'Cutie, vrac, carton (XDK)',
          XDL: 'Cutie, vrac, din plastic (XDL)',
          XDM: 'Ladă, vrac, din lemn (XDM)',
          XDN: 'Seringa dozatoare (XDN)',
          XDP: 'Demijohn, protejat (XDP)',
          XDR: 'Tambur (XDR)',
          XDS: 'Tavă, un strat fără capac, plastic (XDS)',
          XDT: 'Tavă, un strat fără capac, din lemn (XDT)',
          XDU: 'Tavă, un strat fără capac, polistiren (XDU)',
          XDV: 'Tavă, un strat fără capac, carton (XDV)',
          XDW: 'Tavă, două straturi fără capac, plastic (XDW)',
          XDX: 'Tavă, două straturi fără capac, din lemn (XDX)',
          XDY: 'Tavă, două straturi fără capac, carton (XDY)',
          XEC: 'Pungă, plastic (XEC)',
          XED: 'Caz, cu baza de paleti (XED)',
          XEE: 'Carcasă, cu suport palet, din lemn (XEE)',
          XEF: 'Carcasă, cu suport palet, carton (XEF)',
          XEG: 'Carcasă, cu suport palet, plastic (XEG)',
          XEH: 'Carcasă, cu suport palet, metal (XEH)',
          XEI: 'Caz, izotermie (XEI)',
          XEN: 'Plic (XEN)',
          XFB: 'FlexiBag (XFB)',
          XFC: 'Ladă, fructe (XFC)',
          XFD: 'Ladă, înrămată (XFD)',
          XFE: 'Flexitank (XFE)',
          XFI: 'Bradkin (XFI)',
          XFL: 'Balon (XFL)',
          XFO: 'Cufăr de picior (XFO)',
          XFP: 'Pachet de filme (XFP)',
          XFR: 'Cadru (XFR)',
          XFT: 'Furnizor de alimente (XFT)',
          XFW: 'Cărucior, cu platformă (XFW)',
          XFX: 'Sac, recipient flexibil (XFX)',
          XGB: 'Sticla, gaz (XGB)',
          XGI: 'Grinzi (XGI)',
          XGL: 'Recipient, galon (XGL)',
          XGR: 'Recipient, sticlă (XGR)',
          XGU: 'Tavă, cu elemente plane stivuite orizontal (XGU)',
          XGY: 'Sac, gunny (XGY)',
          XGZ: 'Grinzi, în pachet/bucata/truss (XGZ)',
          XHA: 'Coș, cu mâner, plastic (XHA)',
          XHB: 'Coș, cu mâner, din lemn (XHB)',
          XHC: 'Coș, cu mâner, carton (XHC)',
          XHG: 'Butoi hogshead (XHG)',
          XHN: 'Umeraş (XHN)',
          XHR: 'Coș nuiele (XHR)',
          XIA: 'Pachet, afisaj, lemn (XIA)',
          XIB: 'Pachet, afisaj, carton (XIB)',
          XIC: 'Pachet, afisaj, plastic (XIC)',
          XID: 'Pachet, afisaj, metal (XID)',
          XIE: 'Pachet, arata (XIE)',
          XIF: 'Pachet, flux (XIF)',
          XIG: 'Pachet, hârtie învelită (XIG)',
          XIH: 'Tambur, plastic (XIH)',
          XIK: 'Pachet, carton, cu capace de prindere (XIK)',
          XIL: 'Tavă rigidă, cu capac stivuit (CEN TS 14482:2002) (XIL)',
          XIN: 'Lingou (XIN)',
          XIZ: 'Lingouri, în pachet/bucata/truss (XIZ)',
          XJB: 'Sac, jumbo (XJB)',
          XJC: 'Jerrican, dreptunghiular (XJC)',
          XJG: 'Ulcior (XJG)',
          XJR: 'Borcan (XJR)',
          XJT: 'Jutebag (XJT)',
          XJY: 'Jerrican, cilindric (XJY)',
          XKG: 'Butoi de bere (XKG)',
          XKI: 'Kit (XKI)',
          XLE: 'Bagaj (XLE)',
          XLG: 'Jurnal (XLG)',
          XLT: 'Lot (XLT)',
          XLU: 'Lug (XLU)',
          XLV: 'Liftvan (XLV)',
          XLZ: 'Bușteni, în pachet/truss (XLZ)',
          XMA: 'Ladă, metal (XMA)',
          XMB: 'Sac, se înmulteste? (XMB)',
          XMC: 'Ladă, lapte (XMC)',
          XMR: 'Recipient, din metal (XMR)',
          XMS: 'Sack, cu mai multe pereti (XMS)',
          XMT: 'Mat (XMT)',
          XMW: 'Recipient, înfășurat din plastic (XMW)',
          XMX: 'Cutie de chibrituri (XMX)',
          XNA: 'Nedisponibil (XNA)',
          XNE: 'Despachetat sau neambalat (XNE)',
          XNF: 'Despachetat sau neambalat, o singură unitate (XNF)',
          XNG: 'Despachetate sau neambalate, mai multe unități (XNG)',
          XNS: 'Cuib (XNS)',
          XNT: 'Plasă (XNT)',
          XNU: 'Plasă, tub, plastic (XNU)',
          XNV: 'Net, tub, textile (XNV)',
          XOA: 'Palet, CHEP 40 cm x 60 cm (XOA)',
          XOB: 'Palet, CHEP 80 cm x 120 cm (XOB)',
          XOC: 'Palet, CHEP 100 cm x 120 cm (XOC)',
          XOD: 'Palet, AS 4068 (XOD)',
          XOE: 'Palet, ISO T11 (XOE)',
          XOF: 'Platformă, greutate sau dimensiune nespecificată (XOF)',
          XOK: 'Bloc (XOK)',
          XOT: 'Octabina (XOT)',
          XOU: 'Recipient, exterior (XOU)',
          XP2: 'Pan (XP2)',
          XPA: 'Pachet (XPA)',
          XPC: 'Parcela (XPC)',
          XPD: 'Palet, modular, manșon 80x100 cm (XPD)',
          XPE: 'Palet, modular, manșon 80x120 cm (XPE)',
          XPF: 'Stilou injector (pen) (XPF)',
          XPG: 'Placă (XPG)',
          XPH: 'Ulcior (XPH)',
          XPI: 'Țeavă (XPI)',
          XPJ: 'Punnet (XPJ)',
          XPK: 'Pachet (XPK)',
          XPL: 'Găleată (XPL)',
          XPN: 'Scândură (XPN)',
          XPO: 'Husă (XPO)',
          XPR: 'Recipient, din plastic (XPR)',
          XPT: 'Oala (XPT)',
          XPU: 'Tavă (XPU)',
          XPV: 'Țevi, în pachet/bucata/truss (XPV)',
          XPX: 'Palet (XPX)',
          XPY: 'Plăci, în pachet/bucata/truss (XPY)',
          XPZ: 'Scânduri, în pachet/bucată/truss (XPZ)',
          XQA: 'Tambur, otel, cap nedetașabil (XQA)',
          XQB: 'Tambur, oțel, cap detașabil (XQB)',
          XQC: 'Tambur, din aluminiu, cap nedetașabil (XQC)',
          XQD: 'Tambur, aluminiu, cap detașabil (XQD)',
          XQF: 'Tambur, din plastic, cap nedetașabil (XQF)',
          XQG: 'Tambur, plastic, cap detașabil (XQG)',
          XQH: 'Butoi lemn, tip cep (XQH)',
          XQJ: 'Butoi lemn, cap detașabil (XQJ)',
          XQK: 'Jerican, otel, cap nedetașabil (XQK)',
          XQL: 'Jerrican, otel, cap detasabil (XQL)',
          XQM: 'Cap de plastic, nedetașabil (XQM)',
          XQN: 'Jerrican, plastic, cap detasabil (XQN)',
          XQP: 'Cutie, lemn, lemn natural, obișnuit (XQP)',
          XQQ: 'Cutie, lemn, lemn natural, cu pereți rezistenti la cernere (XQQ)',
          XQR: 'Cutie, plastic, extins (XQR)',
          XQS: 'Cutie, plastic, solid (XQS)',
          XRD: 'Tijă (XRD)',
          XRG: 'Inel (XRG)',
          XRJ: 'Rack, umeras de îmbrăcăminte (XRJ)',
          XRK: 'Rack (XRK)',
          XRL: 'Rolă (XRL)',
          XRO: 'Rolă (XRO)',
          XRT: 'ReDNet (XRT)',
          XRZ: 'Tije, în pachet/bucata/truss (XRZ)',
          XSA: 'Sack (XSA)',
          XSB: 'Lespede (XSB)',
          XSC: 'Ladă, superficială (XSC)',
          XSD: 'Ax (XSD)',
          XSE: 'Pieptul marii (XSE)',
          XSH: 'Plic (XSH)',
          XSI: 'Derapeaza (XSI)',
          XSK: 'Carcasă, cutie, cadru (XSK)',
          XSL: 'Foaia de alunecare (XSL)',
          XSM: 'Tablă de metal (XSM)',
          XSO: 'Bobină (XSO)',
          XSP: 'Folie de plastic (XSP)',
          XSS: 'Caz, din otel (XSS)',
          XST: 'Foaia de hartie (XST)',
          XSU: 'Valiză (XSU)',
          XSV: 'Plic, otel (XSV)',
          XSW: 'Infoliată (XSW)',
          XSY: 'Mânecă (XSY)',
          XSZ: 'Foi, în pachet/bucată/truss (XSZ)',
          XT1: 'Comprimat (XT1)',
          XTB: 'Cadă (XTB)',
          XTC: 'Piept de ceai (XTC)',
          XTD: 'Tub, pliabil (XTD)',
          XTE: 'Pneu (XTE)',
          XTG: 'Recipient pentru cisterna, generic (XTG)',
          XTI: 'Cravata (XTI)',
          XTK: 'Rezervor, dreptunghiular (XTK)',
          XTL: 'Cadă, cu capac (XTL)',
          XTN: 'Staniu (XTN)',
          XTO: 'Tun (XTO)',
          XTR: 'Trunchi (XTR)',
          XTS: 'Truss (XTS)',
          XTT: 'Sac, tote (XTT)',
          XTU: 'Tub (XTU)',
          XTV: 'Tub, cu duză (XTV)',
          XTW: 'Palet, triwall (XTW)',
          XTZ: 'Tuburi, în pachet/bucată/truss (XTZ)',
          XUC: 'Neascutita (XUC)',
          XUN: 'Unitate (XUN)',
          XVA: 'VAT (XVA)',
          XVG: 'Vrac, gaz (la 1031 mbar și 15 grdC) (XVG)',
          XVI: 'Flacon (XVI)',
          XVK: 'Vanpack (XVK)',
          XVL: 'Vrac, lichid (XVL)',
          XVO: 'Vrac, solide, particule mari (XVO)',
          XVP: 'Ambalaj vidat (XVP)',
          XVQ: 'Vrac, gaz lichefiat (la temp./presiune anormală) (XVQ)',
          XVN: 'Vehicul (XVN)',
          XVR: 'Particule groase, solide, granulare (XVR)',
          XVS: 'Vrac, deșeuri metalice (XVS)',
          XVY: 'Vrac, solide, particule fine (pulberi) (XVY)',
          XWA: 'Recipient vrac (XWA)',
          XWB: 'Biberonul de Wickerbottle (XWB)',
          XWC: 'Recipient vrac, oțel (XWC)',
          XWD: 'Recipient vrac, aluminiu (XWD)',
          XWF: 'Recipient vrac, din metal (XWF)',
          XWG: 'Recipient vrac, din oțel, presurizat > 10 kpa (XWG)',
          XWH: 'Recipient vrac, din aluminiu, presurizat > 10 kpa (XWH)',
          XWJ: 'Recipient vrac, metal, presurizat 10 kpa (XWJ)',
          XWK: 'Recipient vrac, din oțel, lichide (XWK)',
          XWL: 'Recipient vrac, aluminiu, lichide (XWL)',
          XWM: 'Recipient vrac, metalic, lichide (XWM)',
          XWN: 'Recipient vrac, plastic țesut, fără acoperire/căptușeală (XWN)',
          XWP: 'Recipient vrac, plastic țesut, acoperit (XWP)',
          XWQ: 'Recipient vrac, plastic țesut, căptușit (XWQ)',
          XWR: 'Recipient vrac, plastic țesut, acoperit/căptușit (XWR)',
          XWS: 'Recipient vrac, pelicula din plastic (XWS)',
          XWT: 'Recipient vrac, textil, acoperit/căptușit (XWT)',
          XWU: 'Recipient vrac, din lemn natural, cu sigiliu interior (XWU)',
          XWV: 'Recipient vrac, textil, acoperit (XWV)',
          XWW: 'Recipient vrac, textil, căptușit (XWW)',
          XWX: 'Recipient vrac, textil, acoperite și căptușit (XWX)',
          XWY: 'Recipient vrac, placaj, căptușit (XWY)',
          XWZ: 'Recipient vrac, lemn reconstituit, căptușit (XWZ)',
          XXA: 'Pungă, plastic țesut, fără strat interior/căptușeală (XXA)',
          XXB: 'Sac, plastic țesut, dovada cernerii (XXB)',
          XXC: 'Pungă, plastic țesut, rezistentă la apă (XXC)',
          XXD: 'Pungă, folie de plastic (XXD)',
          XXF: 'Sac, textil, fără strat interior (XXF)',
          XXG: 'Sac, textil, probă de cernere (XXG)',
          XXH: 'Sac, textil, rezistent la apă (XXH)',
          XXJ: 'Pungă, hârtie, multi (XXJ)',
          XXK: 'Pungă, hârtie, multi (XXK)',
          XYA: 'Ambalaj compozit, recipient din plastic în tambur de oțel (XYA)',
          XYB: 'Ambalaj compozit, recipient din plastic în cutie de oțel (XYB)',
          XYC: 'Ambalaj compozit, recipient din plastic în tambur de aluminiu (XYC)',
          XYD: 'Ambalaj compozit, recipient din plastic în ladă de aluminiu (XYD)',
          XYF: 'Ambalaj compozit, recipient din plastic în cutie de lemn (XYF)',
          XYG: 'Ambalaj compozit, recipient din plastic în tambur din placaj (XYG)',
          XYH: 'Ambalaj compozit, recipient din plastic în cutie din placaj (XYH)',
          XYJ: 'Ambalaj compozit, recipient din plastic în tambur din fibre (XYJ)',
          XYK: 'Ambalaj compozit, recipient din plastic în cutie pentru panouri fibrolemn (XYK)',
          XYL: 'Ambalaj compozit, recipient din plastic în tambur de plastic (XYL)',
          XYM: 'Ambalaj compozit, recipient din plastic în cutie din plastic solid (XYM)',
          XYN: 'Ambalaj compozit, recipient din sticlă în tambur de oțel (XYN)',
          XYP: 'Ambalaj compozit, recipient din sticlă în cutie de otel (XYP)',
          XYQ: 'Ambalaj compozit, recipient din sticlă în tambur de aluminiu (XYQ)',
          XYR: 'Ambalaj compozit, recipient din sticlă în ladă de aluminiu (XYR)',
          XYS: 'Ambalaj compozit, recipient din sticlă în cutie de lemn (XYS)',
          XYT: 'Ambalaj compozit, recipient din sticlă în tambur din placaj (XYT)',
          XYV: 'Ambalaj compozit, recipient din sticlă în coș de răchită (XYV)',
          XYW: 'Ambalaj compozit, recipient din sticlă în tambur din fibră (XYW)',
          XYX: 'Ambalaj compozit, recipient din sticlă în cutie pentru panouri fibrolemn (XYX)',
          XYY: 'Ambalaj compozit, recipient din sticlă în ambalaj din plastic expandabil (XYY)',
          XYZ: 'Ambalaj compozit, recipient din sticlă în ambalaj din plastic solid (XYZ)',
          XZA: 'Recipient vrac, hârtie, multi (XZA)',
          XZB: 'Sac mare (XZB)',
          XZC: 'Recipient vrac, hârtie, multi (XZC)',
          XZD: 'Recipient vrac, plastic rigid, cu echipamente structurale, solide (XZD)',
          XZF: 'Recipient vrac, plastic rigid, de sine statator, solide (XZF)',
          XZG: 'Recipient vrac, plastic rigid, cu echipament structural, presurizat (XZG)',
          XZH: 'Recipient vrac, plastic rigid, de sine statator, presurizat (XZH)',
          XZJ: 'Recipient vrac, plastic rigid, cu echipamente structurale, lichide (XZJ)',
          XZK: 'Recipient vrac, plastic rigid, de sine statator, lichide (XZK)',
          XZL: 'Recipient vrac, compozit, plastic rigid, solide (XZL)',
          XZM: 'Recipient vrac, compozit, plastic flexibil, solide (XZM)',
          XZN: 'Recipient vrac, compozit, plastic rigid, presurizat (XZN)',
          XZP: 'Recipient vrac, compozit, plastic flexibil, presurizat (XZP)',
          XZQ: 'Recipient vrac, compozit, plastic rigid, lichide (XZQ)',
          XZR: 'Recipient vrac, compozit, plastic flexibil, lichide (XZR)',
          XZS: 'Recipient vrac, compozit (XZS)',
          XZT: 'Recipient vrac, panouri fibrolemnoase (XZT)',
          XZU: 'Recipient vrac, flexibil (XZU)',
          XZV: 'Recipient vrac, din metal, altele decât oțelul (XZV)',
          XZW: 'Recipient vrac, lemn natural (XZW)',
          XZX: 'Recipient vrac, placaj (XZX)',
          XZY: 'Recipient vrac, lemn reconstituit (XZY)',
          XZZ: 'Unitate definită de comun acord (XZZ)',
          DBM: 'Decibel (DBM)',
          DBW: 'Decibel Watt (DBW)',
          FNU: 'Unitate nefelometrică de formazină (FNU)',
          HAD: 'Bucată zi (HAD)',
          HMO: 'Bucată lună (HMO)',
          HWE: 'Bucată săptămână (HWE)',
          KWY: 'kilowați an (KWY)',
          MKD: 'Zi metru pătrat (MKD)',
          MKM: 'Lună metru pătrat (MKM)',
          MKW: 'Săptămâna metru pătrat (MKW)',
          MNJ: 'Mega Joule pe metru cub normalizat (MNJ)',
          MQD: 'Zi metru cub (MQD)',
          MQM: 'Luna metru cub (MQM)',
          MQW: 'Săptămâna metru cub (MQW)',
          MRD: 'Zi metru (MRD)',
          MRM: 'Lună metru (MRM)',
          MRW: 'Săptămână metru (MRW)',
          MTZ: 'milihertz (MTZ)',
          NTU: 'Unitatea de turbiditate nefelometrică (NTU)',
          Z9: 'nanomol (Z9)',
          XO1: 'Cușcă pe două fețe pe roți cu curea de fixare (XO1)',
          XO2: 'Cărucior (XO2)',
          XO3: 'Palet unic ISO 0 (XO3)',
          XO4: 'Palet unic ISO 1 (XO4)',
          XO5: 'Palet unic ISO 2 (XO5)',
          XO6: 'Palet cu dimensiuni exceptionale (XO6)',
          XO7: 'Palet din lemn 40 cm x 80 cm (XO7)',
          XO8: 'Palet plastic SRS 60 cm x 80 cm (XO8)',
          XO9: 'Palet plastic SRS 80 cm x 120 cm (XO9)',
          XOG: 'Palet ISO 0 (XOG)',
          XOH: 'Palet ISO 1 (XOH)',
          XOI: 'Palet ISO 2 – 2/1 EURO Palet (XOI)',
          XOJ: 'Palet 1/4 EURO (XOJ)',
          XOL: 'Palet 1/8 EURO (XOL)',
          XOM: 'Palet sintetic ISO 1 (XOM)',
          XON: 'Palet sintetic ISO 2 (XON)',
          XOP: 'Palet angro (XOP)',
          XOQ: 'Palet 80 X 100 cm (XOQ)',
          XOR: 'XOR (XOR)',
          XOS: 'Palet unic (XOS)',
          XOV: 'Palet returnabil (XOV)',
          XOW: 'Geanta mare, dimensiunea paletului (XOW)',
          XOX: 'Un palet pe roți cu margine ridicată (81 x 67 x 135) (XOX)',
          XOY: 'Palet pe roți cu margine ridicată (81 x 72 x 135) (XOY)',
          XOZ: 'Palet cu roți cu jantă ridicată ( 81 x 60 x 16) (XOZ)',
          XP1: 'Palet CHEP 60 cm x 80 cm (XP1)',
          XP3: 'Palet LPR 60 cm x 80 cm (XP3)',
          XP4: 'Palet LPR 80 cm x 120 cm (XP4)',
          XSX: 'Set (XSX)',
          XME: 'recipient, din metal (XME)',
          XPB: 'palet, cutie combinată cu cutie deschisă și palet (XPB)',
          XTY: 'cisternă, cilindrică (XTY)',
          XCY: 'cilindru (XCY)',
          C62: 'unitate (C62)',
          EA: 'unități (EA)',
          CMT: 'centimetru (CMT)',
          H87: 'bucati (H87)',
          INH: 'inch (INH)',
          KGM: 'kilogram (KGM)',
          KMT: 'kilometru (KMT)',
          LTR: 'litru (LTR)',
          MTK: 'metru patrat (MTK)',
          MTQ: 'metru cub (MTQ)',
          MTR: 'metru (MTR)',
          TNE: 'tona (tona metrica TNE)',
          GRM: 'gram (GRM)',
          LM: 'metru liniar (LM)',
          DZN: 'duzină (DZN)',
          SET: 'set (SET)',
          FOT: 'picior (FOT)',
          J57: 'baril (petrol UK) (J57)',
          PF: 'palet (PF)',
          NAR: 'număr de articole (NAR)',
          XPP: 'bucată (XPP)',
        },
        errors: {
          requiredUnitMeasurement: "Campul 'Unitate masura' este obligatoriu",
          requiredOperationPurpose: "Campul 'Scop operatiune' este obligatoriu",
          requiredGrossWeight: "Campul 'Greutate bruta' este obligatoriu",
          requiredCargoName: "Campul 'Denumire marfa' este obligatoriu",
          requiredQuantity: "Campul 'Cantitate' este obligatoriu",
          maxLength8: 'Campul nu poate depasi 8 caractere',
          maxLength200: 'Campul nu poate depasi 200 de caractere',
          requiredNetWeight: "Campul 'Greutate neta' este obligatoriu",
          requiredUnitPrice: "Campul 'Pret unitar' este obligatoriu",
          requiredCombinedNomenclature: "Campul 'Cod tarifar' este obligatoriu",
          maxlengthCombinedNomenclature: 'Campul cod tarifar nu poate depasi 8 caractere',
        },
        secondaryCurrencyCode: 'Moneda alternativa',
        combinedNomenclature: 'Cod tarifar',
        cargoName: 'Denumire marfa',
        quantity: 'Cantitate',
      },
      operationType: 'Tip operatiune',
      declaringCompanyReference: 'Referinta declarant',
      selectContactWarning: 'Selectati minim un contact',
      notificationContacts: 'Contactele mele pentru notificare',
      operationTypes: {
        10: 'Achiziție intracomunitară (10)',
        12: 'Operațiuni în sistem lohn (UE) - intrare (12)',
        14: 'Stocuri la dispoziția clientului (Call-off stock) - intrare (14)',
        20: 'Livrare intracomunitară (20)',
        22: 'Operațiuni în sistem lohn (UE) - ieșire (22)',
        24: 'Stocuri la dispoziția clientului (Call-off stock) - ieșire (24)',
        30: 'Transport pe teritoriul național (30)',
        40: 'Import (40)',
        50: 'Export (50)',
        60: 'Tranzacție intracomunitară - Intrare pentru depozitare/formare nou transport (60)',
        70: 'Tranzacție intracomunitară - Ieșire după depozitare/formare nou transport (70)',
      },
      confirmation: {
        confirmationType: 'Tip confirmare',
        observations: 'Observatii',
        confirmationTypes: {
          10: 'Confirmat (10)',
          20: 'Confirmat partial (20)',
          30: 'Infirmat (30)',
        },
        errors: {
          requiredConfirmationTypeUuid: "Campul 'Tip confirmare' este obligatoriu",
        },
      },
      location: {
        stateType: {
          ptf: 'Punct de trecere frontiera',
          customsOffice: 'Birou vamal',
          address: 'Adresa',
        },
        startTitle: 'Locatie de start',
        ptf: 'Punct de trecere frontiera',
        errors: {
          requiredPtf: "Campul 'Punct de trecere frontiera' este obligatoriu",
          requiredCustomsOffice: "Campul 'Birou vamal' este obligatoriu",
          requiredAddress: "Campul 'Adresa' este obligatoriu",
        },
        endTitle: 'Locatie de sfarsit',
        customsOffice: 'Birou vamal',
        noLocation: 'Nicio locatie selectata',
      },
      errors: {
        requiredOperationType: "Campul 'Tip operatiune' este obligatoriu",
        maxLength50: 'Campul nu poate depasi 50 de caractere',
        requiredShipment: "Campul 'Transport' este obligatoriu",
      },
      commercialPartner: {
        title: 'Partener comercial',
        name: 'Nume',
        errors: {
          requiredName: "Campul 'Nume' este obligatoriu",
          requiredCountry: "Campul 'Tara' este obligatoriu",
          maxLength30: 'Campul nu poate depasi 30 de caractere',
          maxLength300: 'Campul nu poate depasi 300 de caractere',
          patternCode: 'Campul trebuie sa contina minim 2 cifre si sa nu contina spatii albe',
        },
        country: 'Tara',
        code: 'CUI',
        asIndividual: 'Persoana fizica',
        contacts: 'Contacte partener comercial',
      },
      legalEntityInfoMessage: 'Selectati din firme existente, de la ANAF sau completati campurile manual.',
      legalEntityErrorMessage: 'Tara, CUI-ul si Numele sunt obligatorii pentru salvare.',
    },
    vehicleHistory: {
      licensePlates: 'Placi inmatriculare',
      modificationDate: 'Data modificarii',
      observation: 'Observatii',
      activeVehicle: 'Vehicul activ',
      declaringCompanyCode: 'CUI declarant',
      declaringCompanyReference: 'Ref. declarant',
      title: 'Istoric modificari vehicul',
    },
    checkStatuses: {
      UNCHECKED: 'Neverificat',
      COMMUNICATION_ERROR: 'Eroare de comunicare',
      AUTHORIZATION_ERROR: 'Eroare de autorizare',
      PENDING: 'In asteptare',
      OK: 'Aviz valid',
      NOT_OK: 'Aviz invalid',
      ERROR: 'Eroare',
    },
    authorization: {
      validTo: 'Valid pana la',
      token: 'Token',
      title: 'Autorizari ANAF (eFactura + eTransport)',
      processAuthorization: 'Procesare autorizare',
      authorizedBy: 'Autorizat de',
      authorizedAt: 'Autorizat la',
      addAuthorizationTooltip: 'Adauga autorizare noua ANAF',
      addAuthorization: 'Autorizare noua',
      authorizationSuccess: 'Autorizare cu succes',
      authorizationError: 'Eroare la autorizare',
    },
    list: {
      title: 'eTransport',
      createdBy: 'Adaugat de',
      externalReference: 'Ref. declarant',
      uit: 'Cod UIT',
      uploadIndex: 'Index',
      shipmentDate: 'Data transport',
      validUntil: 'Valabil pana la data',
      operationType: 'Tip operatiune',
      commercialPartner: 'Partener comercial',
      shipmentOrganizerName: 'Organizator transport',
      address: 'Adresa',
      licensePlate: 'Placa inmatriculare',
      startLocation: 'Locatie inceput',
      endLocation: 'Locatie sfarsit',
      orderNumber: 'Numar comanda',
      order: 'Comanda',
      status: 'Status',
      confirmationType: 'Tip confirmare',
      latestActionType: 'Tip ultima actiune',
      collaborationStatus: 'Colaborare',
      uploadStatus: 'Status incarcare',
      checkStatus: 'Status verificare',
      actionStatus: 'Ultima actiune',
      anafMessage: 'Mesaj Anaf',
      resetFilters: 'Reseteaza filtre',
      uitUnchecked: 'Cod UIT neverificat',
      uitValid: 'Cod UIT valid',
      uitInvalid: 'Cod UIT invalid',
      import: 'Import',
      personalizedImport: 'Import personalizat',
      downloadTemplate: 'Descarca sablon',
      modifiedVehicleTooltip: 'Vehiculul a fost modificat la data de: ',
      totalNetWeight: 'Total greutate neta (kg)',
      totalGrossWeight: 'Total greutate bruta (kg)',
      totalValue: 'Total valoare lei',
      bulkSendSuccessfulMessage: 'eTransporturile au fost trimise cu succes!',
      bulkCheckSuccessfulMessage: 'eTransporturile au fost verificate cu succes!',
      verifyData: 'Verificati datele...',
      selectedETransports: 'eTransporturi selectate',
      selectMessage: 'Selecteaza eTransporturi netrimise sau neverificate',
      sendETransports: 'Trimite eTransporturi',
      checkETransports: 'Verifica eTransporturi',
      predefinedNotices: {
        UNSEND: 'Avize netrimise',
        UNVERIFIED: 'Avize neverificate',
      },
      actionCheckStatuses: {
        UNCHECKED: 'Actiune neverificata',
        PENDING: 'Verificare in asteptare',
        COMMUNICATION_ERROR: 'Eroare de comunicare, incercati din nou mai tarziu',
        ERROR: 'Eroare',
        NOT_OK: 'Actiune invalida',
        OK: 'Actiune valida',
      },
      checkStatuses: {
        UNCHECKED: 'Aviz neverificat',
        PENDING: 'Verificare in asteptare',
        COMMUNICATION_ERROR: 'Eroare de comunicare',
        AUTHORIZATION_ERROR: 'Eroare de autorizare',
        ERROR: 'Eroare',
        NOT_OK: 'Aviz invalid',
        OK: 'Aviz valid',
      },
      uploadStatuses: {
        UNSENT: 'Netrimis',
        CONVERSION_ERROR: 'Eroare de conversie',
        COMMUNICATION_ERROR: 'Eroare de comunicare',
        ERROR: 'Eroare la incarcare',
        UPLOAD_SUCCESS: 'Incarcat cu succes',
        AUTHORIZATION_ERROR: 'Eroare de autorizare',
        CANCEL_SUCCESS: 'Anulat',
        null: '',
      },
      actionTypes: {
        CANCEL: 'Anulare',
        MODIF_VEHICLE: 'Modificare vehicul',
        CONFIRMATION: 'Confirmare',
      },
      checkActionStatus: 'Verifica stare actiune',
      uploadAction: 'Incarca actiune',
      collaborationSent: 'Invitatia de colaborare a fost trimisa',
      collaborationPartiallyCompleted: 'Datele au fost completate partial de catre colaboratori',
      collaborationCompleted: 'Datele au fost completate de colaboratori',
    },
    confirmETransportTitle: 'Confirmare eTransport',
    commercialDataTitle: 'Completare date comerciale eTransport',
    shipmentDataTitle: 'Completare date transport',
    dataUpdateSuccess: 'Datele au fost actualizate cu succes!',
    contactSuggestion: 'Pentru a actualiza contactele trebuie sa editati eTransport-ul',
    shipmentOrganizer: {
      list: {
        title: 'Organizator eTransport',
        uit: 'UIT',
        declaringCompanyCode: 'Cod declarant',
        declaringCompanyName: 'Nume declarant',
        declaringCompanyReference: 'Ref. declarant',
        shipmentDate: 'Data transport',
        validUntil: 'Data expirare UIT',
        shipmentOrganizerCode: 'Cod transportator',
        shipmentOrganizerName: 'Nume transportator',
        licensePlates: 'Placi inmatriculare',
        startLocation: 'Locație început',
        endLocation: 'Locație final',
        documents: 'Documente',
      },
      anafCommunicationError: 'Eroare de comunicare cu ANAF. Reincercati din nou mai tarziu',
    },
    errors: {
      ETransportNotificationNotUploadReadyException: 'eTransport-ul nu este complet pentru a putea fi trimis!',
    },
  },
  error: {
    '403': 'You are not authorized to access the page.',
    'warehouse-times-minimum-one-interval-error': 'Ora de final este aceeasi cu ora de start.',
    'warehouse-end-time-before-start-time-error': 'Ora de final trebuie sa fie dupa ora de inceput.',
    UserNotFoundException: 'User-ul nu a fost gasit',
    PackageContractTariffNotUnique:
      'Exista deja un contract cu acest furnizor pentru pachetul si teritoriile selectate in intervalul de timp ales',
    OrderAuditPdfGenerationException: 'PDF-ul nu poate fi generat deoarece nu există tranzacții salvate.',
    TaskDeletedException: 'Task-ul este sters!',
    TaskCheckpointDeletedException: 'Checkpoint-ul este sters!',
    TaskCheckpointUpdateStatusException: 'Statusul checkpoint-ului este invalid!',
    EmployeeAlreadyIsDriver: 'Angajatul selectat este sofer',
    userexists: 'Login name already used!',
    userAlreadyHasOwner:
      'Ati fost deja asignat unei alte companii. Selectati compania dintre cele existente in platforma',
    UserAlreadyAssignedException: 'Ati fost deja asignat unei alte companii.',
    InvalidGeneratedAndSignedPdfException: 'Pdf-ul nu poate fi generat si semnat momentan. Reincercati mai tarziu!',
    url: {
      not: {
        found: 'Not found',
      },
    },
    unauthorized: 'Actiune neautorizata',
    title: 'Error page!',
    'terminal-reservation-end-time-same-with-start-time-error':
      'Ora de final este aceeasi cu ora de inceput, programarea trebuie sa aiba minim un interval.',
    'terminal-reservation-end-time-before-start-time-error':
      'Ora de final a programarii nu poate fi inaintea orei de inceput.',
    'invalid-status-for-offer-request': 'Cererea de oferta nu mai este valabila',
    validExternalReferenceAlreadyExistForTheReferenceType: 'Exista deja o referinta externa valida de acest tip',
    Size: 'Campul {{field}} nu respecta dimensiunea minima/maxima!',
    NotNull: 'Campul {{ field }} nu poate fi gol!',
    server: {
      not: {
        reachable: 'Server not reachable',
      },
    },
    requiredGlobalAccountTypeValue: 'Campul Tip cont global este obligatoriu',
    requiredGlobalAccountCode: 'Campul Cod cont global este obligatoriu',
    'overlapping-terminal-reservation-error': 'Programarile se suprapun, alegeti intervale de timp libere.',
    'invoice-external-error-single-company-contacts-selected': 'Alegeti contacte de la ambele companii ',
    internalServerError: 'Internal server error',
    idexists: 'A new {{ entityName }} cannot already have an ID',
    'external-invoice-orders-different-payment-time-limit-error': 'Alegeti comenzi care au acelasi Termen de plata',
    'external-invoice-orders-invoiced-by-other-invoices-error': 'Cel putin o comanda apartine deja de alta factura',
    'external-invoice-orders-invoiced-error': 'Cel putin o comanda este deja facturata',
    error: {
      validation: 'Eroare de validare',
      '429': 'Prea multe cereri',
    },
    EmailImportSettingsWrongFormatException: 'Email import invalid!',
    emailexists: 'Email is already in use!',
    'email-already-sent-in-the-last-five-minutes-error': 'Ati trimis deja un mesaj in ultimele 5 minute!',
    EFacturaAuthorizationException: 'Nu aveti o autorizare ANAF valida!',
    defaultError: 'A aparut o eroare',
    currentUserNotFound: 'User-ul curent nu a fost gasit. Incercati din nou.',
    companyAlreadyHasSuperUser: 'Compania are deja un alt user asignat. Contactati un administrator.',
    'bad-credentials': 'Datele de autentificare introduse sunt incorecte, Verificati datele si incercati din nou',
    AssignedUserAlreadyExistsException: 'Compania are deja un alt user asignat.',
    activityMustHaveAtLeastOneContact: 'Activitatea trebuie sa contina cel putin un contact!',
    AbstractNotifiableEntityEmptyContactListException: 'Nu ati selectat niciun contact!',
    ShipmentGroupDefaultSolutionException: 'Informatiile necesare sunt prea vechi. Reincarcati pagina!',
    'external-invoice-orders-invalid-currency-codes-error':
      'Puteti selecta comenzi in cel mult de o alta moneda pe langa cea a facturii',
    'no-rights-selected': 'Nu puteti salva un rol fara drepturi',
    InvalidCompanyAddressException: 'Adresa de companie este invalida, verificati campurile si incercati din nou.',
    invalidPasswordFormat:
      'Parola trebuie sa contina cel putin o litera mica, cel putin o litera mare, cel putin o cifra, cel putin un caracter special, trebuie sa aiba minim 9 caractere si maxim 32 de caractere!',
    'error-cannot-add-ownership-request-phone-null':
      'Nu se poate revendica o locatie fara a avea numarul de telefon valid.',
    'error-cannot-add-ownership-request-phone-not-validated':
      'Nu se poate revendica o locatie fara a avea numarul de telefon introdus si validat',
    '429': 'Ati depasit numarul admis de solicitari! Incercati mai tarziu.',
    ActiveTariffOnOperationalTerritoryInvalidateException: 'Exista un tarif activ pe acest teritoriu',
    MaxAttemptsExceededException: 'Ati depasit numarul maxim admis de solicitari!',
    AttemptsExceededExceptionPT1M: 'Prea multe incercari! Incercati peste 1 minut',
    AttemptsExceededExceptionPT1H: 'Prea multe incercari! Incercati peste o ora',
    AttemptsExceededExceptionPT24H: 'Prea multe incercari! Incercati peste o zi',
    AttemptsExceededExceptionPT240H: 'Prea multe incercari! Incercati peste 10 zile',
    AttemptsLeft4: 'Mai aveti 4 incercari!',
    AttemptsLeft3: 'Mai aveti 3 incercari!',
    AttemptsLeft2: 'Mai aveti 2 incercari!',
    AttemptsLeft1: 'Mai aveti o incercare!',
    'blocked-user': 'Utilizatorul este blocat temporar din cauza prea multor incercari de autentificare esuate.',
    'remaining-time-until-unblocked-beggining-message': 'Timp ramas pana la deblocare: ',
    'remaining-days-until-unblocked': ' zile, ',
    'remaining-hours-until-unblocked': ' ore, ',
    'remaining-minutes-until-unblocked': ' minute, ',
    'remaining-seconds-until-unblocked': ' secunde.',
    usernameAlreadyExists: 'Exista deja acest nume de utilizator',
    missingPhoneNumber: 'Numarul de telefon este obligatoriu',
    invalidPhoneNumber: 'Număr de telefon invalid',
    invalidEmail: 'E-mail invalid',
    externalVendorRequestCredentialDTOMap: 'Nu au fost introduse credentiale pentru fiecare request',
    'order-shipper-party': 'Lipseste numarul de cont al transportatorului.',
    'order-payment-party': 'Lipsesc detaliile de plata.',
    'order-with-already-allocated-shipment-drafts': 'Transporturile utilizate pentru acesta comanda sunt deja alocate.',
    'task-with-already-allocated-shipment-drafts': 'Transporturile utilizate pentru acest task sunt deja alocate.',
    'original-sp-pre-order-not-updatable': 'Comanda subcontractata nu se mai afla in faza de pre-comanda.',
    'shipment-group-solution-not-locked-in': 'Solutia de segmentare nu este definitiva.',
    'terminal-reservation-vendor-and-external-service-provider-error':
      'Programarea trebuie să fie făcută fie cu un singur transportator partener, fie cu un singur curier.',
    ShipmentCanNotBeCancelledException: 'Transportul nu poate fi anulat!',
    PickupAndShipmentCanNotBeCancelledException: 'Ridicarea si transportul nu pot fi anulate!',
    OrderTariffCancelledException: 'Comanda nu poate fi creată/acceptată deoarece tariful a fost anulat!',
    InvalidOrderForAuditException: 'Nu s-a putut genera auditul deoarece comanda se afla intr-o stare invalida!',
    'invalid-shipment-status-change-invoice-generated':
      'Schimbarea statusului nu mai este posibila deoarece comanda este deja facturata!',
    'invalid-shipment-status-change': 'Schimbarea statusului nu este posibila!',
    'duplicate-routed-order-template-label': 'Exista deja un sablon de ruta cu acest nume!',
  },
  emptyListPlaceholder: {
    description: 'Nu exista niciun element pentru cautarea facuta',
    changeFilters: 'Modificati filtrele pentru o noua cautare!',
  },
  efactura: {
    seeInvoiceDetails: 'Vezi detalii factura',
    officeAddressStateCountryMessage:
      'Pentru sediul social al <strong>firmelor din Romania completarea județului si a tarii este obligatorie</strong>.',
    officeAddressBucharestMessage:
      'Pentru firmele din <strong>București</strong> la județ se va trece București, iar <strong>sectorul</strong> se va scrie in campul Localitate in <strong>formatul SECTOR1-6</strong> (ex: SECTOR3)',
    messages: {
      type: 'Status factura',
      title: 'Titlu',
      serial: 'Serial',
      searchDaysMessage: 'Selecteaza numarul de zile pentru afisarea mesajelor (max. 60 de zile in trecut)',
      pageTitle: 'Mesaje ANAF',
      idRequest: 'ID solicitare',
      id: 'ID',
      emptyMessage: 'Niciun rezultat gasit.',
      details: 'Detalii',
      cui: 'CUI',
      createdAt: 'Creat la',
      cif: 'CIF',
    },

    assignedToInvoice: 'Alocata la o factura',
    assignedToCost: 'Alocata la un cost',
    assignInvoiceNotAvailable: 'Factura este alocata',
    invoiceSent: 'Factura este trimisa',
    title: 'eFacturi',
    assignToCost: 'Aloca pe un cost',
    assignToOrder: 'Aloca pe o comanda',
    supplierName: 'Nume furnizor',
    partnerName: 'Nume partener',
    partnerCif: 'CIF partener',
    supplierCif: 'CIF furnizor',
    uploadedAt: 'Incarcata la',
    uploadId: 'efactura.uploadId',
    downloadId: 'efactura.downloadId',
    invoiceSeriesNumber: 'Serie factura',
    invoiceDate: 'Data facturii',
    maturityDate: 'Data scadentei',
    amount: 'Suma',
    amountInclTax: 'Suma cu taxe incluse',
    currency: 'Moneda',
    details: 'Detalii',
    type: 'Tip',
    errorMessage: 'Mesaj de eroare',
    zipFileUuid: 'efactura.zipFileUuid',
    pdfFileUuid: 'efactura.pdfFileUuid',
    invoiceNotSystemGenerated: 'Factura nu a fost emisa din platforma!',
    downloadZip: 'Descarca ZIP',
    downloadPdf: 'Descarca PDF',
    import: {
      selectAnafInvoice: 'Alege eFactura',
      dialogTitle: 'Importa date eFactura',
      importButton: 'Importa date',
      selectAnafInvoiceSeries: 'Alege serie factura',
      externalInvoice: {
        selectCustomer: 'Clientul trebuie selectat',
        selectSp: 'Transportatorul partener trebuie selectat',
      },
    },
  },
  dispatcher: {
    tasks: {
      taskStatusChange: {
        title: 'Schimba status',
        submit: 'Salveaza',
        rejectReason: 'Motiv refuz',
        reject: 'Respinge',
        pickup: 'Preluare',
        delivery: 'Predare',
        return: 'Retur',
        handshakePersonName: 'Nume persoana tranzactie',
        error: {
          requiredRejectReason: 'Acest camp este obligatoriu',
          requiredHandshakePersonName: 'Acest camp este obligatoriu',
          requiredAchievedAt: 'Acest camp este obligatoriu',
        },
        description: 'Descriere',
        comment: 'Comentariu',
        chooseAction: 'Alege Status',
        achievedAt: 'La data',
      },
      summary: {
        vehicles: 'Vehicule asignate / disponibile',
        tasks: 'Taskuri asignate / disponibile',
        drivers: 'Soferi asignati / disponibili',
        cardTitle: 'Vedere de ansamblu',
        'available-tasks': 'Taskuri disponibile',
        addNewRoute: 'Adauga ruta noua',
      },
      listTitle: 'Lista taskuri',
      updatedAt: 'Ultima actualizare',
      updatedByDriver: 'Modificat de sofer',
      updatedByDispatcher: 'Modificat de dispecer',
      showTasks: 'Tasks',
      showMap: 'Map',
      showAvailableResources: 'Resurse disponibile',
      online: 'online',
      offline: 'offline',
      noDataFoundDescription: 'Nu exista Taskuri neatribuite',
      lastSeen: 'Online la data',
      estimatedDirection: 'Date estimate de google maps',
      edit: 'Modifica',
      cancel: 'Anuleaza',
      details: 'Detalii task',
      viewDetails: 'Vezi detalii',
      delete: 'Sterge',
      completedDirection: 'Date concrete bazate pe interactiunea cu aplicatia',
      changeStatus: 'Schimba status',
      availableTasks: 'Taskuri neatribuite',
      assignToDriver: 'Muta pe alta masina',
      unavailableDelivery: 'Livrare indisponibila',
      changeVehicle: 'Modifica vehicul',
      changeMainDriver: 'Modifica sofer principal',
      changeSecondDriver: 'Modifica sofer secundar',
      warehouseEmployee: 'Persoana contact depozit',
      warehouseEmployeeManuallyAddedTooltip: 'Persoana de contact de la depozit a fost introdusa manual',
      warehouseEmployeeScannedTooltip:
        'Persoana de contact de la depozit a fost scanata prin intermediul aplicatiei mobile',
      driverEmployee: 'Persoana contact sofer',
      driverEmployeeManuallyAddedTooltip: 'Persoana de contact sofer a fost introdusa manual',
      driverEmployeeScannedTooltip: 'Persoana de contact sofer a fost scanata prin intermediul aplicatiei mobile',
      latestStatusAchieved: 'Ultimul status primit la data de',
      comments: 'Observatii',
      checkpoints: {
        status: {
          not_started: 'Neinceput',
          completed: 'Finalizat',
          completed_delayed: 'Finalizat cu intarziere',
          unavailable: 'Indisponibil',
          refused: 'Refuzat',
          cancelled: 'Anulat',
          closed: 'Închis',
        },
      },
      takenPackages: 'Pachete preluate',
      takenPackagesSummary: (params) => {
        const { actualPackagesLength, totalPackagesLength } = params;
        return `Au fost preluate ${actualPackagesLength} din totalul de ${totalPackagesLength} pachete`;
      },
      proofOfHandover: {
        signature: 'Semnatura',
        signatures: 'Semnaturi',
        achievedAt: 'Realizat la',
        responsibleName: 'Responsabil',
        executedBy: 'Executat de',
        comment: 'Comentariu',
        unavailableMessage: 'Livrarea a fost indisponibilă, pachetele se returnează',
        executedByType: {
          DRIVER: 'Executat din aplicația mobilă de șofer',
          WAREHOUSE: 'Executat din aplicația mobilă de depozit',
          PREORDER_LINK: 'Executat prin link de precomandă',
          OFFICE: 'Executat din aplicația web',
        },
        responsibleType: {
          CARRIER: 'Sofer',
          SENDER: 'Expeditor',
          CONSIGNEE: 'Destinatar',
        },
      },
    },
  },
  'delivery-outbox': {
    vendorName: 'Transportator',
    utils: {
      shipments: 'Transporturi',
      open: 'Deschide',
      'empty-message': 'Adauga o cerere de oferta',
      'empty-list': 'Lista este goala',
    },
    type: 'Tip',
    totalWeight: 'Greutate totala',
    title: 'Outbox',
    'timeline-phase': {
      transport: 'Transport',
      order: 'Comanda',
      offer_request: 'Cerere de oferta',
      invoice: 'Facturare',
    },
    sort: 'Sorteaza',
    shipmentFlowType: 'Tip Flux',
    receivedOffers: 'Oferte primite',
    pickupCompany: 'Companie ridicare',
    pickupLocation: 'Locatie ridicare',
    deliveryLocation: 'Locatie predare',
    pickupCity: 'Oras ridicare',
    orderStatus: 'Status comanda',
    offerRequestStatusEnum: {
      sent: 'Trimisa',
      rejected: 'Refuzata',
      received: 'Primită',
      offers_received: 'Oferte disponibile',
      offer_accepted: 'Acceptata',
      in_progress: 'In desfasurare',
      completed: 'Finalizata',
      cancelled: 'Anulata',
      archived: 'Arhivata',
    },
    offerRequestStatus: 'Status cerere de oferta',
    more: {
      resendInvoiceUploadInvitationEmail: 'Retrimitere email de incarcare factura',
      orderCancelRequestDisabledTooltip: 'Exista o cerere de anulare sau comanda nu se afla intr-un status potrivit',
      orderCancelRequest: 'Anuleaza comanda',
      orderCancelForced: 'Anuleaza comanda fortat',
    },
    invoiceStatusEnum: {
      UNPAID: 'Neplatita',
      STORNO: 'Storno',
      PARTIAL_PAID: 'Partial platita',
      PAID: 'Platita',
      NOT_INVOICED: 'Nefacturata',
      CANCELLED: 'Stornata',
    },
    invoiceStatus: 'Status factura',
    filter: 'Filtreaza',
    pickupStart: 'Data preluare',
    deliveryEnd: 'Data livrare',
    employeeName: 'Numele angajatului',
    documentNumber: 'Numarul documentului',
    shipmentSeries: 'Serie transport',
    deliveryCompany: 'Companie livrare',
    deliveryCity: 'Oras predare',
    deadline: 'Deadline',
    createdAt: 'Data trimiterii',
    costCenters: 'Centre de cost',
    assignedToUser: 'Atribuite mie',
    addOfferRequest: '+ Adauga cerere oferta',
    addInternalOrder: '+ Adauga comanda interna',
    addContractOrder: '+ Adauga comanda',
    addSupplierOrder: '+ Adauga comanda furnizor',
    addPreOrder: '+ Adauga pre-comanda',
    requestedBy: 'Solicitat de',
    moreShipments: 'mai multe...',
    lessShipments: 'vezi mai puțin',
    units: {
      kg: 'kg',
      pcs: 'buc',
    },
  },
  'delivery-shared': {
    shipmentList: {
      pcs: 'buc',
      moreShipments: 'mai multe...',
      lessShipments: 'vezi mai puțin',
    },
  },
  'delivery-inbox': {
    urgent: 'Urgent',
    type: 'Tip',
    'try-again': 'Incercati din nou',
    title: 'Inbox',
    'timeline-phase': {
      transport: 'Transport',
      order: 'Comanda',
      offer_request: 'Cerere de oferta',
      invoice: 'Facturare',
      finished: 'Finalizat',
    },
    'sort-labels': {
      deadline: 'Deadline',
      createdAt: 'Data primirii',
    },
    sort: 'Sorteaza',
    solve: 'Rezolva',
    viewInvoice: 'Facturare',
    shipments: 'Transporturi',
    pickupCity: 'Oras ridicare',
    phases: {
      transport: 'Transport',
      order: 'Comanda',
      'offer-request': 'Cerere de oferta',
      invoice: 'Finalizat',
    },
    orderStatus: 'Status comanda',
    offerRequestStatusEnum: {
      sent: 'Trimisa',
      rejected: 'Refuzata',
      received: 'Primită',
      offers_received: 'Oferte disponibile',
      offer_accepted: 'Acceptata',
      in_progress: 'In desfasurare',
      completed: 'Finalizata',
      cancelled: 'Anulata',
      archived: 'Arhivata',
    },
    offerRequestStatus: 'Status cerere de oferta',
    'no-results-found': 'Nu s-a putut gasi niciun rezultat pentru cautarea dvs.',
    more: {
      refuseOfferRequest: 'Refuza Cerere de oferta',
      orderCancelRequestDisabledTooltip: 'Exista o cerere de anulare sau comanda nu se afla intr-un status potrivit',
      orderCancelRequest: 'Anuleaza Comanda',
      orderCancelForced: 'Anuleaza Comanda Fortat',
    },
    filter: 'Filtreaza',
    expiringOffersMessage: 'Aveti oferte care expira !',
    employeeName: 'Numele angajatului',
    documentNumber: 'Numarul documentului',
    shipmentSeries: 'Serie transport',
    deliveryCity: 'Oras predare',
    pickupStart: 'Data preluare',
    deliveryEnd: 'Data livrare',
    customerName: 'Nume client',
    'choose-account': 'Selecteaza cont',
    assignedToUser: 'Asignate mie',
    addOfferRequest: '+ Adauga cerere oferta',
    accountName: 'Cont',
    bulkActions: {
      title: 'Actiuni simultane',
      submit: 'Trimite',
      selectedItems: 'articole selectate',
      selectAll: 'Selecteaza toate',
      deselectAll: 'Deselecteaza toate',
      toggleSelection: {
        order: {
          accept: 'Accepta',
          reject: 'Refuza',
          archive: 'Arhiveaza',
          selectEmployee: 'Selecteaza angajat',
        },
      },
      clearSelection: 'Sterge selectia',
    },
  },
  'delivery-app': {
    vendorTag: {
      wizardTabTitle: 'Transportator partener',
      wizardTabHeader: 'Etichete transportator partener',
      vendorSort: 'Sorteaza transportatorii parteneri dupa etichete',
      vendorFilter: 'Sau selecteaza etichete',
      value: 'Denumire eticheta',
      search: 'Cauta etichete',
      newTitle: 'Adauga eticheta',
      error: {
        requiredValue: 'Campul Denumire eticheta este obligatoriu',
      },
    },
    vendor: {
      wizardTabTitle: 'Companie',
      wizardTabHeader: 'Detalii companie',
      viewCompany: 'Vezi Companie',
      uniqueIdNumber: 'Număr unic identificare',
      unblockCompany: 'Deblocheaza Compania',
      to: 'Catre',
      title: 'Transportatori parteneri',
      tags: 'Etichete',
      singular: 'Transportator partener',
      searchOne: 'Cauta un transportator partener',
      searchMultiple: 'Cauta transportatori parteneri',
      refresh: 'Datele acestui transportator nu au fost inca procesate. Apasati aici pentru a reincerca.',
      plural: 'Transportatori parteneri',
      platformMemberLegend:
        'Transportatorul nu este inregistrat in platforma. Acesta va primi un email cu cererea de oferta creata.',
      paymentTimeLimit: 'Termen plata',
      name: 'Nume',
      mainPhoneNumber: 'Telefon',
      mainEmailAddress: 'Email',
      industryType: 'Tip industrie',
      country: 'Tara',
      contactsWarning: 'Acest transportator nu are contacte. Adauga folosind urmatorul buton.',
      blockCompany: 'Blocheaza Compania',
      blockCommentPlaceholder: 'Introduceti motiv',
      blockForm: {
        error: {
          requiredComment: 'Motivul este obligatoriu',
        },
      },
      'amendment-title': 'Introduce-ti amendamente',
      amendment: 'Amendament',
      addNew: 'Adauga transportator partener',
      courier: 'Curier',
    },
    'shipment-tracking': {
      title: 'Urmarire transporturi',
      filter: 'Filtreaza',
      costCenter: 'Centru de cost',
      deliveryDate: 'Data predare',
      pickupDate: 'Data preluare',
      deliveryCity: 'Oras predare',
      pickupCity: 'Oras preluare',
      deliveryCompany: 'Companie predare',
      pickupCompany: 'Companie preluare',
      documentNumber: 'Numar comanda',
      shipmentSeries: 'Serie transport',
      setAsFavorite: 'Seteaza ca favorit',
      removeFavorite: 'Elimina de la favorite',
      externalReference: 'Ref. externa',
      timelineView: 'Cronologie',
      listView: 'Listă',
      packageId: 'ID Pachet',
      status: 'Status',
      noPackages: 'Nu s-au găsit pachete pentru acest transport',
    },
    vehicle: {
      width: 'Latime (m)',
      weight: 'Masa proprie (kg)',
      volume: 'Volum (m3)',
      vehicleTypeValue: 'Tipul vehiculului',
      user: 'Utilizator',
      type: 'Tip',
      tonnage: 'Tonaj',
      title: 'Vehicule',
      tabs: {
        success: 'Success',
        saved: 'Vehicul salvat',
        financial: 'Financiar',
        fuelCards: 'Carduri de combustibil',
        equipment: 'Echipament',
        documents: 'Documente',
        details: 'General',
      },
      subtitle: 'Rute',
      requiredField: 'Acest camp este obligatoriu',
      registrationDate: 'Data inmatricularii',
      pricePerKm: 'Pret/km (RON)',
      power: 'Putere',
      owner: 'Proprietar',
      name: 'Nume',
      model: 'Model',
      maximumAllowedMass: 'Masa maxima admisa (kg)',
      manufacturingYear: 'An fabricatie',
      make: 'Marca',
      licensePlateLabel: 'Eticheta placa inmatriculare',
      licensePlate: 'Placa inmatriculare',
      length: 'Lungime (m)',
      legalCharge: 'Incarcatura legala',
      inventoryNumber: 'Numar inventar',
      height: 'Inaltime (m)',
      general: {
        wheelbase: 'Ampatament (mm)',
        volume: 'Volum (m3)',
        vin: 'Cod identificare',
        vehicle: 'Vehicul',
        usableWeight: 'Greutate utila (kg)',
        urbanConsumption: 'Consum urban (Litri/100km)',
        traction: 'Tractiune',
        technical: 'Informatii tehnice',
        region: 'Regiune',
        photos: 'Poze Vehicul',
        nrSeats: 'Numar locuri',
        nrDoors: 'Numar usi',
        model: 'Model',
        mixedConsumption: 'Consum mix (Litri/100km)',
        loadingType: 'Incarcare',
        loadingMeters: 'Ampatament (m)',
        lateralLoading: 'Laterala',
        lateralDoorWidth: 'Latime usa laterala (m)',
        lateralDoorHeight: 'Inaltime usa laterala (m)',
        gpsMonitorisation: 'Monitorizare GPS',
        GPSDisabled: 'Inactiv',
        GPSActive: 'Activ',
        general: 'Informatii generale',
        gearBox: 'Cutie de viteza',
        fuelType: 'Combustibil',
        fuelTankCapacity: 'Capacitate rezervor (Litri)',
        extraUrbanConsumption: 'Consum extra urban (Litri/100km)',
        engineType: 'Tip motor',
        engineMaxPower: 'Putere maxima (Kw/hp)',
        engineCMC: 'CMC',
        emissionsStandard: 'Norma poluare',
        doorHeight: 'Inaltime usa (m)',
        division: 'Divizie',
        dateOfFabrication: 'Data fabricare',
        costCenter: 'Centru de cost',
        condition: 'Conditie',
        company: 'Companie',
        color: 'Culoare',
        co2Emissions: 'Emisii CO2 (g/km)',
        cargoWidth: 'Latime (m)',
        cargoLength: 'Lungime (m)',
        cargoHeight: 'Inaltime (m)',
        cargo: 'Compartiment marfa',
        brand: 'Marca',
        backLoading: 'Spate',
        backDoorWidth: 'Latime usa spate (m)',
        backDoorHeight: 'Inaltime usa spate (m)',
      },
      fuel: 'Combustibil',
      financial: {
        valVehicle: 'Valoare vehicul (EUR)',
        value: 'Costuri',
        valResidual: 'Valoare reziduala (EUR)',
        valOperations: 'Valoare operatiuni (EUR)',
        valAccesories: 'Valoare accesorii (EUR)',
        taxCategoryPlaceholder: 'Selecteaza o categorie de taxare',
        taxCategory: 'Categorie taxare',
        startDate: 'Data intrare in folosinta',
        returnDate: 'Data returnare',
        policyNr: 'Numar polita',
        ownerPlaceholder: 'Selecteaza un proprietar',
        owner: 'Proprietar',
        operatorPlaceholder: 'Selecteaza un operator',
        operator: 'Operator',
        nrKmCtr: 'Numar total kilometrii contract',
        nrInventory: 'Numar inventar',
        nrCtr: 'Numar contract',
        monitoringStartDate: 'Data inceput monitorizare',
        kmAtRendition: 'Numar kilometrii la predare',
        insuranceStartDate: 'Data incepere',
        insuranceEndDate: 'Data finalizare',
        insurance: 'Asigurare',
        general: 'Informatii generale',
        financingType: 'Tip finantare',
        financingPeriod: 'Perioada de finantare (Luni)',
        endDate: 'Data iesire din folosinta',
        deliveryDate: 'Data livrare',
        costKmNotDriven: 'Cost kilometri nerulati (EUR)',
        costKm: 'Cost depasire kilometri (EUR)',
        casco: 'Franciza CASCO',
        addOwner: 'Adauga un proprietar',
        addOperator: 'Adauga un operator',
        additionalInfo: 'Informatii suplimentare',
      },
      fuelCards: {
        title: 'Carduri de combustibil',
        series: 'Serie',
        provider: 'Nume furnizor',
        add: 'Adauga card de combustibil',
        edit: 'Editeaza card de combustibil',
        details: 'Detalii card de combustibil',
        delete: 'Sterge card de combustibil',
        errors: {
          requiredSeries: "Campul 'Series' este obligatoriu",
          requiredProvider: "Campul 'Nume furnizor' este obligatoriu",
        },
      },
      ewp: 'EWP',
      error: {
        requiredUninstallationDate: 'Campul Data demontare este obligatoriu',
        requiredTransferDate: 'Campul Data primire document este obligatoriu',
        requiredOperator: 'Campul Operator este obligatoriu',
        requiredNewDocumentHolder: 'Campul Detinator nou este obligatoriu!',
        requiredLicensePlate: 'Campul Placa inmatriculare este obligatoriu',
        requiredInstallationDate: 'Campul Data montare este obligatoriu',
        requiredField: 'Acest camp este obligatoriu',
        requiredEquipmentVO: 'Campul Tip echipament este obligatoriu!',
        requiredEquipmentType: 'Campul Tip echipament este obligatoriu',
        requiredDocumentVO: 'Campul Tip document este obligatoriu!',
        requiredDocumentType: 'Campul Tip document este obligatoriu!',
        requiredDocument: 'Campul Tip document este obligatoriu',
        requiredCompanyOwner: 'Campul Proprietar este obligatoriu',
      },
      equipment: {
        validTo: 'Valid pana la',
        validPeriod: 'Perioada de valabilitate',
        validFrom: 'Valid din',
        uninstallEquipment: 'Demonteaza echipament',
        uninstallationDate: 'Data demontare',
        installEquipment: 'Monteaza echipament',
        installationDate: 'Data montare',
        equipmentTypePlaceholder: 'Selecteaza tip echipament',
        equipmentType: 'Tip echipament',
        equipments: 'Echipamente',
        editEquipment: 'Editeaza echipament',
        addEquipmentType: 'Adauga tip echipament',
        addEquipment: 'Adauga echipament',
      },
      engine: 'Motor',
      'edit-vehicle-title': 'Editeaza vehicul',
      documents: {
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        transferDoc: 'Transfera document',
        transferDate: 'Data primire document',
        title: 'Documente',
        status: 'Status',
        photos: 'Poze document',
        obs: 'Observatii',
        newDocumentHolder: 'Detinator nou',
        markInactive: 'Marcheaza ca inactiv',
        markActive: 'Marcheaza ca activ',
        issueDate: 'Data emitere',
        inactive: 'Inactiv',
        expirationDate: 'Data expirare',
        editDocument: 'Editeaza document',
        documentTypePlaceholder: 'Selecteaza un tip de document',
        documentType: 'Tip document',
        documentHolder: 'Detinator',
        document: 'Document',
        details: 'Detalii document',
        currentDocumentHolder: 'Detinator curent',
        addDocumentType: 'Adauga tip document',
        addDocument: 'Adauga document',
        active: 'Activ',
      },
      description: 'Descriere',
      configuration: 'Configuratie',
      color: 'Culoare',
      chassisSeries: 'Serie sasiu',
      category: 'Cateogrie',
      addNew: 'Adauga Vehicul',
      'add-vehicle-title': 'Adauga vehicul',
    },
    utils: {
      loadMore: 'Mai multe',
      loadLess: 'Mai putine',
      others: 'alte',
      yes: 'Da',
      width: 'Latime',
      weight: 'Greutate',
      volume: 'Volum',
      upload: 'Incarca',
      update: 'Actualizeaza',
      unselected: 'Neselectat',
      type: 'tip',
      termsAndConditions: 'Termeni si Conditii',
      tableEmptyMessage: 'Nu a fost gasit nici un rezultat',
      sumWeight: 'kg',
      sumVolume: 'm',
      'statuses-selected': 'statusuri selectate',
      'select-statuses': 'Selecteaza statusuri',
      sort: 'Sorteaza',
      showLess: 'Afiseaza mai putine pachete',
      showAllPackages: 'Afiseaza toate pachetele',
      id: 'Id',
      movePieceLeft: 'Mută piesa la stânga',
      movePieceRight: 'Mută piesa la dreapta',
      shipmentId: 'Id',
      settings: 'Preferinte',
      sentOffer: 'Sunt de acord să contractez',
      sent: 'Trimite',
      send: 'Trimite',
      search: 'Cauta',
      saveAndSend: 'Salveaza si Trimite',
      save: 'Salveaza',
      reset: 'x',
      requiredLegend: 'Campurile marcate cu * sunt obligatorii!',
      refuse: 'Refuza',
      preview: 'Panou Control',
      pickUpDate: 'Data de preluare',
      pickup: 'Preluare',
      packages: 'Pachete',
      return: 'Retur',
      ok: 'Ok',
      nrPcs: 'pcs',
      no: 'Nu',
      nextStep: 'Pasul urmator',
      next: 'Mai departe',
      negotiationHistory: 'Istoric negociere',
      negotiate: 'Negociaza',
      'needs-invoice-select-item': {
        null: 'Toate',
        needsInvoiceLabel: 'Da',
        hasInvoiceLabel: 'Nu',
      },
      myContacts: 'Contactele mele',
      moreDetails: 'Mai multe detalii',
      maxDimension: 'cm',
      manualAdd: 'Adauga manual',
      length: 'Lungime',
      language: 'Limba',
      labels: 'Etichete',
      invoicePreview: 'Preview',
      height: 'Inaltime',
      group: 'Grupeaza',
      findSolution: 'Gaseste solutii',
      filter: 'Filtreaza',
      error: 'Eroare',
      emptyMessage: 'Nici a fost gasit nici un rezultat',
      'empty-list': 'Nu exista niciun element pentru cautarea facuta. Modificati filtrele pentru o noua cautare!',
      edit: 'Editeaza factura',
      download: 'Descarca',
      details: 'Detalii',
      deliveryDate: 'Data de predare',
      delivery: 'Predare',
      deleteConfirmation: 'Confirmare stergere',
      delete: 'Sterge',
      days: 'Zile',
      day: 'Zi',
      create: 'Creeaza',
      continue: 'Continua',
      confirmation: 'Confirmare',
      'columns-selected': 'coloane selectate',
      closePanel: 'Inchide panoul',
      close: 'Inchide',
      clear: 'Reseteza',
      chooseFile: 'Alege fisiere',
      'choose-columns': 'Alege coloane',
      choose: 'Alege',
      change: 'Schimba',
      cancel: 'Inchide',
      'boolean-select-item': {
        true: 'Da',
        null: 'Toate',
        false: 'Nu',
      },
      bindingBody:
        'Continuarea reprezintă acordul Dumneavoastră expres de a intra în raporturi contractuale, fiind echivalentă cu semnarea contractului de transport în condițiile detaliate în Termeni și condiții de utilizare Deliwell si Contractul de transport. După această confirmare orice modificare, reziliere sau anulare se poate realiza doar prin acordul părților.',
      backToSearch: (param) => (param.context ? `Inapoi la cautare ${param.context}` : `Inapoi la cautare`),
      selectFromExistentVehicles: 'Selecteaza din vehicule existente',
      selectFromExistentDrivers: 'Selecteaza din soferi existenti',
      attachments: 'Atasamente',
      signatures: 'Semnaturi',
      all: 'Toate',
      'advanced-filters': 'Filtre avansate',
      addService: 'Adauga serviciu',
      addFile: 'Adauga fisiere',
      add: 'Adauga',
      accept: 'Accepta',
    },
    util: {
      showDetails: 'Detalii',
      save: 'Salveaza',
      isEmailAuthTooltipMessage: 'Trebuie sa fiti inregistrati in platforma pentru a accesa aceasta functionalitate',
      defaultError: 'A aparut o eroare',
    },
    territoryAssignment: {
      deleteTerritoryConfirm: 'Confirmati stergerea teritoriului',
      deleteConfirm: 'Confirmati stergerea',
    },
    tariff: {
      template: 'Adauga din sablon',
      'start-zone': 'Zona Start',
      'service-name': 'Nume Serviciu',
      service: 'Serviciu',
      'price-interval': {
        to: 'Pana la',
        title: 'Intervale de tarifare',
        from: 'De la',
        'base-quantity': 'Cantitatea de baza',
        'base-price': 'Pret de baza',
        'add-quantity-step': 'Pas crestere pret',
        'add-price-per-step': 'Variatie pret per pas',
      },
      'new-title': 'Tarif nou',
      'list-title': 'Tarife',
      'from-template-title': 'Tarif nou din sablon',
      error: {
        requiredto: 'Obligatoriu de completat!',
        requiredtariffCalculationMethod: 'Metoda calcul este obligatoriu de completat!',
        requiredstartZone: 'Zona de start este obligatoriu de completat!',
        requiredfrom: 'Obligatoriu de completat!',
        requiredendZone: 'Zona de sfarsit este bligatoriu de completat!',
        requireddeliveryServiceVO: 'Nume serviciu este obligatoriu de completat!',
        requiredcurrency: 'Moneda este obligatoriu de completat!',
        requiredcontractVO: 'Contractul este obligatoriu de ales!',
        requiredbaseQuantity: 'Obligatoriu de completat!',
        requiredbasePrice: 'Obligatoriu de completat!',
        requiredaddQuantityStep: 'Obligatoriu de completat!',
        requiredaddPricePerStep: 'Obligatoriu de completat!',
        requiredaccountVO: 'Contul este obligatoriu de ales!',
        invalidIntervals: 'Intervalele introduse nu trebuie sa se intersecteze!',
        invalidInterval: 'Intervalul introdus este invalid!',
      },
      'end-zone': 'Zona Sfarsit',
      'detail-title': 'Editare tarif',
      'customer-name': 'Nume Client',
      currency: 'Moneda',
      contract: 'Contract',
      'calculation-method-value': {
        WEIGHT: 'Greutate',
        PIECES: 'Piese',
      },
      'calculation-method': 'Metoda calcul',
      addNew: 'Adauga Tarif',
      account: 'Cont',
    },
    suggestions: {
      selectDispatcher: 'Click pentru a selecta un angajat',
      unassignEmployee: 'Dezatribuie',
      orderListPage:
        'Comenzile se creeaza pe baza unei oferte sau se pot trimite pe baza unui contract incheiat in platforma.',
      addVendorTag: 'Pentru a adauga o eticheta, apasa click pe butonul urmator',
      addVendor: 'Pentru a adauga un transportator, apasa click pe butonul urmator',
      addExternalVendor: 'Pentru a adauga un curier, apasa click pe butonul urmator',
      addCustomer: 'Pentru a adauga un client, apasa click pe butonul urmator',
      addBankAccountForPartnerPopup:
        "Conturile bancare trebuie sa fie in statusul Activ si tipul Normal. Pentru a verifica existenta conturilor bancare intrati in 'Profil compania mea / parteneri'",
      addBankAccount:
        'Conturile bancare trebuie sa fie in statusul Activ si tipul Normal. Daca nu aveti unul, adaugati-l folosind aceasta icoana',
      addAccount: 'Pentru a adauga un cont, apasa click pe butonul urmator',
      employeeList: 'Pentru a adauga un angajat, apasa click pe butonul urmator',
      transportProjectList: 'Pentru a adauga un proiect de transport, apasa click pe butonul urmator',
    },
    driverExpenses: {
      title: 'Deconturi soferi',
      list: {
        expenseDate: 'Data decont',
        name: 'Sofer',
        licensePlate: 'Vehicul',
        description: 'Descriere',
        expenseType: 'Tip decont',
        currencyCode: 'Moneda',
        amount: 'Suma',
        localCurrencyAmount: 'Suma in RON',
        localCurrencyExchangeRate: 'Rata de schimb',
        documentNumber: 'Chitanta',
        status: 'Status decont',
      },
      options: {
        expenseType: {
          CLAIM: 'Decont',
          ADVANCE: 'Avans',
        },
        status: {
          REQUESTED: 'Cerut',
          APPROVED: 'Aprobat',
          DECLINED: 'Respins',
        },
        currencyCode: {
          RON: 'RON',
          EUR: 'EUR',
          USD: 'USD',
        },
      },
      totalInRon: 'Total cheltuieli',
      monthAndYear: 'Deconturi din luna si anul: ',
      approve: 'Aproba',
      decline: 'Respinge',
    },
    courierManagement: {
      title: 'Curieri',
      list: {
        courierType: 'Firma curierat',
      },
      courierType: {
        FED_EX: 'FedEx',
        UPS: 'UPS',
        DHL: 'DHL',
      },
      new: 'Adauga',
      form: {
        apis: {
          RATES_AND_TRANSIT_TIMES: 'Tarife si timpi de tranzit',
          SHIPMENT: 'Expediere',
          PICKUP: 'Solicitare de ridicare',
          TRACKING: 'Urmarire',
          UPLOAD_DOCUMENT: 'Incarcare documente comerciale',
          UPS_APIS: 'Acces API-uri UPS',
          DHL_APIS: 'Acces API-uri DHL',
        },
        apiKey: 'Cheie API',
        secretKey: 'Cheie secreta',
        accountNumber: 'Numar cont',
        courierType: 'Firma curierat',
        copy: 'Copiaza',
        paste: 'Lipeste',
      },
      accountNumber: {
        title: 'Numere de cont',
        add: 'Adauga numar de cont',
        saveMultipleForFedEx: 'Doresc salvarea acestui numar de cont si pentru API-urile de: ',
        fedexApis: 'API-uri FedEx',
        editLabel: 'Editeaza eticheta',
        addLabel: 'Adauga eticheta',
        noAccountNumbersWarningMessage: 'Acest curier nu are numere de cont asociate. Adauga folosind butonul urmator',
        selectAnAccountNumberTooltip: 'Trebuie sa selectati un numar de cont!',
        list: {
          accountNumber: 'Numar cont',
          label: 'Eticheta',
          countryCode: 'Tara asociata',
          postalCode: 'Cod postal asociat',
        },
        isPrimary: 'Acesta va fi contul principal',
        primaryAccountInfo:
          'Setand acest cont ca principal, contul care este in prezent principal va fi inlocuit automat.',
        markPrimary: 'Seteaza acest cont ca principal',
        unmarkPrimary: 'Elimina statutul de principal',
        error: {
          requiredAccountNumber: 'Numarul de cont este obligatoriu!',
        },
      },
      discount: {
        title: 'Discount-uri',
        add: 'Adauga discount',
        chargeTypes: {
          BASE_SERVICE: 'Tarif de baza transport',
          FUEL_SURCHARGE: 'Taxa combustibil',
          ADDITIONAL_SURCHARGE: 'Taxe suplimentare',
        },
        discountPercentage: 'Discount',
        chargeType: 'Tip taxa',
        serviceType: 'Tip serviciu',
        editPercentage: 'Editeaza discount',
        allCourierChargeTypesHaveBeenAdded: 'Toate tipurile de taxe au fost deja adaugate!',
        useDiscounts: 'Aplic discount-urile peste preturile primite de la curier',
        deleteConfirmationMessage: 'Esti sigur ca vrei sa stergi discount-ul?',
        selectServiceTypes: 'Selectati servicii',
        errors: {
          maxDiscountPercentage: 'Valoarea discount-ului nu poate depasi 100!',
          minDiscountPercentage: 'Valoarea discount-ului nu poate fi mai mica decat 0!',
          requiredDiscountPercentage: 'Valoarea discount-ului este obligatorie!',
        },
      },
      tag: 'Curier',
      latestStatusInfo: 'Ultimul status de la ',
      noLatestStatusInfo: 'Nu exista un ultim status de la curier!',
      serviceTypes: {
        FEDEX_FIRST: 'FedEx® First',
        FEDEX_PRIORITY_EXPRESS: 'FedEx® Priority Express',
        FEDEX_PRIORITY: 'FedEx® Priority',
        FEDEX_PRIORITY_FREIGHT: 'FedEx® Priority Freight',
        FEDEX_10KG_BOX: 'FedEx® 10kg Box',
        FEDEX_25KG_BOX: 'FedEx® 25kg Box',
        FEDEX_INTERNATIONAL_CONNECT_PLUS: 'FedEx® International Connect Plus',
        FEDEX_REGIONAL_ECONOMY: 'FedEx® Regional Economy',
        FEDEX_REGIONAL_ECONOMY_FREIGHT: 'FedEx® Regional Economy Freight',
        EXPRESS_SAVER: 'FedEx® Express Saver',
        FEDEX_INTERNATIONAL_PRIORITY_EXPRESS: 'FedEx® International Priority Express',
        INTERNATIONAL_FIRST: 'FedEx® International First',
        FEDEX_INTERNATIONAL_PRIORITY: 'FedEx® International Priority',
        INTERNATIONAL_ECONOMY: 'FedEx® International Economy',
        FEDEX_GROUND: 'FedEx® Ground',
        FIRST_OVERNIGHT: 'FedEx® First Overnight',
        FEDEX_FIRST_FREIGHT: 'FedEx® First Overnight Freight',
        FEDEX_1_DAY_FREIGHT: 'FedEx® 1Day Freight',
        FEDEX_2_DAY_FREIGHT: 'FedEx® 2Day Freight',
        FEDEX_3_DAY_FREIGHT: 'FedEx® 3Day Freight',
        INTERNATIONAL_PRIORITY_FREIGHT: 'FedEx® International Priority Freight',
        INTERNATIONAL_ECONOMY_FREIGHT: 'FedEx® International Economy Freight',
        FEDEX_INTERNATIONAL_DEFERRED_FREIGHT: 'FedEx® International Deferred Freight',
        INTERNATIONAL_PRIORITY_DISTRIBUTION: 'FedEx® International Priority DirectDistribution',
        INTERNATIONAL_DISTRIBUTION_FREIGHT: 'FedEx® International Priority DirectDistribution Freight',
        INTL_GROUND_DISTRIBUTION: 'FedEx® International Ground Distribution',
        GROUND_HOME_DELIVERY: 'FedEx® Home Delivery',
        SMART_POST: 'FedEx® Ground Economy',
        PRIORITY_OVERNIGHT: 'FedEx® Priority Overnight',
        STANDARD_OVERNIGHT: 'FedEx® Standard Overnight',
        FEDEX_2_DAY: 'FedEx® 2Day',
        FEDEX_2_DAY_AM: 'FedEx® 2Day AM',
        FEDEX_EXPRESS_SAVER: 'FedEx® Express Saver',
        SAME_DAY: 'FedEx® SameDay',
        SAME_DAY_CITY: 'FedEx® SameDay City',

        UPS_STANDARD: 'UPS Standard',
        UPS_WORLDWIDE_EXPRESS_PLUS: 'UPS Worldwide Express Plus',
        UPS_WORLDWIDE_SAVER: 'UPS Worldwide Saver',
        UPS_2ND_DAY_AIR: 'UPS 2nd Day Air',
        UPS_2ND_DAY_AIR_AM: 'UPS 2nd Day Air AM',
        UPS_3_DAY_SELECT: 'UPS 3 Day Select',
        UPS_GROUND: 'UPS Ground',
        UPS_NEXT_DAY_AIR: 'UPS Next Day Air',
        UPS_NEXT_DAY_AIR_EARLY: 'UPS Next Day Air Early',
        UPS_NEXT_DAY_AIR_SAVER: 'UPS Next Day Air Saver',
        ROADIE_XD_AM: 'Roadie XD AM',
        ROADIE_XD_PM: 'Roadie XD PM',
        ROADIE_XD: 'Roadie XD',
        UPS_ACCESS_POINT_ECONOMY: 'UPS Access Point Economy',
        UPS_EXPEDITED: 'UPS Expedited',
        UPS_EXPRESS: 'UPS Express',
        UPS_EXPRESS_12_GERMANY: 'UPS Express 12 Germany',
        UPS_WORLDWIDE_EXPRESS_FREIGHT: 'UPS Worldwide Express Freight',
        UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY: 'UPS Worldwide Express Freight Midday',
        UPS_WORLDWIDE_ECONOMY_DDU: 'UPS Worldwide Economy DDU',
        UPS_WORLDWIDE_ECONOMY_DDP: 'UPS Worldwide Economy DDP',
        DHL_EXPRESS_WORLDWIDE_DOC: 'Express Worldwide',
        DHL_EXPRESS_WORLDWIDE_NON_DOC: 'Express Worldwide',
        DHL_EXPRESS_1200_DOC: 'Express 12:00',
        DHL_EXPRESS_1200_NON_DOC: 'Express 12:00',
        DHL_EXPRESS_EASY_NON_DECL: 'Express Easy',
        DHL_EXPRESS_EASY_NON_UE_DECL: 'Express Easy',

        DHL_MEDICAL_EXPRESS_UE_NON_DECL: 'Medical Express',
        DHL_EXPRESS_0900_DOC: 'Express 09:00',
        DHL_EXPRESS_0900_NON_DOC: 'Express 09:00',
        DHL_EXPRESS_WORLDWIDE_UE_NON_DECL: 'Express Worldwide',
        DHL_ECONOMY_SELECT_DOC: 'Economy Select',
        DHL_ECONOMY_SELECT_NON_DOC: 'Economy Select',
        DHL_EXPRESS_BREAKBULK: 'Express Breakbulk',
        DHL_ECONOMY_BREAKBULK: 'Economy Breakbulk',
        DHL_EXPRESS_1030_NON_DECL: 'Express 10:30',
        DHL_EXPRESS_1030_DECL: 'Express 10:30',
        DHL_EXPRESS_DOMESTIC: 'Express Domestic',
        DHL_MEDICAL_EXPRESS_NON_DECL: 'Medical Express',
        DHL_MEDICAL_EXPRESS_DECL: 'Medical Express',
      },
      fedex: {
        latestStatusDetailType: {
          AA: 'La aeroport',
          AC: 'La unitatea Canada Post',
          AD: 'În livrare',
          AF: 'La unitatea FedEx locală',
          AO: 'Expediere sosind la timp',
          AP: 'La preluare',
          AR: 'Ajuns la locația FedEx',
          AX: 'La unitatea USPS',
          CA: 'Expediere anulată sau transportator',
          CH: 'Locație schimbată',
          DD: 'Întârziere livrare',
          DE: 'Excepție la livrare',
          DL: 'Livrat',
          DP: 'Plecat',
          DR: 'Vehicul furnizat, dar neutilizat',
          DS: 'Vehicul expediat',
          DY: 'Întârziere',
          EA: 'În drum spre aeroport sau export aprobat',
          ED: 'În drum spre livrare',
          EO: 'În drum spre aeroportul de origine',
          EP: 'În drum spre preluare',
          FD: 'La destinația FedEx',
          HL: 'Reținut la locație',
          HP: 'Gata pentru ridicare de către destinatar',
          IT: 'În tranzit',
          IX: 'În tranzit (vezi detalii)',
          LO: 'A părăsit originea',
          OC: 'Comandă creată',
          OD: 'În curs de livrare',
          OF: 'La unitatea de origine FedEx',
          OX: 'Informații despre expediere trimise la USPS',
          PD: 'Întârziere la preluare',
          PF: 'Avion în zbor',
          PL: 'Avion aterizat',
          PM: 'În procesare',
          PU: 'Preluat',
          PX: 'Preluat (vezi detalii)',
          RR: 'CDO solicitat',
          RM: 'CDO modificat',
          RC: 'CDO anulat sau destinatar',
          RS: 'Returnat expeditorului',
          RP: 'Linkul etichetei de returnare trimis prin e-mail expeditorului',
          LP: 'Linkul etichetei de returnare anulat de expeditor',
          RG: 'Linkul etichetei de returnare expiră în curând',
          RD: 'Linkul etichetei de returnare expirat',
          SE: 'Excepție la expediere',
          SF: 'La unitatea de sortare',
          SP: 'Status împărțit',
          TR: 'Transfer',
          CC: 'Vămuire finalizată',
          CD: 'Întârziere la vămuire',
          CP: 'Vămuire în curs',
          SH: 'Expeditor',
          CU: 'Vamă',
          BR: 'Broker',
          TP: 'Partener de transfer',
        },
      },
      errors: {
        requiredCourierType: "Campul 'Firma curierat' este obligatoriu!",
        'requiredSecretKey-RATES_AND_TRANSIT_TIMES':
          "Campul 'Cheie secreta' este obligatoriu pentru API-ul de Tarife si timpi de tranzit",
        'requiredApiKey-RATES_AND_TRANSIT_TIMES':
          "Campul 'Cheie API' este obligatoriu pentru API-ul de Tarife si timpi de tranzit",
        'requiredAccountNumber-RATES_AND_TRANSIT_TIMES':
          "Campul 'Numar cont' este obligatoriu pentru API-ul de Tarife si timpi de tranzit",
        'requiredSecretKey-SHIPMENT': "Campul 'Cheie secreta' este obligatoriu pentru API-ul de Expediere",
        'requiredApiKey-SHIPMENT': "Campul 'Cheie API' este obligatoriu pentru API-ul de Expediere",
        'requiredAccountNumber-SHIPMENT': "Campul 'Numar cont' este obligatoriu pentru API-ul de Expediere",
        'requiredSecretKey-PICKUP': "Campul 'Cheie secreta' este obligatoriu pentru API-ul de Solicitare de ridicare",
        'requiredApiKey-PICKUP': "Campul 'Cheie API' este obligatoriu pentru API-ul de Solicitare de ridicare",
        'requiredAccountNumber-PICKUP': "Campul 'Numar cont' este obligatoriu pentru API-ul de Solicitare de ridicare",
        'requiredSecretKey-TRACKING': "Campul 'Cheie secreta' este obligatoriu pentru API-ul de Urmarire",
        'requiredApiKey-TRACKING': "Campul 'Cheie API' este obligatoriu pentru API-ul de Urmarire",
        'requiredAccountNumber-TRACKING': "Campul 'Numar cont' este obligatoriu pentru API-ul de Urmarire",
        'requiredSecretKey-UPLOAD_DOCUMENT':
          "Campul 'Cheie secreta' este obligatoriu pentru API-ul de Incarcare documente",
        'requiredApiKey-UPLOAD_DOCUMENT': "Campul 'Cheie API' este obligatoriu pentru API-ul de Incarcare documente",
        'requiredAccountNumber-UPLOAD_DOCUMENT':
          "Campul 'Numar cont' este obligatoriu pentru API-ul de Incarcare documente",
        'requiredApiKey-UPS_APIS': "Campul 'Cheie API' este obligatoriu pentru API-urile oferite de UPS",
        'requiredSecretKey-UPS_APIS': "Campul 'Cheie secreta' este obligatoriu pentru API-urile oferite de UPS",
        'requiredAccountNumber-UPS_APIS': "Campul 'Numar cont' este obligatoriu pentru API-urile oferite de UPS",
        'requiredApiKey-DHL_APIS': "Campul 'Cheie API' este obligatoriu pentru API-urile oferite de DHL",
        'requiredSecretKey-DHL_APIS': "Campul 'Cheie secreta' este obligatoriu pentru API-urile oferite de DHL",
        'requiredAccountNumber-DHL_APIS': "Campul 'Numar cont' este obligatoriu pentru API-urile oferite de DHL",
      },
    },
    packageTracking: {
      title: 'Urmarire pachete',
      filter: 'Filtreaza  (Ultimele 10 zile)',
      packageIdFilter: 'Cauta in toate pachetele, pe cele cu exact acest id',
      destination: 'Destinatie',
      packageEventSource: {
        web: 'Status obtinut in aplicatia web',
        mobile: 'Status obtinut prin aplicatia mobila',
        external: 'Status primit dintr-un mediu extern',
      },
      packageSelectionMethod: {
        SCANNED: 'Scanat',
        MANUALLY_SELECTED: 'Selectat manual',
        MANUALLY_INSERTED: 'Inserat manual',
        AUTOMATICALLY_MATCHED: 'Potrivit automat',
      },
      packageSelectionMethodShort: {
        SCANNED: 'Scanat',
        MANUALLY_SELECTED: 'Selectat',
        MANUALLY_INSERTED: 'Inserat',
        AUTOMATICALLY_MATCHED: 'Automat',
      },
      adHocPackage: 'Ad-hoc',
      statusEnum: {
        REQUESTED: 'Coletul a fost solicitat',
        REQUEST_REJECTED: 'Cererea de colet a fost respinsa',
        CANCELLED: 'Coletul a fost contramandat',
        SCHEDULED: 'Coletul este programat pentru expediere',
        IN_PROGRESS: 'Coletul este planificat pentru preluare',
        TRANSIT_START: 'Coletul este in tranzit',
        TRANSIT_END: 'Tranzitul coletului s-a incheiat',
        LOST: 'Coletul a fost pierdut',
        UNAVAILABLE: 'Coletul este indisponibil',
        RETURN_TO_ORIGIN: 'Pachetul se returneaza',
        RETURNED_TO_ORIGIN: 'Coletul a fost returnat',
        DELIVERED: 'Coletul a fost livrat cu succes',
      },
      shortStatusEnum: {
        REQUESTED: 'Solicitat',
        REQUEST_REJECTED: 'Respins',
        CANCELLED: 'Contramandat',
        SCHEDULED: 'Programat',
        IN_PROGRESS: 'Planificat',
        TRANSIT_START: 'In tranzit',
        TRANSIT_END: 'Tranzit incheiat',
        LOST: 'Pierdut',
        UNAVAILABLE: 'Indisponibil',
        RETURN_TO_ORIGIN: 'Se returneaza',
        RETURNED_TO_ORIGIN: 'Returnat',
        DELIVERED: 'Livrat',
      },
      shipmentSeriesFilter: 'Filtreaza dupa seria transportului',
      markAsLost: 'Marcheaza ca pierdut',
      markAsLostConfirmHeader: 'Confirmare marcare ca pierdut',
      markAsLostConfirmMessage: 'Sunteti sigur ca doriti sa marcati acest pachet ca pierdut?',
      markedAsLostSuccess: 'Pachetul a fost marcat ca pierdut',
    },
    shipment: {
      filters: {
        pickupLocation: 'Locatie ridicare',
        deliveryLocation: 'Locatie predare',
        pickupCity: 'Oras ridicare',
        deliveryCity: 'Oras Predare',
      },
      routing: {
        assignToAll: 'Informatia a fost atribuita tuturor transporturilor!',
        error: {
          requiredDriverName: 'Numele soferului e obligatoriu',
          requiredDriverPhone: 'Numarul de telefon al soferului e obligatoriu',
          requiredLicensePlate: 'Placa de inmatriculare e obligatorie',
          requiredVehicleType: 'Tipul vehicului e obligatoriu',
          requiredVehicle: 'Vehiculul e obligatoriu',
          requiredDriver: 'Soferul e obligatoriu',
        },
      },
      util: {
        requested: 'cerut',
        overlap: 'intersectat',
        given: 'oferit',
      },
      unstackable: 'Nesuprapozabil',
      type: 'Tip',
      tariff: 'Tarif transport',
      createAutomaticTask: 'Creaza task pentru acest transport',
      tags: 'Etichete',
      stackable: 'Suprapozabil',
      savedAttachments: 'Atasamente existente',
      saveCmr: 'Incarca CMR selectat',
      saveAttachments: 'Incarca atasamentele selectate',
      request: {
        title: 'Cerere transport',
        modalTitle: 'Completeaza datele urmatoare: ',
        error: {
          defaultValidationMessage: 'A aparut o eroare',
        },
      },
      reference: 'Referinta',
      packagesDetails: '{{packagesNumber}} pachete | {{weight}} kg | {{volume}} cbm',
      otherDocuments: 'Alte documente',
      series: 'Serie transport',
      number: 'Numar transport',
      locked: 'Transport exclusiv',
      updateVehicle: 'Actualizeaza masina',
      updateDriver: 'Actualizeaza sofer si contact',
      updateDriverSuccessMessage: 'Soferul a fost actualizat cu succes!',
      updateVehicleSuccessMessage: 'Masina a fost actualizata cu succes!',
      emptyVehicleWarningMessage: 'Completati cel putin un camp pentru a actualiza masina',
      emptyDriverWarningMessage: 'Completati cel putin un camp pentru a actualiza soferul',
      removeVehicle: 'Sterge masina',
      removeDriver: 'Sterge sofer',
      removeDriverSuccessMessage: 'Soferul a fost sters cu succes!',
      removeVehicleSuccessMessage: 'Masina a fost stearsa cu succes!',
      hasAssociatedTerminalReservations:
        'Actualizarea acestor date va suprascrie informatiile deja introduse in programarea comenzii in depozit.',
      summaryTitle: 'Rezumat transporturi',
      assignToShipments: 'Asigneaza pe toate transporturile',
      assignToShipmentsTooltip: 'Precompleteaza datele pe celelalte transporturi',
      assignVehicleToShipments: 'Asigneaza masina pe transporturi',
      assignDriverToShipments: 'Asigneaza sofer si contact pe transporturi',
      list: {
        title: 'Task transport',
        modalTitle: 'Salveaza task',
      },
      flowTypeEnum: {
        THIRD_COUNTRY: '3rd Country',
        OUT: 'Outbound',
        IN: 'Inbound',
      },
      flowType: 'Tip Flux',
      externalReference: 'Ref. externa',
      error: {
        pickupRequired: 'Informatiile despre ridicare sunt obligatoriu de completat',
        isEmptyshipment: 'Trebuie sa existe cel putin un transport',
        isEmptypackages: 'Trebuie sa existe cel putin un pachet',
        isEmptyProductCustomsClearanceDTOS: 'Trebuie sa existe cel putin un produs',
        packageCountExceeded: 'Numarul de pachete depaseste limita de 200',
        deliveryServicerequired: 'Serviciul de livrare este obligatoriu',
        deliveryRequired: 'Informatiile despre livrare sunt obligatoriu de completat',
        addressOrLocationRequired: 'Selecti o adresa sau o locatie',
      },
      downloadTemplateCMR: 'Descarca CMR cu detalii transport',
      downloadPackageLabels: 'Descarca etichetele pachetelor',
      downloadCMR: 'Descarca CMR',
      downloadAWB: 'Descarca AWB',
      displayPackageLabels: 'Arata etichetele pachetelor',
      displayCMR: 'Arata CMR',
      displayAWB: 'Arata AWB',
      deliveryService: 'Serviciul de livrare',
      delete: 'Sterge transport',
      customsRegime: 'Regim vamal',
      customsDuty: 'Taxe vamale',
      contactPerson: 'Persoana de contact',
      companyName: 'Nume companie',
      common: {
        shipment: 'Transport',
        weight: 'Greutate',
        volume: 'Volum',
        tags: 'Etichete',
        stackable: 'Suprapozabil',
        size: 'Dimensiuni',
        shipmentTags: 'Etichete transporturi',
        services: 'Servicii',
        searchClient: 'Cauta client',
        save: 'Salveaza',
        pieces: 'Nr. pachete',
        pickup: 'Locatie redicare',
        perPackage: '/pachet',
        package: 'Pachet',
        onChangeCurrencyNote: 'Se va schimba valuta pentru toate transporturile!',
        next: 'Urmatorul pas',
        dropHere: 'Drop item here',
        delivery: 'Locatie livrare',
        customerName: 'Client',
        currency: 'Valuta',
        close: 'Inchide',
        cargoValue: 'Valoare marfa',
        budget: 'Buget',
        'boolean-select-item': {
          true: 'Da',
          null: 'Toate',
          false: 'Nu',
        },
        vendor: 'Transportator',
      },
      CMR: 'CMR',
      chooseCMR: 'Alege CMR nou',
      chooseAttachments: 'Alege atasamente noi',
      cargoValue: 'Valoare marfa',
      budget: 'Buget',
      booleanAffirmationValues: {
        true: 'Da',
        false: 'Nu',
      },
      awb: 'AWB',
      attachedCMR: 'CMR Existent',
      assignedDispatcher: 'Dispecer asignat',
      add: 'Adauga transport',
      status: {
        requested: 'Solicitat',
        request_rejected: 'Respins',
        cancelled: 'Anulat',
        before_pickup: 'Nepreluat',
        in_progress: 'Planificat',
        partially_in_progress: 'Parțial planificat',
        unavailable_cargo: 'Marfă indisponibilă',
        returned_to_origin: 'Returnat',
        partially_returned_to_origin: 'Partial returnat',
        in_transit: 'Tranzit',
        partially_in_transit: 'Parțial în tranzit',
        transit_end: 'Tranzit incheiat',
        partially_transit_end: 'Parțial tranzit incheiat',
        return_to_origin: 'Retur expeditor',
        partially_return_to_origin: 'Retur partial',
        lost: 'Pierdut',
        partially_completed: 'Parțial livrată',
        mixed: 'Variabil',
        mixed_with_failure: 'Variabil cu esec',
        completed: 'Livrată',
        completed_with_failure: 'Livrata incomplet',
        undelivered: 'Nelivrata',
        documents_received: 'Documente primite',
      },
    },
    'shipment-templates': {
      vendor: {
        dashboard: {
          title: 'Transporturi programate',
        },
        'add-shipment-template': {
          errors: {
            isEmptyvendors: 'Trebuie selectat cel puțin un transportator',
          },
        },
      },
      recurrentShipment: 'Transport recurent',
      recurrenceEndDate: 'Data incheiere recurenta',
      recurrence: 'Recurenta',
      errors: {
        requiredCronExpression: "Campul 'Recurenta' este obligatoriu",
      },
      defaultRecurrenceEndDate: 'In mod implicit, data de incheiere a recurentei este peste un an',
      customer: {
        dashboard: {
          title: 'Clienți',
        },
      },
      common: {
        dashboard: {
          subtitle: 'Șabloane Transport',
          createOffReqTooltip: 'Selectați cel puțin un transport pentru a crea o cerere',
          createOffReq: 'Creează cerere de ofertă',
          'add-button': 'Adaugă',
        },
        chips: {
          placedOnOfferReq: 'Pe cerere de oferta',
        },
        'add-shipment-template': {
          title: 'Adaugă sablon',
        },
        'edit-shipment-template': {
          title: 'Editeaza sablon',
        },
        'action-menu': {
          newTemplateFromTemplate: 'Creează șablon din șablon',
          newScheduledShipmentFromTemplate: 'Creează transport programat din șablon',
        },
      },
      chooseRecurrence: 'Alege recurenta',
    },
    'shipment-split': {
      allSegmentsMustHaveAtLeastOneShipmentMessage: 'Toate segmentele trebuie sa aiba cel putin un transport',
      yes: 'Da',
      updateSegment: 'Salveaza modificarile in solutia curenta',
      unsavedChangesWarning: 'Daca aveti modificari nesalvate, aceste se vor pierde',
      unsavedChanges: 'Aveti modificari nesalvate. pentu a nu pierde aceste modificari apasati Salveaza',
      title: 'Shipment Split',
      emptySegment: 'Segmentul nu contine nici un draft',
      success: 'Succes',
      'split-wizard': {
        splitMethodTitle: 'Metoda spargere',
        splitConditionTitle: 'Conditii spargere',
        secondCardFooter: 'Impartirea transporturilor intr-un punct de locatie intermediar',
        packagesSplitTitle: 'Pachete',
        packages: 'Pachete',
        packagesDisabledTooltip: 'Aceasta metoda de split nu este disponibila pentru ca acest shipment nu are pachete',
        enablePackagesGrouping: 'Activeaza gruparea pachetelor',
        disablePackagesGrouping: 'Dezactiveaza gruparea pachetelor',
        'next-step': 'Pasul urmator',
        locationSplitTitle: 'Punct de intrerupere',
        locations: 'Locatii',
        firstCardFooter: 'Impartirea pachetelor in 2 transporturi',
        addPoint: 'Adauga punct de predare',
      },
      sort: 'Sorteaza',
      solutions: 'Solutii',
      'show-on-map': 'Vizualizeaza pe harta',
      'shipments-actions': {
        split: 'Shipment Split',
        'assign-to-new-shipment': 'Atribuie pe o ruta noua',
      },
      shipments: 'Transporturi',
      'shipment-segment-solution': {
        title: 'Solutii',
        'selection-dialog-title': 'Modificati ruta?',
        'offer-requests': 'Cereri de oferta trimise',
        'offer-request': {
          status: 'Status',
          'empty-list': 'Momentan nu ati trimis nici o cerere de oferta!',
          details: 'Detalii',
          deadline: 'Deadline',
        },
        'create-solution': 'Creeaza solutie',
        'create-offer-request': 'Creeaza cerere de oferta',
        back: 'Inapoi',
      },
      'shipment-group-solutions': {
        vehicle: 'Masina',
        'transit-time': 'Timp tranzit',
        'order-create': 'Creeaza comanda',
        'pre-order-create': 'Creeaza pre-comanda',
        'pre-offer-request-create': 'Creeaza cerere de pre-oferta',

        tooltips: {
          'task-details': 'Detalii task-uri',
          'order-details': 'Detalii comanda',
          'not-preferred': 'Trebuie sa setati solutia ca fiind preferata',
          disabled: 'Exista o solutie completa pe care s-au creat task-uri / comenzi',
          'add-task': 'Creeaza task-uri',
          'accept-offer-and-create-order': 'Accepta oferta si creeaza comanda',
        },
        title: 'Solutii',
        'summaries-panel': {
          title: 'Solutii',
          seeAll: 'Vezi Toate Solutiile',
          routingSolutions: 'Solutii Proprii',
          offers: 'Oferte',
          offerRequests: 'Cereri Oferte',
        },
        sellAllSolutions: 'Vezi toate solutiile',
        'segments-title': 'Traseu',
        'routing-solution': {
          title: 'Solutii transport',
          'solution-created-message': 'Solutie creeata cu succes!',
          rsTitle: 'Solutie transport',
          'rs-expired': 'Solutia a expirat',
          offerTitle: 'Oferta',
          'offer-request-message': 'Cerere de oferta creeata cu succes!',
          'offer-expired': 'Oferta de la baza solutiei a expirat',
          'more-details': 'Click pentru mai multe detalii',
          'list-title': 'Solutii',
          expired: 'Solutia a expirat!',
          'empty-list': 'Momentan nu aveti nici o solutie',
          'empty-create': 'Creaza solutie proprie',
          'disabled-selection': 'Trebuie sa aveti cel putin o solutie!',
          details: 'Detalii',
          'create-vendor-solution-message': 'Creeaza solutie',
          'create-solution-message': 'Creeaza solutie folosind flota proprie',
        },
        offer: {
          title: 'Oferta',
          negotiate: 'Negociaza',
          'list-title': 'Oferte',
          expired: 'Oferta a expirat!',
          'empty-list': 'Momentan nu aveți nicio ofertă ',
          'empty-create': 'Creeaza Cerere de oferta',
          'create-routing-solution': 'Creeaza solutie de transport',
        },
        'master-routing-solutions': {
          'unselected-routing-solution': 'Nu a fost selectata nici o solutie',
          title: 'Solutii complete',
          'save-solution': 'Salveaza solutia',
          'create-solution': 'Creeaza solutia',
          'context-menu': {
            'set-preferred': 'Schimbati solutia preferata?',
            preferred: 'Preferata',
            'complete-offer': 'Oferta completa',
          },
          'confirmation-dialog': {
            dialogMessage:
              'Dupa finalizarea actiunii, nu o sa mai aveti posibilitatea sa schimbati solutia completa preferata!',
            dialogHeader: 'Sunteti sigur?',
            cancelLabel: 'Inchide',
            acceptLabel: 'Doresc sa continui',
          },
          'cancel-solution': 'Anuleaza',
          'additional-info': 'Dati click dreapta pe solutie pentru a seta ca preferata sau pentru a crea oferta',
        },
        'graphic-legend': {
          warn: 'Ruta subcontractor',
          primary: 'Ruta proprie',
        },
        driver: 'Sofer',
        dialog: {
          'order-details': 'Detalii comanda',
          'create-order': 'Creeaza comanda',
        },
        defaultForSubco: 'Creata prin subcontractare directa',
        lockedInSolution: 'Solutie definitiva',
        inProgressSolution: 'Solutie in lucru',
        createdAt: 'Creata la data:',
        'available-until': 'Expira in',
      },
      'shipment-group-solution-tracking': {
        title: 'Shipment Group Solution Tracking',
        'empty-tracking': 'Nu au fost create task-uri sau comanda',
        delayed: 'Transportul a intarziat',
      },
      selectedSegment: 'Segmentul selectat',
      'select-route': 'Selectati aceasta ruta?',
      'select-existing-route': 'Selecteaza ruta existenta',
      'select-existing-root-segment': 'Selecteaza segment',
      'segment-popup-form': {
        'vendor-route-tab': {
          vendor: 'Transportator',
          title: 'Ruta subcontractor',
          source: 'Origine',
          save: 'Salveaza',
          errors: {
            isEmptySource: 'Campul Origine este obligatoriu',
            isEmptyDestination: 'Campul Destinatie este obligatoriu',
          },
          destination: 'Destinatie',
        },
        'owned-route-tab': {
          waypoints: 'Puncte intermediare',
          vehicleType: 'Tip vehicul',
          title: 'Ruta sablon',
          source: 'Origine',
          save: 'Salveaza',
          'map-placeholder': 'Selecteaza Originea si Destinatia, pentru vizualizarea pe harta!',
          error: {
            isEmptyWaypoint: 'Punctul intermediar nu poate fi gol!',
            isEmptySource: 'Campul Origine este obligatoriu',
            isEmptyDestination: 'Campul Destinatie este obligatoriu',
          },
          destination: 'Destinatie',
          'add-waypoint': 'Adauga punct intermediar',
        },
      },
      'segment-definition': {
        waypointError: 'Selectati doua puncte pentru definirea segmentului',
        title: 'Definire Segment',
        selected: 'selectat',
        'not-selected': 'neselectat',
        info: 'Selectati capetele segmentului',
      },
      saveWithUpdatedSegment: 'Salveaza o solutie noua',
      saveSuccessMessage: 'Salvare a fost efectuata cu succes. Puteti trece in pasul urmator',
      save: 'Salveaza',
      routes: {
        tooltip: {
          'show-on-map': 'Afiseaza pe harta',
          details: 'Detalii ruta',
          'create-from-template': 'Creaza ruta din sablon',
        },
        'route-types': {
          vendor_route: 'Ruta subcontractor',
          route_template: 'Ruta sablon',
          route: 'Ruta proprie',
        },
      },
      'routes-list-title': 'Rute',
      'routes-filter-form': {
        'vendor-name': 'Nume subcontractor',
        'vehicle-type': 'Tip vehicul',
        'route-type': 'Tipul rutei',
        origin: 'Localitate de plecare',
        'license-plate': 'Numar inmatriculare',
        destination: 'Localitate de destiantie',
      },
      route: {
        'show-on-map': 'Vezi traseu pe harta',
      },
      'route-load': {
        weight: 'Greutate',
        volume: 'Volum',
        title: 'Incarcatura ruta',
        nrPcs: 'Pachete',
        empty: 'Nu exista nici o incarcatura!',
      },
      'resolve-choice': {
        title: 'Metoda de rezolvare',
        subcontractingTitle: 'Cere oferta',
        subcontractingDescription: 'Cere oferta de la transportatorii parteneri pentru grupul de shipment-uri',
        splitTitle: 'Rezolvare completa',
        splitDescription: 'Rezolva grupul de shipment-uri cu ajutorul functionalitatii de split al shipment-urilor',
      },
      'replace-segment': 'Schimba segment cu unul similar',
      pickupAndDeliveryTitle: 'Actualizare date ridicare/predare pentru sectiunea de traseu',
      pickup: 'Pickup',
      packagesTitle: 'Pachete atribuite pe sectiunea de traseu',
      packages: 'Pachete',
      'no-shipment-info': 'Trageti si lasati un shipment aici, pentru a incarca pe ruta',
      'no-segment-error': 'Nu exista segmente',
      no: 'Nu',
      nextButtonSolutionNotCompleteTooltip:
        'Solutia nu este completa. Finalizati solutia inainte de a trece la pasul urmator',
      nextButtonHasChangesTooltip: 'Aveti modificari nesalvate. Apasati Salveaza inainte de a trece la pasul urmator',
      'more-waypoints': 'Inca {{waypointsLeft}} opriri',
      missingRouteSelection: 'trebuie selectat un segment',
      errorSummary: 'Erorre',
      childPackagesMismatch:
        'Numărul total de pachete din transporturile copil trebuie să fie egal cu cel al transportului părinte. Ajustați splitul înainte de a salva.',
      errorSuccessMessage: 'Verificati datele si incercati din nou',
      error: {
        requiredPieces: 'Cantitatea pachetelor nu poate fi goala',
        notPositiveValue: 'Cantitatea pachetelor nu poate fi negativa',
        maxValueExceeded: 'Cantitatea pachetelor introdusa nu poate fi mai mare decat valoarea originala',
        maxDistanceExceeded: 'Adresa trebuie sa fie la o distanta mai mica de 50km de segment',
        allPiecesAreZero: 'Trebuie sa includeti cel putin un pachet!',
        minTotalPieces: 'Numărul total de piese trebuie să fie cel puțin 1',
      },
      delivery: 'Delivery',
      'delete-segment': 'Sterge segment',
      'create-route-inline': 'Creeaza ruta noua',
      'create-new-route': 'Creeaza ruta noua',
      confirmation: 'Confirmati',
      clearSolutionTooltip: 'Click pentru a incepe solutie noua',
      choseSaveMode: 'Doriti sa inlocuiti in solutia curenta sau sa creati o solutie noua',
      'choose-split-type': 'Alege tipul de impartire',
      'choose-pickup-address': 'Alege adresa de pickup',
      'choose-package-number': 'Introduceti nr. de pachete dorit',
      'choose-delivery-address': 'Alege adresa de delivery',
      canvas: {
        howToStartPartTwo: ', urmat de selectia unei rute pentru a incepe procesul de solutionare a transporturilor',
        howToStartPartOne: 'Apasati butonu',
      },
      'are-you-sure-delete': 'Sunteti sigur ca doriti sa stergeti acest element',
      'add-segment': 'Adaugati segment',
      activeSegment: 'Segmentul original',
      pickupIsFarAway: 'Punctul de ridicare este departe de shipmentul original',
      deliveryIsFarAway: 'Punctul de livrare este departe de shipmentul original',
      dispatchOriginal: 'Continua cu transportul original',
      splitAndDispatch: 'Imparte',
      shipmentSplitRequired:
        'Este recomandata impartirea in mai multe transporturi. Doriti sa continuam cu impartirea sau sa continuam cu transportul original?',
      pickupSplitRequired:
        'Punctul de ridicare este prea departe de locatia Solutiei. Doriti sa continuam sau schimbati adresa',
      deliverySplitRequired:
        'Punctul de livrare este prea departe de locatia Solutiei. Doriti sa continuam sau schimbati adresa',
      bothSplitRequired:
        'Atat punctul de ridicare cat si cel de livrare sunt prea departe de locatia Solutiei. Doriti sa continuam sau schimbati adresele',
      makeChanges: 'Modific',
      continue: 'Continui salvarea',
    },
    'shipment-groups-dashboard': {
      tooltips: {
        'shipment-group-solution-tracking': 'Urmareste solutia de transport',
      },
      title: 'Workspace',
      status: {
        workInProgress: 'In lucru',
        sentOrdersNumber: 'Comenzi trimise',
        receivedOffersNumberPerSentOfferRequestsNumber: 'Oferte primite / Cereri trimise',
        paymentTimeLimit: 'Termen de plata',
        orderStatus: 'Status comanda',
        orderAccepted: 'Comanda Acceptata',
        offerSent: 'Oferta trimisa',
        noWorkInProgress: 'Noua',
        noOrderAccepted: 'Comanda Neacceptata',
        noOfferSent: '0 oferte trimise',
        masterRsNumber: 'Solutii complete',
        createdTasksNumber: 'Taskuri create',
      },
      shipments: 'Transporturi',
      routingSolution: 'Solutii de transport',
      resolve: 'Rezolva',
      pickupCity: 'Localitate ridicare',
      order: 'Ordoneaza',
      notificationTooltip: 'Pentru a putea vedea noile cereri apasati butonul. Atentie! Filtrele se vor reseta!',
      noRoutingSolution: 'Momentan nu exista nici o solutie',
      newOfferRequestsNotification: 'Aveti cereri de oferta noi',
      goToOrderDetails: 'Detalii',
      goToOfferRequestDetails: 'Detalii',
      filter: 'Filtreaza',
      expiredGroup: 'Expirat',
      dueTime: 'Timp ramas',
      dispatcher: 'Dispecer',
      deliveryCity: 'Localitate livrare',
      customerName: 'Nume client',
      assignedToUser: 'Atribuite mie',
      addOfferRequest: '+ Adauga cerere oferta',
      activeGroup: 'Activ',
      'account-input-label': 'Selecteaza cont',
      account: 'Cont',
    },
    'shipment-group': {
      'vehicle-type': 'Tip masina',
      'transit-time': 'Timp transit',
      'subcontracting-title': 'Oferte transportatori parteneri',
      subcontract: 'Cere oferta',
      'routing-solution-title': 'Solutii de transport',
      'routing-solution': 'Solutii de transport',
      paymentTimeLimit: 'Termen plata',
      'license-plate': 'Numar inmatriculare',
      'driver-name': 'Nume sofer',
    },
    'ship-transaction-terms-and-cond': {
      statuses: {
        rejected: 'Refuzate',
        accepted: 'Acceptate',
      },
      rejected: 'T&C Refuzate',
      reject: 'Refuz termenii si conditiile',
      currentStatus: 'Termenii si Conditiile au fost',
      comments: 'Observatii',
      accepted: 'T&C Acceptate',
      accept: 'Accept termenii si conditiile',
    },
    services: {
      title: 'Servicii',
      newService: 'Adauga serviciu',
      name: 'Denumire',
      error: {
        requiredserviceName: 'Campul Denumire este obligatoriu',
      },
      description: 'Descriere',
    },
    serviceProvider: {
      list: {
        vehicleTypes: 'Tip Vehicule',
        title: 'Calificare furnizori de servicii',
        routes: 'Rute',
        name: 'Nume',
        fleetSize: 'Flota',
        deliveredInTimePercentage: 'Livrat in timp (%)',
        countries: 'Tari',
        complaintPercentage: 'Procent de reclamatii (%)',
        averagePricePerKm: 'Pret mediu pe km',
      },
    },
    'scheduled-shipments': {
      title: 'Transporturi programate',
      createOfferRequestTooltip: 'Selectați cel puțin un transport pentru a crea o cerere',
      createOfferRequest: 'Creeaza cerere de oferta',
      'add-scheduled-shipment': 'Adauga transport programat',
      add: 'Adauga',
    },
    routingSolution: {
      vehicleType: 'Tip vehicul',
      transitDays: 'Zile tranzit',
      segmentSuggestionMessage:
        'Pe acest segment, preluarea si predarea coletului trebuie sa fie in intervalul urmator: ',
      minTimeAvailability: 'Valabilitatea minima a solutiei de transport este de',
      expired: 'Solutia de transport a expirat!',
      error: {
        requiredrouteUuid: 'A aparut o eroare cu selectarea rutei. Incearca din nou',
        requiredpackageGroupUuid: 'A aparut o eroare cu selectarea pachetelor. Incearca din nou',
        requiredcurrency: 'Campul Moneda este obligatoriu',
        requiredcost: 'Costul si moneda sunt obligatorii!',
      },
      details: 'Detalii',
      currency: 'Moneda',
      cost: 'Cost',
    },
    'routing-solution': {
      vehicleType: 'Tip vehicul',
      licensePlate: 'Numar inmatriculare',
      driverName: 'Nume sofer',
    },
    routes: {
      withETAAfter: 'Cu ETA dupa',
      title: 'Rute',
      route: {
        vehicle: 'Masina',
        'update-title': 'Actualizare ruta',
        templates: 'Sabloane',
        locations: 'Locatii',
        label: 'Nume',
        etd: 'ETD',
        eta: 'ETA',
        error: {
          waypointsInvalid: 'Trebuie sa fie minim 2 locatii',
          requiredStart: 'Campul ETD este obligatoriu',
          requiredName: 'Campul Nume este obligatoriu',
          requiredFinish: 'Campul ETA este obligatoriu',
        },
        'edit-confirmation': 'Doriti sa actualizati aceasta ruta?',
        driver: 'Sofer',
        'details-title': 'Detalii ruta',
        'add-title': 'Adaugare ruta',
        'add-location': 'Adauga locatii',
      },
      'route-template': {
        'update-title': 'Actualizare ruta sablon',
      },
      filters: {
        'vehicle-type': 'Tip vehicul',
        'route-type': 'Tipul rutei',
        origin: 'Localitate de plecare',
        'license-plate': 'Numar inmatriculare',
        'driver-name': 'Numele soferului',
        destination: 'Localitate de destinatie',
      },
      common: {
        source: 'Origine',
        googleError: 'Google maps nu a reusit sa creeze o ruta intre Origine si Destinatie',
        error: {
          isEmptyWaypoint: 'Punctul intermediar nu poate fi gol!',
          isEmptySource: 'Campul Origine este obligatoriu',
          isEmptyDestination: 'Campul Destinatie este obligatoriu',
        },
        destination: 'Destinatie',
        addWaypoint: 'Adauga punct intermediar',
      },
      addButtonLabel: 'Adauga ruta',
    },
    location: {
      autocomplete: 'Adauga locatie',
    },
    planner: {
      order: {
        title: 'Detalii planificator comanda',
        tasks: 'Taskuri',
        task: 'Task',
        deliveryCompanyNames: 'Companii livrare',
        pickupCompanyNames: 'Companii ridicare',
        status: 'Status',
        spName: 'Transportator partener',
        sales: 'Sales',
        pickups: 'Puncte de ridicare',
        pickup: 'Punct de ridicare',
        paymentTimeLimit: 'Termen plata',
        orderNumber: 'Numar comanda',
        invoiceGenerated: 'Facturat',
        locked: 'Incuiat',
        listTitle: 'Comenzi',
        handover: {
          country: 'Tara',
          city: 'Localitate',
        },
        error: {
          defaultValidationMessage: 'A apărut o eroare. Verifică datele introduse și încearcă din nou',
          accountrequired: 'Contul este obligatoriu de selectat!',
        },
        'dispatcher-header': 'Expeditor',
        dispatcher: 'Nume dispecer',
        delivery: 'Punct de livrare',
        deliveries: 'Puncte de livrare',
        delete: 'Sterge planificarea comenzii',
        customerName: 'Client',
        currencyCode: 'Moneda',
        totalWeight: 'Greutate totala',
        packageNumber: 'Numar pachete',
        pieces: 'buc',
        createdAt: 'Creata la',
        contact: {
          phoneNumber: 'Numar telefon',
          name: 'Nume',
        },
        billingCycle: 'Ciclu de facturare',
        add: 'Adauga comanda',
        account: 'Cont',
        requestingCompanyName: 'Companie solicitantă',
      },
      name: 'Nume',
    },
    package: {
      id: 'Id-ul pachetului',
      width: 'Latime',
      size: 'Dimensiuni',
      weight: 'Greutate/Pachet',
      type: 'Tip ambalaj',
      totalWeight: 'Greutate totala',
      totalVolume: 'Volum total',
      totalCount: 'Numar de pachete',
      title: 'Pachete',
      tags: 'Descriere marfă',
      pieces: 'Nr. pachete',
      status: {
        REQUESTED: 'Solicitat',
        REQUEST_REJECTED: 'Respins',
        CANCELLED: 'Contramandat',
        SCHEDULED: 'Programat',
        IN_PROGRESS: 'Planificat',
        TRANSIT_START: 'In tranzit',
        TRANSIT_END: 'Tranzit incheiat',
        LOST: 'Pierdut',
        UNAVAILABLE: 'Indisponibil',
        RETURN_TO_ORIGIN: 'Se returneaza',
        RETURNED_TO_ORIGIN: 'Returnat',
        DELIVERED: 'Livrat',
      },
      packageEvent: {
        lastEventAchievedAtDate: 'Status obtinut la data de',
        lastEventAchievedAtAddress: 'Status obtinut la adresa',
      },
      packages: 'pachete',
      numberOfPackagesAssignedToShipment: 'Pentru aceasta expediere au fost atribuite',
      length: 'Lungime',
      height: 'Inaltime',
      error: {
        widthrequired: 'Latimea e obligatorie',
        weightrequired: 'Greutatea e obligatorie',
        piecesrequired: 'Numarul de bucati e obligatoriu',
        noPackages: 'Trebuie adaugat cel putin un pachet!',
        lengthrequired: 'Lungimea e obligatorie',
        heightrequired: 'Inaltimea e obligatorie',
        descriptionrequired: 'Descrierea e obligatorie',
      },
      tracking: {
        destination: 'Destinatie',
        pickup: 'Preluare',
        indicateAProblem: 'Semnaleaza o problema',
        renewStatus: 'Cere reinnoire status',
        moreActions: 'Mai multe actiuni',
      },
      delete: 'Sterge pachet',
      add: 'Adauga pachet',
      select: 'Selecteaza un pachet',
      search: 'Cauta un pachet',
      custom: 'Pachet personalizat',
      packageStatusPopupTitle: 'Statusuri pachete',
      packageStatusPopupButtonTooltip: 'Vezi statusuri pachete',
      downloadPdf: 'Descarca PDF',
    },
    productCustomsClearance: {
      title: 'Detalii produse',
      add: 'Adauga marfa',
      commodityDescription: 'Descrierea marfii',
      quantity: 'Cantitate',
      quantityUnits: 'Unitate de masura',
      unitPrice: 'Pret unitar',
      customsValue: 'Valoare vamala',
      countryOfManufacture: 'Tara de fabricatie',
      amount: 'Valoare',
      currency: 'Moneda',
      totalWeight: 'Greutate totala (kg)',
      harmonizedCode: 'Cod tarifar',
      customsCurrency: 'Preturile sunt exprimate in moneda: ',
      commodity: 'Marfa ',
      quantityUnitLabels: {
        AR: 'Carat',
        CM: 'Centimetru',
        CFT: 'Picior Cub',
        M3: 'Metru Cub',
        DOZ: 'Duzină',
        DPR: 'Două duzine',
        EA: 'Fiecare',
        LFT: 'Picior',
        G: 'Gram',
        GR: 'Brut',
        KG: 'Kilogram',
        LNM: 'Metru Liniar',
        LTR: 'Litru',
        M: 'Metru',
        MG: 'Miligram',
        ML: 'Mililitru',
        NO: 'Număr',
        OZ: 'Uncie',
        PR: 'Pereche',
        PCS: 'Bucăți',
        LB: 'Livră',
        SFT: 'Picior Pătrat',
        M2: 'Metru Pătrat',
        SYD: 'Iard Pătrat',
        YD: 'Iard',
      },
      error: {
        requiredCommodityDescription: "Campul 'Descrierea marfii' este obligatoriu!",
        requiredQuantity: "Campul 'Cantitate' este obligatoriu!",
        requiredQuantityUnits: "Campul 'Unitate de masura' este obligatoriu!",
        requiredCountryOfManufacture: "Campul 'Tara de fabricatie' este obligatoriu!",
        requiredValue: 'Campul este obligatoriu!',
        requiredCustomLabel: "Campul 'Cod produs' este obligatoriu!",
        requiredCurrencyCode: 'Campul este obligatoriu!',
        requiredTotalWeight: "Campul 'Greutate totala (kg)' este obligatoriu!",
        minQuantity: 'Cantitatea nu poate fi mai mica decat 0',
        minValue: 'Valoarea nu poate fi mai mica decat 0',
        greaterThanTotalWeight: 'Greutatea totala trebuie sa fie mai mare de 0 kg',
        maxlengthHarmonizedCode: 'Codul tarifar nu poate avea mai mult de 8 caractere!',
        requiredProductCustomsClearancesCurrencyCode: "Campul 'Moneda' este obligatoriu!",
        requiredEnglishLanguage: 'Descrierea trebuie sa fie in limba engleza!',
        productsWeightIsBiggerThanPackagesWeight:
          'Greutatea totala a produselor trebuie sa fie mai mica sau egala cu greutatea totala a pachetelor!',
      },
      nomenclature: {
        productName: 'Numele produsului',
        customLabel: 'Codul produsului',
        addEmptyProduct: 'Adauga produs necompletat',
        searchProduct: 'Cauta produs',
        selectProduct: 'Selecteaza un produs',
        addProductToNomenclature: 'Adauga acest produs in nomenclator',
        saveInNomenclature: 'Salveaza in nomenclator',
        saveSelectedProducts: 'Salveaza produsele selectate',
        enterCustomLabel: 'Codul produsului',
        listTitle: 'Nomenclator produse',
        formTitle: 'Adauga produs',
        editTitle: 'Editare produs',
        productSavedSuccessfully: 'Produsul a fost salvat.',
        productDeletedSuccessfully: 'Produsul a fost sters.',
        saveProductChangesHeader: 'Confirmați salvarea?',
        saveProductChangesMessage: 'Dacă salvați, produsele care au următoarele coduri produs vor fi actualizate',
        saveProductWithNoChangesMessage:
          'Pentru a continua fără modificarea produselor, debifați opțiunea „Salvează în nomenclator”.',
        unitMeasurementInvalidMessage: 'Unitatea de măsură salvată pe produs nu este validă. Alegeți alta.',
        errors: {
          currencyNotTheSame: 'Valuta produsului nu este validă sau nu corespunde cu cea selectată',
          productNomenclatureSaveException:
            'Nu s-a putut efectua salvarea produselor în nomenclator. Pentru a continua, verificați dacă toate câmpurile sunt completate corect sau debifați opțiunea de salvare    ',
        },
      },
    },
    order: {
      wizard: {
        stepTwo: 'Transporturi',
        stepThree: 'Documente transport',
        stepOne: 'Detalii',
        stepFour: 'Rezumat',
        contractStep: 'Contract',
      },
      pickupDate: 'Data preluare',
      deliveryDate: 'Data livrare',
      dispatcher: 'Dispecer',
      viewOrder: 'Vizualizeaza comanda',
      viewComplaints: 'Reclamatii ',
      viewBlacklistHistory: 'Istoric blacklist ',
      uninvoicedOrders: 'Comenzi precedente nefacturate',
      unarchiveOrderTooltip: 'Comanda se poate dezarhiva doar daca este arhivata',
      unarchiveOrder: 'Dezarhiveaza comanda',
      downloadOrderAuditPdf: 'Descarca Pdf Audit Comanda',
      totalWeight: 'Greutate totala',
      packageNumber: 'Numar pachete',
      pieces: 'buc',
      deliveryCompanyNames: 'Companii livrare',
      pickupCompanyNames: 'Companii ridicare',
      externalReferences: 'Referinte externe',
      invoiceSerialNumber: 'Serie factura',
      invoiceList: {
        navigateToInvoiceTooltip: 'Click pentru detalii',
        navigateToInvoiceListTooltip: 'Navighează la toate facturile',
        seeMore: 'Vezi mai multe',
        seeLess: 'Vezi mai puțin',
      },
      uits: 'Uit transporturi',
      tasks: 'Taskuri',
      task: 'Task',
      statusTooltipForSp: 'Comanda poate fi trecuta in acest status doar de client',
      statusTooltipForCustomer: 'Comanda poate fi trecuta in acest status doar de furnizor',
      statusRequested: 'Clientul a cerut o actualizare de status pentru aceasta comanda!',
      statusHistory: 'Istoric status',
      statusEnum: {
        sent: 'Trimisa',
        accepted: 'Acceptata',
        rejected: 'Refuzata',
        in_progress: 'Planificata',
        partially_in_progress: 'Partial planificata',
        returned_to_origin: 'Returnata',
        partially_returned_to_origin: 'Partial returnata',
        in_transit: 'In Tranzit',
        partially_in_transit: 'Partial in tranzit',
        transit_end: 'Tranzit incheiat',
        partially_transit_end: 'Parțial tranzit incheiat',
        return_to_origin: 'Retur',
        partially_return_to_origin: 'Returnata partial',
        lost: 'Pierduta',
        partially_completed: 'Partial livrata',
        mixed: 'Variabil',
        mixed_with_failure: 'Variabil cu esec',
        completed: 'Livrata',
        completed_with_failure: 'Livrata incomplet',
        undelivered: 'Nerealizata',
        documents_partially_received: 'Documente partial disponibile',
        documents_received: 'Documente disponibile',
        archived: 'Arhivata',
        cancelled: 'Anulata',
      },
      statusCommentTitle: 'Adauga comentariu (optional)',
      status: 'Status',
      'shipment-tracking': 'Solutia pe baza careia a fost rezolvata comanda',
      serviceProvider: 'Furnizor',
      sentListTitle: 'Comenzi trimise',
      sendTitle: 'Comanda trimisa la',
      sendCustomerOrderEmailAccepted: 'Retrimite E-Mail Comanda Acceptata',
      savedSuccess: (param) => `Comanda cu numarul #${param.orderNumber} a fost salvata cu success`,
      resendStatusUpdate: 'Retrimite mail actualizare status',
      resendOrderEmailTooltip: 'Retrimiterea emailului de comanda se poate face doar in statusul 1.Acceptata',
      resendOrderEmail: 'Retrimitere email de comanda',
      resendInvoiceUploadInvitationEmail: 'Retrimitere email de incarcare factura',
      requestStatus: 'Cere actualizare de status',
      rejectTitle: 'Respinge comanda',
      rejectOrderMessage: 'Esti sigur ca doresti sa respingi aceasta comanda',
      refuseReason: 'Motivul refuzului',
      refuseOrder: {
        title: 'Refuza comanda',
        refuseButton: 'Refuza',
        mainButton: 'Refuza comanda',
        comments: 'Motiv',
      },
      refuse: 'Respinge',
      receivedTitle: 'Comanda primita de la',
      receivedListTitle: 'Comenzi primite',
      price: 'Pret',
      pickups: 'Preluari',
      pickup: 'Preluare',
      orderTrackingTitle: 'Tracking comanda',
      ordersTrackingTitle: 'Urmarire comenzi',
      ordersTrackingDescription: 'Filtrati comenzile in desfasurare sau in tranzit si vizualizeazati-le pe harta',
      orderStatus: {
        success: 'Success',
        sentSuccessMessage: 'Mail-ul cu actualizarea de status a fost trimis cu success',
        requestMessage: 'Alerta de actualizare a statusului a fost trimisa catre transportator',
        lastModifiedByEmployeeName: 'Modificat de catre angajatul',
        lastModifiedByEmail: 'Modificat de catre emailul',
        lastModifiedAt: 'Ultima modificare',
        historyTitle: 'Istoric status',
        comment: 'Comentarii',
      },
      orderRefuseMessage: 'Comanda a fost refuzata.',
      orderNumber: 'Nr. comanda',
      noOfferFound: 'Comanda nu a fost creata pe baza unei oferte',
      'no-preferred-solution': {
        title: 'Nu exista solutii preferate',
        body: 'Dati click pe butonul urmator pentru a creea o solutie completa',
      },
      newTitle: 'Comanda noua',
      listTitle: 'Comenzi',
      invalidStatusTooltip: 'Comanda nu poate fi trecuta in acest status',
      'go-to-mrs': 'Mai multe detalii',
      generateInvoices: {
        title: 'Factura',
        languageWarning: 'Limba selectata este cea alesa de client',
        language: 'Limba',
        description:
          'Selectati comenzi in aceeasi moneda, ce nu au facturi emise, pentru care doriti sa generati facturi',
        currencyWarning:
          'Comenzile selectate contin mai mult de o moneda. Selectati moneda dorita pentru a factura comenzile selectate.',
        action: 'Genereaza factura',
      },
      exclusiveOrder: 'Comanda exclusiva',
      error: {
        serviceProviderrequired: 'Furnizorul este obligatoriu de ales',
        noValidContractFound: 'Nu exista un contract valid la data curenta pentru acest serviciu!',
        notEqualCustomRegimes: 'Flag-ul de REGIM VAMAL trebuie sa aiba aceeasi valoare pentru toate transporturile!',
        notEqualCustomDuties: 'Flag-ul de TAXE VAMALE trebuie sa aiba aceeasi valoare pentru toate transporturile!',
        noProperPriceInterval: 'Nu exista un interval de pret definit pentru aceasta cantitate!',
        moreOrNoneTariffs: 'Exista mai multe sau niciun tarif definit pentru aceste zone!',
        isEmptyshipment: 'Trebuie adaugat cel putin un transport',
        differentTimeLimitError: 'Trebuie selectate comenzi cu acelasi termen de plata',
        DelServiceProviderNotFoundException: 'Nu exista creat niciun contract cu un furnizor de servicii!',
        DeliveryCustomerNotFoundException: 'Nu exista creat niciun contract cu un furnizor de servicii!',
        defaultValidationMessage: 'A aparut o eroare!',
        customerrequired: 'Clientul este obligatoriu de ales',
        requiredVehicleType: 'Tipul vehicului este obligatoriu',
      },
      emptyDocuments: 'Niciun document incarcat',
      emptyCMR: 'Niciun CMR incarcat',
      downloadPdf: 'Descarca Pdf Comanda',
      pdfSignedAndGenerated: 'Pdf generat si semnat',
      pdfUnSignedOrNotGenerated: 'Pdf nu este semnat sau generat',
      downloadInvoice: 'Descarca Factura',
      documents: 'Documente',
      details: 'Detalii',
      delivery: 'Predare',
      deliveries: 'Predari',
      customer: 'Client',
      createTask: 'Creeaza task',
      createFromExistingOrder: 'Creeaza comanda din sablon',
      createSupplierOrderFromExisting: 'Creeaza comanda furnizor din sablon',
      create: 'Creeaza comanda',
      costCenters: 'Centre de cost',
      CMR: 'CMR',
      changeStatusInfo: 'Pentru a schimba statusul alegeti unul nou din lista de mai sus',
      changeShipmentStatus: {
        title: 'Status transport',
        status: 'Status',
        lastModifiedAt: 'La data',
        dialog: {
          rejectLabel: 'Nu',
          message:
            'Sunteti sigur ca doriti schimbarea statusului? Odata schimbat nu se poate trece in statusurile anterioare',
          header: 'Schimbare status',
          acceptLabel: 'Da',
        },
        comments: 'Detalii',
        actionedByUser: 'Modificat de',
        achievedAt: 'La data',
        error: {
          requiredstatus: 'Statusul este obligatoriu',
        },
      },
      cancelOrderForcedButton: 'Anuleaza comanda fortat',
      cancelOrderDisabledTooltip: 'Exista o cerere de anulare sau comanda nu se afla intr-un status potrivit',
      cancelOrderButton: 'Anuleaza comanda',
      cancelOrder: {
        rejectCancelOrder: 'Refuz',
        orderCancelled: 'Comanda este ANULATA',
        hasCancelRequest: 'Aceasta comanda are o cerere de anulare',
        cancelRequest: 'Cerere de anulare',
        cancelOrderDialog: {
          title: 'Cerere Anulare Comanda',
          forcedWarning:
            'Anularea se va face fara acordul celelalte parti implicate. Anularea acesteia va duce la penalizari conform Termenii si Conditiile de transport.',
          forced: 'Anulare fortata',
          details: 'Motiv',
          attachments: 'Atasamente',
        },
        acceptCancelOrder: 'Accept anularea comenzii',
      },
      calculatePrice: 'Calculeaza pretul',
      billingCycleEnum: {
        Weekly: 'Saptamanal',
        Per_shipment: 'Pe livrare',
        Monthly: 'Lunar',
        Manual: 'Manual',
        Bi_monthly: 'Bi-lunar',
      },
      attachments: {
        title: 'Atasamente',
        shipments: 'Documente transport',
        browse: 'Alege',
      },
      archiveOrderTooltip: 'Comanda se poate arhiva doar daca este livrata, anulata sau are documente disponibile ',
      archiveOrder: 'Arhiveaza comanda',
      addStatusComment: 'Adauga comentariu',
      addOrderMessage: 'O comandă poate fi trimisă doar dacă există un contract valid în platformă.',
      addOrder: 'Adauga comanda',
      addPreOrder: 'Adauga pre-comanda',
      addSupplierOrder: 'Adauga comanda furnizor',
      supplierOrderTitle: 'Comanda furnizor',
      supplierOrderEmptyState: '',
      supplierOrderTimeline: {
        prepare: {
          title: 'Pregateste solicitarea',
          description: 'Aduna detaliile contractului si confirma disponibilitatea furnizorului.',
        },
        submit: {
          title: 'Trimite comanda',
          description: 'Completeaza formularul pentru comanda furnizor si transmite-l spre validare.',
        },
        review: {
          title: 'Urmareste validarea',
          description: 'Monitorizeaza statusul comenzii in timp ce furnizorul o analizeaza.',
        },
      },
      supplierOrderTariffCheckboxLabel: 'Vreau tarif la nivelul comenzii',
      supplierOrderTariffCheckboxTooltip: 'Elimina tarifele pe transport pentru a activa tariful pe comanda.',
      supplierOrderTariffDescription: 'Tariful va fi aplicat la nivelul intregii comenzi.',
      fromParty: 'De la (client)',
      toParty: 'Către (furnizor)',
      uuid: 'UUID',
      supplierOrderPartiesTitle: 'Părțile comenzii',
      supplierOrderPartiesDescription: 'Confirmă cine trimite comanda și cine o onorează.',
      validation: {
        minShipments: 'Este necesară cel puțin o comandă de transport.',
        maxPackagePieces: 'Numărul total de colete ({{current}}) depășește maximul permis ({{max}}).',
        shipmentsMinLengthShipmentsCount: 'Este necesar cel puțin un transport.',
      },
      add: 'Adauga comanda',
      accountPaymentTimeLimitTooltip: 'Termen de plata setat de transportator',
      preorderTooltip: 'Aceasta este o precomanda, iar continutul ei va fi actualizat.',
      preorder: {
        title: 'Precomanda',
        description:
          'Aceasta este o precomanda, iar continutul ei va fi actualizat in urma legaturii cu comanda oficiala primita de la client.',
      },
      acceptOrder: {
        title: 'Accepta comanda',
        mainButton: 'Accepta comanda',
        bodyMessage: 'Esti sigur ca doresti sa accepti comanda?',
        acceptButton: 'Accepta',
      },
      acceptAndCreate: 'Accepta si trimite comanda',
      accept: 'Accepta',
      courierDispatchDetails: 'Detalii expeditie de la curier',
      courierMasterTrackingNumber: 'Numar de urmarire transport',
      courierPackageTrackingNumbers: 'Numere de urmarire per pachet',
      courierCreateShipmentError: 'Crearea expeditiei a esuat!',
      courierCreatePickupError: 'Solicitarea de ridicare a esuat!',
      courierPickupConfirmationCode: 'Cod confirmare ridicare',
      orderPaymentParty: {
        title: 'Detalii plata',
        paymentType: 'Responsabil plata',
        paymentTypes: {
          SENDER: 'Expeditor',
          RECIPIENT: 'Destinatar',
          THIRD_PARTY: 'Terț',
        },
        accountNumber: 'Numar cont platitor',
        countryCode: 'Țara asociată contului',
        postalCode: 'Codul poștal asociat contului',
        sendOrder: 'Trimite comanda',
        saveAndSendOrder: 'Salveaza si trimite comanda',
        seeAccountNumber: 'Vezi numar cont',
        editAccountNumber: 'Editeaza numar cont',
        error: {
          requiredPaymentType: 'Responsabilul de plata este obligatoriu',
          requiredPayerAccountNumber: 'Numarul de cont al platitorului este obligatoriu',
          requiredCountryCode: 'Țara asociată contului este obligatorie',
          requiredPostalCode: 'Codul poștal asociat contului este obligatoriu',
        },
      },
      tradeDocument: {
        documentNumber: 'Numar document',
        issuedOn: 'Emis in',
        error: {
          requiredDocumentNumber: "Campul 'Numar document' este obligatoriu",
          requiredIssuedOn: "Campul 'Emis in' este obligatoriu",
        },
      },
      incoterm: {
        label: 'Incoterm',
        values: {
          EXW: 'Ex Works (EXW)',
          DDP: 'Delivered Duty Paid (DDP)',
          DDU: 'Delivered Duty Unpaid (DDU)',
        },
        error: {
          requiredIncoterm: "Campul 'Incoterm' este obligatoriu",
        },
      },
      commercialInvoice: 'Factura comerciala',
      etdLabel: 'Atasati electronic factura comerciala (recomandat)',
      etdTooltip: 'Factura comerciala este necesara pentru transporturile in afara Uniunii Europene',
      commercialInvoiceRequired: 'Incarcarea facturii comerciale este obligatorie daca alegeti sa o atasati electronic',
      orderShipperParty: {
        title: 'Detalii expeditor',
        accountNumber: 'Numar cont expeditor',
        error: {
          requiredShipperAccountNumber: 'Numarul de cont al expeditorului este obligatoriu',
        },
      },
      orderShipperAndPaymentPartiesPopup: {
        title: 'Detalii suplimentare transport',
        accountNumber: {
          PAYMENT_PARTY: 'Numar cont platitor',
          SHIPPER_PARTY: 'Numar cont expeditor',
        },
        shouldAddUploadTradeDocumentCredentials:
          'Pentru a încărca electronic documente, este necesară introducerea credențialelor pentru încărcarea documentelor asociate curierului FedEx.',
      },
      downloadMergedLabel: 'Descarca etichetele',
      downloadLabel: 'Descarca eticheta',
      verifyStatus: 'Verifica status',
      trackPackage: 'Urmarirea pachetului cu AWB ',
      latestScanLocation: 'Cea mai recenta locatie',
      latestStatus: 'Cel mai recent status',
      noTrackingDetails: 'Nu exista informatii de urmarire momentan!',
      latestAncillaryDetail: 'Detalii auxiliare',
      latestAncillaryDetailReason: 'Motiv',
      latestAncillaryDetailAction: 'Actiune',
      latestServiceCommitMessage: 'Mesaj informativ',
      previousActions: 'Actiuni anterioare',
      retryCreatingShipmentAndPickup: 'Reincearca crearea expeditiei si a ridicarii',
      successfullyCancelledCourierOrderShipment: 'Expeditie anulata cu succes!',
      successfullyCancelledCourierOrderPickup: 'Ridicare anulata cu succes!',
      downloadProofOfDelivery: 'Descarca dovada livrarii',
      seeStatus: 'Vezi status',
      customerOrderTerminalReservations: 'Programari in depozit',
    },
    offerSummary: {
      transitTime: 'Timp tranzit',
      carType: 'Tipul masinii',
    },
    offerRequest: {
      preOfferRequestTooltip:
        'Aceasta este o cerere de pre-oferta si va fi ascunsa de indata ce comanda creata pe baza acesteia va fi legata de o comanda parinte.',
      preOfferRequest: {
        title: 'Cerere de pre-oferta',
        description: 'Acesta va fi ascunsa dupa ce comanda create pe baza acesteia va fi legata de o comanda parinte.',
      },
      wizard: {
        stepTwo: 'Transporturi',
        stepThree: 'Rezumat',
        stepOne: 'Detalii',
      },
      vendorContacts: (param) => `Contactele transportatorului (${param.companyName})`,
      externalVendorsQuestion: 'Doriti livrare cu firme de curierat?',
      unavailableOfferRequest: 'Cererea de oferta nu se afla intr-un status potrivit pentru aceasta actiune',
      to: 'Catre',
      templates: 'Sabloane',
      suppliers: 'Furnizori',
      statusReject: 'Status refuz',
      status: 'Status',
      spOfferRequestTitle: 'Cerere de oferta primita',
      shipments: 'Transporturi',
      shipmentDetails: {
        value: 'Valoare',
        stackable: 'Suprapozabil',
        singleCar: 'Transport exclusiv',
        type: 'Tip',
        service: 'Serviciu',
        invalid: 'Lipsesc date! Click pentru a adauga datele lipsa!',
        budget: 'Buget',
      },
      shipment: 'Transport',
      serviceType: 'Serviciu',
      serviceProviders: 'Furnizori',
      sentNotifications: 'Vezi notificarile trimise pentru aceasta cerere',
      saveAndSend: 'Salveaza si Trimite',
      save: 'Salveaza',
      resolve: 'Rezolva',
      resendOfferRequestEmail: 'Retrimitere email cu cererea de oferta',
      resendOfferRequestCancelledEmail: 'Retrimitere email cu anulare cererea de oferta',
      requestStatus: {
        sent: 'Trimisa',
        rejected: 'Refuzata',
        received: 'Primită',
        offers_received: 'Oferte disponibile',
        offer_accepted: 'Acceptata',
        in_progress: 'In desfasurare',
        completed: 'Finalizata',
        cancelled: 'Anulata',
        archived: 'Arhivata',
      },
      rejectStatus: {
        rejected_terms_and_conditions: 'Termeni si Conditii Respinse',
        lost_price: 'Pret',
        lost_offer_late: 'Oferta intarziata',
        lost_no_solution: 'Nicio solutie',
        lost_no_feedback: 'Niciun raspuns',
        lost_improper_sol: 'Solutie necorespunzatoare',
        lost_blocked: 'Blocat',
      },
      pickups: 'Puncte de ridicare',
      pickup: 'Punct de ridicare',
      paymentTimeLimitWarning: 'Exista transportatori cu termen de plata diferit',
      paymentTimeLimit: 'Termen plata',
      deliveryCompanyNames: 'Companii livrare',
      pickupCompanyNames: 'Companii ridicare',
      offerStatus: {
        offer_sent: 'Trimisa',
        offer_received: 'Primita',
        offer_not_sent: 'Netrimisa',
        offer_accepted: 'Acceptata',
        no_offer: 'Lipseste oferta',
      },
      offers: 'Oferte',
      courierErrorRates: 'Erori curier',
      correctOfferRequest: 'Corecteaza cererea de oferta',
      seeOfferRequestCourierSuccessRateResponses:
        'Vezi raspunsul de succes returnat de API-ul de tarife si timpi de tranzit',
      offerRequestCourierSuccessRateResponses: 'Raspuns de succes returnat de API-ul de tarife si timpi de tranzit',
      offerRequestTitle: 'Cerere de oferta trimisa',
      offerRequestSentTo: 'Cerere de oferta trimisa catre',
      offerRequestNumber: 'Numar',
      offerRequestDetailsTitle: 'Detalii cerere de oferta trimisa',
      offerNotAccepted: 'Neacceptata',
      offerAccepted: 'Acceptata',
      noOffers: 'Nu exista oferte pentru cererea curenta!',
      noContactsChosen: 'Niciun contact ales',
      newOffer: 'Adaugare oferta',
      negotiateTitle: 'Negociere',
      negotiateBody:
        'Aceasta oferta, poate fi negociata ulterior de catre client, avand posibilitatea a de a solicita o noua oferta.',
      moreDetails: 'Mai multe detalii',
      minimumOfferTimeAvailability: 'Valabilitatea minima a ofertelor',
      list: {
        title: 'Cereri Oferta',
        spOfferStatusType: {
          offer_sent: 'Oferte trimise',
          offer_not_sent: 'Oferte netrimise',
          offer_accepted: 'Oferte acceptate',
        },
        spOfferRequestStatusType: {
          received: 'Primita',
          offer_accepted: 'Acceptate',
          in_progress: 'In derulare',
          cancelled: 'Anulate',
        },
        spOfferRequestRejectStatusType: {
          rejected_terms_and_conditions: 'Termeni si Conditii Respinse',
          lost_price: 'Lost price',
          lost_offer_late: 'Offer late',
          lost_no_solution: 'No solution',
          lost_no_feedback: 'No feedback',
          lost_improper_sol: 'Improper solution',
          lost_blocked: 'Lost blocked',
        },
        serviceProviders: 'Furnizori',
        search: 'Cauta',
        requestStatus: 'Status cerere',
        requestedAt: 'Data cererii',
        requestBy: 'Client',
        rejectStatus: 'Status refuz',
        paymentTimeLimit: 'Termen plata',
        offerStatusType: {
          offer_received: 'Cu oferte',
          offer_accepted: 'Acceptate',
          no_offer: 'Fara oferte',
        },
        offerStatus: 'Status oferta',
        offerRequestStatusType: {
          sent: 'Trimise',
          offer_accepted: 'Acceptate',
          cancelled: 'Anulate',
        },
      },
      hideDetails: 'Ascunde detaliile',
      from: 'De la',
      form: {
        invalidShipments:
          'Lipsesc date valide din transporturi. Click pe transporturile marcate cu rosu pentru a actualiza datele!',
        handoverChangeWarning: 'Verificati daca intervalele de preluare, predare sunt corecte',
      },
      error: {
        requiredPieces: 'Numarul de pachete este obligatoriu',
        requiredHeight: 'Inaltimea este obligatorie',
        requiredWidth: 'Latimea este obligatorie',
        requiredLength: 'Lungimea este obligatorie',
        requiredWeight: 'Greutatea este obligatorie',
        widthRequired: 'Latimea este obligatorie',
        weightRequired: 'Greutatea este obligatorie',
        selectedDateAfterCurrentDate: 'Deadline-ul trebuie sa fie mai mare ca data curenta',
        requireddeadline: 'Deadline-ul este obligatoriu',
        requiredCustomerVO: 'Clientul este obligatoriu',
        requiredaddress: 'Adresa este obligatorie',
        piecesRequired: 'Nr. Pachete este obligatoriu',
        packageLimitExceeded: 'Numarul de packete pe o tranzactie nu poate depasi 200',
        NullPointerException: 'A aparut o eroare pe server',
        lengthRequired: 'Lungimea este obligatorie',
        isEmptyvendors: 'Trebuie selectat cel putin un transportator',
        isEmptypackage: 'Trebuie sa existe cel putin un pachet',
        heightRequired: 'Inaltimea este obligatorie',
        minLength: 'Lungimea trebuie sa fie minim 1 cm',
        minWeight: 'Greutatea trebuie sa fie minim 1 kg',
        greaterThanWeight: 'Greutatea trebuie sa fie mai mare de 0 kg',
        minPieces: 'Numarul de pachete minim este 1',
        maxPieces: (value: { max: number; actual: number }) =>
          'Numarul de pachete nu poate depasi valoarea ' + value.max,
        minWidth: 'Latimea trebuie sa fie minim 1 cm',
        minHeight: 'Inaltimea trebuie sa fie mimim 1 cm',
        arrayItemsFieldhasContactsNotEqualTo:
          'Au fost selectati transporatatori care nu au contacte la care sa primeasca pe email, cererea de oferta. Contactele acestora trebuie sa aibe o adresa de email valida, sa primeasca cereri, metoda de contact sa fie email iar vizibilitatea acestora sa fie una dintre urmatoarele valori - Client, Public sau Ambele',
      },
      dispatcher: 'Dispecer',
      disabledAddCompleteOfferTooltip: (isEmailAuth) => {
        if (isEmailAuth) {
          return 'Trebuie sa fiti inregistrati in platforma pentru a accesa aceasta functionalitate';
        }
        return 'Trebuie sa aveti o solutie completa preferata!';
      },
      details: 'Detalii',
      detail: {
        width: 'Latime',
        weight: 'Greutate',
        vehicleType: 'Tipul masinii',
        type: 'Tip',
        transitPeriod: 'Timp tranzit',
        tags: 'Etichete',
        status: 'Status',
        stackable: 'Suprapozabil',
        spName: 'Nume',
        serviceProvidersTitle: 'Furnizori de servicii',
        sendAt: 'Trimisa la',
        search: 'Cauta',
        reject: 'Anuleaza',
        priceValue: 'Pret',
        postalCode: 'Cod postal',
        pieces: 'Bucati',
        pickupLocations: 'Punct de ridicare',
        pickup: 'Punct de ridicare',
        paymentTimeLimit: 'Termen plata',
        pageTitle: 'Detaliu cerere oferta',
        packages: 'Pachete',
        offerTitle: 'Oferte',
        offersTitle: 'Oferte',
        offerRequestTitle: 'Cerere oferta',
        offerRequestStatus: {
          sent: 'Trimisa',
          offers_received: 'Oferte primite',
          offer_accepted: 'Oferta acceptata',
          completed: 'Finalizata',
          cancelled: 'Inchisa',
        },
        name: 'Nume',
        locked: 'Blocat',
        licensePlate: 'Numar inmatriculare',
        length: 'Lungime',
        height: 'Inaltime',
        driverName: 'Nume sofer',
        deliveryLocations: 'Punc de livrare',
        delivery: 'Punct de livrare',
        deadline: 'Termen de finalizare',
        customerOfferStatuses: {
          offer_received: 'Oferta primita',
          offer_accepted: 'Oferta acceptata',
          no_offer: 'Nici o oferta',
        },
        customerOfferStatus: 'Statusul ofertei primite de la transportator',
        currency: 'Moneda',
        createOrderTooltip: 'Creaza comanda',
        contactPhone: 'Telefon contact',
        comments: 'Comentarii',
        cargoValue: 'Valoare marfa',
        budget: 'Buget',
        address: 'Adresa',
        acceptTooltip: 'Accepta oferta',
      },
      description: 'Descriere',
      delivery: 'Punct de livrare',
      deliveries: 'Puncte de livrare',
      deadline: 'Deadline',
      customerContacts: (param) => `Contactele clientului (${param.companyName})`,
      customer: 'Client',
      createOfferRequestFromDraft: 'Creeaza cerere de oferta din sablon',
      createFromExisting: 'Creeaza cerere de oferta din sablon',
      confirmationDialog: {
        header: 'Confirmare',
        body: 'Dupa confirmare, datele introduse nu vor mai putea fi editate!',
      },
      cancelRequest: 'Anuleaza cererea',
      cancelReason: 'Motivul anularii',
      cancelOfferRequest: 'Anuleaza cererea de oferta',
      cancelledOfferRequest: 'Cerere de oferta ANULATA',
      bindingTitle: 'Irevocabil',
      binding: 'Binding',
      addCompleteOfferTooltip: 'Creeaza o oferta completa dintr-o solutie completa',
      addCompleteOffer: 'Oferta completa',
      add: 'Adaugare cerere de oferta',
    },
    offerCreation: {
      totalCost: 'Cost total',
      shipments: 'Transporturi',
      serviceProviders: 'Transportatori parteneri',
      sendOffer: 'Trimite oferta',
      routingSolutions: 'Solutii de transport',
      requiredRoutingSolution: 'Trebuie aleasa cel putin o solutie de rutare!',
      requestDate: 'Data cerere',
      offersPreview: 'Sumar oferte',
      groups: 'Grupuri',
      deadline: 'Deadline',
      createOffer: 'Creare oferta',
    },
    offerChat: {
      textInput: 'Scrie un mesaj...',
      systemMessage: {
        username: 'Sistem',
        content: {
          sp_closed: 'A fost creata o oferta noua',
          customer_closed: 'Clientul este de acord cu termenii negociati',
          closed: 'Negocierea a luat sfarsit',
        },
      },
      offerLoading: 'Oferta se incarca...',
      navigateToOfferRequestTooltip: 'Navigheaza la cererea de oferta',
      confirmationDialog: {
        confirmHeader: 'Confirmare',
        acceptConfirm: 'Sunteti de acord cu termenii discutati?',
      },
      chatThreadTitle: 'Negociere',
      basedOnOffer: 'Bazata pe oferta de ',
      actionBar: {
        createOffer: 'Oferta',
      },
    },
    offer: {
      vehicleType: 'Tip vehicul',
      vehicle: 'Vehicul',
      updateVehicle: 'Actualizeaza vehicul',
      transitDays: 'Zile tranzit',
      totalCostWarning: 'Costul total al ofertei este de',
      timeAvailability: 'Valabil',
      text: 'Oferta',
      termsAndConditionsTooltip: 'Termeni si Conditii',
      termsAndConditionsStep: {
        offerRequestTermsAndConditions: 'Termeni si conditii primiti pe cererea de oferta',
      },
      termsAndConditionsDisabledTooltip: 'Nu exista Termeni si Conditii',
      steps: {
        termsAndConditions: 'Termeni si Conditii',
        offer: 'Oferta',
        masterRoutingSolutions: 'Solutii',
        completeOffer: 'Oferta completa',
      },
      shipmentList: 'Transporturi cerute',
      selectRoutingSolutionsHeader: 'Selecteaza una sau mai multe solutii de transport',
      selectMasterRoutingSolution: 'Selectati o solutie',
      masterRoutingSolutions: {
        disabledMasterRoutingSolution:
          'Solutia nu este disponibila pentru ca nu face parte dintr-o solutie de split definitiva.',
      },
      savedSuccess: (param) =>
        `Oferta in valoare de ${param.offerPrice.value} ${param.offerPrice.currencyCode} avand seria ${param.offerSeries} trimisa in cadrul cererii #${param.offerRequestNumber} pentru clientul ${param.offerCustomer} a fost salvata cu success`,
      save: 'Adaugare oferta',
      resendOfferEmail: 'Retrimitere email cu oferta creata',
      resendOffer: 'Retrimitere oferta',
      refuseReason: 'Motivul refuzului',
      refuseOffer: 'Refuza oferta',
      price: 'Pret',
      pickupTimeWindowStart: 'Preluare de la',
      pickupTimeWindowEnd: 'Preluare pana la',
      paymentTimeLimit: 'Termen plata',
      offerRefused: 'Oferta a fost refuzata!',
      offerPopupTitle: 'Oferta noua',
      offerContacts: 'Contactele ofertei',
      offerAccepted: 'Oferta Acceptata',
      noOffers: 'Momentan nu exista oferte',
      newSolution: {
        title: 'Creeaza solutie noua ',
        description:
          'Nu esti multumit de solutiile existente. Apasa click pe butonul de mai jos pentru a creea o noua solutie, si reia porcesul de raspuns la cererea de oferta de la inceput.',
      },
      minPaymentTimeLimit: 'Termen de plata minim provenit de pe segmentele solutiei',
      minOfferTimeAvailability: 'Valabilitatea minima a ofertei este de',
      masterRoutingSolution: 'Solutia',
      licensePlate: 'Placa inmatriculare',
      label: 'Eticheta',
      vehicleAndDriverData: 'Masina si sofer',
      hasConflictsTooltip: 'Oferta contine date modificate fata de cererea de oferta',
      hasConflictsMessage:
        'Oferta contine date modificate fata de cererea de oferta. Sunteti sigur ca doriti sa continuati?',
      expired: 'Oferta a expirat!',
      error: {
        requiredRefuseReason: 'Motivul refuzului este obligatoriu',
        requiredPrice: 'Pretul este obligatoriu',
        detailsrequired: 'Detaliile sunt obligatoriu de completat!',
      },
      driverName: 'Nume sofer',
      driver: 'Sofer',
      directOffer: {
        title: 'Raspuns direct',
        description: 'Adauga raspuns fara rezolvare',
      },
      details: 'Detalii',
      deliveryTimeWindowStart: 'Livrare de la',
      deliveryTimeWindowEnd: 'Livrare pana la',
      customer: 'Client',
      currency: 'Moneda',
      createdBy: 'Creata de',
      createCompleteOffer: (param) =>
        param.offerRequestNumber ? `Raspunde la cererea de oferta nr. ${param.offerRequestNumber}` : 'Raspunde',
      contactPhone: 'Telefon contact',
      completeOffer: {
        'form-title': 'Oferta completa noua',
        'enable-complete-solution-details': 'Vezi Detalii Solutie Completa',
        'complete-solution-details': {
          title: 'Detalii Solutie Completa',
        },
        'close-complete-solution-details': 'Inchide Detalii Solutie Completa',
      },
      changesFromOfferRequest: 'Modificari fata de cererea de oferta',
      binding: 'Binding',
      baseOffer: 'Oferta de baza',
      basedOn: 'Oferta',
      amendmentStep: {
        termsAndConditionsNotFound: 'Nu exista Termeni si conditii',
        offerTermsAndConditions: 'Termeni si conditii ce vor fi trimisi cu oferta',
        offerRequestTermsAndConditions: 'Termeni si conditii primiti pe cererea de oferta',
      },
      amendment: 'Amendamente',
      alreadyAcceptedAnotherOffer: 'A fost deja acceptata alta oferta!',
      acceptOfferAndCreateOrder: 'Accepta si trimite comanda',
      acceptedOffer: 'Oferta acceptata!',
      deliveredBy: 'Livrare până la ',
      deliveredBetween: 'Livrare între ',
    },
    'offer-request': {
      savedSuccess: (param) => {
        return `Cererea de oferta cu numarul #${param.offerRequestNumber} a fost salvata cu success`;
      },
      new: {
        titleServiceProvider: 'Adauga cerere de oferta primita de la client',
        titleCustomer: 'Trimite cerere de oferta catre transportator',
        titleCustomerSubcontracting: 'Subcontracteaza cu o cerere de oferta',
        titleCustomerPre: 'Trimite cerere de pre-oferta catre transportator',
        titleCustomerPreSubcontracting: 'Subcontracteaza cu o cerere de pre-oferta',
      },
      list: {
        sentTitle: 'Cereri de oferta trimise',
        receivedTitle: 'Cereri de oferta primite',
        addNew: 'Adauga',
      },
    },
    'navigation-suggestions': {
      shipmentGroupSolution: 'Detalii Solutie',
      orderDetails: 'Detalii Comandă',
      offerRequestDetails: 'Detalii Cerere de Ofertă',
      back: {
        workspace: 'Înapoi la Workspace',
        undefined: 'Inapoi',
        subcontracting: 'Înapoi',
        'sp-order-list': 'Înapoi la Comenzi Primite',
        'sp-offer-request-list': 'Înapoi la Cereri de Ofertă Primite',
        outbox: 'Înapoi la Outbox',
        'offer-request-details': 'Înapoi la detalii Cerere de Ofertă',
        inbox: 'Înapoi la Inbox',
        'customer-shipment-template': 'Înapoi la Transporturi',
        'customer-order-list': 'Înapoi la Comenzi Trimise',
        'customer-offer-request-list': 'Înapoi la Cereri de Ofertă Trimise',
      },
    },
    menu: {
      workspace: 'Workspace',
      warehouse: 'Depozit',
      warehouseTerminals: 'Terminale',
      warehouseReservations: 'Programari',
      vendorDrafts: 'Transportatori parteneri',
      vendor: 'Transportatori parteneri',
      courier: 'Curieri',
      vehicle: 'Vehicule',
      transportProject: 'Proiecte de Transport',
      tariffs: 'Tarife',
      standardPackageDimensions: 'Pachete standard',
      nomenclatureList: 'Nomenclator produse',
      spInvoicePayments: 'Incasari',
      shipmentTracking: 'Urmarire transporturi',
      packageTracking: 'Urmarire pachete',
      shipmentGroups: 'Grupaje transporturi',
      services: 'Servicii',
      scheduledShipments: 'Transporturi programate',
      routes: 'Rute',
      orderSent: 'Trimise',
      orderReceived: 'Primite',
      order: 'Comenzi',
      offerRequestSent: 'Trimise',
      offerRequestReceived: 'Primite',
      offerRequestEmails: 'Emailuri',
      offerRequest: 'Cereri oferte',
      invoicesSent: 'Facturi Emise',
      financial: 'Financiar',
      invoices: 'Facturi',
      invoiceAssociation: 'Asociere facturi',
      'invoice-payments': 'Plati facturi',
      employeeAssignment: 'Atribuire planner',
      driver: 'Soferi',
      drafts: 'Șabloane Transport',
      dispatcher: 'Dispecer',
      taskList: 'Dispecer Transporturi',
      details: 'Detalii',
      'delivery-outbox': 'Outbox',
      'delivery-inbox': 'Inbox',
      customerList: 'Lista clienti',
      customerInvoices: 'Facturi Primite',
      eFacturi: 'eFacturi',
      anafMessages: 'Mesaje ANAF',
      customerInvoicePayments: 'Plati',
      customerDrafts: 'Clienți',
      costs: 'Costuri',
      costCenters: 'Centre de Cost',
      contractResponse: 'Contracte cu clienti',
      contractRequest: 'Contracte cu furnizori',
      contract: 'Contracte',
      contacts: 'Contacte',
      complaint: 'Reclamatii',
      cashFlow: 'Cash Flow',
      budgetManagement: 'Buget',
      addresses: 'Adrese',
      'address-templates': 'Șabloane Adrese',
      account: 'Conturi',
      collaboration: 'Colaborare',
      collaborationShipments: 'Transporturi',
      eTransportDeclarant: 'Declarant',
      eTransportOrganizer: 'Organizator transport',
      eTransportAnafMessages: 'Mesaje ANAF',
      eTransportActions: 'Actiuni',
      namedLocation: 'Locatii',
      ownershipRequest: 'Cereri locatii',
      operationalTerritory: 'Teritorii',
      externalMappings: 'Referinte externe',
      shipmentManagement: 'Gestiune transporturi',
      fleet: 'Flota',
      imports: 'Importuri',
      ediImport: 'EDIFACT',
      driverExpense: 'Deconturi soferi',
      driverTimesheet: 'Pontaj',
      supplierDelegation: 'Delegari tarife',
    },
    invoicePreview: {
      vatDescriptions: {
        RO_XR: 'Operatiune scutita de TVA cf. Art.144 dir. TVA Europeana',
        RO_ST: 'TVA Standard',
        RO_0R: 'Operatiune scutita de TVA cf. cod. Fiscal',
        RO_AE: 'Reverse charge',
        RO_K: 'VAT exempt for EEA intra-community supply of goods and services',
        RO_G: 'Free export item, tax not charged',
        RO_O: 'Service outside scope of tax',
        RO_E: 'Exempt from tax',
      },
      vatCode: 'COD TVA',
      vat: 'TVA',
      exemptionReason: 'MOTIV SCUTIRE',
      totalNet: 'TOTAL NET',
      total: 'TOTAL',
      tooltips: {
        deleteService: 'Stergere serviciu',
      },
      swiftCode: 'Swift',
      storno: 'Storno factura seria ',
      shipTo: 'SHIP TO',
      shipNumber: 'NR. TRANSP',
      serviceProviderDetails: 'Informatii Furnizor',
      serviceProvider: 'Furnizor',
      service: 'SERVICIU',
      series: 'Serie si numar factura',
      senderAndReceiver: 'EXP / DEST',
      registrationCode: 'Nr. inmatriculare',
      phone: 'Tel',
      paymentTimeLimit: 'Termen plata',
      paymentDueDate: 'Data scadenta',
      orderNumber: 'NR. COMANDA',
      operationType: 'TIP OPERATIUNE',
      net: 'NET',
      licensePlate: 'NR. VEHICUL',
      issueDate: 'Data facturarii',
      invoiceTitle: 'FACTURA',
      fromDate: 'din data',
      exchangeWarning: {
        title: 'Curs valutar mai vechi de o zi',
        description:
          'Unul sau mai multe cursuri valutare sunt mai vechi de o zi. Puteti modifica oricare dintre acestea cu cursul valutar dorit.',
      },
      email: 'E-mail',
      date: 'DATA',
      customerBankAccounts: 'Conturi bancare client',
      costCenter: 'CENTRU DE COST',
      correspondenceAddress: 'Adresa corespondenta',
      companyLocation: 'Sediu social',
      comment: 'Observatii',
      billTo: 'BILL TO',
      billingAddress: 'Adresa de facturare',
      bankNo: (param) => (param.currencyCode ? `Cont (${param.currencyCode})` : 'Cont'),
      bankName: 'Banca',
      bankAccounts: 'Conturi bancare',
      accounting: 'Accounting',
    },
    invoice: {
      vatRate: 'Cod TVA',
      exemptionReason: 'Motiv Scutire',
      vat: 'TVA',
      updateAndPreview: 'Actualizeaza & Vizualizeaza',
      unselectAll: 'Deselecteaza toate facturile',
      totalPrice: 'Pret total',
      showInvoicePDF: 'Arata factura',
      serviceProviderName: 'Nume Furnizor',
      sentOrdersDropdownDisabledMessage: 'Trebuie sa selectati un furnizor si o moneda',
      selectedInvoices: 'Facturi selectate',
      selectCancelable: 'Alegeti factura care va fi stornata',
      selectEfactura: 'Este necesara alegerea unei eFacturi deoarece ambele companii sunt din Romania',
      report: {
        infoText: (params) => {
          const invoiceSeries = params.invoiceSeries;
          if (invoiceSeries && invoiceSeries.length > 1) {
            const formattedInvoiceSeries = invoiceSeries
              .map((series: any, index: any) => `${index + 1}.${series}`)
              .join(', ');
            return `Genereaza un raport pentru facturile cu seriile ${formattedInvoiceSeries}`;
          }
          return `Genereaza un raport pentru factura cu seria ${invoiceSeries[0]}`;
        },
        generateReportSuggestion: 'Alege o moneda, apoi selecteaza facturi trimise si neplatite',
        generateReport: 'Genereaza Raport',
        fromBankAccount: 'Contul din care se face plata',
        excel: {
          toBankAccountListSummary: 'Cont Destinatie',
          serviceProviderName: 'Beneficiar',
          lineCount: 'Detalii 2',
          invoiceSeries: 'Detalii 1',
          fromBankAccount: 'Cont sursa',
          currencyCode: 'Moneda',
          amountToPay: 'Suma',
        },
        errors: {
          requiredFromBankAccountUuid: 'Campul Contul din care se face plata este obligatoriu',
        },
      },
      refuseReasonPlaceholder: 'Introduceti motivul',
      refuseInvoice: 'Refuzati Factura',
      receivedTitle: 'Facturi primite',
      receivedOrdersDropdownDisabledMessage: 'Trebuie sa selectati un client si o moneda',
      paymentTimeLimit: 'Termen plata',
      paymentStatuses: {
        UNPAID: 'Neplatita',
        PARTIAL_PAID: 'Platita partial',
        PAID: 'Platita',
      },
      externalInvoiceTypes: {
        ISSUED: 'Emisa',
        STORNO: 'Storno',
      },
      invoiceTypes: {
        ISSUED: 'Emisa',
        STORNO: 'Storno',
        CANCELLED: 'Stornata',
      },
      invoiceType: 'Tip factura',
      paymentStatus: 'Status plata',
      paymentDueDate: 'Data scadenta',
      payment: {
        title: 'Adauga plata',
        'service-provider-suggestion':
          'Alege o moneda, apoi selecteaza facturi, trimise, neplatite, cu acelasi client si moneda',
        'selected-order-tooltip': 'Numarul de ordine al facturii selectate',
        'customer-suggestion':
          'Alege o moneda, apoi selecteaza facturi, primite, neplatite, cu acelasi furnizor si moneda',
        'add-receipt': 'Adauga incasare',
        'add-payment': 'Adauga plata',
      },
      ordersTotalCost: 'Pret total comenzi',
      association: {
        orderNumber: 'Numar comanda',
        awb: 'AWB',
        orderDate: 'Data comanda',
        invoiceSeries: 'Serie factura',
        pickupNamedLocationLabel: 'Locatie incarcare',
        pickupAddress: 'Adresa incarcare',
        deliveryNamedLocationLabel: 'Locatie descarcare',
        deliveryAddress: 'Adresa descarcare',
        requestingCompanyName: 'Companie solicitanta',
        courierName: 'Curier',
        orderPriceWithoutVat: 'Valoare comanda (net)',
        invoicePriceWithoutVat: 'Valoare factura (net)',
        balance: 'Balanta',
        issueDate: 'Data emitere',
        createdAt: 'Data creare',
        orderCurrencyCode: 'Moneda comanda',
        invoiceCurrencyCode: 'Moneda factura',
        paymentTimeLimit: 'Termen de plata',
        paymentDueDate: 'Data scadenta',
      },
      seeInvoices: 'Vizualizeaza facturi',
      downloadInvoices: 'Descarca facturi',
      ordersPaymentTimeLimit: 'Termen de plata comenzi',
      orderContacts: 'Contacte de pe comenzi',
      numberLTFilter: 'Limita superioara',
      numberGTFilter: 'Limita inferioara',
      newTitle: 'Detalii factura',
      newService: 'Adauga serviciu suplimentar pe comanda',
      newInvoiceStartDate: 'Data noua de inceput a scadentei',
      newDueDate: 'Data limita de plata noua',
      netPrice: 'Pret net',
      list: {
        tooltips: {
          warningTooltip: 'Preturile si/sau termenele de plata sunt diferite',
          systemInvoice: 'Factura emisa de platforma',
          externalInvoice: 'Factura emisa extern',
          download: 'Descarca factura',
          downloadConfirmation: 'Descarca confirmare',
          disabledStorno: 'Stornarea nu este posiblia atat timp cat factura nu este finalizata',
          disabledSendByEmail:
            'Trimiterea mail-ului nu este posibila atat timp cat factura nu este finalizata sau daca nu a fost generata de sistem',
          disabledEfacturaDownload: 'Factura trebuie sincronizata la anaf inainte sa fie posibila descarcarea pdf-ului',
          disabledMarkAsPaid: 'Marcarea ca platita nu este posibila atat timp cat factura nu este finalizata',
        },
        storno: 'Stornare factura',
        split: 'Esalonare',
        sendInvoiceToAnaf: 'Trimite factura la ANAF',
        resendInvoiceToAnaf: 'Retrimite factura la ANAF',
        paid: 'Marcheaza ca incasat',
        newReceipt: 'Incasare noua',
        newPaymentTooltip: 'Aceasta factura este platita',
        newPayment: 'Plata noua',
        invoiceItemWarningLegend: 'Datele facturii nu corespund cu datele de pe comenzi',
        invoiceItemRejectLegend: 'Factura respinsa',
        invoiceItemAnafErrorsLegend: 'Eroare ANAF',
        invoiceItemStornoLegend: 'Factura storno',
        anafErrorInvoices: 'Facturi cu erori anaf in luna curenta',
        waitingForTaxProcCompletionInvoices: 'Facturi cu proces anaf nefinalizat in luna curenta',
        waitingForTaxSubmissionInvoices: 'Facturi netrimise la anaf in luna curenta',
        edit: 'Editeaza factura',
        details: 'Detalii factura',
        customerPaid: 'Marcheaza ca platit',
      },
      issuedTitle: 'Facturi emise',
      issueDate: 'Data emitere',
      invoiceStatuses: {
        REJECTED: 'Respinsa',
        PENDING: 'In Asteptare',
        NOT_FINALIZED: 'Netrimisa',
        AWAITING_TAX_SUBMISSION: 'Asteapta trimiterea la fiscalitate',
        AWAITING_TAX_PROC_COMPLETION: 'Asteapta finalizarea procesului fiscal',
        TAX_PROC_VALIDATION_FAILURE: 'Validare nereusita a procesului fiscal',
        FINALIZED: 'Trimisa',
      },
      invoiceStatus: 'Status factura',
      invoiceSeries: 'Serie si numar factura',
      orderNumber: 'Numar comanda',
      invoicedOrders: 'Comenzi facturate',
      invoicedOrdersTooltip: 'Sunt afisate doar comenzile facturate',
      allOrders: 'Comenzi',
      allOrdersTooltip: 'Sunt afisate toate comenzile',
      invoiceDateHistory: 'Istoric schimbare data scadenta',
      introducedAt: 'La data',
      generate: 'Incarca factura',
      finalPaymentDueDate: 'Data scadenta stabilita',
      filters: {
        statusPending: 'Facturi in asteptare',
        paymentDueDateExpired: 'Scadenta depasita',
        awaitingTaxSubmission: 'Netrimise la anaf in luna curenta',
        anafInvoiceStatusErrors: 'Erori anaf in luna curenta',
        awaitingTaxProcCompletion: 'Proces anaf nefinalizat in luna curenta',
        paymentDueDateAlmostExpired: 'Scadenta aproape depasita',
      },
      errors: {
        totalShipmentPriceError:
          'Suma preturilor net ale transporturilor nu este in concordanta cu totalul net al comenzii',
        SingleCompanyContactsSelectedException: 'Nu ati selectat contacte pentru ambele companii',
        InvalidOrderCurrencyCodesException:
          'Puteti selecta comenzi in cel mult de o alta moneda pe langa cea a facturii',
        invalidInvoiceTypeSelection: 'Nu este permisa selectia simultana facturilor emise/stornate cu cele storno',
        shipmentPriceError: 'Suma preturilor net ale transporturilor depaseste totalul net al comenzii',
        requiredVendor: 'Campul Nume furnizor este obligatoriu!',
        requiredVatRate: 'Campul Cod TVA este obligatoriu!',
        requiredExemptionReason: 'Campul Motiv Scutire este obligatoriu!',
        requiredTotalVATAmount: 'Campul TVA este obligatoriu!',
        requiredTotalNetAmount: 'Campul Pret net este obligatoriu!',
        requiredTotalAmount: 'Campul Pret total este obligatoriu!',
        requiredSecondaryTotalVATAmount: 'Campul Pret TVA este obligatoriu!',
        requiredSecondaryTotalNetAmount: 'Campul Pret net este obligatoriu!',
        requiredSecondaryTotalAmount: 'Campul Pret total este obligatoriu!',
        requiredSecondaryCurrencyCode: 'Campul Moneda este obligatoriu!',
        requiredPaymentTimeLimit: 'Campul Termen de Plata este obligatoriu!',
        requiredPaymentStatus: 'Campul Status plata este obligatoriu!',
        requiredInvoiceType: 'Campul Tip factura este obligatoriu!',
        requiredPaymentDueDate: 'Campul Data scadenta este obligatoriu!',
        requiredLanguage: 'Trebuie sa selectati limba pentru a putea trimite factura!',
        requiredIssueDate: 'Campul Data emitere este obligatoriu!',
        requiredInvoiceStatus: 'Campul Status factura este obligatoriu!',
        requiredInvoiceSeries: 'Campul Serie factura este obligatoriu!',
        requiredInvoiceExternalSPOrderDTOs: 'Campul Comenzi facturate este obligatoriu!',
        requiredCurrencyCode: 'Campul Moneda este obligatoriu!',
        requiredContactsFromBothCompanies: 'Contactele de la ambele companii sunt necesare',
        requiredClient: 'Campul Nume client este obligatoriu!',
        requiredCanceledInvoice: 'Campul Factura Stornata este obligatoriu!',
        requiredInvoiceExchangeRate: 'Cursul valutar este obligatoriu!',
        requiredServiceName: 'Campul Descriere serviciu suplimentar este obligatoriu!',
        requiredTotalNetPrice: 'Campul Cost serviciu este obligatoriu!',
        minTotalNetPrice: 'Campul Cost serviciu nu poate fi negativ!',
        noOrders: 'Nu ati selectat nicio comanda',
        multiplePaymentTimeLimitValidationError: 'Trebuie sa selectate doar comenzi cu acelasi termen de plata',
        isEmptyAttachments: 'Campul Incarca factura este obligatoriu!',
        invoicesValidationError: 'Trebuie sa selectati doar comenzi nefacturate',
        invalidPaymentTimeLimitValidationError: 'Termenul de plata nu poate fi 0',
        differentTimeLimitErrorInvoiceExternalSPOrderDTOs: 'Trebuie selectate comenzi cu acelasi termen de plata',
        customersValidationError: 'Trebuie sa selectati doar comenzi ale aceluiasi client',
        currenciesValidationError: 'Comenzile selectate contin prea multe tipuri de monezi',
        accountsValidationError: 'Trebuie sa selectati doar comenzi cu acelasi cont',
        accountsLengthValidationError: 'Pentru fiecare comanda trebuie selectat un account',
      },
      error: {
        requiredNewInvoiceStartDate: 'Campul Data noua de inceput a scadentei este obligatoriu!',
      },
      EFacturaStatusTitle: 'Status eFactura ANAF',
      editTitle: 'Editare factura',
      editExternalInvoice: 'Editeaza factura',
      downloadEFacturaZip: 'Descarca eFactura ZIP',
      downloadEFacturaPdf: 'Descarca eFactura PDF',
      download: 'Descarca',
      detailTitle: 'Detaliu factura',
      deleteSecondaryCurrencyValues: 'Sterge moneda secundara',
      dateOfChange: 'Data schimbarii',
      dateLTFilter: 'Data sfarsit',
      dateGTFilter: 'Data inceput',
      customPaymentDialog: {
        title: 'Selectati Data Esalonare',
        setCustomPaymentDate: 'Esaloneaza',
        errors: {
          requiredAgreedPaymentDate: 'Selectati o data de esalonare.',
        },
        customPaymentDate: 'Data Esalonare',
      },
      customPaymentDate: 'Data Esalonare',
      customPaymentAgreement: 'Plata esalonata',
      customerName: 'Nume client',
      customDutyTypes: {
        DUTIES_NOT_APPLICABLE: 'Nevamuibil',
        DUTIES_APPLICABLE: 'Vamuibil',
      },
      currencyCode: 'Moneda',
      createdBy: 'Nume utilizator',
      createdAt: 'Data schimbarii',
      contactsDropdownDisabledMessage: 'Trebuie sa selectati minim o comanda',
      contacts: 'Contacte',
      confirmExternalCancel: 'Sunteti sigur ca doriti sa stornati aceasta factura? Aceasta actiune este ireversibila!',
      comment: 'Observatii',
      clientContacts: 'Contacte client',
      checkEFacturaStatus: 'Verifica stare eFactura',
      changeInvoiceStartDate: 'Schimba data de inceput a scadentei',
      cancelInvoice: 'Stornare factura',
      balance: 'Sold',
      author: 'Autor',
      attachments: 'Atasamente',
      anafInvoiceStatusMessage: {
        UPLOAD_SUCCESS: 'Factura a fost trimisa cu succes la ANAF. Verificati starea facturii.',
        UNSENT: 'Factura nu a fost trimisa la ANAF',
        UNCHECKED: 'Statusul facturii nu a fost verificat, verificati starea prin butonul din meniul din dreapta',
        TEMPORARY_ERROR: 'Reverifica starea facturii.',
        PENDING: 'Factura este in procesare de catre ANAF',
        OK: 'Factura a fost validata si procesata cu succes de catre ANAF',
        NOT_OK: 'Factura trimisa este invalida. Descarcati fisierul ZIP',
        ERROR: 'Factura trimisa contine erori',
        CONVERSION_ERROR: 'Factura trimisa contine erori de conversie',
        COMMUNICATION_ERROR: 'Eroare de comunicare cu ANAF. Reincercati din nou mai tarziu',
      },
      anafInvoiceStatuses: {
        UPLOAD_SUCCESS: 'Succes',
        UNSENT: 'Netrimis',
        UNCHECKED: 'Neverificat',
        TEMPORARY_ERROR: 'Eroare temporara',
        PENDING: 'In asteptare',
        OK: 'Factura valida',
        NOT_OK: 'Factura invalida',
        ERROR: 'Eroare',
        CONVERSION_ERROR: 'Eroare de conversie',
        COMMUNICATION_ERROR: 'Eroare de comunicare',
      },
      anafInvoiceStatus: 'Status ANAF',
      addService: {
        label: 'Adauga serviciu',
        inputs: {
          vat: 'TVA',
          type: 'Tipul serviciului',
          total: 'Cost serviciu',
          operationType: 'Tip operatiune',
          description: 'Descriere serviciu suplimentar',
          currency: 'Moneda',
          vatExemptionReason: 'Adauga motivul scutirii de TVA',
        },
        errors: {
          requiredVat: 'Campul TVA este obligatoriu!',
          requiredTotal: 'Campul Cost serviciu  este obligatoriu!',
          requiredDescription: 'Campul Descriere serviciu suplimentar este obligatoriu!',
          requiredCurrency: 'Campul Moneda este obligatoriu!',
          requiredVatExemptionReason: 'Pentrul codul selectat trebuie adaugat motivul scutirii de TVA',
          maxlengthVatExemptionReason: 'Numarul maxim de caractere este 100',
          minTotal: 'Campul Cost serviciu nu poate fi negativ!',
        },
      },
      addSecondaryCurrencyValues: 'Adauga moneda secundara',
      paymentTermsNote: 'Note termeni de plata',
      addNewLine: 'Adauga rand',
      addNewInvoice: 'Adauga factura',
      addInvoice: 'Adauga factura',
      actions: {
        updateAndPreview: 'Actualizeaza & Vizualizeaza',
        sendByEmail: 'Trimite pe email',
        reject: 'Refuza',
        finalizeTooltip: 'Dupa trimiterea facturii, detaliile acesteia nu vor mai putea fi editate',
        finalize: 'Trimite',
        download: 'Descarca',
        accept: 'Accepta',
      },
      acceptInvoice: {
        confirmMessage: 'Sunteti sigur ca doriti sa acceptati factura? Aceasta actiune este ireversibila!',
      },
    },
    handover: {
      postalCode: 'Cod Postal',
      Pickup: {
        title: 'Preluare',
        timeWindow: 'Interval de preluare',
        startTime: 'De la',
        loadingReference: 'Referinta incarcare',
        error: {
          timeWindowStartrequired: 'Inceputul intervalului de preluare este obligatoriu',
          pickupIsBeforeToday: 'Data de preluare trebuie sa fie in prezent!',
          pickupEndTimeIsBeforeNow: 'Timpul final de preluare trebuie sa fie in prezent!',
        },
        endTime: 'Pana la',
      },
      error: {
        noAddressSelected: 'Selectati o adresa valida',
        deliveryIsBeforePickup: 'Data de predare trebuie sa fie dupa data de preluare!',
      },
      Delivery: {
        title: 'Predare',
        timeWindow: 'Interval de predare',
        startTime: 'De la',
        loadingReference: 'Referinta descarcare',
        error: {
          timeWindowStartrequired: 'Inceputul intervalului de predare este obligatoriu',
          deliveryIsBeforePickup: 'Data de predare trebuie sa fie dupa data de preluare',
        },
        endTime: 'Pana la',
      },
      country: 'Tara',
      companyName: 'Companie',
      city: 'Localitate',
      chooseAddress: 'Selecteaza o adresa',
      addNewAddress: 'Adauga o adresa noua',
    },
    guide: {
      skipLabel: 'Termină',
      'shipment-split': {
        'vendor-routing-solutions': 'Trasee preluate din comenzile efectuate catre partenerii transportatori',
        solutions: 'Lista cu solutiile de transport deja create',
        'shipment-panel':
          'Transporturile ce trebuie sa fie rezolvate prin incarcarea masinilor si sectiunilor de trasee',
        'segment-details': 'Detalii despre incarcarea sectiuni de traseu si actiunile specifice',
        'own-routing-solutions':
          'Sabloane de trasee si Trasee complete folosite pentru construirea solutiei de transport',
        'new-segment': 'Adauga sectiune de traseu prin selectia traseelor existente sau prin crearea unui nou traseu',
        'clear-solution': 'Incepe lucru la o solutie noua',
        canvas:
          'Spatiul de lucru, cu posibilitatea de a adauga sectiuni de trasee si a le lega cap la cap pentru a obtine solutia de transport. Si incarcarea lor cu transporturi prin drag & drop',
      },
      'shipment-group-solutions': {
        solutions:
          'Lista cu Solutii proprii si Solutii create din oferte. Din acest panou veti selecta solutii pentru segmentul de ruta corespunzator.',
        'segment-canvas': 'Configuratia de rute creata in ecranul anterior',
        offers:
          'Lista cu Ofertele primite de la Cererile de Oferta subcontractate, in cazul unei rute de subcontractor.',
        'master-routing-solutions':
          'Scopul acestei pagini este sa creati solutii complete. O solutie completa este alcatuita din solutii pentru fiecare segment de ruta.',
        'master-routing-solution':
          'Aceasta linie constituie o solutie completa. Folositi click dreapta pe o solutie completa ca sa deschideti meniul de actiuni!',
      },
      restartTour: 'Reporneste tutorial',
      prevLabel: 'Înapoi',
      nextLabel: 'Înainte',
      doneLabel: 'Termină',
    },
    error: {
      vendorsRequired: 'Acest camp este obligatoriu',
      shipmentTariffRequired: 'Este obligatorie selectarea unui tarif pentru transport',
      minLengthVendors: 'Selectati minim un transportator',
      territoryNameExists: 'Exista deja un teritoriu creat cu acest nume!',
      startTimeNotStandard: 'Timpul de inceput este in afara intervalului standard',
      startTimeAfterEndTime: 'Timpul de inceput este dupa timpul de final',
      startDateAfterEndDate: 'Data de sfarsit trebuie sa fie mai mare calendaristic decat data de inceput!',
      requiredValue: 'Valoarea raportata este obligatoriu de completat!',
      requiredStartDate: 'Data de inceput este obligatoriu de completat!',
      requiredName: 'Numele este obligatoriu de completat!',
      minLengthName: 'Numele trebuie sa contina minim 3 caractere!',
      requiredPhoneNumber: 'Numarul de telefon este obligatoriu de completat!',
      minLengthPhoneNumber: 'Numarul de telefon este prea scurt!',
      requiredCompanyName: 'Numele companiei este obligatoriu de completat!',
      requiredInterval: 'Intervalul este obligatoriu',
      requiredFinishDate: 'Data de sfarsit este obligatoriu de completat!',
      requiredCustomer: 'Campul Client este obligatoriu',
      requiredComments: "Campul 'Motiv' este obligatoriu",
      requiredCode: 'Codul este obligatoriu de completat!',
      requiredAccountName: 'Camplul Nume cont este obligatoriu',
      required: 'Campul este obligatoriu de completat!',
      pickupTimeWindowStartBeforeStandardInterval: 'Data de preluare trebuie sa fie in prezent',
      packageLimitExceeded: 'Numarul de packete pe o tranzactie nu poate depasi 200',
      deliveryIsBeforePickup: 'Data de predare trebuie sa fie dupa data de preluare!',
      noAddressSelected: 'Selectati o adresa valida',
      missingStartTime: 'Lipseste timpul de inceput',
      missingEndTime: 'Lipseste timpul de final',
      maxlengthType: 'Campul nu trebuie sa depaseasca 255 de caractere',
      invalidStartTime: 'Timp inceput invalid',
      invalidEndTime: 'Timp sfarsit invalid',
      endTimeNotStandard: 'Timpul de final este in afara intervalului standard',
      duplicateVendorTagValueForOwner: 'Exista deja o eticheta creata cu aceasta valoare!',
      maxLengthPhoneNumber: 'Numarul de telefon trebuie sa contina maxim 20 de caractere!',
      DuplicateUniqueID: 'Mai exista un client cu acest numar unic de inregistrare!',
      DuplicateNumericPartOfUniqueID:
        'Mai exista o companie cu aceeasi parte numerica a numarului unic de inregistrare!',
      duplicateLegalEntityForVendor: 'Compania aleasa este deja transportator partener!',
      DuplicateCompanyName: 'Exista deja un client cu acest nume!',
      deliveryTimeWindowStartBeforeStandardInterval: 'Data de livrare trebuie sa fie in prezent',
      defaultValidationMessage: 'A apărut o eroare. Verifică datele introduse și încearcă din nou',
      customerVORequired: 'Acest camp este obligatoriu',
      nameRequired: 'Campul nume este obligatoriu',
      phoneNumberRequired: 'Campul numar de telefon este obligatoriu',
      phoneNumberLengthMessage: 'Campul numar de telefon trebuie sa contina maxim 20 de caractere',
      shipmentsRequired: 'Trebuie sa adaugati cel putin un transport',
      packagesRequired: 'Trebuie sa adaugati cel putin un pachet',
      deadlineInFuture:
        'Data selectată trebuie să fie în viitor.Dacă este selectată data de astăzi, ora trebuie să fie ulterioară orei curente.',
      selectAtLeastOneContactPerEntity: 'Selectati cel putin un contact pentru fiecare companie',
      selectAtLeastOneAccountNumberPerCourier: 'Selectati cel putin un numar de cont pentru fiecare curier',
      validationError: 'Eroare de validare',
      dateTimeWithTimezoneInPastDeadline:
        'Deata selectată trebuie să fie în viitor. Dacă este selectată data de astăzi, ora trebuie să fie ulterioară orei curente.',
      orderContactRequired: 'Selectati sau introduceti un contact pentru fiecare locatie/adresa de preluare/predare.',
      beforeOffsetTimeWindowDto: 'Data si ora de livrare trebuie sa fie in viitor',
      shipmentVehicleDTO: {
        vehicleType: {
          required: "Campul 'Tip vehicul' este obligatoriu",
        },
      },
      productCustomsClearanceDTOS: 'Produsele sunt invalide',
      pickup: {
        name: {
          required: 'Campul nume este obligatoriu',
        },
        phoneNumber: {
          required: 'Campul numar de telefon este obligatoriu',
        },
        contact: {
          name: {
            required: 'Numele contactului locatiei de ridicare este obligatoriu!',
            minLength: {
              min: 'Numele contactului locatiei de ridicare trebuie sa contina minim 3 caractere!',
            },
          },
          phoneNumber: {
            required: 'Numarul de telefon al contactului locatiei de ridicare este obligatoriu!',
            minLength: {
              min: 'Numarul de telefon al contactului locatiei de ridicare este prea scurt',
            },
          },
        },
        address: {
          cityRequired: 'Campul oras este obligatoriu',
          postalCodeRequired: 'Campul cod postal este obligatoriu',
        },
        namedLocationVORequired: 'Locatia de ridicare este obligatorie',
        timeWindowDto: {
          startRequired: 'Inceputul intervalului de timp este obligatoriu',
          invalidDateTime: 'Data si ora de ridicare sunt invalide',
          beforeOffset: 'Data si ora de livrare trebuie sa fie in viitor',
        },
      },
      delivery: {
        name: {
          required: 'Campul nume este obligatoriu',
        },
        phoneNumber: {
          required: 'Campul numar de telefon este obligatoriu',
        },
        contact: {
          name: {
            required: 'Numele contactului locatiei de livrare este obligatoriu!',
            minLength: {
              min: 'Numele contactului locatiei de livrare trebuie sa contina minim 3 caractere!',
            },
          },
          phoneNumber: {
            required: 'Numarul de telefon al contactului locatiei de livrare este obligatoiu',
            minLength: {
              min: 'Numarul de telefon al contactului locatiei de livrare este prea scurt',
            },
          },
        },
        address: {
          cityRequired: 'Campul oras este obligatoriu',
          postalCodeRequired: 'Campul cod postal este obligatoriu',
        },
        namedLocationVORequired: 'Locatia de livrare este obligatorie',
        timeWindowDto: {
          startRequired: 'Inceputul intervalului de timp pentru livrare este obligatoriu',
          invalidDateTime: 'Data si ora de livrare sunt invalide',
          beforeOffset: 'Data si ora de livrare trebuie sa fie in viitor',
        },
      },
      packages: {
        heightRequired: 'Inaltimea pachetului este obligatorie',
        widthRequired: 'Latimea pachetului este obligatorie',
        lengthRequired: 'Lungimea pachetului este obligatorie',
        weightRequired: 'Greutatea pachetului este obligatorie',
        piecesRequired: 'Numarul de bucati este obligatoriu',
      },
      offerRequestWithCourierMustHaveOneShipment: 'Cererile de oferta cu curieri trebuie sa aiba un singur transport!',
      $cross: {
        pickupTimeWindowStartInvalid: 'Intervalul de timp de ridicare este invalid',
        packageRequired: 'Pachetul este obligatoriu',
        pickupLocationRequired: 'Locatia de ridicare este obligatorie',
        deliveryLocationRequired: 'Locatia de livrare este obligatorie',
        productCustomsClearanceDTOSRequired: 'Produsele sunt obligatorii',
        packageCountExceeded: 'Numarul de pachete nu poate depasi 200',
        isDateTimeEqualOrAfter:
          'Intervalul de timp de livrare trebuie sa fie dupa sau egal cu intervalul de timp de ridicare',
        tagsPerPackageGroup: 'Lipseste descrierea marfii pentru pachete',
        productsWeightIsBiggerThanPackagesWeight:
          'Greutatea totala a produselor trebuie sa fie mai mica sau egala cu greutatea totala a pachetelor!',
        shipmentTariffRequired: 'Este obligatorie selectarea unui tarif pentru transport',
      },
    },
    employeeAssignment: {
      validTo: 'Valid pana la',
      validFrom: 'Valid de la',
      title: 'Atribuire planner',
      territoryName: 'Nume teritoriu',
      territory: 'Teritoriu',
      territories: 'Teritorii',
      pid: 'PID',
      newTerritory: 'Teritoriu Nou',
      markAsMainTooltip: 'Marcheaza ca Agent Vazari principal',
      error: {
        requiredValidTo: 'Campul Valid pana la este obligatoriu',
        requiredValidFrom: 'Campul Valid de la este obligatoriu',
        requiredName: 'Campul Nume Teritoriu este obligatoriu',
      },
      employees: 'Angajati',
      employeeName: 'Nume angajat',
      employeeAssignment: 'Atribuire angajat',
      employee: 'Angajat',
      deleteTooltip: 'Sterge',
      activeStatuses: {
        true: 'Activ',
        false: 'Inactiv',
      },
      active: 'Activ',
    },
    email: {
      to: 'Catre',
      title: 'Email-uri',
      subject: 'Subiect',
      'receive-date': 'Data primirii',
      'plain-text-content': 'Plain Text Content',
      from: 'De la',
      'create-offer-request': 'Creare cerere de oferta',
      cc: 'CC',
    },
    driver: {
      workSchedule: 'Programul de lucru',
      validTo: 'Valabil pana la',
      validFrom: 'Valabil din',
      title: 'Soferi',
      tabs: {
        success: 'Succes',
        saved: 'Sofer salvat',
        license: 'Permis de conducere',
        'identity-card': 'Act de identitate',
        documents: 'Documente',
        details: 'General',
        vehicle: 'Vehicul',
      },
      subtitle: 'Rute',
      pricePerKm: 'Pret pe km',
      licensePlate: 'Vehicul asociat',
      pid: 'PID',
      phoneNumber: 'Numar de telefon',
      name: 'Nume',
      licenseExpirationDate: 'Data expirare permis',
      licenseCategory: 'Categorie permis',
      license: {
        title: 'Permis de conducere',
        licenseCategory: {
          issueDate: 'Data emitere',
          expirationDate: 'Data expirare',
          addCategory: 'Adauga categorie',
        },
        issueAuthority: 'Autoritate emitenta',
        editLicense: 'Editeaza permis de conducere',
        driverLicenseNumber: 'Numar permis de conducere',
        driverLicenseCategories: 'Categoriile permisului de conducere',
        details: 'Detalii permis de conducere',
        addLicense: 'Adauga permis de conducere',
      },
      idSeries: 'Serie C.I.',
      idNumber: 'Numar C.I.',
      'identity-document': {
        title: 'Act de identitate',
        series: 'Serie',
        number: 'Numar',
        issueDate: 'Data emitere',
        issueAuthority: 'Autoritate emitenta',
        expirationDate: 'Data expirare',
        editIdentityDocument: 'Editeaza act de identitate',
        details: 'Detalii act de identitate',
        addIdentityDocument: 'Adauga act de identitate',
      },
      vehicle: {
        title: 'Vehicul',
        subtitle: 'Asociati/Dezasociati vehicul',
        vehiclePlaceholder: 'Vehicul',
        unassign: 'Dezasociaza',
        assign: 'Asociaza',
        errors: {
          requiredVehicleVO: "Campul 'Vehicul' este obligatoriu!",
        },
      },
      fridCode: 'Cod FRID',
      error: {
        requiredSeries: 'Seria actului de identitate este obligatorie!',
        requiredPricePerKm: 'Campul Pret pe km este obligatoriu',
        requiredNumber: 'Numarul actului de identitate este obligatoriu!',
        requiredLicenseCategory: 'Campul Categorie permis este obligatoriu!',
        requiredIssueDate: 'Data emiterii actului de identitate este obligatorie!',
        requiredIssueAuthority: 'Autoritatea emitenta a actului de identitate este obligatorie!',
        requiredExpirationDate: 'Data expirarii actului de identitate este obligatorie!',
        requiredEmployee: 'Campul Angajat este obligatoriu',
        requiredDriverLicenseNumber: 'Numarul permisului de conducere este obligatoriu!',
        requiredDescription: 'Campul Descriiere este obligatoriu',
        minlengthSeries: 'Seria trebuie sa contina 2 caractere!',
        minlengthNumber: 'Numarul trebuie sa contina 6 cifre!',
        maxlengthSeries: 'Seria trebuie sa contina 2 caractere!',
        maxlengthNumber: 'Numarul trebuie sa contina 6 cifre!',
        EmployeeRequired: 'Angajatul este obligatoriu de ales!',
        EmployeeAlreadyIsDriver: 'Angajatul ales a fost deja marcat ca sofer!',
      },
      erpId: 'ID ERP',
      employee: 'Angajat',
      'edit-driver-title': 'Detalii sofer',
      documents: {
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        title: 'Documente',
        status: 'Status',
        photos: 'Poze document',
        obs: 'Observatii',
        markInactive: 'Marcheaza ca inactiv',
        markActive: 'Marcheaza ca activ',
        issueDate: 'Data emitere',
        inactive: 'Inactiv',
        expirationDate: 'Data expirare',
        editDocument: 'Editeaza document',
        documentTypePlaceholder: 'Selecteaza un tip de document',
        documentType: 'Tip document',
        document: 'Document',
        details: 'Detalii document',
        addDocumentType: 'Adauga tip document',
        addDocument: 'Adauga document',
        active: 'Activ',
      },
      description: 'Descriere',
      dangerousGoodsCertification: 'Certificari marfa periculoasa',
      county: 'Judet',
      contactPersonPhoneNumber: 'Numar de telefon persoana de contact',
      common: {
        employee: 'Angajat',
      },
      cnp: 'CNP',
      cityOfResidence: 'Localitatea de resedinta',
      bankAccount: 'Cont Bancar',
      address: 'Adresa',
      addNew: 'Adauga Sofer',
      'add-driver-title': 'Adauga sofer',
      activityType: 'Tip activitate',
      activeTo: 'Activ pana la',
      activeFrom: 'Activ de la',
    },
    title: 'Modul livrari',
    'delivery-inbox': {
      statusChange: 'Statusul a fost schimbat',
      phaseChange: 'Stadiul a fost schimbat',
      isNew: 'Intrare noua',
      assigmentChange: 'Angajatul atribuit a fost schimbat',
    },
    customer: {
      title: 'Client',
      searchClient: 'Cauta client',
      order: {
        listTitle: 'Lista comenzi client',
      },
      list: {
        walletCurrencyCode: 'Moneda portofel',
        walletBalance: 'Suma portofel',
        uniqueIdentificationNumber: 'Numar unic de indentificare',
        unblockCompany: 'Deblocheaza compania',
        title: 'Lista clienti',
        territoryVo: 'Teritoriu',
        name: 'Nume Client',
        mainPhoneNumber: 'Telefon',
        mainEmailAddress: 'Email',
        globalAccType: 'Tip cont global',
        globalAccCode: 'Cod cont global',
        favourite: 'Favorit',
        country: 'Tara',
        blockCompany: 'Blocheaza compania',
      },
      detail: {
        uniqueIdNumber: 'Număr unic identificare',
        title: 'Companie',
        territory: 'Teritoriu',
        mainEmail: 'Email Principal',
        mainAddress: 'Adresă principală',
        industryType: 'Tip industrie',
        header: 'Detalii Companie',
        generalInfo: 'Informatii generale',
        favouriteCustomer: 'Client Favorit',
        customerName: 'Nume client',
      },
      contactsWarning: 'Acest client nu are contacte. Adauga folosind urmatorul buton.',
      addressList: {
        type: 'Tip Adresa',
        title: 'Adrese',
        state: 'Stat',
        postalCode: 'Cod postal',
        location: 'Locatie',
        label: 'Eticheta',
        country: 'Tara',
        companyAddress: 'Adresa companie',
        city: 'Localitate',
        address: 'Adresa',
        add: 'Adauga adresa',
      },
      address: {
        pickup: 'Adresa incarcare',
        editTitle: 'Editare adresa',
        delivery: 'Adresa descarcare',
        addTitle: 'Adauga adresa noua de incarcare/descarcare',
      },
    },
    currencyValue: {
      value: 'Valoare',
      currencyCode: 'Moneda',
    },
    contract: {
      'valid-to': 'Valid pana in',
      'valid-from': 'Valid din',
      'service-provider': 'Furnizor',
      'new-title': 'Contract nou',
      'list-title': 'Contracte cu clienti',
      label: 'Numar Inregistrare / Data',
      error: {
        requiredvalidTo: 'Data de sfarsit este obligatoriu de completat!',
        requiredvalidFrom: 'Data de start este obligatoriu de completat!',
        requiredstatus: 'Status este obligatoriu de completat!',
        requiredlabel: 'Numarul de inregistrare este obligatoriu de completat!',
        requiredcustomerVO: 'Clientul este obligatoriu de ales!',
        requiredaccountVO: 'Contul este obligatoriu de ales!',
      },
      'edit-title': 'Editare Contract',
      customer: 'Client',
      'contract-status-value': {
        requested: 'Cerut',
        accepted: 'Aprobat',
      },
      'contract-status': 'Status contract',
      'company-name': 'Nume Client',
      comments: 'Comentarii',
      'attachments-title': 'Atasamente',
      addNew: 'Adauga Contract',
      account: 'Cont',
    },
    contactList: {
      visibilityTypes: {
        SERVICE_PROVIDER: 'Furnizor servicii',
        PUBLIC: 'Public',
        null: 'Toate',
        NONE: 'Privat',
        CUSTOMER: 'Client',
        BOTH: 'Ambele',
      },
      visibilityType: 'Vizibilitate',
      title: 'Contacte',
      receivesRequests: 'Primește cereri',
      phoneNumber: 'Telefon',
      ownerCompanyName: 'Detinator companie',
      email: 'Email',
      contactName: 'Nume',
      contactMethods: {
        VISIT: 'Vizita',
        TEL: 'Telefon',
        null: 'Toate',
        EMAIL: 'Email',
      },
      contactMethod: 'Metodă de contact',
      contactIsNotOwned: 'Contactul nu poate fi sters deoarece nu este detinut de dumnevoastra',
      contactCountry: 'Tara',
      companyName: 'Nume companie',
      add: 'Adauga contact',
    },
    contact: {
      title: 'Contact',
      selectContacts: 'Selecteaza contacte',
      phoneNumber: 'Numar telefon contact',
      name: 'Nume contact',
      error: {
        requiredPhoneNumber: 'Numarul de telefon este obligatoriu',
        requiredName: 'Numele este obligatoriu',
        requiredDeliveryPhoneNumber: 'Numarul de telefon este obligatoriu',
        requiredDeliveryName: 'Numele este obligatoriu',
        requiredDeliveryContactName: 'Numele este obligatoriu',
        requiredDeliveryCompanyName: 'Compania este obligatorie',
        requiredContactName: 'Numele este obligatoriu',
        requiredCompanyName: 'Compania este obligatorie',
        maxlengthPhoneNumber: 'Numarul de telefon nu trebuie sa depaseasca 20 de caractere',
        requiredNamedLocationPartnerContactVO: 'Selectarea unui contact este obligatorie',
        maxlengthName: 'Numele nu trebuie sa depaseasca 100 de caractere',
        maxlengthLoadingReference: 'Referinta nu trebuie sa depaseasca 250 de caractere',
        maxlengthCompanyName: 'Numele companiei nu trebuie sa depaseasca 100 de caractere',
        maxlength: 'Numarul de telefon nu trebuie sa depaseasca 20 de caractere',
      },
      email: 'E-Mail',
      addContact: 'Adauga contact',
    },
    complaint: {
      title: 'Reclamatii',
      statuses: {
        resolved: 'Rezolvata',
        in_progress: 'In progres',
        created: 'Creata',
      },
      status: 'Status',
      resolveComplaint: 'Marcheaza ca rezolvata',
      replies: 'Replici reclamatie',
      noParentComplaint: 'Nu exista nicio reclamatie.',
      noComplaintHistory: 'Nu exista un istoric pentru aceasta reclamatie',
      noChildComplaints: 'Nu exista nicio replica pentru aceasta reclamatie',
      message: 'Mesaj',
      lastReplyBy: 'Ultima modificare facuta de',
      initialComplaint: 'Reclamatia initiala',
      history: 'Istoric reclamatie',
      error: {
        requiredMessage: 'Campul Mesaj este obligatoriu!',
      },
      createdAt: 'Reclamat la',
      chooseFile: 'Alege fisier',
      addToExisting: 'Replica noua',
      addNew: 'Reclamatie noua',
    },
    common: {
      map: 'Harta',
    },
    billingCycle: {
      Weekly: 'Saptamanal',
      Per_shipment: 'Pe livrare',
      Monthly: 'Lunar',
      Manual: 'Manual',
      Bi_monthly: 'Bilunar',
    },
    address: {
      state: 'Judet',
      selectedAddress: 'Detalii adresa selectata',
      postalCode: 'Cod Poștal',
      newAddress: 'Detalii adresa noua',
      error: {
        postalCoderequired: 'Codul postal este obligatoriu',
        noAddressSelected: 'Adresa este obligatoriu de selectat sau de creat',
        countryrequired: 'Tara este obligatorie',
        cityrequired: 'Campul Localitate este obligatoriu',
      },
      country: 'Țară',
      city: 'Oraș',
      addressTypes: {
        WorkPoint: 'Punct de lucru',
        Warehouse: 'Depozit',
        Shipping: 'Livrare',
        Registered: 'Inregistrare',
        Pickup: 'Incarcare',
        Main: 'Principala',
        Invoicing: 'Invoicing',
        Delivery: 'Descarcare',
        Decision: 'Decizie',
        Correspondence: 'Corespondenta',
        Billing: 'Facturare',
      },
      addressType: 'Tip adresă',
      addressLine: 'Adresă',
    },
    'address-template': {
      list: {
        title: 'Șabloane adrese',
        city: 'Oraș',
        state: 'Județ',
        country: 'Țară',
        addressLine: 'Linie adresă',
        postalCode: 'Cod poștal',
        label: 'Etichetă',
        forCompany: 'Pentru compania',
        streetName: 'Nume stradă',
        streetNumber: 'Număr stradă',
        block: 'Bloc',
        building: 'Scară',
        floor: 'Etaj',
        apartment: 'Apartament',
        details: 'Detalii',
      },
    },
    account: {
      status: 'Status',
      serviceProviderName: 'Nume furnizor',
      'payment-time-limit': 'Termen de plata (nr zile)',
      'new-title': 'Adauga cont',
      'list-title': 'Conturi',
      latestShipmentDate: 'Data ultimei livrari',
      lastModifiedAt: 'Ultima modificare',
      firstShipmentDate: 'Data primei livrari',
      error: {
        defaultValidationMessage: 'A apărut o eroare. Verifică datele introduse și încearcă din nou',
      },
      'edit-title': 'Editare cont',
      customerName: 'Nume client',
      customer: 'Client',
      creditStopped: 'Credit oprit',
      contactPhoneNumber: 'Nr. tel. contact',
      contactName: 'Nume contact',
      contactEmail: 'Email contact',
      contact: 'Contact',
      billingName: 'Nume facturare',
      billingCycle: 'Modalitate Facturare',
      billingAccountNumber: 'Nr. cont facturare',
      address: 'Adresa',
      addNew: 'Adauga Cont',
      accountStatus: 'Status',
      accountRequestedAt: 'Cerere trimisa la data',
      accountNumber: 'Nr. cont',
      accountName: 'Nume cont',
      accountCreatedAt: 'Creat la data',
      accountClosedAt: 'Inchis la data',
      'account-status-value': {
        requested: 'Cerut',
        created: 'Creat',
        closed: 'Inchis',
      },
    },
    localTimezoneInfoMessage: 'Orele selectate corespund fusului orar al locației alese.',
    supplierDelegationManagement: {
      title: 'Delegari tarife catre parteneri comerciali',
      new: 'Adauga delegari',
      form: {
        add: 'Delegare tarife catre parteneri comerciali',
        edit: 'Editare delegari pentru',
        suppliers: 'Parteneri comerciali',
        tariffs: 'Tarife',
        validFrom: 'Valid de la',
        validTo: 'Valid pana la',
        availability: 'Perioada de valabilitate',
        selectSuppliers: 'Selecteaza parteneri comerciali',
        selectedTariffsBadge: ' tarife selectate',
        noAvailableTariffs: 'Nu exista tarife disponibile',
        contractsSuggestionMessage:
          'Pentru a putea delega tarife catre partenerii comerciali, este necesar sa aveti cel putin un contract salvat. Puteti adauga unul folosind butonul din dreapta.',
        contactSuggestionMessage:
          'Pentru ca partenerii comerciali sa poata crea comenzi cu furnizori pe baza tarifelor delegate, este necesar sa aveti cel putin un contact public care sa primeasca cereri. Puteti adauga unul folosind butonul din dreapta.',
        contactSuggestionMessageWithParam: (param) =>
          `Pentru ca ${param.name} sa poata crea comenzi cu furnizori pe baza tarifelor delegate, este necesar sa aveti cel putin un contact public care sa primeasca cereri. Puteti adauga unul folosind butonul din dreapta.`,
        errors: {
          required: 'Selectarea a cel putin unui partener comercial este obligatorie!',
          requiredTariffs: 'Selectarea a cel putin unui tarif este obligatorie!',
          requiredValidFrom: 'Data de început a valabilitatii este obligatorie!',
          minLengthSuppliers: 'Trebuie sa adaugi cel putin un partener comercial!',
        },
      },
      list: {
        createdAt: 'Creat la',
        supplierName: 'Nume partener comercial',
        activeTariffDelegationsCount: 'Total delegari active',
      },
      invalidate: 'Esti sigur ca vrei sa stergi aceasta delegare?',
      invalidateAll: 'Stergere delegari',
      invalidateAllConfirmationMessage: (param) =>
        `Esti sigur ca vrei sa stergi delegarile pentru <strong>${param.name}</strong> ?`,
    },
  },
  'saft-app': {
    downloadFile: 'Descarcati fiserul generat la:',
    uploadFile: 'Incarca',
    d406Declaration: 'Declaratie d406',
    cnpValidation: 'Validare si inlocuire CNP',
    cnpValidationUpload: 'Incarcati fisierul excel care contine CNP-urile',
    cnpFileWarn: 'Introduceti un singur fisier excel',
    accountingNote: 'Nota contabila',
    title: 'Incarcati fisierul excel si xml-ul segmentului 3: ',
    noRecentFiles: 'Nu aveti fisiere incarcate recent',
    segmentNumber: 'Numar segment',
    filesWarn: 'Introduceti un singur fisier xml si unul excel impreuna cu nota contabila',
  },
  'date-utils': {
    seconds: 'sec',
    minutes: 'min',
    hours: 'h',
    errors: {
      selectedDateAfterCurrentDatedateRange: 'Data selectata este in trecut',
      pickupIsBeforeToday: 'Data de preluare trebuie sa fie in prezent',
      pickupEndTimeIsBeforeNow: 'Timpul final de preluare trebuie sa fie in prezent',
      deliveryIsBeforePickup: 'Data de predare trebuie sa fie dupa data de preluare',
    },
    days: 'zile',
  },
  dash: {
    users_prev_year: 'Medie utilizatori noi pe zi intr-o luna',
    users_current_month: 'Media utilizatori unici pe zi pe luna curenta',
    users: 'Utilizatori',
    user: 'Utilizator',
    upload: 'Upload',
    total_orders_per_month_ytd: 'Comenzi primite pe luna in ultimul an',
    total_orders_per_day_mtd: 'Medie comenzi primite pe zi in ultima luna',
    total_offer_requests_per_month_ytd: 'Cereri oferta pe luna in ultimul an',
    total_offer_requests_per_day_mtd: 'Medie cereri oferta pe zi in ultima luna',
    total_GP: 'GP total',
    requests: 'Cereri de oferta',
    registered_users_prev_year: 'Medie utilizatori inregistrati pe luna in ultimul an',
    registered_users_current_month: 'Medie utilizatori noi pe zi lucratoare in luna curenta',
    orders_by_status: 'Statusuri comenzi pe ultimele 3 zile',
    orders: 'Comenzi',
    order_status: {
      sent: 'Trimisa',
      accepted: 'Acceptata',
      rejected: 'Refuzata',
      in_progress: 'Planificata',
      partially_in_progress: 'Partial planificata',
      returned_to_origin: 'Returnatar',
      partially_returned_to_origin: 'Partial returnata',
      in_transit: 'In Tranzit',
      partially_in_transit: 'Partial in tranzit',
      transit_end: 'Tranzit incheiat',
      partially_transit_end: 'Parțial tranzit incheiat',
      return_to_origin: 'Retur',
      partially_return_to_origin: 'Retur partial',
      lost: 'Pierduta',
      partially_completed: 'Partial livrata',
      mixed: 'Variabil',
      mixed_with_failure: 'Variabil cu esec',
      completed: 'Livrata',
      completed_with_failure: 'Livrata incomplet',
      undelivered: 'Nerealizata',
      documents_partially_received: 'Documente partial disponibile',
      documents_received: 'Documente disponibile',
      archived: 'Arhivata',
      cancelled: 'Anulata',
    },
    new_temp_users_prev_year: 'Medie utilizatori fara cont nou pe zi intr-o luna',
    new_temp_users_current_month: 'Medie utilizatori fara cont pe zi lucratoare in luna curenta',
    new_platform_customers: 'Utilizatori noi intr-o lună în ultimul an',
    gross_profit_ytd: 'Profitul pe luna in ultimul an',
    gross_profit_mtd: 'Profitul mediu pe zi in luna curenta',
    edit: 'Editare',
    delete: 'Șterge',
    dashboard_admin: 'Administrare panou de control',
    charts: 'Grafice',
    cancel: 'Înapoi',
    avg_transactions_prev_year: 'Medie tranzactii pe anul precedent',
    avg_transactions_current_month: 'Medie tranzactii pe zi pe luna',
    avg_gross_profit_ytd: 'Profitul mediu per comanda pe luna in ultimul an',
    avg_GP: 'GP mediu',
    active_offers_req_offers_value: 'Total: {{total}} <br> Active: {{active}}',
    active_offers_req_offers: 'Oferte pe ultimele 3 zile',
    abandoned_signups_to_date: 'Sign-up-uri abandonate',
  },
  'crm-app': {
    utils: {
      yes: 'Da',
      update: 'Salvează',
      total: 'Total',
      todayFilter: 'Azi',
      'show-advanced-filters': 'Afiseaza filtrare avansata',
      selectFilter: 'Cautari predefininte',
      search: 'Caută',
      saveFilter: 'Salveaza cautarea',
      save: 'Salvează',
      resetTableFilters: 'Reseteaza filtre',
      reset: 'x',
      requiredLegend: 'Toate câmpurile marcate cu (*) sunt obligatorii',
      preview: 'Tablou de bord',
      no: 'Nu',
      nextStep: 'Pasul urmator',
      newRequest: 'Cerere noua',
      minimizeFilters: '<<',
      expandFilters: '>>',
      enable: 'Activeaza',
      edit: 'Editeaza',
      details: ' - Detalii ',
      deleteConfirmationMessage: 'Confirmare stergere',
      currentWeekFilter: 'Saptamana curenta',
      'columns-selected': 'coloane selectate',
      close: 'Inchide',
      clearTableFilters: 'Sterge Filtrele Din Tabel',
      'choose-columns': 'Alege coloane',
      cancel: 'Inchide',
      'boolean-values': {
        true: 'Da',
        null: 'Toate',
        false: 'Nu',
      },
      all: 'Toate',
      'advanced-filters': 'Căutate avansată',
      addFilterName: 'Adauga nume pentru cautare',
      add: 'Adauga',
    },
    suggestions: {
      salesNotFound:
        'Pentru a putea efectua aceasta actiune utilizatorul curent are nevoie de un Sales atribuit si activ.',
      missingServicesForOpportunity:
        'Se pot selecta doar servicii definite pe profilul clientului. Dati click pe sageata urmatoare pentru a naviga la profil client',
      missingEmployee: 'Daca angajatul cautat nu se afla in dropdown. Dati click pe sageata urmatoare',
      editOpportunitySuggestion:
        'Pentru a adauga servicii sau edita alte detalii ale oportunitatii, dati click pe sageata urmatoare.',
      editActivitySuggestion:
        'Pentru a schimba statusul sau alte detalii ale activitatii, dati click pe sageata urmatoare.',
      companyNotServiceProvider:
        'Pentru a adauga un Sales, compania din care faceti parte trebuie sa fie Service Provider. Dati click pe sageata urmatoare pentru a modifica acest lucru.',
      addContact:
        'Nu aveti niciun contact! Pentru a putea crea o activitate aveti nevoie de cel putin un contact. Dati click pe sageata urmatoare pentru a crea unul',
    },
    service: {
      'weight-unit': 'Unitate greutate',
      'weight-per-shipment': 'Greutate/livrare',
      'volume-unit': 'Unitate volum',
      'volume-per-shipment': 'Volum/livrare',
      'transit-time': 'Timp tranzit',
      'traffic-channel-type': 'Canal trafic',
      tags: 'Tip marfa',
      'shipments-per-year': 'Livrări/an',
      'shipment-type': 'Tip livrare',
      'service-type': 'Tip serviciu',
      'revenue-per-shipment': 'C.A./livrare (euro)',
      origin: 'Origine',
      'new-title': 'Serviciu nou',
      'incoterm-value': 'Valoare incoterm',
      'gross-profit-per-shipment': 'Profit brut/livrare (euro)',
      error: {
        requiredweightUnitValue: 'Unitate greutate este obligatoriu de completat!',
        requiredweightPerShipment: 'Greutate/livrare este obligatoriu de completat!',
        requiredvolumeUnitValue: 'Unitate volum este obligatoriu de completat!',
        requiredvolumePerShipment: 'Volum/livrare este obligatoriu de completat!',
        requiredtransitTime: 'Timp tranzit este obligatoriu de completat!',
        requiredtrafficChannelTypeValue: 'Canal trafic este obligatoriu de completat!',
        requiredshipmentType: 'Tip livrare este obligatoriu de completat!',
        requiredshipmentsPerYear: 'Livrări/an este obligatoriu de completat!',
        requiredserviceTypeValue: 'Tip serviciu este obligatoriu de completat!',
        requiredrevenuePerShipment: 'Venit/livrare este obligatoriu de completat!',
        requiredorigin: 'Origine este obligatoriu de completat!',
        requiredincotermValue: 'Valoare incoterm este obligatoriu de completat!',
        requiredgrossProfitPerShipment: 'Venit brut/livrare este obligatoriu de completat!',
        requireddestination: 'Destinație este obligatoriu de completat!',
        originDestinationAddressValidationError: 'Nu pot exista mai multe Origini si mai multe Destinatii',
      },
      'edit-title': 'Editare serviciu',
      destination: 'Destinație',
      competitor: 'Competitor',
      comments: 'Comentarii',
      'add-service': 'Adauga serviciu',
    },
    selectItems: {
      weightUnitValue: 'Unitate de masura greutate',
      volumeUnitValue: 'Unitate de masura volum',
      vehicleType: 'Tip vehicul',
      trafficChannelTypeValue: 'Tip canal de trafic',
      shipmentType: 'Tip transport',
      serviceTypeValue: 'Tip servicii',
      salesChannels: 'Canal vanzari',
      revenueBrands: 'Interval cifra afaceri',
      reasonWonLostValues: 'Motiv castig pierderi',
      offerRefuseReason: 'Motive refuz oferta',
      needs: 'Nevoi client',
      jobTitleValue: 'Pozitie',
      invoiceOperationType: 'Tip operatiune',
      industryTypeValue: 'Tip industrie',
      incotermValue: 'Valoare Incoterm',
      gpBrands: 'Interval profitabilitate',
      globalAccountTypes: 'Tip cont global',
      documentType: 'Tip document',
      contactTypeValue: 'Tip contact',
      callFrequency: 'Frecventa de apelare',
      buyingRoleValue: 'Rol cumparator',
      activityType: 'Tip Activitate',
      activityPurpose: 'Scop Activitate',
      activityOutcome: 'Rezultat activitate',
      activityObjective: 'Obiectiv Activitate',
      activeUserType: 'Tip User',
    },
    selectItem: {
      value: 'Valoare',
      title: 'Valori prestabilite',
      label: 'Descriere',
      filterValue: 'Cauta valoare',
      filterLabel: 'Cauta descroere',
      filterFieldName: 'Cauta nume câmp',
      fieldName: 'Nume câmp',
      edit: 'Editeaza',
      delete: 'Stergere',
      all: ' - toate -',
      addValue: 'Adauga valoare',
      addLabel: 'Adauga etichetă',
    },
    sales: {
      territory: {
        validTo: 'Valid pana la',
        validFrom: 'Valid de la',
        title: 'Asignare Vanzari-Teritoriu',
        territory: 'Teritoriu',
        territories: 'Teritorii',
        salesName: 'Nume Angajat Vanzari',
        salesAssignment: 'Atribuire angajat',
        sales: 'Angajati Vanzari',
        sale: 'Angajat Vanzari',
        pid: 'PID',
        name: 'Nume teritoriu',
        markAsMainTooltip: 'Marcheaza ca Agent Vazari principal',
        historyMenuLabel: 'Asignare Vanzari-Teritoriu',
        error: {
          requiredName: 'Campul Nume teritoriu este obligatoriu',
        },
        deleteTooltip: 'Sterge',
        deleteTerritoryConfirm: 'Confirmati stergerea teritoriului',
        deleteConfirm: 'Sunteti sigur ca doriti sa stergeti acest element?',
        datePopUp: 'Introduceti datele',
        dateError: 'Introduceti un interval de timp valid',
        addTitle: 'Adauga Teritoriu',
        activeStatuses: {
          true: 'Activ',
          false: 'Inactiv',
        },
        active: 'Activ',
      },
      new: {
        title: 'Adaugare Sales',
      },
      list: {
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        undefinedValidTo: 'Nedefinit',
        title: 'Sales',
        territories: 'Teritorii',
        salesChannelValue: 'Canal vânzări',
        pid: 'Număr identificare',
        name: 'Nume',
        manager: 'Manager',
        latestOpportunity: 'Oportunitate',
        LatestActivity: 'Activitate',
        filter: 'Caută',
        expired: 'Inactiv',
        assignSales: 'Atribuie Sales',
        assignedFrom: 'Atribuit din',
        addSales: 'Adaugă Sales',
        active: 'Activ',
      },
      error: {
        requiredValidTo: 'Campul Valid pana la este obligatoriu',
        requiredValidFrom: 'Campul Valabil din este obligatoriu',
        requiredSalesManager: 'Campul Manager Sales este obligatoriu',
        requiredName: 'Campul Nume este obligatoriu',
        requiredEmployee: 'Campul Angajat este obligatoriu',
        DuplicateEmployeeForSales: 'Exista deja un Sales pentru acest Angajat',
        defaultValidationMessage: 'A aparut o eroare',
      },
      edit: {
        title: 'Editare Sales',
      },
      common: {
        validTo: 'Valabil pană la',
        validFrom: 'Valabil din',
        selectSalesChannel: 'Selecteaza canal vanzari',
        salesManager: 'Manager Sales',
        salesChannelValue: 'Canal vânzări',
        employee: 'Angajat',
      },
    },
    opportunity: {
      version: {
        title: 'Istoric',
        pipelineStage: 'Stadiu',
        name: 'Nume oportunitate',
        modifiedBy: 'Modificat de',
        modifiedAt: 'Modificat la',
      },
      territory: 'Teritoriu',
      teamOpportunities: 'Oportunitatile echipei',
      'shipments-per-year': 'Livrări per an',
      service: 'Serviciu',
      'sales-name': 'Nume vanzari',
      'sales-channel': 'Canal vanzari',
      sales: 'Vânzări',
      revenue: {
        totalRev: 'C.A. total',
        totalPercentGp: 'Profit brut estimat',
        totalGp: 'Profit brut total',
        potentialRev: 'C.A. potential',
        potentialGp: 'Profit brut potential',
        percentGp: 'Agreed gross profit',
        committedRev: 'C.A. agreat',
        committedGp: 'Profit brut agreat',
      },
      'revenue-per-shipment': 'C.A. per livrare',
      'reason-won-lost': 'Motiv pierdut sau câștigat',
      'reason-for-lead': 'Motiv',
      probability: 'Probabilitate',
      'potential-revenue': 'Potențial C.A.',
      'potential-gp': 'Potențial profit brut',
      'pipeline-stages': {
        UNABLE_TO_GAIN: 'Câștig indisponibil',
        SUBMIT_PROPOSAL: 'Transmitere oferta',
        SHIPPING_TO_PROFILE: 'Expedieri conform profil',
        SHIPPING: 'Expediere',
        RECEIVE_TENDER: 'Primire solicitare',
        IMPLEMENTED: 'Implementată',
        IDENTIFY_BUSINESS: 'Identificare business',
        FUTURE_OPPORTUNITY: 'Oportunitate viitoare',
      },
      'pipeline-stage': 'Stadiu',
      'opportunity-types': {
        SPOT_SHIPMENT: 'Spot Shipment',
        PRICING: 'Tarifare',
        CROSS_SELLING: 'Cross Selling',
        ACQUISITION: 'Achiziție',
      },
      'opportunity-type': 'Tip oportunitate',
      'opportunity-title': 'Oportunitate',
      'opportunity-name': 'Nume oportunitate',
      'opportunity-info-header': 'Detalii oportunitate',
      'number-of-shipments': 'Număr expedieri',
      'new-title': 'Oportunitate noua',
      myOpportunities: 'Oportunitatile mele',
      'main-competitor-name': 'Competitor principal',
      'list-title': 'Oportunitati',
      'lead-source': 'Sursă',
      'gp-per-shipment': 'Profit brut per livrare',
      'first-shipment-expected-date': 'Data primului transport',
      'expected-close-date': 'Dată estimare închidere',
      'detail-title': 'Oportunitate',
      'customer-name': 'Nume client',
      'contract-signed': 'Contract semnat',
      contact: {
        'new-title': 'Oportunitate - Contact nou',
        'list-title': 'Oportunitate - Contacte',
      },
      competitors: 'Competitori',
      'business-renewal-date': 'Dată reînnoire contract',
      allOpportunities: 'Toate oportunitatiile',
      addServices: 'Adauga servicii',
      addServiceDisabledTooltip: 'Pentru a adauga servicii, trebuie selectat un client',
      'add-opportunity': 'Adauga oportunitate',
      accountTitle: 'Cont',
      accountDetails: 'Detalii cont',
      account: 'Cont',
    },
    menu: {
      title: 'Meniu',
      sales: 'Vanzari',
      opportunityVersion: 'Istoric',
      opportunityDetail: 'Detalii',
      opportunityContacts: 'Contacte',
      opportunityAddress: 'Adrese',
      opportunityActivity: 'Activitati',
      opportunityAccount: 'Cont',
      opportunity: 'Oportunitati',
      language: 'Limba',
      customerProfile: 'Profil',
      customerOpportunity: 'Oportunitati',
      customerDetail: 'Detalii',
      customerCredit: 'Credit',
      customerContacts: 'Contacte',
      customerAttachments: 'Atașamente',
      customerAddress: 'Adrese',
      customerActivity: 'Activitati',
      customer: 'Clienti',
      credit: 'Credite',
      address: 'Adrese',
      activityDetail: 'Detalii',
      activityContacts: 'Contacte',
      activityAddress: 'Adrese',
      activity: 'Activitati',
    },
    legalEntity: {
      title: 'Companie',
      error: {
        DuplicateUniqueID: 'Exista deja un client cu acest numar unic de identificare!',
        DuplicateCompanyName: 'Exista deja un client cu acest nume!',
      },
      add: 'Adauga o noua companie',
    },
    error: {
      timeIntervalError: 'Timpul de sfarsit trebuie sa fie mai mare ca timpul de inceput',
      territory_name_exists: 'Acest nume de teritoriu exista deja!',
      startDateAfterEndDate: 'Data de sfarsit trebuie sa fie mai mare calendaristic decat data de inceput!',
      select_item_exists: 'Valoarea predefinita exista deja.',
      requiredValue: 'Valoarea raportata este obligatoriu de completat!',
      requiredStartDate: 'Data de inceput este obligatoriu de completat!',
      requiredStage: 'Stadiu este obligatoriu de completat!',
      requiredOpportunityName: 'Nume Oportunitate este obligatoriu de completat!',
      requiredName: 'Numele este obligatoriu de completat!',
      requiredFinishDate: 'Data de sfarsit este obligatoriu de completat!',
      requiredCustomerName: 'Campul Client este obligatoriu de completat!',
      requiredCode: 'Codul este obligatoriu de completat!',
      requiredactualCompletionDate: 'Data finalizare realizata este obligatoriu de completat!',
      required: 'Campul este obligatoriu de completat!',
      opportunity_contact_exists: 'Acest contact este deja salvat pe oportunitate!',
      alreadyExistingAddressOfType: 'Exista deja o adresa de acest tip!',
      defaultValidationMessage: 'A apărut o eroare. Verifică datele introduse și încearcă din nou',
      activityMustHaveAtLeastOneContact: 'Activitatea trebuie sa contina cel putin un contact!',
      activity_contact_exists: 'Acest contact este deja salvat pe activitate!',
    },
    customer: {
      YTDRevenue: 'YTD: C.A.',
      YTDGP: 'YTD: Profit brut',
      vatSplitStatus: 'Plata defalcata TVA',
      vatRegistration: 'Platitor TVA',
      vatInactiveStatus: 'Inactiv (TVA)',
      vatInactivationDate: 'Inactiv (TVA) de la',
      vat: 'Valoare TVA',
      'unique-id-number': 'Număr unic identificare',
      totalOpportunityRev: 'C.A. total opp.',
      totalOpportunityGP: 'Profit brut total opp.',
      totalCommittedRev: 'C.A. total committed',
      'territory-name': 'Nume teritoriu',
      territory: 'Teritoriu',
      teamCustomers: 'Echipa mea',
      'sales-name': 'Nume agent vânzări',
      'sales-channel': 'Canal Vânzări',
      'registration-code': 'Nr. de ordine Registrul Comertului',
      'profile-sales-channel': 'Canal vânzări',
      'profile-gp-brand': 'Interval de profitabilitate',
      profile: 'Profil',
      overview: {
        totalPotentialRevGP: 'Profit brut potențial',
        'total-value': 'YTD: Cifra de afaceri',
        'start-time': 'Timp de început',
        'shipment-type': 'Tip livrare',
        'service-type': 'Tip serviciu',
        'sales-team': 'Echipă vânzări',
        routes: 'Rute',
        'route-source-location': 'Sursa',
        'route-name': 'Nume',
        'route-destination-location': 'Destinatie',
        profit: 'YTD: Profit',
        'planned-start-date': 'Dată planificată începere',
        'pipeline-stage': 'Stadiu',
        'phone-number': 'Număr telefon',
        orders: 'Comenzi',
        'order-tasks': 'Task-uri',
        'order-status': 'Status',
        'order-pickups': 'Preluari',
        'order-deliveries': 'Livrari',
        'opportunity-type': 'Tip',
        'opportunity-total-potential-gross-profit-per-year': 'Profit brut potențial total/lună',
        'opportunity-potential-gross-profit': 'Potențial Profit Brut Oportunitate',
        'opportunity-name': 'Nume',
        'opportunity-commited-gross-profit': 'Profit brut agreat oportunități',
        opportunities: 'Oportunități',
        noBillingData: 'Nu exista date despre profit si cifra de afaceri',
        'next-contact-date': 'Următoarea dată de contact',
        'never-call': 'Nu suna',
        'more-opportunities': 'Mai multe oportunități',
        'more-contacts': 'Mai multe contacte',
        'more-activities': 'Mai multe activități',
        'job-title': 'Titlu post',
        'first-shipment-expected-date': 'Data primului transport',
        'end-time': 'Timp de sfârșit',
        email: 'Email',
        dueAmount: 'Total de plata',
        dso: 'DSO',
        createdBy: 'Creat de',
        contracts: 'Contracte',
        'contract-valid-to': 'Valid pana la',
        'contract-valid-from': 'Valid din',
        'contract-status-value': {
          requested: 'Cerut',
          accepted: 'Aprobat',
        },
        'contract-status': 'Status',
        contacts: 'Contacte',
        'contact-type': 'Tip contact',
        'contact-name': 'Nume',
        comments: 'Comentarii',
        'buying-role': 'Rol',
        'business-renewal-date': 'Dată reînnoire contract',
        actualPaymentTerm: 'Actual payment term',
        'actual-completion-date': 'Dată finalizare realizată',
        'activity-status': 'Stadiu activitate',
        activities: 'Activități',
      },
      nextContactDate: 'Urmatoarea data de contact',
      'new-customer': 'Client nou',
      myCustomers: 'Clientii mei',
      'main-phone': 'Telefon principal',
      'main-email': 'Email Principal',
      'main-address': 'Adresă principală',
      loyaltyCode: 'Cod loialitate',
      'loyalty-options': {
        Uptrader: 'Uptrader',
        Stable: 'Stabil',
        New: 'Nou',
        Lost: 'Pierdut',
        Inactive: 'Inactiv',
        Downtrader: 'Downtrader',
      },
      listTitle: 'Clienti',
      'legal-entity-search': 'Caută companie (după nume sau număr unic de identificare)',
      'legal-entity-header': 'Detalii Companie',
      lastContactDate: 'Ultima data de contact',
      globalAccount: {
        type: 'Tip cont global',
        code: 'Cod cont global',
        add: 'Adauga un nou cont global',
      },
      'global-account-type': 'Tip Cont Global',
      'global-account-code': 'Cod Cont Global',
      generalInfo: 'Informatii generale',
      financialInfo: 'Financial info',
      favourite: 'Favorit',
      errors: {
        DuplicateUniqueID: 'Mai exista o firma cu acest numar unic de inregistrare!',
        customer_exists: 'Firma aceasta este deja client!',
      },
      error: {
        uniqueIdNumberrequired: 'Numarul unic de identificare este obligatoriu de completat!',
        territoryrequired: 'Teritoriul este obligatoriu de ales!',
        alreadyExistingAddressOfType: 'Exista deja o adresa de acest tip!',
        customer_exists: 'Exista deja un client creat pentru aceasta companie!',
        countryrequired: 'Tara este obligatoriu de completat!',
        companyNamerequired: 'Numele clientului este obligatoriu de completat!',
      },
      customerRating: 'Customer Fin. Rating',
      'customer-title': 'Client',
      'customer-stages': {
        Track: 'Monitorizare',
        Suspect: 'Suspect',
        Prospect: 'Prospect',
        Maintain: 'Mentenanță',
        Lost: 'Pierdut',
        Action: 'Acțiune',
      },
      'customer-stage': 'Stadiu client',
      'customer-search': 'Caută client',
      'customer-profile': {
        totalRevenue: 'Cifra de afaceri totala',
        totalGrossProfit: 'Profit brut total',
        'total-potential-revenue': 'Cifra de afaceri totala servicii',
        'total-potential-gp': 'Profit brut total servicii',
        title: 'Profil client',
        services: 'Servicii',
        'sales-channel-options': {
          telesales: 'Televânzări',
          majorAccount: 'Cont major',
          globalAccount: 'Cont global',
          fieldSales: 'Vânzări teren',
          directChannel: 'Canal direct',
        },
        'sales-channel': 'Canal Vânzări',
        'revenue-brand': 'Interval de cifră de afaceri',
        need: 'Nevoie de business',
        mainCompetitor: 'Competitor principal',
        'last-shipment-date': 'Ultima dată de livrare',
        'gp-brand': 'Interval de profitabilitate',
        error: {
          requiredSalesChannelValue: 'Campul Canal Vanzari este obligatoriu',
          requiredCustomerNeedValue: 'Campul Necesitati este obligatoriu',
          requiredCommodity: 'Campul Tip marfa este obligatoriu',
        },
        competitors: 'Competitori',
        commodity: 'Tip marfă',
      },
      'customer-new-warning': 'Clientul este NOU!',
      'customer-name': 'Nume client',
      'customer-loyalty-code': 'Cod de loialitate',
      'customer-last-contact-date': 'Ultima dată de contact',
      'customer-info-header': 'Informații client',
      'customer-industry-type': 'Tip industrie',
      'customer-credit-status': 'Status credit',
      'customer-country': 'Tara',
      'customer-city': 'Oras',
      'customer-call-frequency': 'Frecvență apelare (număr zile)',
      credit: {
        validationDate: 'Data validare',
        title: 'Detalii cerere credit',
        statusEnum: {
          Warning_exceeded: 'Atenție depășire',
          Expired: 'Expirat',
          Closed: 'Închis',
          Active: 'Activ',
        },
        requestStatus: 'Status cerere',
        requestHistory: 'Istoric cerere credit',
        requestEnum: {
          Under_decision: 'In asteptarea deciziei',
          Requested: 'Solicitat',
          Rejected: 'Respins',
          Approved: 'Aprobat',
        },
        requestedBy: 'Solicitat de',
        requestDate: 'Data solicitare',
        requestComment: 'Comentarii cerere credit',
        paymentTerms: 'Termeni de plata',
        paymentMethodEnum: {
          Credit_card: 'Card de credit',
          Credit: 'Credit',
          Cash: 'Cash',
        },
        paymentMethod: 'Metoda de plata',
        expectedYearlyRevenue: 'Venit anual estimat',
        error: {
          requestDaterequired: 'Data solicitare este obligatoriu de completat!',
          expectedYearlyRevenuerequired: 'Venitul anual estimat este obligatoriu de completat!',
          currencyValuerequired: 'Valuta este obligatoriu de completat!',
          creditLimitrequired: 'Limita creditului este obligatoriu de completat!',
        },
        currencyValue: 'Valuta',
        creditStatus: 'Status credit',
        creditLimit: 'Limita credit',
        creditChecked: 'Credit validat',
        checkValidityDays: 'Durata disponibilitate credit (zile)',
        checkExpiryDate: 'Data expirare credit',
        checkedBy: 'Aprobat de',
        checkDate: 'Data aprobare credit',
        checkComment: 'Comentarii verificare credit',
        billingCycleEnum: {
          Weekly: 'Saptamanal',
          Per_shipment: 'Pe livrare',
          Monthly: 'Lunar',
          Manual: 'Manual',
          Bi_monthly: 'Bi-lunar',
        },
        billingCycle: 'Ciclu de facturare',
        availableCredit: 'Credit disponibil',
        approvedAmount: 'Credit aprobat',
        approved: 'Aprobat',
        approvalTitle: 'Detalii aprobare credit',
      },
      'credit-status': {
        Warning_exceeded: 'Atenție depășire',
        Expired: 'Expirat',
        Closed: 'Închis',
        Active: 'Activ',
      },
      contactedBy: 'Contactat de',
      contact: {
        list: {
          title: 'Contacte',
          add: 'Contact nou',
        },
        detail: {
          phoneNumber: 'Numar telefon',
          'person-name': 'Nume',
          'person-idSeries': 'Serie',
          'person-idNumber': 'Numar',
          'person-county': 'Judet',
          'person-address': 'Adresa',
          new: {
            title: 'Contact Nou',
            save: 'Salveaza',
            close: 'Inchide',
          },
          inputs: {
            addNewContact: 'Contact nou',
          },
          errors: {
            defaultValidationMessage: 'A aparut o eroare',
          },
          email: 'Email',
          edit: {
            title: 'Contact existent',
          },
          common: {
            selectExistentContact: 'Selecteaza un contact existent',
            neverCall: 'Nu suna',
            jobTitleValue: 'Tip Job',
            contactTypeValue: 'Tip Contact',
            clearContactSelection: 'Sterge contact selectat',
            buyingRoleValue: 'Rol',
            autocompletePlaceholder: 'Cauta contact',
          },
        },
        deleteConfirm: 'Sunteti sigur(a) ca vreti sa stergeti acest contact?',
        customerContactTabTitle: 'Contact client',
        customerContactTabHeader: 'Detalii contact client',
        contactTabTitle: 'Contact',
        contactTabHeader: 'Detalii contact',
      },
      'contact-title': 'Contact',
      attachments: {
        'uploaded-list': 'Lista atasamente incarcate',
        'new-upload': 'Incarca un nou fisier',
      },
      allCustomers: 'Toti clientii',
      'address-title': 'Adresa',
      'add-customer': 'Adauga client',
    },
    credit: {
      status: 'Status',
      requestStatus: 'Status cerere',
      requestedBy: 'Cerut de',
      requestDate: 'Cerut la',
      listTitle: 'Credite',
      expiryDate: 'Expira la',
      currencyValue: 'Valuta',
      creditAmount: 'Valoare credit',
      approvalDate: 'Aprobat la',
    },
    contact: {
      list: {
        visibilityTypes: {
          SERVICE_PROVIDER: 'Furnizor servicii',
          PUBLIC: 'Public',
          null: 'Toate',
          NONE: 'Privat',
          CUSTOMER: 'Client',
          BOTH: 'Ambele',
        },
        visibilityType: 'Vizibilitate',
        title: 'Contacte',
        search: 'Caută',
        receivesRequests: 'Primeste cereri',
        phoneNumber: 'Telefon',
        neverCall: 'Nu suna',
        jobTitleValue: 'Titlu',
        email: 'Email',
        contactTypeValue: 'Tip contact',
        contactName: 'Nume',
        contactMethods: {
          VISIT: 'Vizita',
          TEL: 'Telefon',
          null: 'Toate',
          EMAIL: 'E-Mail',
        },
        contactMethod: 'Metoda de contact',
        contactCountry: 'Țară',
        buyingRoleValue: 'Rol',
        add: 'Contact nou',
      },
    },
    billingCycle: {
      Weekly: 'Saptamanal',
      Per_shipment: 'Pe livrare',
      Monthly: 'Lunar',
      Manual: 'Manual',
      Bi_monthly: 'Bilunar',
    },
    address: {
      state: 'Stat',
      'postal-code': 'Cod Poștal',
      newTitle: 'Adresa noua',
      list: {
        title: 'Adrese',
        add: 'Adaugă',
      },
      error: {
        noAddressSelected: 'Selectati o adresa valida',
      },
      detailTitle: 'Detalii adresa',
      country: 'Țară',
      city: 'Oraș',
      'address-types': {
        Warehouse: 'Depozit',
        Shipping: 'Expediție',
        Registered: 'Adresă înregistrare',
        Pickup: 'Ridicare',
        Main: 'Principală',
        Invoicing: 'Facturare',
        Delivery: 'Livrare',
        Decision: 'Unitate decizie',
        Correspondence: 'Corespondență',
        Billing: 'Plăți',
      },
      'address-type': 'Tip adresă',
      'address-line': 'Adresă',
    },
    activity: {
      territory: 'Teritoriu',
      teamActivities: 'Echipa mea',
      startTime: 'De la',
      'start-time': 'Timp de început',
      saveAndCreateNew: 'Salveaza si mergi la Calendar Activitati',
      'sales-search': 'Atribuit la',
      sales: 'Vânzări',
      'planned-start-date': 'Dată planificată începere',
      pipelineStage: 'Stadiu oportunitate',
      'pipeline-stage': 'Stadiu oportunitate',
      overview: {
        title: 'Detalii activitate',
        startedAt: 'Inceput la',
        saveSuccess: 'Modificarile au fost salvate cu succes',
        saveError: 'A aparut o erroare',
        opportunity: 'Oportunitate',
        finishedAt: 'Sfarsit la',
        customer: 'Client',
        contact: 'Contact',
        assignedTo: 'Atribuit la',
        actualCompletionDate: 'Dată finalizare realizata',
        activityType: 'Tip activitate',
        activityStatus: 'Status activitate',
        activityOutcome: 'Rezultat activitate',
        activityObjective: 'Obiectiv activitate',
      },
      'opportunity-type': 'Tip oportunitate',
      'opportunity-search': 'Oportunitate',
      'opportunity-name': 'Nume oportunitate',
      'opportunity-header': 'Informații oportunitate',
      myActivities: 'Activitatile mele',
      list: {
        addNew: 'Adauga',
      },
      'list-title': 'Activitati',
      error: {
        requiredCustomerSummaryVO: 'Campul Client este obligatoriu',
        requiredCustomerContactSummaryVO: 'Campul Contact Principal este obligatoriu',
        requiredcontacts: 'Campul Contacte este obligatoriu',
        requiredAssignedToSalesSummaryVo: 'Campul Atribuit la este obligatoriu',
        requiredActivityType: 'Campul Tip Activitate este obligatoriu',
        requiredActivityStatus: 'Campul Status activitate este obligatoriu',
        requiredActivityPurpose: 'Campul Obiectiv activitate este obligatoriu',
        requiredActivityOutcome: 'Campul Rezultat activitate este obligatoriu',
        requiredActivityObjective: 'Campul Obiectiv activitate este obligatoriu',
      },
      endTime: 'Pana la',
      'end-time': 'Timp de sfârșit',
      'detail-title': 'Activitate',
      'customer-stage': 'Stadiu client',
      'customer-search': 'Client',
      'customer-name': 'Nume client',
      contact: {
        title: 'Contacte',
        'new-title': 'Contact activitate noua',
        new: 'Contact nou',
        list: {
          phoneNumber: 'Numar telefon',
          contactTypeValue: 'Tip contact',
          contactName: 'Nume',
          buyingRoleValue: 'Rol',
        },
        'add-contact': 'Adauga contactul',
      },
      'completion-date-time-stamp': 'Data finalizare generata',
      comments: 'Comentarii',
      allActivities: 'Toate activitatile',
      'actual-completion-date': 'Dată finalizare realizata',
      activityCalendar: 'Calendar activitati',
      'activity-type': 'Tip activitate',
      'activity-title': 'Activitate',
      'activity-statuses': {
        Scheduled: 'Planificat',
        Requested: 'Cerere',
        Rejected: 'Respins',
        null: 'Toate',
        Done: 'Finalizat',
        Cancelled: 'Anulat',
      },
      'activity-status': 'Stadiu activitate',
      'activity-purpose': 'Scop activitate',
      'activity-planning': 'Informatii Planning',
      'activity-outcome': 'Rezultat activitate',
      'activity-objective': 'Obiectiv activitate',
      'activity-name': 'Nume activitate',
      'activity-main-contact': 'Contact Principal',
      'activity-header': 'Informații principale',
    },
  },
  costs: {
    totalCosts: 'Costuri totale',
    list: {
      value: 'Suma',
      validTo: 'Pana la',
      validFrom: 'De la',
      title: 'Costuri',
      serviceProviderName: 'Nume furnizor',
      serviceProviderCUI: 'CUI furnizor',
      name: 'Nume',
      documentType: 'Tip document',
      documentInfo: 'Numar / data document',
      description: 'Descriere',
      currencyCode: 'Moneda',
      createdBy: 'Adaugat de',
      createdAt: 'Data adaugarii',
      coveragePeriod: 'Perioada de acoperire',
      costAssociationTypes: {
        VEHICLE: 'Vehicul',
        SERVICE_PROVIDER_ORDER: 'Comanda',
        DRIVER: 'Sofer',
        COST_CENTER: 'Centru de cost',
      },
      costAssociationType: 'Tip asociere cost',
    },
    form: {
      vehicleAttachments: 'Atasamente vehicul',
      vehicle: 'Vehicul',
      value: 'Suma',
      validTo: 'Data sfarsit',
      validFrom: 'Data inceput',
      title: 'Titlu',
      serviceProviderName: 'Nume furnizor',
      serviceProviderCUI: 'CUI furnizor',
      recurrence: 'Recurenta',
      quantity: 'Cantitate',
      orderNumber: 'Numarul comenzii',
      order: 'Comanda',
      oneTimeCost: 'Cost unic',
      measurementUnit: 'Unitate de masura',
      errors: {
        requiredVehicle: "Campul 'Vehicul' este obligatoriu",
        requiredValue: "Campul 'Suma' este obligatoriu",
        requiredValidTo: "Campul 'Data sfarsit' este obligatoriu",
        requiredValidFrom: "Campul 'Data inceput' este obligatoriu",
        requiredTitle: "Campul 'Titlu' este obligatoriu",
        requiredPrice: 'Suma este obligatorie',
        requiredDriver: "Campul 'Sofer' este obligatoriu",
        requiredCurrencyCode: "Campul 'Moneda' este obligatoriu",
        '0Price': 'Moneda este obligatorie',
        requiredOneOfFour: 'Unul din cele patru campuri trebuie completate',
        patternServiceProviderCUI: 'Campul trebuie sa contina minim 2 cifre si sa nu contina spatii albe',
      },
      driver: 'Sofer',
      documentType: 'Tip document',
      documentInfo: 'Numar / data document',
      description: 'Descriere',
      customerName: 'Client',
      currencyCode: 'Moneda',
      cronExpressions: {
        yearly: 'Anual, incepand de azi',
        monthly: 'Lunar, incepand de azi',
      },
      costCenter: 'Centru de cost',
      attachments: 'Atasamente',
    },
    edit: 'Editeaza cost',
    'delete-confirmation-message': (param) =>
      `Esti sigur ca doresti sa stergi costul <strong>${param.costTitle}</strong> ?`,
    delete: 'Sterge cost',
    costs: 'costuri',
    add: 'Adauga cost',
  },
  costCenter: {
    utils: {
      update: 'Actualizeaza',
      search: 'Cauta',
      save: 'Salveaza',
      requiredLegend: 'Campurile marcate cu * sunt obligatorii!',
      close: 'Inchide',
      cancel: 'Anuleaza',
      add: 'Adauga',
      deleteConfirmationMessage: 'Sunteti sigur ca doriti sa stergeti acest centru de cost?',
    },
    selectDialog: {
      title: 'Centru de cost',
    },
    selectButton: 'Centru de Cost',
    manage: {
      title: 'Actualizeaza Centru de Cost',
    },
    list: {
      validTo: 'Valid pana la',
      title: 'Centre de Cost',
      parentLabel: 'Parinte',
      label: 'Nume',
      isPrivate: 'Privat',
      isCustomerBehalf: 'Creat de transportator',
      disabledDeleteTooltip: 'Centrul de cost este deja inactiv',
      createdAt: 'Creat la',
    },
    input: 'Centru de Cost',
    edit: {
      title: 'Editare Centru de Cost',
    },
    add: {
      title: 'Adauga Centru de Cost',
      parent: 'Parinte',
      label: 'Nume',
      isPrivate: 'Privat',
      error: {
        requiredLabel: 'Numele este obligatoriu.',
      },
    },
  },
  contract: {
    tariff: 'Tarif',
    sp: {
      transitTime: 'Zile tranzit',
      transitNamedLocation: 'Locatie tranzit',
      tooltip: {
        weight: 'Greutate',
        vehicleType: 'Tip vehicul',
        validTo: 'Valid pana la',
        validity: 'Valabilitate',
        validFrom: 'Valid de la',
        type: 'Tip ambalaj',
        transitTime: 'Timp tranzit',
        transitNamedLocation: 'Locatie tranzit',
        transitPoint: 'Punct de tranzit',
        tags: 'Etichete',
        size: 'Dimensiuni',
        serviceProvider: 'Furnizor',
        referenceNumber: 'Numar referinta',
        pieces: 'Numar pachete',
        paymentTimeLimit: 'Termen plata',
        noticeTime: 'Preavizare',
        label: 'Eticheta',
        exclusive: 'Transport exclusiv',
        customerComments: 'Comentarii client',
        customer: 'Client',
        operationalTerritory: 'Teritoriu',
        pickupNamedLocation: 'Locatie preluare',
        deliveryNamedLocation: 'Locatie livrare',
        centralNamedLocation: 'Locatie centrala',
      },
      title: 'Contract',
      tariffs: 'Tarife',
      selectAccount: 'Selecteaza cont',
      save: 'Salveaza',
      price: 'Pret',
      from: 'de la',
      exclusive: 'Transport exclusiv',
      dynamicTariffsInfoMessage:
        'Prețurile introduse sunt per pachet și vor fi folosite pentru a genera un preț dinamic la comandă.',
      disabledDynamicTariffsInfoMessage:
        'Contractele cu pret calculat automat nu se pot folosi doarece exista transporturi care nu sunt alcatuite din locatii si pachete standard sau nu exista contracte pentru aceastea',
      errors: {
        requiredTransitTime: 'Campul pret este obligatoriu',
        requiredPrice: 'Campul pret este obligatoriu',
        requiredAccount: 'Campul cont este obligatoriu',
        required: 'Campul este obligatoriu',
      },
      details: 'Detalii',
      'contract-answer': 'Raspunde la cererea de contract',
      comments: 'Comentarii',
      cancel: 'Inapoi',
      'answer-details': 'Vezi detalii',
      account: 'Cont',
    },
    'select-tariff': 'Selecteaza tarif',
    'remove-tariff': 'Elimina tariful',
    selectedTariff: 'Tarif selectat',
    request: {
      waypoint: 'Locatie',
      'view-response-title': 'Raspuns cerere contract',
      utils: {
        transport: 'Transport',
        to: 'Catre',
        save: 'Salveaza',
        reject: 'Refuza',
        edit: 'Editeaza',
        duplicate: 'Duplica',
        delete: 'Sterge',
        close: 'Inchide',
        cancel: 'Anuleaza',
        accept: 'Accepta',
      },
      fixedPriceContract: 'Pret fix',
      useFixedPriceContract: 'Foloseste contract cu pret fix',
      dynamicPriceContract: 'Pret calculat automat',
      selectedPackages: 'Pachete selectate',
      routes: 'Rute',
      routesAndTerritories: 'Rute si Teritorii',
      removeWaypoint: 'Sterge locatie',
      removeRoute: 'Sterge ruta',
      rejectedRequest: 'Cererea de contract a fost refuzata',
      rejectedReason: 'Motiv refuz',
      quantity: 'Cantitate',
      'page-title': 'Cerere de contract',
      packages: 'Pachete',
      form: {
        width: 'Latime',
        weight: 'Greutate',
        validTo: 'Valabil pana la',
        validFrom: 'Valabil de la',
        'valid-to': 'Valid pana in',
        'valid-from': 'Valid din',
        type: 'Tip ambalaj',
        transitTime: 'Timp tranzit (zile)',
        tags: 'Etichete',
        serviceProvider: 'Nume furnizor',
        'service-provider-name': 'Nume furnizor',
        referenceNumber: 'Numar referinta',
        pieces: 'Nr. pachete',
        paymentTimeLimit: 'Termen de plata (zile)',
        notice: 'Preavizare (zile)',
        locked: 'Transport exclusiv',
        'location-required': 'Este obligatorie selectarea a minim 2 locatii pentru o ruta.',
        'location-or-territory-required': 'Este obligatorie selectarea a minim 2 locatii sau teritorii pentru o ruta.',
        'list-title': 'Contracte cu clienti',
        length: 'Lungime',
        label: 'Eticheta',
        height: 'Inaltime',
        details: 'Detalii',
        description: 'Nume',
        currency: 'Moneda',
        'contract-request-status': 'Status',
        carType: 'Tip masina',
      },
      errors: {
        requiredWidth: 'Campul este obligatoriu',
        requiredWeight: 'Campul este obligatoriu',
        requiredValidTo: "Campul 'Valabil pana la' este obligatoriu",
        requiredValidFrom: "Campul 'Valabil de la' este obligatoriu",
        requiredPieces: 'Campul este obligatoriu',
        requiredLength: 'Campul este obligatoriu',
        requiredHeight: 'Campul este obligatoriu',
        requiredCurrencyCode: "Campul 'Moneda' este obligatoriu",
        requiredContacts: 'Cel putin un contact este obligatoriu',
        minPieces: 'Cantitate invalida',
        invalidFormWithContacts:
          'Este obligatorie selectarea unui furnizor, unei rute cu minim doua locatii, unui contact si unui pachet',
        invalidForm:
          'Este obligatorie selectarea unui furnizor, unei rute cu minim doua locatii/teritorii si a unui pachet',
      },
      editUnavailable: 'Editarea cererii nu mai este disponibila',
      'edit-page-title': 'Editeaza cerere de contract',
      comments: 'Comentarii',
      addWaypoint: 'Adauga locatie',
      addRoute: 'Adauga ruta',
      addRouteOrTerritory: 'Adauga ruta sau teritoriu',
      addTerritory: 'Adauga teritoriu',
      addLocations: 'Locatii',
      addTerritories: 'Teritorii',
      addCustomDimensions: 'Adauga alte pachete',
      acceptRequest: 'Sunteti sigur ca doriti sa acceptati contractul? Aceasta actiune este ireversibila!',
    },
    order: {
      tariffType: 'Tip tarifare',
      tariffRequired: 'Este obligatorie selectarea unui tarif',
      shipmentTariff: 'Tarifare pe transport',
      orderTariff: 'Tarifare pe comanda',
      changeTariffType: 'Schimba tipul de tarifare',
    },
    customer: {
      'valid-to': 'Valid pana la',
      'valid-from': 'Valid din',
      utils: {
        add: 'Adauga',
      },
      statuses: {
        REJECTED: 'Refuzat',
        PENDING: 'In asteptare',
        null: 'Niciun status',
        CONFIRMATION_PENDING: 'In asteptarea confirmarii',
        CANCELED: 'Anulat',
        ACCEPTED: 'Acceptat',
      },
      status: 'Status',
      serviceProvider: 'Furnizor',
      'list-title': 'Contracte cu furnizori',
      label: 'Eticheta',
      'edit-contract-request': 'Editeaza cererea de contract',
      contractRejectTitle: 'Refuza Contractul',
      contractRejectReason: 'Motivul refuzului',
      'contract-request-details': 'Vezi detalii raspuns',
    },
    cancellation: {
      rejectCancelContract: 'Refuz',
      cancelRequest: 'Cerere de anulare',
      cancelledContract: 'Contractul este ANULAT',
      cancelContractForcedButton: 'Anuleaza contractul fortat',
      cancelContractDialog: {
        title: 'Cerere Anulare Contract',
        forcedWarning:
          'Anularea se va face fara acordul celelalte parti implicate. Anularea acesteia va duce la penalizari conform Termenii si Conditiile de transport.',
        forced: 'Anulare fortata',
        details: 'Motiv',
      },
      cancelContractButton: 'Anuleaza contractul',
      acceptCancelContract: 'Accept anularea contractului',
    },
  },
  contactManagement: {
    receivesRequestsRequiredTooltip: 'Pentru a selecta o metoda de contact trebuie sa primeasca cereri',
    inputs: {
      visibilityTypes: {
        SERVICE_PROVIDER: 'Furnizor servicii',
        PUBLIC: 'Public',
        NONE: 'Privat',
        CUSTOMER: 'Client',
        BOTH: 'Ambele',
      },
      visibilityType: 'Vizibilitate',
      searchPerson: 'Cauta persoana existenta',
      receivesRequests: 'Primeste cereri',
      phoneNumber: 'Telefon',
      person: 'Persoana',
      new: 'Persoana Noua',
      email: 'Email',
      contactMethods: {
        VISIT: 'Vizita',
        TEL: 'Telefon',
        EMAIL: 'E-Mail',
      },
      contactMethod: 'Metoda de contact',
      clearSelection: 'Sterge persoana selectata',
      addPerson: 'Adauga persoana noua',
      addContact: 'Adauga contact nou',
    },
    error: {
      patternEmail: 'Campul Email nu este valid',
      requiredVisibility: 'Campul Vizibilitate este obligatoriu',
      requiredPhoneNumber: 'Campul Telefon este obligatoriu',
      requiredPerson: 'Campul Persoana este obligatoriu',
      requiredEmail: 'Campul Email este obligatoriu',
      requiredContactMethod: 'Campul Metoda de contact este obligatoriu',
    },
    companyPartnerContact: {
      addTitle: 'Adauga contact pentru partener',
    },
  },
  constants: {
    cronExpressions: {
      yearly: 'O data pe an',
      weekly: 'O data pe saptamana',
      monthly: 'O data pe luna',
      daily: 'O data pe zi',
    },
  },
  consolidation: {
    utils: {
      solve: 'Rezolva',
    },
    'shipment-group': {
      title: 'Consolidare',
      saveShipmentGroupDisabledTooltip: 'Selecteaza un grupaj din dreapta pentru a putea salva un grupaj nou',
      noDataDescription: 'Niciun grupaj de transporturi valabil',
      list: {
        title: 'Grupaje transporturi',
      },
      invalidShipmentGroupsMessage: 'Selecteaza grupaje cu transporturi care nu sunt deja selectate',
      addGroup: 'Adauga grupaj',
    },
  },
  companyAsset: {
    unsupportedType: 'Tipul asset-ul nu este suportat!',
  },
  company: {
    suggestions: {
      addLogoAsset: 'Nu aveti un logo al companiei configurat. Adauga-l cu click pe butonul urmator',
      addCompanyContact: 'Adauga un contact nou companiei: ',
    },
    utils: {
      yes: 'Da',
      upload: 'Incarca',
      singleUpload: 'Se poate incarca un singur atasament de acest tip',
      select: 'Selecteaza',
      search: 'Cauta',
      save: 'Salveaza',
      requiredLegend: 'Campurile marcate cu * sunt obligatorii!',
      requiredLabel: 'Toate campurile marcate cu * sunt obligatorii',
      no: 'Nu',
      next: 'Pagina urmatoare',
      invalidateEmployeeConfirmationMessage:
        'Dupa stergere, acest utilizator va deveni invalid si nu se va mai putea autentifica!',
      edit: 'Editeaza',
      deleteConfirmationTitle: 'Confirmare stergere',
      deleteConfirmationMessage: 'Sunteti sigur ca doriti ca angajatul, <b>{{employeeName}}</b>, sa fie sters?',
      close: 'Inchide',
      cancel: 'Inchide',
      'boolean-select-item': {
        true: 'Da',
        null: 'Toate',
        false: 'Nu',
      },
      all: 'Toate',
    },
    type: {
      service_provider: 'Transportator',
      forwarder: 'Casa de expeditii',
      customer: 'Client',
    },
    'subscription-type': {
      subscription: {
        list: {
          title: 'Abonamente',
        },
        legalEntity: 'Companie',
        detail: 'Detalii',
      },
      'select-company-type': 'Alege tip companie',
      private: 'Privat',
      'new-actions': 'Definire Actiuni',
      'list-title': 'Tipuri Abonamente',
      inputs: {
        typeName: 'Nume Abonament',
        subscriptionPrice: 'Pret',
        subscriptionDetails: 'Detalii',
        subscriptionCurrency: 'Moneda',
        private: 'Privat',
        pricePerExtraCredit: 'Cost per credit suplimentar',
        legalEntity: 'Companie',
        creditStart: 'Creditul initial',
        companyType: 'Tip companie',
      },
      errors: {
        requiredtypeName: 'Campul Name este obligatoriu',
        requiredsubscriptionPrice: 'Campul pret este obligatoriu',
        requiredsubscriptionCurrency: 'Campul moneda este obligatoriu',
        requiredPricePerExtraCredit: "Campul 'Cost suplimentar per credit' este obligatoriu",
        requiredCreditStart: "Campul 'Credit initial' este obligatoriu",
        requiredcompanyType: 'Campul tip companie este obligatoriu',
      },
      companyTypes: {
        service_provider: 'Transportator',
        forwarder: 'Casa Expeditii',
        customer_with_fleet: 'Client cu flota',
        customer: 'Client',
      },
      companies: 'Companii',
      'add-title': 'Definire Tipuri Abonamente',
      add: 'Adauga',
      actions: {
        SEND_ORDER: 'Trimitere comanda',
        RECEIVE_ORDER: 'Primire comanda',
        pricePerExtraCredit: 'Cost per credit suplimentar',
        'offer-request': 'Cerere de oferta',
        monthlyIncludedAmount: 'Actiuni incluse',
        info: 'Acces la toate functionalitatiile aplicatiei',
        creditStart: 'Credit initial',
        credits: 'credite',
        CREATE_OFFER: 'Cereri de oferta',
        actionCost: 'O actiune suplimentara costa',
      },
      'actions-list': {
        list: {
          validTo: 'Valid pana la',
          validFrom: 'Valid din',
          title: 'Lista actiuni',
          subscriptionTypeName: 'Nume subscriptie',
          subscriptionTypeModule: 'Modul subscriptie',
          search: 'Cauta',
          name: 'Nume',
          monthlyIncludedAmount: 'Inclus lunar',
          cost: 'Costul',
          adminTitle: 'Administrare actiuni',
        },
        inputs: {
          validTo: 'Valid pana la',
          validFrom: 'Valid din',
          monthlyIncludedAmount: 'Incluse in fiecare luna',
          actionName: 'Nume actiune',
          actionCost: 'Costul actiunii',
        },
        errors: {
          requiredcost: 'Campul Costul actiunii este necesar',
          requiredactionName: 'Campul Nume Actiune este necesar',
        },
        detailTitle: 'Detalii actiune',
        addTitle: 'Adauga actiune',
      },
    },
    myCompany: {
      title: 'Profil companie',
      subscriptionValidFrom: 'Valid din',
      subscriptionRenewedAt: 'Reinnoit la',
      firstSubscriptionDate: 'Abonament creat la',
      remainingCredit: 'Numar credite ramase',
      details: 'Detalii companie',
    },
    menu: {
      userActionTracking: 'Actiuni Utilizatori',
      termsAndConditions: 'Termeni si Conditii',
      roleConfiguration: 'Configurare Roluri',
      partners: 'Parteneri',
      employees: 'Angajati',
      details: 'Detalii',
      contacts: 'Contacte',
      companyProfile: 'Profil Companie',
      companies: 'Companii',
      bankAccounts: 'Conturi Bancare',
      bankAccountAudit: 'Audit Cont Bancar',
      allCompanies: 'Toate companiile',
      addresses: 'Adrese',
    },
    'le-terms-and-conditions': {
      types: {
        SERVICE_PROVIDER_OFFER_REQ: 'Termeni si Conditii cu Transportatorii:',
        CUSTOMER_OFFER_REQ: 'Termeni si Conditii cu Clientii:',
      },
      title: 'Termeni si Conditii in limba ',
      preview: 'Previzualizeaza',
      'general-terms-and-conditions-title': {
        SERVICE_PROVIDER_OFFER_REQ: 'Termeni si Conditii generali cu Transportatorii',
        CUSTOMER_OFFER_REQ: 'Termeni si Conditii generali cu Clientii',
      },
      dashboard: {
        vendors: 'Transportatori parteneri',
        customers: 'Clienti',
      },
      add: {
        versions: 'Versiuni',
        version: 'Versiune in lucru: ',
        'valid-to': 'Valabil pana la',
        'valid-from': 'Valabil de la',
        tooltip: {
          SERVICE_PROVIDER_OFFER_REQ: 'Adaugati T&C generali cu Transportatorii pentru a putea accesa butonul',
          CUSTOMER_OFFER_REQ: 'Adaugati T&C generali cu Clientii pentru a putea accesa butonul',
        },
        'time-undefined': 'Nedefinit',
        'new-major-version-button': 'Adauga o versiune majora noua',
        'new-major-version': 'Adauga o versiune noua de la 0',
        'for-other': {
          SERVICE_PROVIDER_OFFER_REQ: 'Adauga T&C pentru alti transportatori',
          CUSTOMER_OFFER_REQ: 'Adauga T&C pentru alti clienti',
        },
        errors: {
          requiredValidFrom: 'Valabilitatea de inceput nu poate fi goala',
          requiredTemplate: 'Continutul termenilor si conditiilor nu poate fi gol',
        },
        availability: 'Valabilitate',
        'active-version': 'Versiunea activa',
      },
    },
    error: {
      noContactsWithEmail:
        'Nu a fost gasit niciun contact al acestei companii care sa fie marcat ca Primeste cereri sau care sa aiba o adresa de email valida!',
      alreadyExistingAddressOfType: 'Exista deja o adresa de acest tip!',
    },
    employee: {
      role: {
        roleSavedSuccess: 'Configuratia Rolului a fost salvata cu succes!',
      },
      new: {
        title: 'Adauga Angajat',
      },
      list: {
        validTo: 'Valid pana la',
        validFrom: 'Valid Din',
        undefinedValidTo: 'Nedefinit',
        search: 'Cauta',
        pid: 'PID',
        phoneNumber: 'Telefon',
        name: 'Nume',
        hasUserStatus: {
          false: 'Absent',
        },
        hasUser: 'Utilizator',
        expired: 'Inactiv',
        county: 'Judet',
        country: 'Tara',
        add: 'Adauga Angajat',
        active: 'Activ',
      },
      error: {
        requiredValidTo: 'Campul Valid pana la este obligatoriu',
        requiredValidFrom: 'Campul Valid din este obligatoriu',
        requireduserName: 'Campul Nume Utilizator este obligatoriu',
        patternEmail: 'Campul Email nu este valid',
        requiredPerson: 'Campul Persoana este obligatoriu',
        requiredpassword: 'Campul Parola este obligatoriu',
        requiredname: 'Campul Nume este obligatoriu',
        requiredcounty: 'Campul Judet este obligatoriu',
      },
      edit: {
        title: 'Editare Angajat',
      },
      common: {
        wizard: {
          userStep: 'Utilizator',
          employeeStep: 'Angajat',
        },
        validTo: 'Valid pana la',
        validFrom: 'Valid din',
        userDTO: {
          userName: 'Nume utilizator',
          password: 'Parola',
        },
        selectDepartment: 'Selecteaza departament',
        phoneNumber: 'Telefon',
        personDTO: {
          selectUser: 'Selecteaza user sau completeaza campurile de mai jos',
          person: 'Persoana',
          name: 'Nume',
          idSeries: 'Serie CI',
          idNumber: 'Numar CI',
          county: 'Judet',
          country: 'Tara',
          cnp: 'Cnp',
          address: 'Adresa',
          addPerson: 'Adauga persoana',
        },
        newDepartment: 'Departament nou',
        email: 'Email',
        departmentName: 'Nume departament',
      },
    },
    creditCard: {
      expirationDateFormat: 'MM/YY',
      expirationDate: 'Data expirarii',
      error: {
        requiredName: 'Campul Nume este obligatoriu',
        requiredExpirationDate: 'Campul Data expirarii este obligatoriu',
        requiredCardNumber: 'Campul Numar card este obligatoriu',
        invalidExpirationDate: 'Data expirarii este invalida',
        invalidCardNumber: 'Numarul cardului este invalid',
      },
      cardOwner: 'Nume',
      cardNumber: 'Numar card',
      card: 'CARD',
    },
    contact: {
      unsubscribeSuccess: 'V-ati dezabonat cu success',
      unsubscribe: 'Dezabonare',
      save: 'Salveaza',
      new: 'Contact nou',
      list: {
        visibilityTypes: {
          SERVICE_PROVIDER: 'Furnizor servicii',
          PUBLIC: 'Public',
          null: 'Toate',
          NONE: 'Privat',
          CUSTOMER: 'Client',
          BOTH: 'Ambele',
        },
        visibilityType: 'Vizibilitate',
        search: 'Cauta',
        receivesRequests: 'Primește cereri',
        phoneNumber: 'Telefon',
        ownerCompanyName: 'Detinator companie',
        email: 'Email',
        contactName: 'Name',
        contactMethods: {
          VISIT: 'Vizita',
          TEL: 'Telefon',
          null: 'Toate',
          EMAIL: 'Email',
        },
        contactMethod: 'Metodă de contact',
        contactIsNotOwned: 'Contactul nu poate fi sters deoarece nu este detinut de dumnevoastra',
        contactCountry: 'Tara',
        companyName: 'Companie',
        companyIsSuperAdmin: 'Contactul nu poate fi sters deoarece apartine detinatorului companiei',
        add: 'Adaugare',
      },
      detail: 'Detalii contact',
      confirmEmailUnsubscribe: 'Sunteti sigur ca doriti sa va dezabonati de la notificarile primite pe email?',
      close: 'Inchide',
    },
    companyType: {
      service_provider: 'Transportator',
      forwarder: 'Casa de Expeditii',
      customer_with_fleet: 'Client cu flota',
      customer: 'Client',
    },
    companyDetails: {
      invoiceSeriesPrefix: 'Prefix Serie Factura',
      invoice: {
        logo: 'Logo',
      },
      existingCompanyError: 'Compania pe care doriti sa o adaugati este deja inregistrata in platforma',
      createServiceProvider: 'Service Provider',
      companyTabTitle: 'Companie',
      companyTabHeader: 'Detalii companie',
      companyFormSubTitle: 'Acestea sunt datele oficiale provenite de la ministerul finantelor',
    },
    businessProfile: {
      subscriptionTypeTabHeader: 'Detalii abonament',
      publicTitle: 'Companie',
      partnerTitle: 'Companii partenere',
      myProfileTitle: 'Profilul Companiei',
      list: {
        vat: 'TVA',
        uniqueIdentificationNumber: 'Numar unic de indentificare',
        typeValue: 'Tip',
        sendInvitationEmail: 'Trimitere invitatie de colaborare',
        search: 'Cauta',
        PUBLIC: 'Nu este partner',
        platformMember: 'Membru platforma',
        PARTNER: 'Partener',
        mainPhoneNumber: 'Telefon',
        mainEmailAddress: 'Email',
        industryTypesValue: 'Tip industrie',
        delete: 'Sterge',
        country: 'Tara',
        contactList: 'Lista de contacte',
        onCompanyAddress: 'Adaugare adresa de companie',
        companyName: 'Nume Companie',
        city: 'Localitate',
        businessProfileType: 'Partener',
        addCompany: 'Adauga Companie',
        account: 'Cont',
      },
      companyTabHeader: 'Detalii companie',
      cardTabHeader: 'Detalii card',
      bankAccountTabHeader: 'Detalii conturi bancare',
      partners: {
        selectPartner: 'Selecteaza o companie partenera',
      },
    },
    bankAccount: {
      updateExisting: 'Actualizeaza contul bancar',
      typeEnum: {
        VAT: 'TVA',
        Primary: 'Principal',
        Normal: 'Normal',
      },
      type: 'Tip cont',
      title: 'Cont Bancar',
      swiftCode: 'Cod Swift',
      statusEnum: {
        Suspended: 'Suspendat',
        Closed: 'Inchis',
        Active: 'Activ',
      },
      status: 'Status cont',
      saveNew: 'Salveaza contul bancar',
      lastModifiedBy: 'Ultima modificare de',
      lastModifiedAt: 'Ultima modificare la',
      iban: 'Iban',
      error: {
        requiredType: 'Campul Tip este obligatoriu!',
        requiredStatus: 'Campul Status este obligatoriu!',
        requiredIban: 'Campul Iban este obligatoriu!',
        requiredCurrencyCode: 'Campul Moneda este obligatoriu!',
        requiredBankName: 'Campul Nume Banca este obligatoriu!',
        bankAccountOwnershipError: 'Nu se pot adauga/actualiza date despre conturile bancare ale altei companii',
      },
      currencyCode: 'Moneda',
      bankName: 'Nume Banca',
      addNew: 'Adauga cont bancar',
    },
    address: {
      newTitle: 'Adresa noua',
      mainAddress: 'Adresa principala',
      list: {
        add: 'Adaugare',
      },
      error: {
        noAddressSelected: 'Selectati o adresa valida',
      },
      detailTitle: 'Detalii adresa',
    },
  },
  'company-user': {
    title: 'Utilizatori',
    list: {
      username: 'Nume utilizator',
      phone: 'Telefon',
      'last-login': 'Ultima logare',
      indefinitely: 'Termen nedeterminat',
      email: 'Email',
      createdAt: 'Creat la',
      company: 'Companie',
      activeTo: 'Activ pana la',
    },
  },
  'company-profile': {
    utils: {
      search: 'Caută',
      save: 'Salveaza',
      emptyMessage: 'Nu a fost gasit nici un rezultat',
      cancel: 'Anuleaza',
      all: 'Toate',
    },
    performedActions: {
      performedBy: 'Realizata de',
      paymentDate: 'Data plata',
      'list-title': 'Actiuni Efectuate',
      creditPaymentSum: 'Numar Credite',
      actionName: 'Nume actiune',
    },
  },
  'company-details': {
    'terms-and-conditions': 'Termeni si Conditii',
    details: 'Detalii',
  },
  code: 'Cod cont global',
  close: 'Inchide',
  'cash-flow': {
    viewTransactions: 'Vezi toate tranzactiile',
    updateBalance: 'Actualizeaza numerar',
    transactions: {
      value: 'Valoare',
      type: {
        payment: 'Plata',
        invoice: 'Factura',
        cashflow_item: 'Tranzactie',
      },
      title: 'Tranzactii',
      invoiceSeries: 'Serie factura',
      form: {
        errors: {
          requiredValue: "Campul 'Valoare' este obligatoriu",
          requiredDate: "Campul 'Data' este obligatoriu",
          requiredCurrencyCode: "Campul 'Moneda' este obligatoriu",
          requiredComments: "Campul 'Detalii/Eticheta' este obligatoriu",
        },
      },
      emptyTransactionsMessage: 'Nicio tranzactie in aceasta zi',
      employee: 'Modificat de angajatul',
      edit: 'Editeaza tranzactie',
      deleteMessage: 'Sunteti sigur ca doriti sa stergeti tranzactia?',
      deleteHeader: 'Confirma stergerea',
      dateTransactionsTitle: 'Cash Flow din',
      date: 'Data',
      currencyCode: 'Moneda',
      Correction: 'Corectie',
      comments: 'Detalii / Eticheta',
      add: 'Adauga tranzactie',
    },
    transaction: 'Tranzactie',
    title: 'Cash Flow',
    selectStartDate: 'Selecteaza data',
    noCurrenciesSelected: 'Selecteaza o moneda',
    currentDayBalance: 'Numerar ziua curenta',
    correction: {
      title: 'Actualizeaza numerar',
      targetAmount: 'Numerar actualizat',
      form: {
        errors: {
          requiredTargetAmount: "Campul 'Numerar nou' este obligatoriu",
          requiredDate: "Campul 'Data' este obligatoriu",
          requiredCurrencyCode: "Campul 'Moneda' este obligatoriu",
        },
      },
      date: 'Data',
      currencyCode: 'Moneda',
    },
    addTransaction: 'Adauga tranzactie',
  },
  'budget-management': {
    totalCosts: 'Total Costuri',
    selectQuarter: 'Selecteaza trimestru',
    quarterWeek: (params) => `Saptamana ${params.weekNumber}`,
    'list-title': (params) => `Buget ${params.year}`,
    emptyCell: '-',
    budgetCosts: 'Costuri Bugetate',
    actualCosts: 'Costuri Realizate',
  },
  'bp-selectable-contact-list': {
    selected: 'selectate',
    noContactsSelected: 'Nu ati selectat niciun contact',
    'contact-list-title': 'Contacte',
  },
  blacklist: {
    type: 'Tip',
    lastModifiedByEmployeeName: 'Modificat de ',
    date: 'Data',
    comment: 'Comentariu',
    blacklistHistory: 'Istoric blacklist',
  },
  auth: {
    yes: 'Da',
    warnings: {
      emailNullReference: 'Pentru a continua navigarea spre alte pagini, trebuie sa setati un email!',
    },
    validationCode: 'Cod de validare',
    validatePhoneNumber: 'Validare numar de telefon',
    validateCode: 'Valideaza cod',
    utils: {
      requiredLegend: 'Campurile marcate cu * sunt obligatorii!',
      cancel: 'Anuleaza',
      back: 'Inapoi',
    },
    users: 'Utilizatori',
    username: 'Nume utilizator',
    ipAddress: 'Adresă IP',
    operatingSystem: 'Sistem de operare',
    browser: 'Browser',
    user: {
      new: 'Creaza utilizator',
      edit: 'Editeaza utilizator',
    },
    signupButton: 'Inregistreaza Companie',
    signup: 'Inregistrare',
    sendSmsValidation: 'Trimite SMS pentru validare',
    selectAll: 'Selecteaza toate rolurile',
    search: 'Cauta',
    save: 'Salvare',
    role: {
      otherRights: 'Alte Drepturi',
      newRole: 'Denumire rol nou',
      isPlatform: 'Rol Platforma',
      editRole: 'Editeaza rol',
      descriptionPlaceholder: 'Introduceti descrierea rolului',
      confirmDeletion: 'Sunteti sigur ca doriti sa stergeti rolul?',
      cloneRole: 'Creeaza un rol duplicat',
      assigned: 'Rol atribuit',
      configuration: {
        errors: {
          requiredName: 'Campul "Denumire rol nou" este obligatoriu',
        },
      },
    },
    rights: 'Drepturi',
    rightName: 'Nume Drept',
    'resend-email-confirmation': {
      success: 'Mailul de confirmare a fost retrimis cu success. Va rog sa verificati e-mail-ul!',
      error: 'Nu s-a putut retrimite mailul de confirmare!',
      button: 'Retrimitere email confirmare',
    },
    registerQuestion: 'Compania dumneavoastra nu se afla in platforma ?',
    profileInfoChanged:
      'Profilul a fost actualizat cu success! Te rugam sa te loghezi din nou pentru ca modificarile sa fie vizibile.',
    phoneNumber: 'Numar de telefon',
    passwordRecoveryRequest: {
      title: 'Asistenta pentru recuperarea parolei',
      recovery: 'Recupereaza parola',
      messages: {
        success: 'Mailul pentru resetarea parolei a fost trimis cu success',
        error: {
          '504': 'Ne pare rau, dar schimbarea parolei nu este posibila momentan!',
          undefined: 'Ne pare rau, dar schimbarea parolei nu este posibila momentan!',
        },
      },
      mainCredential: 'Nume utilizator sau Email',
      error: {
        requiredMainCredential: 'Introduceti un nume de utilizator sau email',
      },
      description: 'Introduce-ti adresa de email sau numele de utilizator asociat contului dumneavoastra',
    },
    passwordRecovery: {
      title: 'Recuperare parola',
      newPasswordConfirmation: 'Confirmare parola noua',
      newPassword: 'Parola noua',
      messages: {
        success: 'Parola utilizatorului a fost schimbata cu succes',
        successfulIfValid: 'Dacă contul există, a fost trimis un e-mail de resetare a parolei',
      },
      error: {
        requiredNewPasswordConfirmation: 'Campul de Confirmare parola noua este obligatoriu',
        passwordConfirmationMatchError: 'Confirmarea parolei nu coincide cu parola',
        minLength9: 'Introduceti minim 9 caractere',
        customPattern:
          'Parola trebuie sa contina cel putin o litera mica, cel putin o litera mare, cel putin o cifra, cel putin un caracter special, trebuie sa aiba minim 9 caractere si maxim 32 de caractere!',
      },
      changePassword: 'Schimba parola',
    },
    passwordExample: 'Exp: parolagauss',
    passwordConfirmation: 'Confirmarea parolei',
    'password-recovery-request-link': 'Ti-ai uitat parola? Apasa aici!',
    password: 'Parola',
    oldPassword: 'Parola veche',
    no: 'Nu',
    name: 'Nume',
    menu: {
      workflows: 'Workflows',
      users: 'Utilizatori',
      sentNotifications: 'Notificari trimise',
      reports: 'Rapoarte',
      profile: 'Profil',
      platformManagementSubscriptions: 'Tipuri abonamente',
      platformManagementInvoices: 'Facturi',
      platformManagementCompanies: 'Companii',
      platformManagement: 'Platforma',
      notificationSettings: 'Setari notificari',
      notifications: 'Notificari',
      notificationEvents: 'Evenimente trimise',
      jobs: 'Jobs',
      importExecutions: 'Import Executions',
      importDefinitions: 'Import Definitions',
      feedbackManagement: 'Management feedback',
      exceptions: 'Exceptii',
      dashboard: 'Dashboard',
      authLogs: 'Istoric autentificari',
      ownedAuthLogs: 'Istoric autentificari',
    },
    loginDate: 'Data autentificare',
    'login-details': 'Date autentificare',
    login: 'Autentificare',
    language: 'Limba',
    itemsSelected: '{0} selectate',
    invalidPhoneNumber: 'Numar de telefon invalid',
    invalidCode: 'Cod de validare gresit',
    indefinitely: 'Termen nedeterminat',
    errors: {
      '504': 'Ne pare rau, dar autentificarea nu este posibila momentan!',
      undefined: 'Ne pare rau, dar autentificarea nu este posibila momentan!',
      requiredConfirmCheckbox: 'Bifarea casetei este obligatorie',
      requiredPhoneNumber: 'Campul Numar de Telefon este obligatoriu',
      requiredPasswordConfirmation: 'Introduceti o parola noua',
      requiredPassword: 'Parola este obligatorie',
      requiredOldPassword: 'Introduceti vechea parola',
      requiredNewPasswordConfirmation: 'Reintroduceti parola noua',
      requiredNewPassword: 'Introduceti o parola noua',
      requiredName: 'Campul Nume utilizator este obligatoriu',
      requiredEmail: 'Campul email este obligatoriu',
      requiredConfirmEmail: 'Bifati ca ati luat la cunostinta trimiterea emailului de confirmare la adresa introdusa.',
      pattern: 'Introduceti o adresa de mail valida',
      passwordConfirmationMatchError: 'Confirmarea parolei nu coincide cu parola',
      passwordConfirmation: {
        requiredPasswordConfirmation: 'Confirmarea parolei este obligatorie!',
        passwordConfirmationMatchError: 'Confirmarea parolei nu coincide cu parola',
      },
      password: {
        required: 'Campul este obligatoriu de completat!',
        requiredNewPassword: 'Parola este obligatorie.',
        requiredConfirmPassword: 'Confirmarea parolei este obligatorie',
      },
      oldPassword: {
        'old-password-match': 'Parola veche nu este corecta!',
      },
      name: {
        required: 'Campul este obligatoriu de completat!',
        minlength: 'Numele utilizatorului trebuie sa aiba cel putin 5 caractere',
      },
      minlengthPasswordConfirmation: 'Introduceti minim 5 caractere',
      minlengthPassword: 'Introduceti minim 5 caractere',
      minlengthOldPassword: 'Introduceti minim 5 caractere',
      minLength5: 'Introduceti minim 5 caractere',
      maxlengthPasswordConfirmation: 'Introduceti maxim 50 de caractere',
      maxlengthPassword: 'Introduceti maxim 50 de caractere',
      maxlengthOldPassword: 'Introduceti maxim 50 de caractere',
      maxLength50: 'Introduceti maxim 50 caractere',
      invalid_token: 'A expirat sesiunea. Efectuati o noua autentificare',
      hasWhitespacePassword: 'Parola nu poate contine spatii albe',
      'expired-user': 'Utilizatorul nu mai este activ',
      emailEmail: 'Adresa de email este invalida',
      email: {
        required: 'Campul este oblicatoriu de completat!',
        pattern: 'Adresa de email este invalida',
      },
      'disabled-user': 'Adresa de e-mail a utilizatorului nu a fost confirmată',
      customPatternUsername:
        "Campul Nume utilizator trebuie sa contina intre 8-20 caractere mici.  Sa nu contina spatii albe sau caractere speciale,  Cuvintele sa fie legate prin '.' sau '_'",
      customPatternEmail: 'Adresa de email este invalida',
      'Bad credentials': 'Nume utilizator sau parolă incorectă!',
    },
    error: {
      'bad-credentials': 'Utilizator sau parolă incorectă',
    },
    emailConfirmation: {
      success: 'Utilizatorul a fost activat cu succes',
      error: 'Utilizatorul nu s-a putut activa',
    },
    email: 'E-mail',
    edit: 'Editare',
    description: 'Descriere',
    delete: 'Sterge',
    confirmEmailCheck: 'Accept ca linkul de confirmare utilizator sa fie trimis la emailul introdus.',
    companyType: 'Tip Companie',
    companySuperAdmin: 'Administrator companie',
    changePassword: 'Schimba parola',
    cancel: 'Anuleaza',
    authenticationLog: 'Istoric autentificari',
    add: 'Adauga',
    activeTo: 'Activ pana la',
    activeRight: 'Drept activ',
    activeOpts: {
      inactive: 'Inactivi',
      all: 'Toti',
      active: 'Activi',
    },
  },
  'auth-app': {
    greeting: 'Salut!',
  },
  attachmentUploader: {
    browse: 'Alege',
  },
  'alert-notification': {
    solve: 'Marcheaza ca rezolvata',
    message: 'Aveti o alerta in asteptare!',
  },
  address: {
    visibilityTypes: {
      SERVICE_PROVIDER: 'Furnizor servicii',
      PUBLIC: 'Public',
      null: 'Toate',
      NONE: 'Privat',
      CUSTOMER: 'Client',
      BOTH: 'Ambele',
    },
    visibility: 'Vizibilitate',
    utils: {
      yes: 'Da',
      save: 'Salveaza',
      no: 'Nu',
      deleteConfirmation: 'Confirmare stergere',
      apply: 'Aplica',
      all: 'Toate',
    },
    type: 'Tip Adresa',
    streetNumber: 'Nr. strada',
    streetName: 'Nume strada',
    state: 'Judet',
    selectAddress: 'Alege adresa cautata',
    searchSavedAddress: 'Cauta adresa salvata',
    'search-box': {
      'update-address': 'Actualizeaza Adresa',
      local: 'adrese salvate',
      label: 'Cauta adresa',
      google: 'google',
    },
    'save-disabled': 'Salvarea adresei poate fi facuta dupa introducerea unei adrese valide',
    inaccurateAddressMessage:
      'Nu s-a putut gasi o locatie fizica pentru adresa introdusa. Verificati corectitudinea campurilor si incercati din nou sau cautati o adresa noua.',
    savedAddressMessage: 'Adresa salvata cu succes !',
    'save-address-title': 'Adauga un nume pentru a salva adresa',
    'save-address-label': 'Salvare adresa',
    readonlyAddressType: 'Tipul adresei nu poate fi modificat atat timp cat este activata bifa de Adresa principala',
    postalCode: 'Cod postal',
    mainAddress: 'Adresa principala',
    locationChanged: 'Locatia a fost schimbata cu succes',
    countyCode: 'Cod judet',
    block: 'Bloc',
    building: 'Scara',
    floor: 'Etaj',
    apartment: 'Apartament',
    location: 'Locatie',
    list: {
      visibilityType: 'Vizibilitate',
      type: 'Tip Adresa',
      state: 'Stat',
      search: 'Cauta',
      postalCode: 'Cod postal',
      ownerCompanyName: 'Detinator companie',
      label: 'Eticheta',
      country: 'Tara',
      companyName: 'Companie',
      city: 'Localitate',
      addressLine: 'Linie',
    },
    hideDialog: 'Inchide',
    google: {
      status: {
        ZERO_RESULTS: 'Nu au fost gasite rezultate pentru aceasta cautare. Incercati din nou',
        UNKNOWN_ERROR: 'A aparut o eroare',
        REQUEST_DENIED: 'Google nu permite utilizarea acestui serviciu',
        OVER_QUERY_LIMIT: 'S-a depasit numarul de cautari. Contactati administratorul platformei pentru detalii',
        NOT_FOUND: 'Locatia nu a fost gasita',
        INVALID_REQUEST: 'Aceasta cautare nu este permisa',
      },
    },
    error: {
      ZERO_RESULTS: 'Nu s-a gasit niciun rezultat. Mutati pinul si incercati din nou',
      requiredVisibilityType: 'Visibilitatea este obligatorie',
      requiredState: 'Judetul este obligatoriu',
      requiredPostalCode: 'Codul postal este obligatoriu',
      requiredCountry: 'Tara este obligatorie',
      requiredCity: 'Localitatea este obligatorie',
      requiredStreetName: 'Numele strazii este obligatoriu',
      requiredStreetNumber: 'Numarul strazii este obligatoriu',
      requiredAddressValueType: 'Tipul adresei este obligatoriu',
      requiredAddressTypeValue: 'Tipul adresei este obligatoriu',
      requiredAddressLabel: 'Eticheta este obligatorie',
      requiredaddress: 'Adresa este obligatorie',
      pinDistanceTooLong:
        'Distanta dintre adresa selectata si locatia pin-ului pe harta este mai mare de 50km. Muta pin-ul mai aproape de locatia adresei selectate.',
      noAddressSelected: 'Adresa este obligatoriu de selectat sau de creat',
      maxDistanceExceeded: 'Adresa trebuie sa fie la o distanta mai mica de 50km de segment',
    },
    details: 'Detalii',
    country: 'Tara',
    clearSelection: 'Sterge selectia',
    city: 'Localitate',
    choose: 'Alege o adresa existenta',
    addressTypes: {
      Warehouse: 'Depozit',
      Shipping: 'Livrare',
      Registered: 'Inregistrare',
      Pickup: 'Incarcare',
      Office: 'Birou',
      Main: 'Principala',
      Invoicing: 'Invoicing',
      FiscalResidence: 'Resedinta Fiscala',
      Delivery: 'Descarcare',
      Decision: 'Decizie',
      Correspondence: 'Corespondenta',
      Billing: 'Facturare',
    },
    addressPickup: {
      saveAddress: 'Salveaza adresa',
    },
    addressLine: 'Linie adresa',
    addressLabel: 'Eticheta adresa',
    addressIsNotOwned: 'Adresa nu poate fi stearsa deoarece nu este detinut de dumnevoastra',
    'address-title': 'Adresa',
    addNew: 'Adauga o adresa noua',
  },
  'add-form': {
    'warning-vehicle': 'Solutia de rutare a fost completata cu masina',
    'warning-driver': 'Solutia de rutare a fost completata cu soferul',
    'vehicle-type': 'Tipul vehiculului',
    vehicle: 'Masina',
    title: 'Creeaza task-uri',
    start: 'Data de inceput',
    secondDriver: 'Sofer secundar',
    save: 'Salveaza',
    pickup: 'Locatie de ridicare',
    packages: 'Pachete',
    mainDriver: 'Sofer principal',
    finish: 'Data de sfarsit',
    error: {
      selectedDateAfterCurrentDateStart: 'Data de ridicare trebuie sa fie in prezent',
      selectedDateAfterCurrentDateFinish: 'Data de predare trebuie sa fie in prezent',
      requiredVehicleVO: 'Campul Masina este obligatoriu',
      requiredDriverVO: 'Campul Sofer este obligatoriu',
      endBeforeStartDateValidationError: 'Data de predare trebuie sa fie dupa cea de ridicare',
      requiredPickupTimeWindowStart: 'Data de inceput este obligatorie',
      requiredPickupTimeWindowEnd: 'Data de sfarsit este obligatorie',
    },
    delivery: 'Locatie de predare',
  },
  add: 'Adauga cont global nou',
  account: {
    utils: {
      update: 'Salveaza',
      showLess: 'Afiseaza mai putine pachete',
      showAllPackages: 'Afiseaza toate pachetele',
      send: 'Trimite',
      search: 'Cauta',
      save: 'Salveaza',
      reset: 'x',
      requiredLegend: 'Campurile marcate cu * sunt obligatorii!',
      preview: 'Panou Control',
      delete: 'Sterge',
      'columns-selected': 'coloane selectate',
      close: 'Inchide',
      chooseFile: 'Alege fisiere',
      'choose-columns': 'Alege coloane',
      choose: 'Alege',
      cancel: 'Anuleaza',
      'boolean-select-item': {
        true: 'Da',
        null: 'Toate',
        false: 'Nu',
      },
      'advanced-filters': 'Filtre avansate',
      addFile: 'Adauga fisiere',
      add: 'Adauga',
    },
    status: 'Status',
    serviceProviderName: 'Nume furnizor',
    phoneNumber: 'Telefon',
    'payment-time-limit': 'Termen de plata (nr zile)',
    'new-title': 'Cont nou',
    'list-title': 'Conturi',
    latestShipmentDate: 'Data ultimei livrari',
    firstShipmentDate: 'Data primei livrari',
    error: {
      startDateAfterEndDate: 'Data de sfarsit trebuie sa fie mai mare calendaristic decat data de inceput!',
      requiredValue: 'Valoarea raportata este obligatoriu de completat!',
      requiredStartDate: 'Data de inceput este obligatoriu de completat!',
      requiredPaymentTimeLimit: 'Campul Termen de plata este obligatoriu',
      requiredName: 'Numele este obligatoriu de completat!',
      requiredFinishDate: 'Data de sfarsit este obligatoriu de completat!',
      requiredCustomer: 'Campul Client este obligatoriu',
      requiredCode: 'Codul este obligatoriu de completat!',
      requiredAccountName: 'Camplul Nume cont este obligatoriu',
      required: 'Campul este obligatoriu de completat!',
      defaultValidationMessage: 'A apărut o eroare. Verifică datele introduse și încearcă din nou',
    },
    email: 'Email',
    customerName: 'Nume client',
    customer: 'Client',
    creditStoppedReason: 'Motiv oprire credit',
    creditStopped: 'Credit oprit',
    creditLimit: 'Limita credit',
    creditCloseDate: 'Data oprire credit',
    creditAvailable: 'Credit disponibil',
    contactPhoneNumber: 'Nr. tel. contact',
    contactName: 'Nume contact',
    contactEmail: 'Email contact',
    contact: 'Contact',
    billingName: 'Nume facturare',
    billingCycleEnum: {
      Weekly: 'Saptamanal',
      Per_shipment: 'Pe livrare',
      Monthly: 'Lunar',
      Manual: 'Manual',
      Bi_monthly: 'Bilunar',
    },
    billingCycle: 'Modalitate Facturare',
    billingAccountNumber: 'Nr. cont facturare',
    address: 'Adresa',
    accountStatus: 'Status',
    accountRequestedAt: 'Cerere trimisa la data',
    accountNumber: 'Nr. cont',
    accountName: 'Nume cont',
    accountCreatedAt: 'Creat la data',
    accountClosedAt: 'Inchis la data',
    'account-status-value': {
      requested: 'Cerut',
      created: 'Creat',
      closed: 'Inchis',
    },
  },
  'access-denied': {
    title: 'Aceasta pagina este restrictionata!',
    message: 'Din pacate, nu aveti permisiunile necesare pentru a accesa aceasta pagina.',
    errorMessage: '403',
    back: 'Intoarceti-va la Dashboard',
  },
  abstractNotifiableEntityContact: {
    editTooltip: 'Editieaza lista de contacte',
    editDisabledTooltip: 'Momentan nu se poate edita lista de contacte',
  },
  'abstract-entity-contact-list-update-popup': {
    update: 'Actualizeaza',
    title: 'Actualizeaza contactele',
  },
  'self-signup-cards': {
    'authorization-token': {
      title: 'Autorizare semnatura digitala',
      done: 'Realizata',
      'not-done': 'Lipseste',
      'go-to-authorize-token': 'Vezi semnatura digitala',
      'add-authorize-token': 'Adauga semnatura digitala',
      expiringSoon: 'Expira in curand',
      expiringSoonMessage: 'Semnatura va expira in curand, folositi butonul urmator pentru actualizare',
    },
    'terms-and-conditions': {
      title: 'Termeni si Conditii',
      'general-terms-and-conditions-with': {
        service_provider: 'T&C generali cu Transportatorii',
        customer: 'T&C generali cu Clientii',
      },
      'terms-and-conditions-with': {
        service_provider: 'T&C cu Transportatorii',
        customer: 'T&C cu Clientii',
      },
      'go-to-terms-and-conditions': 'Adauga T&C',
      'platform-terms-and-conditions': 'Vezi T&C de platforma',
    },
    'addresses-and-bank-accounts': {
      title: 'Adrese si Conturi Bancare',
      'missing-office-address': '!!! Lipseste Sediul Social',
      'office-address': 'Sediu Social',
      'fiscal-residence-address': 'Domiciliu Fiscal',
      'missing-fiscal-residence-address': '!!! Lipseste Domiciliul Fiscal',
      add: 'Adauga',
      edit: 'Editeaza',
      'active-bank-accounts': ' conturi bancare active',
      'active-bank-account': ' cont bancar activ',
      'go-to-bank-accounts': 'Vezi Conturi Bancare',
    },
    tariffs: {
      title: 'Contracte cu Furnizori',
      'tariff-contracts': ' contracte',
      'tariff-contract': ' contract',
      'add-tariff-contract': 'Adauga o Cerere de Contract',
    },
    'employees-and-contacts': {
      title: 'Angajati si Contacte',
      employee: ' angajat valid',
      employees: ' angajati valizi',
      contact: ' contact',
      contacts: ' contacte',
      'add-employee': 'Adauga angajat',
      'add-contact': 'Adauga contact',
    },
    customers: {
      title: 'Clienti',
      customer: ' client',
      customers: ' clienti',
      'add-customer': 'Adauga client',
    },
    'service-providers': {
      title: 'Transportatori',
      'service-provider': ' transportator',
      'service-providers': ' transportatori',
      'add-service-provider': 'Adauga transportator',
    },
    fleet: {
      title: 'Soferi si Vehicule',
      driver: ' sofer',
      drivers: ' soferi',
      vehicle: ' vehicul',
      vehicles: ' vehicule',
      'add-driver': 'Adauga sofer',
      'add-vehicle': 'Adauga vehicul',
    },
    'util-links': {
      title: 'Link-uri Utile',
      'received-invoices': 'Facturi primite',
      dashboard: 'Dashboard',
      reports: 'Rapoarte',
      workflows: 'Workflows',
      'roles-configuration': 'Configurare roluri',
    },
  },
  httpErrors: {
    connectionError: 'Eroare de conexiune',
    connectionErrorMessage: 'A aparut o eroare de conexiune. Reconectati-va!',
    timeoutError: 'Conexiune instabila',
    timeoutErrorDetail: 'Verificati datele transmise',
  },
  eTransportActions: {
    title: 'Actiuni eTransport',
    list: {
      uit: 'UIT',
      uploadIndex: 'Index incarcare',
      createdAt: 'Data creare',
      actionType: 'Tip actiune',
      anafMessage: 'Mesaj ANAF',
      createdBy: 'Creat de',
      checkStatus: 'Status verificare',
      uploadStatus: 'Status incarcare',
      licensePlates: 'Nr. inmatriculare',
      observations: 'Observatii',
      vehicleModificationDate: 'Data modificare vehicul',
    },
  },
  timesheet: {
    title: 'Pontaj',
    driver: 'Sofer',
    date: 'Data',
    type: 'Tip',
    dailyAllownace: 'Diurna',
    weekendSupplement: 'Supliment de weekend',
    dayOfTheWeek: 'Ziua',
    country: 'Tara',
    monthAndYear: 'Pontaje din luna si anul:',
  },
  namedLocation: {
    addNamedLocation: 'Adauga locatie',
    namedLocation: 'Locatie Publica',
    location: 'Locatie',
    locationSolutions: 'Solutii locatie',
    lockFilters: 'Blocheaza filterele',
    unlockFilters: 'Deblocheaza filtrele',
    details: 'Detalii',
    name: 'Denumire',
    cost: 'Cost',
    packageStatus: 'Status pachet',
    filterTags: 'Etichete',
    locations: 'Locatii publice',
    territoryLocationOne: 'locatie',
    territoryLocationMultiple: 'locatii',
    selectLocation: 'Selecteaza locatie',
    multipleSelectionSummary: '{{count}} locatii selectate',
    labelTitle: 'Denumire locatie',
    addLegalEntity: 'Adauga companie in platforma',
    label: 'Denumire',
    code: 'Cod',
    orderNumber: 'Numar comanda',
    shipmentSeries: 'Serie transport',
    deliveryTimeWindowEnd: 'Data livrare',
    statusMixed: 'Variabil',
    statusInTransit: 'In tranzit',
    statusInWarehouse: 'In depozit',
    statusFailed: 'Cu erori',
    duplicateCheckpoint: 'Ati selectat aceeași destinatie de mai multe ori',
    delete: 'Sterge locatie',
    deleteConfirmationMessageTitle: 'Dupa stergere, aceasta locatie nu va mai putea fi utilizata',
    deleteConfirmationMessage: 'Sunteti sigur ca doriti ca locatia sa fie stearsa?',
    operatingCompanyName: 'Companie operatoare',
    specialConditions: 'Conditii speciale',
    schedule: 'Orar de functionare',
    address: 'Adresa',
    companies: 'Companii',
    owner: 'Proprietar',
    operator: 'Operator',
    operatingCompany: 'Companie operatoare',
    timeIntervalAndAddress: 'Orar de functionare si adresa',
    publicContacts: 'Contacte publice',
    partnerContacts: 'Contacte partener',
    addNewContact: 'Adauga un contact nou',
    updateContacts: 'Actualizeaza contactele',
    updateInfo: 'Actualizeaza datele',
    saveChanges: 'Salveaza modificarile',
    manage: 'Gestioneaza',
    updateNamedLocationSpecialConditions: 'Actualizeaza conditiile speciale',
    emptyPublicContactsMessage: 'Momentan nu au fost atribuite contacte publice',
    emptyPartnerContactsMessage: 'Momentan nu au fost atribuite contacte pentru partener',
    emptySpecialConditionsMessage: 'Momentan nu au fost adaugate conditii speciale',
    emptyScheduleMessage: 'Momentan nu a fost adaugat un program',
    selectDays: 'Selecteaza zilele',
    selectedDays: 'zile selectate',
    shipmentDays: 'Zile transport',
    start: 'Start',
    end: 'Sfarsit',
    maxPackage: 'Capacitate masina',
    startingLocation: 'Locatie de pornire',
    destination: 'Destinatie',
    destinations: 'Destinatii',
    disabledDestinationsMessage: 'Selectati locatia de pornire pentru a putea selecta destinatii',
    timeWarning: 'Info: Intervalul selectat este inainte de orarul locatiei selectate!',
    nextDayWarning:
      'Info: Unul sau mai multe locatii au ore de început anterioare celor precedente, indicând că acestea vor avea loc în ziua următoare.',
    addDestination: 'Adauga destinatie',
    routesOrganisation: 'Organizare ruta',
    emptyLocationMessage: 'Nicio locatie selectata momentan.',
    generalInfo: 'Informatii generale',
    sendOrder: 'Comanda',
    sendOrderTooltip: 'Trimite o comandă către un partener furnizor',
    createTask: 'Task',
    createTaskTooltip: 'Creează un task care va fi rezolvat cu flota ta',
    deleteDraggedShipments: 'Sterge transporturile adaugate',
    dragAndDropHere: 'Drag & Drop aici',
    emptyShipmentsMessage: 'Nu a fost gasit niciun transport.',
    emptyRoutedOrderTemplatesMessage: 'Nu a fost gasit niciun sablon.',
    timezone: 'Fus orar',
    scheduleTimezoneInfo: 'Orarul de functionare este potrivit fusulului orar',
    handoverPlaceholder: 'Cod, nume, companie, oraș, stradă...',
    search: 'Cod, nume, companie, oraș, stradă...',
    company: 'Companie',
    searchAddressSuggestion: 'Sau caută o adresă...',
    emptyNamedLocationContacts: 'Nu a fost gasit niciun contact.',
    emptyLocationsSuggestion: 'Locatia nu exista? Adaugati-o!',
    isClaimedTooltip: 'Aceasta locatie este detinuta',
    operatedBy: 'Operata de',
    cannotEditAddress: 'Aceasta adresa nu se poate edita deoarece locatia a fost folosita',
    employees: 'Angajati',
    emptyEmployees: 'Momentan nu au fost atribuiti angajati',
    updateEmployees: 'Actualizeaza angajati',
    notClaimedForUpdatingEmployees: 'Pentru a putea adauga angajati, este necesara revendicarea locatiei',
    savedFilters: 'Filtre salvate',
    saveFilters: 'Salveaza filtrele',
    routes: 'Sabloane',
    shipments: 'Transporturi',
    preferencesSaveError: 'Selectați cel puțin un filtru cu opțiuni disponibile înainte de a salva.',
    activeFilters: 'Filtre active',
    labelRequired: 'Denumirea este obligatorie!',
    adhocTemplateLabel: 'Sablon ad-hoc',
    dragAndDropForAdhocTemplate: 'Trage si plaseaza transporturi pentru a crea un sablon ad-hoc',
    goToDispatcherShipments: 'Vezi task-uri si transporturi cu această locație',
    errors: {
      patternCode: 'Codul nu trebuie sa contina spatii',
      requiredLabel: "Campul 'Denumire' este obligatoriu",
      requiredOperator: "Campul 'Operator' este obligatoriu",
      requiredCost: "Campul 'Cost' este obligatoriu",
      fillAllSpecialConditions: 'Completati toate conditiile speciale sau renuntati la cele goale',
      requiredIntervals: 'Campurile de Start si Sfarsit sunt obligatorii',
      operatorNotInPlatform: 'Compania operatoare nu este in platforma',
      startBeforePrecedent: 'Timpul de inceput trebuie sa fie dupa timpul de start al locatiei precedente.',
      endAfterStart: 'Timpul de sfarsit trebuie sa fie dupa inceput',
    },
    utils: {
      filterActive: ' filtru activ',
      filtersActive: ' filtre activ',
    },
    ownershipRequest: {
      header: 'Cerere de revendicare locatie',
      title: 'Cereri de revendicare locatie',
      createdAt: 'Creata la',
      namedLocationLabel: 'Locatie',
      message: 'Mesaj',
      statusHeader: 'Status',
      phoneNumber: 'Numar telefon',
      email: 'Email',
      userName: 'Nume utilizator',
      addRequest: 'Revendica locatia',
      phoneNotValidatedWarning: 'Verifica numarul de telefon pentru a putea revendica o locatie',
      delete: 'Sterge cerere',
      deleteConfirmationMessage: 'Sunteti sigur ca doriti sa stergeti aceasta cerere',
      status: {
        ACCEPTED: 'ACCEPTATA',
        PENDING: 'IN ASTEPTARE',
        CANCELED: 'ANULATA',
        REJECTED: 'RESPINSA',
      },
      attachments: 'Atasamente',
      errors: {
        requiredMessage: "Campul 'Mesaj' este obligatoriu",
      },
    },
  },
  operationalTerritory: {
    territories: 'Teritorii',
    territory: 'Teritoriu',
    addOperationalTerritory: 'Adauga teritoriu',
    editOperationalTerritory: 'Editeaza teritoriu',
    label: 'Nume',
    validFrom: 'Valid din',
    validTo: 'Valid până la',
    locationSelectionMessage: 'Alegeti locatiile din lista expandabila',
    centralNamedLocationLabel: 'Locație centrală',
    centralNamedLocationSelectionMessage: 'Alegeti o locatie centrala facand click pe una din locatiile selectate.',
    centralNamedLocationHighlightMessage: 'Locatia centrala este evidentiata cu verde.',
    partners: 'Parteneri',
    partnerSelectionMessage: 'Alegeti partenerii din lista expandabila',
    seeTerritoryLocations: 'Vezi locatii din teritoriu',
    selectTerritory: 'Selecteaza teritoriu',
    invalidate: 'Invalideaza teritoriu',
    errors: {
      requiredLabel: "Campul 'Label' este obligatoriu",
      requiredPartners: "Campul 'Parteneri' este obligatoriu",
      requiredNamedLocations: "Campul 'Locatii' este obligatoriu",
      requiredCentralNamedLocation: "Campul 'Locatie centrala' este obligatoriu",
      requiredValidFrom: "Campul 'Valid din' este obligatoriu",
      requiredValidTo: "Campul 'Valid până la' este obligatoriu!",
      validToValidTo: "Data 'Valid până la' trebuie sa fie dupa data 'Valid din'",
    },
    details: 'Detalii',
  },
  routedOrder: {
    addRoutedOrderTemplate: 'Adauga sablon rute',
    editRoutedOrderTemplate: 'Editeaza sablon rute',
    chronologicalTimeInfoMessage:
      'Info - Locatiile pentru acest sablon vor fi salvate in ordine cronologica dupa timpii de start.',
    deleteTemplateMessage: 'Esti sigur ca vrei sa stergi sablonul selectat?',
    deleteTemplate: 'Sterge sablonul',
    shipmentRemoved: 'Transportul a fost sters',
    shipmentMergeError: 'Nu s-a putut salva combinarea transporturilor.',
    shipmentSplitError: 'Nu s-a putut salva impartirea transporturilor.',
  },
  externalMappings: {
    externalReferences: 'Referinte externe',
    locations: 'Locatii',
    packages: 'Pachete standard',
    standardPackage: 'Pachet standard',
    legalEntities: 'Companii',
    hubLocations: 'Locatii hub',
    addReference: 'Adauga referinta',
    addForLocation: 'Adauga referinta pentru locatie',
    editForLocation: 'Editeaza referinta pentru locatie',
    addForPackage: 'Adauga referinta pentru pachet',
    editForPackage: 'Editeaza referinta pentru pachet',
    addForLegalEntity: 'Adauga referinta pentru companie',
    editForLegalEntity: 'Editeaza referinta pentru companie',
    addForHubLocation: 'Adauga referinta pentru locatie hub',
    editForHubLocation: 'Editeaza referinta pentru locatie hub',
    showAll: 'Vezi toate',
    showOnlyValid: 'Vezi doar valide',
    list: {
      externalRefType: 'Sistem extern',
      externalRefId: 'Referinta',
      namedLocationLabel: 'Denumire locatie',
      standardPackageDimensionName: 'Pachet standard',
      companyName: 'Nume companie',
      uniqueIdentificationNumber: 'CUI',
      validFrom: 'Valid din',
      validTo: 'Valid până la',
    },
    errors: {
      requiredExternalReferenceType: "Campul 'Sistem extern este obligatoriu'",
      requiredExternalReferenceId: "Campul 'Referinta' este obligatoriu",
      requiredNamedLocation: 'Selectarea unei locatii este obligatorie',
      requiredStandardPackage: 'Selectarea unui pachet standard este obligatorie',
      requiredPartner: 'Selectarea unui partener este obligatorie',
      missingNamedLocation: 'Lipseste referinta externa pentru locatie.',
      missingStandardPackage: 'Lipseste referinta externa pentru pachet standard.',
      missingLegalEntity: 'Lipseste referinta externa pentru companie.',
      missingNamedLocationHub: 'Lipseste referinta externa pentru locatia hub.',
      missingUnknown: `Lipseste maparea de entitate pentru codul: {{code}}.`,
      NOMENCLATURE_UNKNOWN: 'Valoare neinterpretabila din protocolul EDI pentru codul: {{code}}.',
      NOMENCLATURE_MISSING_VALUE: 'Lipseste valoare obligatorie din protocolul EDI pentru codul: {{code}}.',
      ContractTariffItemNotMatchedConverterException: 'Nu s-a gasit un contract cu tarif potrivit.',
      ContractTariffItemWithDifferentCurrenciesConverterException: 'S-au gasit contracte cu mai multe monezi.',
      NamedLocationWithoutContactConverterException: 'Nu s-a gasit nici un contact pentru locatia folosita.',
      NamedLocationHubWithoutContactConverterException: 'Transportatorul nu a adaugat niciun contact pentru hub.',
    },
  },
  unedifact: {
    edifactImports: 'Importuri EDIFACT',
    edifactImport: 'Import EDIFACT',
    import: 'Import',
    createdAt: 'Creat la',
    createdBy: 'Creat de',
    fileName: 'Nume fisier',
    interchangeDate: 'Data creare in sistemul extern',
    controlRef: 'Ref. generata de sistemul extern',
    externalReferenceType: 'Sistem extern',
    orderNumber: 'Numar comanda',
    fileUploadedSummary: 'Fisierul a fost incarcat',
    fileUploadedDetails:
      'Fisierul incarcat contine erori, insa nu aveti dreptul de a accesa detaliile acestuia. Contactati supervizorul.',
    fileUploadedContainsErrors:
      'Fisierul a fost incarcat cu succes insa contine erori. Rezolvati-le pentru a putea trimite comanda',
    importDetails: 'Detalii import',
    downloadFile: 'Descarca fisierul',
    generalInformations: 'Informatii generale',
    senderID: 'ID expeditor',
    recipientID: 'ID destinatar',
    navigateToOrder: 'Navigheaza la comanda',
    importContains: 'Importul contine',
    shipments: 'transporturi',
    importProblems: 'Probleme import',
    collapseAll: 'Inchide toate',
    expandAll: 'Deschide toate',
    errors: 'erori',
    warnings: 'avertismente',
    add: 'Adauga',
    licensePlate: 'Placa inmatriculare',
    externalReferenceNumber: 'Numar referinta externa',
    relinkTitle: 'Reasociere import',
    relinkConfirmationMessage: 'Esti sigur ca vrei sa reasociezi importul cu precomanda selectata?',
    relink: 'Asociaza',
  },
  nomenclature: {
    unitMeasurementLabel: 'Unitate de măsură',
    unitMeasurementCode: 'Cod unitate de măsură',
    customLabel: 'Cod produs',
    productName: 'Denumire produs',
    productPrice: 'Preț unitar',
    currencyCode: 'Monedă',
    tariffCode: 'Cod tarifar',
    netWeight: 'Greutate netă (kg)',
    grossWeight: 'Greutate brută (kg)',
    deleteMessage: 'Sunteți sigur că doriți să ștergeți produsul',
    errors: {
      requiredCustomLabel: "Câmpul 'Cod produs' este obligatoriu!",
      requiredProductName: "Câmpul 'Denumire produs' este obligatoriu!",
      requiredProductPrice: "Câmpul 'Preț unitar' este obligatoriu!",
      requiredTariffCode: "Câmpul 'Cod tarifar' este obligatoriu!",
      requiredNetWeight: "Câmpul 'Greutate netă' este obligatoriu!",
      requiredGrossWeight: "Câmpul 'Greutate brută' este obligatoriu!",
      requiredUnitMeasurement: "Câmpul 'Unitate de măsură' este obligatoriu!",
      requiredCurrencyCode: "Câmpul 'Monedă' este obligatoriu!",
      existsCustomLabel: 'Există deja un produs cu acest cod!',
      maxlengthTariffCode: 'Codul tarifar nu poate avea mai mult de 8 caractere!',
      greaterThanGrossWeight: 'Greutatea bruta trebuie sa fie mai mare de 0 kg',
      greaterThanNetWeight: 'Greutatea neta trebuie sa fie mai mare de 0 kg',
    },
  },
  selectableEmployeeList: {
    employees: 'Angajati',
    selected: 'selectati',
    search: 'Cauta angajati...',
  },
};
